(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    let accordionUid = 0;

  class XAccordion extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector(".accordion__trigger");
      this.content = this.querySelector(".accordion__content");
      this._animation = null;
      if (!this.trigger || !this.content) return;

      // Liquid cannot generate a page-unique counter across isolated render
      // calls, so wire guaranteed-unique ids at runtime. This keeps
      // aria-controls / aria-labelledby correct even when several accordions
      // share the same base id (e.g. the default).
      const uid = "accordion-" + accordionUid++;
      this.trigger.id = uid + "-trigger";
      this.content.id = uid + "-content";
      this.trigger.setAttribute("aria-controls", this.content.id);
      this.content.setAttribute("aria-labelledby", this.trigger.id);

      this._onClick = this.toggle.bind(this);
      this.trigger.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      if (this.trigger && this._onClick) {
        this.trigger.removeEventListener("click", this._onClick);
      }
    }

    get isOpen() {
      return this.classList.contains("accordion--open");
    }

    get reduceMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      const group = this.dataset.group;
      const allowMulti = this.hasAttribute("data-multi-open");
      if (group && !allowMulti) {
        const siblings = document.querySelectorAll('x-accordion[data-group="' + group + '"]');
        siblings.forEach((sib) => {
          if (sib !== this && sib.isOpen) sib.close();
        });
      }

      // Capture the current rendered height before cancelling any in-flight
      // animation, so an interrupted toggle resumes from where it was rather
      // than jumping. cancel() reverts WAAPI styles, so read first.
      const start = this.content.getBoundingClientRect().height;
      if (this._animation) this._animation.cancel();

      this.classList.add("accordion--open");
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.hidden = false;

      if (this.reduceMotion) return;
      this._animation = this._animate(start, this.content.scrollHeight);
      if (this._animation) {
        this._animation.onfinish = () => {
          this._animation = null;
        };
      }
    }

    close() {
      const start = this.content.getBoundingClientRect().height;
      if (this._animation) this._animation.cancel();

      // If focus sits inside the panel we are about to hide, move it back to
      // the trigger so focus is never left on a hidden element.
      if (this.content.contains(document.activeElement)) {
        this.trigger.focus();
      }

      this.classList.remove("accordion--open");
      this.trigger.setAttribute("aria-expanded", "false");

      if (this.reduceMotion) {
        this.content.hidden = true;
        return;
      }

      this._animation = this._animate(start, 0);
      if (!this._animation) {
        this.content.hidden = true;
        return;
      }
      this._animation.onfinish = () => {
        // Guard against a later open() having superseded this close.
        if (!this.isOpen) this.content.hidden = true;
        this._animation = null;
      };
    }

    _animate(from, to) {
      if (typeof this.content.animate !== "function") return null;
      return this.content.animate([{ height: from + "px" }, { height: to + "px" }], {
        duration: 300,
        easing: "ease-in-out",
      });
    }
  }

  if (!customElements.get("x-accordion")) {
    customElements.define("x-accordion", XAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["analytics-event"] && !Shopify.designMode) return;
  try {
    class AnalyticsEvent extends HTMLElement {
    connectedCallback() {
      this.eventName = this.getAttribute("event");
      this.trigger = this.getAttribute("on") || "click";
      if (!this.eventName || this._wired) return;
      this._wired = true;

      if (this.trigger === "load") {
        this._publishOnce();
        return;
      }

      if (this.trigger === "view") {
        const el = this._resolveTarget() || this;
        this._observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this._publishOnce();
                obs.disconnect();
              }
            });
          },
          { threshold: 0.5 },
        );
        this._observer.observe(el);
        return;
      }

      // click (default): fire only on a genuine navigation link (`a[href]`)
      // inside the target. Buttons are deliberately excluded so card controls
      // (wishlist toggle, carousel arrows, quick-add size buttons) don't publish
      // a select_item / select_promotion -- only a real click-through does.
      this._clickTarget = this._resolveTarget() || this.parentElement;
      if (this._clickTarget) {
        this._onClick = (e) => {
          if (e.target.closest("a[href]")) this._send();
        };
        this._clickTarget.addEventListener("click", this._onClick);
      }
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._retry) clearInterval(this._retry);
      if (this._clickTarget && this._onClick) {
        this._clickTarget.removeEventListener("click", this._onClick);
      }
    }

    _resolveTarget() {
      const selector = this.getAttribute("target");
      if (selector) return document.querySelector(selector);
      return this.parentElement;
    }

    _payload() {
      const node = this.querySelector('script[type="application/json"]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent);
      } catch (err) {
        return {};
      }
    }

    _send() {
      const api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== "function") return false;
      api.publish(this.eventName, this._payload());
      return true;
    }

    _publishOnce() {
      // view / load fire once. Shopify.analytics may not be defined yet when an
      // above-the-fold element first intersects, so retry until it is (~10s cap)
      // rather than dropping the event.
      if (this._sent) return;
      if (this._send()) {
        this._sent = true;
        return;
      }
      if (this._retry) return;
      let tries = 0;
      this._retry = setInterval(() => {
        if (this._sent || this._send()) {
          this._sent = true;
          clearInterval(this._retry);
        } else if (++tries > 100) {
          clearInterval(this._retry);
        }
      }, 100);
    }
  }

  if (!customElements.get("analytics-event")) {
    customElements.define("analytics-event", AnalyticsEvent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const TRIGGER = ".badge__tooltip";
    const BUBBLE = ".badge__tooltip-bubble";
    const FALLBACK_GUTTER = 16;

    // The computed value of a custom property keeps its authored unit (the mobile gutter
    // is "1rem"), so resolve rem and em to pixels before comparing against a rect.
    const gutterPx = (el) => {
      const raw = getComputedStyle(el).getPropertyValue("--page-gutter").trim();
      const n = parseFloat(raw);
      if (!raw || Number.isNaN(n)) return FALLBACK_GUTTER;
      if (raw.endsWith("rem"))
        return n * parseFloat(getComputedStyle(document.documentElement).fontSize);
      if (raw.endsWith("em")) return n * parseFloat(getComputedStyle(el).fontSize);
      return n;
    };

    // Slide the bubble back inside the page gutters. Measured from the unshifted
    // position on every reveal, so a resize or rotation between reveals needs no
    // extra handling. A hidden bubble still has layout, so the rect is valid before
    // the CSS reveal has painted.
    const clampToGutters = (trigger) => {
      const bubble = trigger.querySelector(BUBBLE);
      if (!bubble) return;
      bubble.style.setProperty("--badge-tt-shift", "0px");
      const rect = bubble.getBoundingClientRect();
      if (!rect.width) return;
      const gutter = gutterPx(bubble);
      const maxRight = window.innerWidth - gutter;
      let shift = 0;
      if (rect.left < gutter) shift = gutter - rect.left;
      else if (rect.right > maxRight) shift = maxRight - rect.right;
      if (shift) bubble.style.setProperty("--badge-tt-shift", `${shift.toFixed(2)}px`);
    };

    // Delegated so badges rendered later (cart drawer, quick add) are covered. Pointer
    // moves between the trigger's own children re-fire pointerover; skip those.
    const onReveal = (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target && target.closest(TRIGGER);
      if (!trigger) return;
      if (event.relatedTarget instanceof Node && trigger.contains(event.relatedTarget)) return;
      clampToGutters(trigger);
    };

    document.addEventListener("pointerover", onReveal);
    document.addEventListener("focusin", onReveal);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bundle-add-to-bag"] && !Shopify.designMode) return;
  try {
    (function () {
    function routeRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return "/";
    }

    function cartAddUrl() {
      return routeRoot() + "cart/add.js";
    }

    /* In-flight guard mirrors quick-add: aria-busy gates keyboard re-entry,
       aria-disabled dims via the button's resting disabled styling. */
    function setLoading(el, on) {
      if (!el) return;
      if (on) {
        el.setAttribute("aria-busy", "true");
        el.setAttribute("aria-disabled", "true");
      } else {
        el.removeAttribute("aria-busy");
        el.removeAttribute("aria-disabled");
      }
    }

    /* Reuse the cart runtime's shared error mechanism: write every
       [data-cart-status] live region the same way the runtime's setError does, so
       a failed bundle add surfaces through the ONE shared cart status. */
    function setCartError(message) {
      var els = document.querySelectorAll("[data-cart-status]");
      for (var i = 0; i < els.length; i++) {
        els[i].setAttribute("data-cart-state", "error");
        els[i].textContent = message || els[i].getAttribute("data-error-msg") || "";
      }
    }

    /* The AJAX cart errors carry `description`; anything without one yields null so
       setCartError falls back to the static cart.error string. */
    function errMessage(err) {
      if (
        err &&
        typeof err === "object" &&
        typeof err.description === "string" &&
        err.description
      ) {
        return err.description;
      }
      return null;
    }

    /* On a FAILED add there is no cart:added, so the runtime never opens the drawer
       and the [data-cart-status] error we wrote would sit unseen -- open it here so
       the shared status surfaces. On SUCCESS we do NOT open it: the runtime opens it
       on cart:added (producers announce, the runtime renders). */
    function openCartDrawer() {
      var host = document.querySelector('x-overlay[data-overlay-id="cart-drawer"]');
      if (host && typeof host.open === "function") {
        host.open();
        return;
      }
      var trigger = document.querySelector('[data-overlay-trigger="cart-drawer"]');
      if (trigger) trigger.click();
    }

    class XBundleAddToBag extends HTMLElement {
      connectedCallback() {
        this.addBtn = this.querySelector("[data-bundle-add]");
        this.payload = this.readPayload();
        if (this.addBtn) {
          this._onClick = this.onClick.bind(this);
          this.addBtn.addEventListener("click", this._onClick);
        }
      }

      disconnectedCallback() {
        if (this.addBtn && this._onClick) {
          this.addBtn.removeEventListener("click", this._onClick);
        }
      }

      readPayload() {
        var node = this.querySelector("[data-bundle-payload]");
        if (!node) return null;
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return null;
        }
      }

      onClick(event) {
        event.preventDefault();
        // A child OOS / unresolved gates the bundle: the button is disabled, but
        // guard the handler too (keyboard, stale state).
        if (this.hasAttribute("data-bundle-incomplete")) return;
        if (!this.payload || !this.payload.children || !this.payload.children.length) return;
        // Re-entrancy: block a second add (mouse OR keyboard) while one resolves.
        if (this.addBtn && this.addBtn.getAttribute("aria-busy") === "true") return;

        var baseProps = this.payload.properties || {};
        // Per-instance grouping key: ONE fresh uuid per click, shared across every child
        // line of this set so it stays a single bundle instance. Clone baseProps -- never
        // mutate the shared island object, or a 2nd click would double-suffix _bundle_id --
        // and overwrite _bundle_id with "<productId>:<uuid>". crypto.randomUUID needs a
        // secure context (fine on the real myshopify.com storefront).
        var uid = baseProps._bundle_id + ":" + crypto.randomUUID();
        var props = Object.assign({}, baseProps, { _bundle_id: uid });
        // One line per distinct child variant, all sharing the same bundle properties so
        // the online cart groups them by _bundle_id and the cart transform buckets them.
        // One click adds one set: duplicate child references become that line's quantity.
        var items = this.payload.children.map(function (child) {
          var unitQty = child.unit_qty > 0 ? child.unit_qty : 1;
          return { id: child.id, quantity: unitQty, properties: props };
        });

        setLoading(this.addBtn, true);

        /* Render-then-show: ask the cart runtime which sections it can render and
           bundle them into THIS add POST so its response carries the rendered drawer
           -- one round-trip, drawer opens populated. sections_url pinned to /cart so
           the header-group drawer renders in a context that contains it. Empty Set ->
           omit sections -> graceful two-trip fallback. */
        var body = { items: items };
        var sectionIds = new Set();
        document.dispatchEvent(
          new CustomEvent("cart:prepare-bundled-sections", {
            detail: { sections: sectionIds, preview: this.addPreview() },
          }),
        );
        if (sectionIds.size) {
          body.sections = Array.from(sectionIds).join(",");
          body.sections_url = routeRoot() + "cart";
        }

        var btn = this.addBtn;
        fetch(cartAddUrl(), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            if (res.ok) return res.json();
            return res.json().then(
              function (data) {
                return Promise.reject(data);
              },
              function () {
                return Promise.reject(res);
              },
            );
          })
          .then(function (data) {
            // Shopify's add is all-or-nothing per request: the whole items[] is
            // accepted or the call rejects. On success announce once; the runtime
            // re-renders from server truth so a partial set can never be faked.
            document.dispatchEvent(
              new CustomEvent("cart:added", { bubbles: true, detail: { item: data } }),
            );
          })
          .catch(function (err) {
            /* No cart:added fires on this path, so remove the runtime's stand-in before
               the drawer opens onto the error; otherwise the shopper sees an error beside a
               bundle that was not added. */
            document.dispatchEvent(new CustomEvent("cart:add-failed", { bubbles: true }));
            setCartError(errMessage(err));
            openCartDrawer();
          })
          .finally(function () {
            setLoading(btn, false);
          });
      }

      /* Preview payload for the runtime's dimmed stand-in. `kind: 'bundle'` selects
         the cart-bundle-group-shaped template; a bundle is grouped into one presentation,
         so a single-line stand-in would not match what replaces it.

         Title comes from `_bundle_title`, the same string the cart group renders. Price
         is read from `x-buy-box`, which owns the bundle discount derivation; re-deriving
         it here would fork the displayed price source of truth. The thumbnail is the
         parent product's featured image (`data-buy-box-image`), matching the merged
         bundle group. Without a buy box or published price, skip the preview. */
      addPreview() {
        var props = (this.payload && this.payload.properties) || {};
        var bb = document.querySelector("x-buy-box");
        if (!bb) return null;
        var price = bb.getAttribute("data-buy-box-bundle-price") || "";
        if (!price) return null;
        return {
          kind: "bundle",
          title: props._bundle_title || "",
          price: price,
          compareAt: bb.getAttribute("data-buy-box-bundle-compare") || "",
          image: bb.getAttribute("data-buy-box-image") || "",
          quantity: 1,
        };
      }
    }

    if (!customElements.get("x-bundle-add-to-bag")) {
      customElements.define("x-bundle-add-to-bag", XBundleAddToBag);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-box"] && !Shopify.designMode) return;
  try {
    class XBuyBox extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector("[data-buy-box-price]");
      this.idInput = this.querySelector("[data-buy-box-id]");
      this.addBtn = this.querySelector("[data-buy-box-add]");
      this.notifyBtn = this.querySelector("[data-buy-box-notify]");
      this.notifyEligible = !!this.notifyBtn;
      this.form = this.querySelector("form");
      this.errorEl = this.querySelector("[data-buy-box-error]");
      this.requiresSize = this.hasAttribute("data-requires-size");
      this.addErrorLabel = this.dataset.labelAddError || "Could not add to bag";
      this.throttleErrorLabel = this.dataset.labelThrottleError || this.addErrorLabel;

      try {
        const priceNode = this.querySelector("[data-buy-box-prices]");
        this.prices = priceNode ? JSON.parse(priceNode.textContent) : {};
      } catch (e) {
        this.prices = {};
      }

      // Size Guide drawer parity: the drawer's controls live OUTSIDE this element
      // (rendered after </x-buy-box> via the overlay), so they cannot bubble
      // size-chip:change into this subtree. Only the main PDP buy-box (data-update-url)
      // owns the drawer; reach its controls through the document and drive them through
      // the same selectVariant() path so the two surfaces stay in lock-step both ways.
      this.ownsDrawer = this.hasAttribute("data-update-url");
      if (this.ownsDrawer) {
        this.sgDrawer = document.querySelector(".size-guide-drawer");
        this.sgPriceEl = document.querySelector("[data-sg-drawer-price]");
        this.sgAddBtn = document.querySelector("[data-sg-drawer-add]");
        this.sgNotifyBtn = document.querySelector("[data-sg-drawer-notify]");
        this.sgNotifyEligible = !!this.sgNotifyBtn;
        this.sgErrorEl = document.querySelector("[data-sg-drawer-error]");
      }

      // Own chips bubble into this element; drawer chips (name 'size-guide-size')
      // do not, so the owning buy-box also listens at the document level for them.
      this._onSize = (event) => {
        if (event.detail && event.detail.value) this.selectVariant(event.detail.value);
      };
      this.addEventListener("size-chip:change", this._onSize);

      if (this.ownsDrawer) {
        this._onDrawerSize = (event) => {
          if (!event.detail || event.detail.name !== "size-guide-size" || !event.detail.value)
            return;
          this.selectVariant(event.detail.value);
        };
        document.addEventListener("size-chip:change", this._onDrawerSize);

        if (this.sgAddBtn) {
          this._onSgAdd = (event) => {
            event.preventDefault();
            if (!this.form) return;
            if (this.form.requestSubmit) this.form.requestSubmit();
            else this.form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
          };
          this.sgAddBtn.addEventListener("click", this._onSgAdd);
        }
      }

      if (this.form) {
        this._onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener("submit", this._onSubmit);
      }
    }

    disconnectedCallback() {
      this.removeEventListener("size-chip:change", this._onSize);
      if (this._onDrawerSize) document.removeEventListener("size-chip:change", this._onDrawerSize);
      if (this.sgAddBtn && this._onSgAdd) this.sgAddBtn.removeEventListener("click", this._onSgAdd);
      if (this.form && this._onSubmit) this.form.removeEventListener("submit", this._onSubmit);
    }

    // Select a variant by id from EITHER the buy-box chips or the drawer chips,
    // reflecting it across both surfaces (chips, price, sold-out / notify swap)
    // so the on-page buy box and the Size Guide drawer stay in sync both ways.
    selectVariant(id) {
      if (!id) return;

      // Mark the chosen chip selected in both chip groups BY VALUE (not by the
      // clicked node) so a click in one surface updates the other.
      const roots = [this];
      if (this.sgDrawer) roots.push(this.sgDrawer);
      roots.forEach((root) => {
        root.querySelectorAll(".size-chip").forEach((c) => {
          const selected = c.dataset.sizeChipValue === id;
          c.classList.toggle("size-chip--selected", selected);
          c.setAttribute("aria-pressed", selected ? "true" : "false");
        });
      });

      if (this.idInput) this.idInput.value = id;

      // A size is now chosen, so a standing "select a size" message is stale.
      this.hideError();

      const entry = this.prices[id];

      // Re-cap the stepper to the newly selected variant's stock (null = uncapped).
      const picker = this.querySelector("x-quantity-picker");
      if (picker && picker.setMax) picker.setMax(entry ? entry.max : null);

      if (entry) {
        this.renderPrice(entry, this.priceEl);
        this.renderPrice(entry, this.sgPriceEl);
        const skuEl = document.querySelector("[data-pdp-sku]");
        if (skuEl && entry.sku)
          skuEl.textContent = skuEl.dataset.skuLabel
            ? skuEl.dataset.skuLabel + ": " + entry.sku
            : "SKU: " + entry.sku;

        if (entry.available) {
          this.removeAttribute("data-sold-out");
          this._setPrimary(true);
        } else {
          this.setAttribute("data-sold-out", "");
          this._setPrimary(false);
        }
      } else if (this.addBtn) {
        this.addBtn.disabled = false;
      }

      // Reflect the selected variant in the URL (?variant=<id>) on the main PDP so the
      // selection is shareable and survives reload. replaceState (not push) keeps the back
      // button on the previous page.
      if (this.hasAttribute("data-update-url")) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", id);
        window.history.replaceState({ path: url.toString() }, "", url.toString());
      }

      this.dispatchEvent(
        new CustomEvent("variant:change", {
          bubbles: true,
          detail: { id: id, variant: entry || null },
        }),
      );
    }

    // Swap the primary action: in-stock shows Add to Bag, sold-out shows Notify Me
    // when the product is notify-eligible; otherwise just disable Add to Bag.
    _setPrimary(available) {
      if (this.notifyEligible && this.notifyBtn) {
        this.notifyBtn.hidden = available;
        if (this.addBtn) {
          this.addBtn.hidden = !available;
          if (available) this.addBtn.disabled = false;
        }
      } else if (this.addBtn) {
        this.addBtn.disabled = !available;
      }

      // Mirror the swap onto the drawer's CTA so both surfaces agree.
      if (this.sgNotifyEligible && this.sgNotifyBtn) {
        this.sgNotifyBtn.hidden = available;
        if (this.sgAddBtn) {
          this.sgAddBtn.hidden = !available;
          if (available) this.sgAddBtn.disabled = false;
        }
      } else if (this.sgAddBtn) {
        this.sgAddBtn.disabled = !available;
      }
    }

    renderPrice(entry, el) {
      if (!el) return;
      const saleLabel = this.dataset.labelSalePrice || "";
      const origLabel = this.dataset.labelOriginalPrice || "";
      let html = '<span class="price' + (entry.onSale ? " price--on-sale" : "") + '" data-price>';
      if (entry.onSale && saleLabel) {
        html += '<span class="price__a11y">' + saleLabel + "</span>";
      }
      html += '<span class="price__current" data-price-current>' + entry.price + "</span>";
      if (entry.onSale && entry.compare) {
        if (origLabel) html += '<span class="price__a11y">' + origLabel + "</span>";
        html += '<span class="price__compare" data-price-compare>' + entry.compare + "</span>";
      }
      html += "</span>";
      el.innerHTML = html;
    }

    onSubmit(event) {
      event.preventDefault();
      // In-flight guard: a second submit (mouse OR keyboard) while the add is
      // resolving is a no-op, so a fast double-tap can't double-add (mirrors
      // quick-add / bundle-add-to-bag). aria-busy is the in-flight flag set below.
      if (this.addBtn && this.addBtn.getAttribute("aria-busy") === "true") return;
      if (this.requiresSize && (!this.idInput || !this.idInput.value)) {
        this.showError(this.dataset.labelSelectSize || "Please select a size");
        return;
      }
      this.hideError();
      this.setAddBusy(true);

      const body = new FormData(this.form);

      /* Render-then-show: bundle the cart sections into THIS add POST so its response
         carries the rendered drawer and the cart runtime opens it already populated in
         ONE round-trip. buy-box keeps its own FormData submit + inline under-button
         error UI rather than routing through window.SeedQuickAdd.add, so a PDP add
         error stays inline under the button instead of opening the drawer onto the
         shared cart status. sections_url is pinned to /cart so the header-group drawer
         renders in a context that contains it (else empty string off the PDP Referer).
         Empty Set -> omit sections -> graceful two-trip fallback. */
      /* Hand the runtime enough to paint a dimmed stand-in of THIS product while the add
         is in flight. Everything here is already on the page; the runtime owns whether
         and how to render it (producers announce, the runtime renders). Omitting `preview`
         is a supported degrade -- the drawer then opens populated, on the response. */
      const sectionIds = new Set();
      document.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          detail: { sections: sectionIds, preview: this.addPreview(body) },
        }),
      );
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";
      if (sectionIds.size) {
        body.append("sections", Array.from(sectionIds).join(","));
        body.append("sections_url", root + "cart");
      }

      /* POST the documented AJAX endpoint, not the form's bare /cart/add action:
         third-party SDKs (Braze et al.) intercept cart mutations by matching the
         `.js` URLs, and the JSON + bundled-sections response is only contractual
         on the AJAX API. Same backend handler, so response shape and latency are
         unchanged. */
      fetch(root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: body,
      })
        /* Read the body as text first, then try JSON: a throttled cart endpoint can
           reply 429 with a non-JSON body (an edge challenge page), which a bare
           r.json() throws on -- collapsing every failure into the generic catch. */
        .then((r) =>
          r.text().then((text) => {
            let data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch (err) {
              data = null;
            }
            return { ok: r.ok, status: r.status, data: data };
          }),
        )
        .then((res) => {
          this.setAddBusy(false);
          if (res.ok) {
            document.dispatchEvent(
              new CustomEvent("cart:added", { bubbles: true, detail: { item: res.data } }),
            );
            return;
          }
          this.addFailed();
          this.showError(this.messageForFailure(res));
          this.reportAddFailure(res);
        })
        .catch((err) => {
          this.setAddBusy(false);
          this.addFailed();
          this.showError(this.addErrorLabel);
          this.reportAddFailure({ status: 0, error: String(err) });
        });
    }

    /* A 429 is a transient rate-limit, not a dead end, so it gets its own
       "try again shortly" copy; a Shopify item error keeps its own description
       (sold out, etc.); everything else falls back to the generic label. */
    messageForFailure(res) {
      if (res.status === 429) return this.throttleErrorLabel;
      if (res.data && res.data.description) return res.data.description;
      return this.addErrorLabel;
    }

    /* Breadcrumb so an intermittent add failure is identifiable in the field
       (status + body) instead of recurring as a silent generic error. */
    reportAddFailure(res) {
      if (window.console && console.warn) console.warn("[buy-box-add] failed", res.status, res.data || "");
      document.dispatchEvent(
        new CustomEvent("cart:add-error", {
          bubbles: true,
          detail: { source: "buy-box", status: res.status },
        }),
      );
    }

    /* A failed add emits no cart:added, so tell the runtime to drop its pending stand-in.
       Without this the phantom line would sit in the drawer until the burst-safety backstop
       -- reading as "added" when it was not. */
    addFailed() {
      document.dispatchEvent(new CustomEvent("cart:add-failed", { bubbles: true }));
    }

    /* The preview payload for the runtime's pending line: the product as the shopper just
       configured it, shaped to match the cart line that will replace it.

       Price comes from the per-variant [data-buy-box-prices] island, NOT from scraping
       [data-buy-box-price]: that element renders sale AND compare-at together, so its
       textContent concatenates both numbers into one unusable string. The island gives the
       two money strings separately, which is what the cart line's own markup needs.

       These are PER-UNIT prices, which is correct: the cart line renders
       `line_item.final_price`, itself a per-unit figure (`final_line_price` is the line
       total) -- so quantity must NOT be multiplied in here. */
    addPreview(body) {
      const titleEl = this.querySelector(".buy-box__title");
      const id = this.idInput ? this.idInput.value : "";
      const chip = id ? this.querySelector('[data-size-chip-value="' + id + '"]') : null;
      const qty = parseInt(body.get("quantity"), 10);
      const p = (this.prices && this.prices[id]) || {};
      return {
        title: titleEl ? titleEl.textContent.trim() : "",
        price: p.price || "",
        compareAt: p.onSale ? p.compare || "" : "",
        image: this.getAttribute("data-buy-box-image") || "",
        colour: this.getAttribute("data-buy-box-colour") || "",
        size: chip ? chip.getAttribute("data-size-chip-label") : "",
        /* Whether the stand-in shows a size dropdown -- the server-computed `has_size`, the
           same gate the cart line uses, so a single-variant add never flashes a phantom
           dropdown. */
        sizeSelectable: this.getAttribute("data-buy-box-size-selectable") === "true",
        quantity: isNaN(qty) ? 1 : qty,
      };
    }

    /* Toggle the in-flight loading state on the PDP Add to Bag and its Size Guide
       drawer twin (which submits the same form): aria-busy is the in-flight flag the
       guard reads + the CSS dims/blocks; aria-disabled mirrors it for assistive
       tech. Matches the bundle / quick-add treatment so every ATC button loads the
       same way. */
    setAddBusy(on) {
      [this.addBtn, this.sgAddBtn].forEach((btn) => {
        if (!btn) return;
        if (on) {
          btn.setAttribute("aria-busy", "true");
          btn.setAttribute("aria-disabled", "true");
        } else {
          btn.removeAttribute("aria-busy");
          btn.removeAttribute("aria-disabled");
        }
      });
    }

    /* Both error slots carry every message: the on-page line under the button, and the
       Size Guide drawer's own line -- the drawer is a modal dialog, so a shopper acting
       inside it can only see the slot that renders inside it. */
    showError(message) {
      [this.errorEl, this.sgErrorEl].forEach((el) => {
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
      });
    }

    hideError() {
      [this.errorEl, this.sgErrorEl].forEach((el) => {
        if (el) el.hidden = true;
      });
    }
  }

  if (!customElements.get("x-buy-box")) {
    customElements.define("x-buy-box", XBuyBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["callout-card"] && !Shopify.designMode) return;
  try {
    /* <callout-card> - a shadow-encapsulated editorial tile injected as a real grid child
     of the Coveo product grid. Co-located CSS (Seed tokens cross the shadow boundary)
     reproduces the section-card design; page CSS cannot reach inside, hence the fork
     (mirrors coveo-product-card). Content arrives in a light-DOM <template> and is cloned
     into the shadow so it never flashes unstyled before upgrade. */
  class CalloutCard extends HTMLElement {
    connectedCallback() {
      if (this._built) return;
      this._built = true;

      var tpl = this.querySelector("template");
      var frag = tpl ? tpl.content.cloneNode(true) : null;

      var root = this.attachShadow({ mode: "open" });
      var style = document.createElement("style");
      style.textContent = CalloutCard.css;
      root.appendChild(style);

      var placement = this.dataset.placement === "underneath" ? "underneath" : "inside";
      var align = this.dataset.align === "centre" ? "centre" : "left";
      var color = this.dataset.color === "dark" ? "dark" : "light";
      var href = this.getAttribute("href");

      var wrapper = document.createElement(href ? "a" : "div");
      wrapper.className = "cc cc--" + placement + " cc--align-" + align + " cc--text-" + color;
      if (href) {
        wrapper.setAttribute("href", href);
        if (this.hasAttribute("data-newtab")) {
          wrapper.setAttribute("target", "_blank");
          wrapper.setAttribute("rel", "noopener");
        }
      }
      if (frag) wrapper.appendChild(frag);
      root.appendChild(wrapper);
    }
  }

  CalloutCard.css = [
    ":host{display:block;height:100%}",
    ":host([hidden]){display:none}",
    "*{box-sizing:border-box}",
    ".cc{position:relative;display:block;height:100%;color:inherit;text-decoration:none;overflow:hidden;transition:opacity var(--transition-base)}",
    "a.cc:hover,a.cc:focus-visible{opacity:.9}",
    "a.cc:focus-visible{outline:2px solid rgb(var(--color-focus));outline-offset:2px}",
    ".cc__media{display:block;width:100%;height:100%;object-fit:cover}",
    ".cc--underneath{display:flex;flex-direction:column}",
    ".cc--underneath .cc__media{flex:1 1 auto;min-height:0}",
    ".cc__content{display:flex;flex-direction:column;gap:var(--space-24)}",
    ".cc__text{display:flex;flex-direction:column;gap:var(--space-16)}",
    ".cc__heading-group{display:flex;flex-direction:column;gap:var(--space-8)}",
    ".cc__eyebrow{margin:0;text-transform:var(--text-case-upper);color:inherit;font-family:var(--font-primary);font-size:var(--text-base);line-height:var(--line-height-base)}",
    ".cc__heading{margin:0;font-family:var(--font-primary);font-size:var(--text-h3-desktop);line-height:var(--line-height-h3-desktop);font-weight:var(--font-weight-regular);color:inherit}",
    ".cc__body{color:inherit}",
    ".cc__body>:first-child{margin-top:0}",
    ".cc__body>:last-child{margin-bottom:0}",
    ".cc--inside .cc__content{position:absolute;inset:0;justify-content:flex-end;padding:var(--space-24) var(--space-32)}",
    ".cc--underneath .cc__content{padding:var(--space-16) var(--space-24) var(--space-24)}",
    ".cc--align-left .cc__cta{align-self:flex-start}",
    ".cc--align-centre .cc__content{text-align:center}",
    ".cc--align-centre .cc__cta{align-self:center}",
    ".cc--text-light .cc__content{color:rgb(var(--color-text-inverse))}",
    ".cc--text-dark .cc__content{color:rgb(var(--color-text-primary))}",
    ".cc__cta{display:inline-flex;align-items:center;justify-content:center;border:1px solid transparent;border-radius:var(--radius-none);font-family:var(--font-primary);font-weight:var(--font-weight-regular);text-decoration:none;width:max-content}",
    ".cc__cta--solid{min-height:var(--space-48);padding-inline:var(--space-40);font-size:var(--text-button);line-height:var(--line-height-button)}",
    ".cc--text-light .cc__cta--solid{background-color:rgb(var(--color-seed-white));color:rgb(var(--color-text-primary))}",
    ".cc--text-dark .cc__cta--solid{background-color:rgb(var(--color-seed-black));color:rgb(var(--color-text-inverse))}",
    ".cc__cta--text{min-height:var(--space-24);padding-inline:0;text-transform:var(--text-case-upper);font-size:var(--text-base);line-height:var(--line-height-button)}",
    ".cc--text-light .cc__cta--text{color:rgb(var(--color-text-inverse))}",
    ".cc--text-dark .cc__cta--text{color:rgb(var(--color-text-primary))}",
    "a.cc:hover .cc__cta--text,a.cc:focus-visible .cc__cta--text{text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:6px}",
    "@media (max-width:768px){",
    ".cc__content{gap:var(--space-16)}",
    ".cc--inside .cc__content{padding:var(--space-16)}",
    ".cc--underneath .cc__content{padding:var(--space-8) var(--space-16) var(--space-16)}",
    ".cc__heading{font-size:var(--text-h4-desktop);line-height:var(--line-height-h4-desktop)}",
    "}",
  ].join("");

  if (!customElements.get("callout-card")) {
    customElements.define("callout-card", CalloutCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["callout-interleave"] && !Shopify.designMode) return;
  try {
    /* <x-callout-interleave> - injects <callout-card> tiles as REAL children of the Coveo
     product grid ([part="result-list"], in the product-list's shadow root) at configured
     slots, re-inserting after each Lit re-render. No Liquid here. */
  class XCalloutInterleave extends HTMLElement {
    connectedCallback() {
      this._alive = true; // cleared on disconnect so the async init can bail
      this.tiles = Array.prototype.slice
        .call(this.querySelectorAll("callout-card[data-callout-position]"))
        .map(function (el) {
          return {
            pos: parseInt(el.dataset.calloutPosition, 10),
            size: el.dataset.calloutSize,
            node: el,
          };
        })
        .filter(function (t) {
          return !isNaN(t.pos);
        })
        .sort(function (a, b) {
          return a.pos - b.pos;
        });
      if (!this.tiles.length) return;

      // Scoped to the PLP: the header predictive-search renders its own
      // atomic-commerce-product-list EARLIER in the DOM, so an unscoped
      // querySelector binds to that empty list and every tile collapses 0x0.
      this.listSelector = this.dataset.listSelector || "#coveo-plp atomic-commerce-product-list";
      // Wait for the Atomic product list AND the shared engine, both set
      // asynchronously by the PLP init. No-op (forever) off a Coveo PLP.
      this.waitFor(
        function () {
          return document.querySelector(this.listSelector) && window.__coveoEngine;
        }.bind(this),
        this.start.bind(this),
      );
    }

    waitFor(test, done, tries) {
      tries = tries || 0;
      if (!this._alive) return; // disconnected while polling - stop rescheduling
      if (test()) {
        done();
        return;
      }
      if (tries > 100) return; // ~10s, then give up (not a Coveo PLP / proxy down)
      this._pollTimer = setTimeout(
        function () {
          this.waitFor(test, done, tries + 1);
        }.bind(this),
        100,
      );
    }

    async start() {
      this.productList = document.querySelector(this.listSelector);
      try {
        const mod =
          await import("https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js");
        if (typeof mod.buildProductListing !== "function") return;
        if (!this._alive) return; // disconnected during the dynamic import
        // A SECOND product-listing controller over the SAME engine = a pure
        // observer on the store Atomic already drives (addReducers is idempotent).
        this.controller = mod.buildProductListing(window.__coveoEngine);
      } catch (e) {
        return; // module/engine unavailable; leave the tiles unplaced (hidden host)
      }

      this.schedulePlace = this.schedulePlace.bind(this);

      // The engine's product-listing state is the authoritative "results changed" signal
      // (responseId / product count) - a filter, sort, search or load-more is the ONLY
      // thing that changes it. onTick() re-arms placement on that change; the narrow
      // MutationObserver (attached lazily in place()) only catches the DOM settling after
      // it and is gated by _needsPlace, so incidental shadow churn never re-places.
      this.unsubscribe = this.controller.subscribe(this.onTick.bind(this));
      this.onTick();

      // Re-place on viewport changes (mobile <-> desktop span differs).
      this._onResize = function () {
        this._needsPlace = true;
        this.schedulePlace();
      }.bind(this);
      window.addEventListener("resize", this._onResize, { passive: true });
    }

    // Observe the result-list ELEMENT's DIRECT children only ({childList}, NOT subtree):
    // card add/remove on a real query change. Deep within-card mutations (image loads,
    // coveo-product-card chip/gallery injections) must NOT fire this. The handler is gated
    // by _needsPlace so it no-ops on incidental churn; it re-arms only if Coveo wiped one
    // of OUR tiles. place() (dis)connects it around its own writes, so we don't self-fire.
    ensureObserver(root) {
      if (this._listMO && root === this._observedRoot) return;
      if (this._listMO) this._listMO.disconnect();
      this._observedRoot = root;
      this._listMO = new MutationObserver(
        function (records) {
          if (this._injecting) return; // our own detach/insert
          var wiped = records.some(function (m) {
            return Array.prototype.some.call(m.removedNodes, function (n) {
              return n.tagName === "CALLOUT-CARD";
            });
          });
          if (wiped) this._needsPlace = true;
          if (!this._needsPlace) return; // placed & stable -> ignore
          this.schedulePlace();
        }.bind(this),
      );
    }

    onTick() {
      const s = this.controller && this.controller.state;
      // Skip ONLY the setView/setContext reset tick (no responseId yet). A legitimate
      // zero-results response (valid responseId, products:[]) DOES pass.
      if (!s || !s.responseId || !s.products) return;
      // React ONLY when the result set changed - new responseId (filter/sort/search) or a
      // changed product count (load-more append/replacement). Incidental image-load/chip
      // mutations never change these -> this keeps placement off the mutation firehose.
      if (s.responseId === this._lastResponseId && s.products.length === this._lastCount) return;
      this._lastResponseId = s.responseId;
      this._lastCount = s.products.length;
      this._needsPlace = true;
      this.schedulePlace();
    }

    schedulePlace() {
      if (!this._alive || this._raf) return;
      this._raf = requestAnimationFrame(
        function () {
          this._raf = 0;
          this.place();
        }.bind(this),
      );
    }

    // Bootstrap fallback: bridge the brief window between a result-set change and the fresh
    // cards rendering, in case the observer isn't yet attached (result-list not mounted).
    // Only runs while _needsPlace is set, so it self-stops once placement succeeds.
    retryPlace() {
      if (this._retryTimer || !this._alive || !this._needsPlace) return;
      this._retryTimer = setTimeout(
        function () {
          this._retryTimer = 0;
          this.place();
        }.bind(this),
        120,
      );
    }

    place() {
      if (!this._alive || !this.productList) return;
      // The product-list element can be swapped by the Section Rendering API; re-acquire.
      if (!this.productList.isConnected) {
        var fresh = document.querySelector(this.listSelector);
        if (fresh && fresh !== this.productList) {
          this.productList = fresh;
          this._observedRoot = null; // force re-observe of the new list's result-list
        }
      }
      const root =
        this.productList.shadowRoot &&
        this.productList.shadowRoot.querySelector('[part="result-list"]');
      // result-list not mounted yet: keep _needsPlace and retry shortly (bootstrap).
      if (!root) {
        this.retryPlace();
        return;
      }

      // Attach the narrow childList observer to the CURRENT result-list element (once).
      this.ensureObserver(root);

      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      var placedOnCards = false;

      // Disconnect around our own writes so they never re-fire the observer (records are
      // delivered in a microtask, after _injecting would already have reset).
      if (this._listMO) this._listMO.disconnect();
      this._injecting = true;
      try {
        // Detach our tiles first so the product cards are a clean, contiguous list.
        this.tiles.forEach(function (t) {
          if (t.node.parentNode) t.node.parentNode.removeChild(t.node);
        });

        // Product cards = every result-list child that is NOT one of our callout tiles.
        const productCards = Array.prototype.filter.call(root.children, function (el) {
          return el.tagName !== "CALLOUT-CARD";
        });

        if (productCards.length > 0) {
          this.tiles.forEach(function (t) {
            const idx0 = t.pos - 1; // 1-based slot -> 0-based product index
            // Out of range (slot beyond loaded products): leave detached until more load.
            if (idx0 < 0 || idx0 >= productCards.length) return;

            // Span: large = 2x2, small = 1x1; mobile = full width (single column).
            if (isMobile) {
              t.node.style.gridColumn = "1 / -1";
              t.node.style.gridRow = "auto";
            } else if (t.size === "large") {
              t.node.style.gridColumn = "span 2";
              t.node.style.gridRow = "span 2";
            } else {
              t.node.style.gridColumn = "span 1";
              t.node.style.gridRow = "span 1";
            }
            // Insert before the slot's product card so it takes that cell and pushes the
            // following products into the next free cells (real grid auto-flow).
            root.insertBefore(t.node, productCards[idx0]);
          });
          placedOnCards = true;
        }
      } finally {
        this._injecting = false;
        if (this._listMO) this._listMO.observe(root, { childList: true });
      }

      if (placedOnCards) {
        // Placed onto rendered cards: stop re-placing until the next result-set change.
        this._needsPlace = false;
      } else {
        // Cards for this result set have not rendered yet (they land a frame after the
        // responseId tick, or this is a zero-results response). Keep _needsPlace so the
        // childList mutation that adds them - or the bootstrap retry - re-fires placement.
        this.retryPlace();
      }
    }

    disconnectedCallback() {
      // Mark dead + cancel any in-flight poll FIRST, so a disconnect mid-init cannot
      // complete start() on a detached element.
      this._alive = false;
      if (this._pollTimer) clearTimeout(this._pollTimer);
      if (this._retryTimer) clearTimeout(this._retryTimer);
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this.unsubscribe) this.unsubscribe();
      if (this._listMO) this._listMO.disconnect();
      this._observedRoot = null;
      if (this._onResize) window.removeEventListener("resize", this._onResize);
      // Remove any injected tiles from the grid (they belong to this controller).
      if (this.tiles) {
        this.tiles.forEach(function (t) {
          if (t.node.parentNode) t.node.parentNode.removeChild(t.node);
        });
      }
    }
  }

  if (!customElements.get("x-callout-interleave")) {
    customElements.define("x-callout-interleave", XCalloutInterleave);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    // x-carousel -- a native CSS-scroll-snap carousel. The browser owns scrolling,
  // momentum and snapping; the JS only (1) measures the reachable snap positions
  // from real slide geometry, (2) reflects the settled state (index, boundaries,
  // indicator) and (3) drives the public prev()/next() API. State is derived from
  // the SAME geometry the browser snaps to, so JS and native snapping never drift.
  class XCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-carousel-track]");
      if (!this.track) return;

      this.index = 0;
      this._itemCount = parseInt(this.dataset.total, 10) || 0;
      this.total = this._itemCount; // page count, re-derived from geometry
      this.snaps = [0]; // reachable scroll offsets (sorted, de-duplicated)
      this._maxScroll = 0;
      this._renderedIndex = -1;
      this.indicatorWrap = this.querySelector("[data-carousel-indicator]");
      this.indicator = this.querySelector("[data-carousel-indicator] .carousel-indicator");
      // Progress indicators are driven continuously (per scroll frame) rather
      // than per page -- cache the check once so the hot path stays branch-cheap.
      this._isProgressIndicator =
        !!this.indicator && this.indicator.classList.contains("carousel-indicator--progress");
      this._reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this._scrollEndSupported = "onscrollend" in window;
      this._activated = false;
      this._rafScroll = 0;

      // Responsive activation: 'below'/'above' a breakpoint keep the carousel
      // live only in that viewport range; no data-active means always live.
      const mode = this.dataset.active;
      if (mode === "below" || mode === "above") {
        const bp = parseInt(this.dataset.breakpoint, 10) || 768;
        const query = mode === "below" ? `(max-width: ${bp}px)` : `(min-width: ${bp + 1}px)`;
        this._mql = window.matchMedia(query);
        this._onMQ = () => this._applyResponsive();
        this._mql.addEventListener("change", this._onMQ);
        this._applyResponsive();
      } else {
        this._activate();
      }
    }

    disconnectedCallback() {
      this._mql?.removeEventListener("change", this._onMQ);
      this._deactivate();
    }

    // Toggle the live carousel as the breakpoint is crossed. `data-carousel-on`
    // drives the CSS (flex track when on; the consumer's layout when off).
    _applyResponsive() {
      if (this._mql.matches) {
        if (this._activated) return;
        this.setAttribute("data-carousel-on", "");
        this._activate();
      } else {
        if (!this._activated) return;
        this.removeAttribute("data-carousel-on");
        this._deactivate();
      }
    }

    // Wire scroll/keyboard/resize behaviour. Idempotent.
    _activate() {
      if (this._activated) return;
      this._activated = true;
      this._renderedIndex = -1;

      // Live scroll: coalesce to one rAF/frame for the hot path (boundaries +
      // active index), and -- where `scrollend` is unsupported -- debounce a
      // settle commit. The hot path reads only scrollLeft; no layout, no allocs.
      this._onScroll = () => {
        if (!this._rafScroll) {
          this._rafScroll = requestAnimationFrame(() => {
            this._rafScroll = 0;
            this._render();
          });
        }
        if (!this._scrollEndSupported) {
          clearTimeout(this._scrollTimer);
          this._scrollTimer = setTimeout(() => this._commit(), 120);
        }
      };
      this.track.addEventListener("scroll", this._onScroll, { passive: true });

      // `scrollend` is the reliable "momentum finished, resting on a snap" signal.
      if (this._scrollEndSupported) {
        this._onScrollEnd = () => this._commit();
        this.track.addEventListener("scrollend", this._onScrollEnd);
      }

      // Geometry is scroll-invariant: cache it, and only re-measure on resize
      // (slide widths / page count change across breakpoints).
      this._resizeObserver = new ResizeObserver(() => this._measure());
      this._resizeObserver.observe(this.track);
      this._measure();

      this._onKeydown = (e) => {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          this.next();
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          this.prev();
        }
      };
      this.addEventListener("keydown", this._onKeydown);

      if (this.hasAttribute("data-clickdrag")) {
        this._initClickDrag();
      }

      // Nested inside another carousel (a product card's image gallery inside a
      // rail): both tracks own a horizontal swipe, and `overscroll-behavior-x:
      // contain` keeps this one for the whole gesture -- so at the last slide the
      // rail would sit still until the finger lifts. Forward the hand-off instead.
      const outerCarousel = this.parentElement?.closest("x-carousel");
      if (outerCarousel) this._initNestedHandoff(outerCarousel);
    }

    // One hand-off per gesture: a committed horizontal swipe with no slide left in
    // that direction pages the outer carousel. Passive listeners, so this track
    // keeps its native scroll and momentum and a tap still activates a slide.
    _initNestedHandoff(outer) {
      const THRESHOLD = 24; // a committed swipe, past the tap slop the browser allows
      let startX = 0;
      let startY = 0;
      let handedOff = true;

      this._onNestedStart = (e) => {
        handedOff = e.touches.length !== 1;
        if (handedOff) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      };
      this._onNestedMove = (e) => {
        if (handedOff || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) < THRESHOLD || Math.abs(dx) <= Math.abs(dy)) return;
        const forward = dx < 0;
        const pos = this._scrollPos();
        // Another slide in the swipe direction: this track keeps the gesture.
        if (forward ? pos < this._maxScroll - 1 : pos > 1) return;
        handedOff = true;
        if (forward) outer.next();
        else outer.prev();
      };
      this.track.addEventListener("touchstart", this._onNestedStart, { passive: true });
      this.track.addEventListener("touchmove", this._onNestedMove, { passive: true });
    }

    // Tear down all wiring and reset scroll position. Idempotent.
    _deactivate() {
      if (!this._activated) return;
      this._activated = false;

      if (this._rafScroll) {
        cancelAnimationFrame(this._rafScroll);
        this._rafScroll = 0;
      }
      clearTimeout(this._scrollTimer);
      this.track?.removeEventListener("scroll", this._onScroll);
      this.track?.removeEventListener("scrollend", this._onScrollEnd);
      this.track?.removeEventListener("touchstart", this._onNestedStart);
      this.track?.removeEventListener("touchmove", this._onNestedMove);
      this.removeEventListener("keydown", this._onKeydown);
      this._resizeObserver?.disconnect();
      this._resizeObserver = null;
      this._destroyClickDrag();

      // Release the indicator back to the stylesheet (drop the inline hide).
      if (this.indicatorWrap) this.indicatorWrap.style.removeProperty("display");

      if (this.track) this.track.scrollLeft = 0;
      this.index = 0;
      this.dataset.index = 0;
    }

    // Logical scroll position (abs() keeps it in a single [0, max] space even
    // under RTL, where scrollLeft runs negative).
    _scrollPos() {
      return Math.abs(this.track.scrollLeft);
    }

    _behavior() {
      return this._reduceMotion && this._reduceMotion.matches ? "auto" : "smooth";
    }

    // Measure the reachable snap positions from real slide geometry, the way the
    // browser does: each slide's scroll offset, clamped into [0, maxScroll], then
    // sorted and de-duplicated (snaps within 1px collapse -- several trailing
    // slides share the final position). The result is BOTH the page count (its
    // length) and the targets prev()/next() page between. When the content fits
    // the view, maxScroll <= 0 and this collapses to a single snap [0] -> 1 page.
    _measure() {
      const slides = this.track.children;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this._maxScroll = max;

      const base = this.track.offsetLeft;
      // A leading scroll-padding insets the snapport, so a slide rests at the
      // scroll offset of its start MINUS that inset -- subtract it here so a
      // gutter-aligned rail (e.g. the cart drawer, padded track + matching
      // scroll-padding) pages between the gutter positions. scroll-padding
      // defaults to `auto` (-> 0) so this is a no-op for every other carousel.
      const padLeft = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
      const raw = [];
      for (let i = 0; i < slides.length; i++) {
        const offset = slides[i].offsetLeft - base - padLeft;
        raw.push(Math.min(Math.max(offset, 0), max));
      }
      raw.sort((a, b) => a - b);

      const snaps = [];
      for (let i = 0; i < raw.length; i++) {
        if (i === 0 || raw[i] - snaps[snaps.length - 1] > 1) snaps.push(raw[i]);
      }
      if (!snaps.length) snaps.push(0);
      // Guarantee the end is reachable as the final page.
      if (max - snaps[snaps.length - 1] > 1) snaps.push(max);
      this.snaps = snaps;

      this._syncPages(snaps.length);
      this._renderedIndex = -1;
      this._render();
    }

    // Reconcile the indicator to the current page count: hide it when there is a
    // single page (nothing to scroll), and add/remove dot/dash items to match.
    _syncPages(pages) {
      pages = Math.max(1, pages);
      this.total = pages;

      // Hide via inline style so it wins over any consumer stylesheet rule
      // (e.g. product-card's absolutely-positioned mobile scrub line) regardless
      // of specificity; restore by clearing the inline value.
      if (this.indicatorWrap) {
        this.indicatorWrap.style.display = pages <= 1 ? "none" : "";
      }

      const ind = this.indicator;
      if (!ind) return;
      ind.dataset.total = pages;

      // Dot/dash render one item per page -- add/remove to match. Number/progress
      // re-derive from this.total when rendered.
      if (
        !ind.classList.contains("carousel-indicator--number") &&
        !ind.classList.contains("carousel-indicator--progress")
      ) {
        const items = ind.querySelectorAll(".carousel-indicator__item");
        for (let i = pages; i < items.length; i++) items[i].remove();
        for (let i = items.length; i < pages; i++) {
          const item = document.createElement("span");
          item.className = "carousel-indicator__item";
          item.setAttribute("aria-hidden", "true");
          ind.appendChild(item);
        }
      }
    }

    // The active page: the largest snap at or before the current scroll position
    // (+1px tolerance). This hysteresis -- a page stays active until scroll
    // crosses the NEXT snap -- is what kills the index flicker on fast/jittery
    // swipes (vs. picking the nearest snap by absolute distance every frame).
    _activeIndex() {
      const pos = this._scrollPos();
      let idx = 0;
      for (let i = 0; i < this.snaps.length; i++) {
        if (this.snaps[i] <= pos + 1) idx = i;
        else break;
      }
      return idx;
    }

    // Live, per-frame reflection: boundary attrs (consumers disable arrows at the
    // ends) + the indicator's active page. Cheap and layout-free; the discrete
    // indicators (dot/dash/number) only repaint when the page actually changes,
    // while a progress fill tracks the raw scroll position every frame.
    _render() {
      const max = this._maxScroll;
      const pos = this._scrollPos();

      this.toggleAttribute("data-at-start", pos <= 1);
      this.toggleAttribute("data-at-end", max <= 0 || pos >= max - 1);

      const idx = this._activeIndex();
      if (idx !== this._renderedIndex) {
        this._renderedIndex = idx;
        this._updateIndicator(idx);
      }

      // A progress scrub line must follow the gesture continuously and
      // symmetrically -- page-quantizing it only advanced on forward scroll at
      // the NEXT snap (laggy), while backward updated immediately (in sync).
      if (this._isProgressIndicator) this._updateProgress(pos, idx);
    }

    // Continuous progress fill: interpolate a fractional page position between
    // the two bracketing snaps and keep the same `(page + 1) / total` mapping the
    // discrete path used, so the resting value on each page is unchanged -- only
    // the movement between pages is now smooth.
    _updateProgress(pos, idx) {
      const snaps = this.snaps;
      const total = this.total;
      let pageProgress;
      if (idx >= snaps.length - 1) {
        pageProgress = snaps.length - 1;
      } else {
        const span = snaps[idx + 1] - snaps[idx]; // snaps are >1px apart (see _measure)
        const frac = span > 0 ? (pos - snaps[idx]) / span : 0;
        pageProgress = idx + Math.min(Math.max(frac, 0), 1);
      }
      const pct = total > 0 ? ((pageProgress + 1) / total) * 100 : 0;
      this.indicator.style.setProperty("--ci-progress", `${pct}%`);
    }

    // Settled state: commit the index and announce the change. Fires
    // carousel:change only when the resting page actually changed.
    _commit() {
      if (this._rafScroll) {
        cancelAnimationFrame(this._rafScroll);
        this._rafScroll = 0;
      }
      this._render();
      const idx = this._activeIndex();
      if (idx === this.index) return;

      this.index = idx;
      this.dataset.index = idx;
      this.dispatchEvent(
        new CustomEvent("carousel:change", {
          bubbles: true,
          detail: { index: idx, total: this.total },
        }),
      );
    }

    _updateIndicator(index) {
      const ind = this.indicator;
      if (!ind) return;

      const current = index + 1;
      const total = this.total;
      const pad = (n) => String(n).padStart(2, "0");

      ind.dataset.current = current;
      ind.setAttribute("aria-label", `Slide ${current} of ${total}`);

      // Progress fill is driven continuously in _updateProgress (every scroll
      // frame), not here -- this per-page path only owns dot/dash/number state
      // plus the data-current/aria-label announce set above.
      if (ind.classList.contains("carousel-indicator--number")) {
        const count = ind.querySelector(".carousel-indicator__count");
        if (count) count.textContent = `${pad(current)} / ${pad(total)}`;
      } else if (!ind.classList.contains("carousel-indicator--progress")) {
        const items = ind.querySelectorAll(".carousel-indicator__item");
        items.forEach((item, i) => {
          item.classList.toggle("carousel-indicator__item--active", i === index);
        });
      }
    }

    // Page to the adjacent snap relative to the LIVE scroll position (not an
    // index counter), so prev()/next() stay correct mid-fling and after a resize.
    // No reachable snap in that direction -> no-op (already at the edge).
    next() {
      const pos = this._scrollPos();
      const target = this.snaps.find((x) => x > pos + 1);
      if (target != null) {
        this._scrollTo(target);
      } else if (this._maxScroll > 1 && pos < this._maxScroll - 1) {
        // Fallback for a scrollable track with no further snap: page ~85%.
        this.track.scrollBy({ left: this.track.clientWidth * 0.85, behavior: this._behavior() });
      }
    }

    prev() {
      const pos = this._scrollPos();
      let target = null;
      for (let i = this.snaps.length - 1; i >= 0; i--) {
        if (this.snaps[i] < pos - 1) {
          target = this.snaps[i];
          break;
        }
      }
      if (target != null) {
        this._scrollTo(target);
      } else if (pos > 1) {
        this.track.scrollBy({ left: -this.track.clientWidth * 0.85, behavior: this._behavior() });
      }
    }

    _scrollTo(left, behavior) {
      this.track.scrollTo({ left, behavior: behavior || this._behavior() });
    }

    // Reveal a descendant slide by aligning its leading edge to the snapport
    // when it is outside the current view. Public API for consumers that select
    // a slide programmatically; pass { instant: true } when the consumer already
    // handled the interaction and only needs visibility restored.
    scrollToChild(el, opts) {
      if (!this.track || !el) return;
      const slide = el.closest(".carousel__slide");
      if (!slide || !this.track.contains(slide)) return;
      const base = this.track.offsetLeft;
      const padLeft = parseFloat(getComputedStyle(this.track).scrollPaddingLeft) || 0;
      const start = slide.offsetLeft - base - padLeft;
      const end = start + slide.offsetWidth;
      const viewStart = this._scrollPos();
      const viewEnd = viewStart + this.track.clientWidth;
      if (start >= viewStart && end <= viewEnd) return;
      this._scrollTo(
        Math.min(Math.max(start, 0), this._maxScroll),
        opts && opts.instant ? "auto" : undefined,
      );
    }

    // Desktop-only drag shim; touch devices keep native scrolling.
    _initClickDrag() {
      const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) return;

      this._isDragging = false;
      this._hasDragged = false;
      this._startX = 0;
      this._startScrollLeft = 0;
      this._dragSamples = [];
      this._momentumRaf = null;
      this._snapTimer = null;

      this._onMouseDown = (e) => {
        if (this._momentumRaf) {
          cancelAnimationFrame(this._momentumRaf);
          this._momentumRaf = null;
        }
        if (this._snapTimer) {
          clearTimeout(this._snapTimer);
          this._snapTimer = null;
        }
        this._isDragging = true;
        this._hasDragged = false;
        this._startX = e.pageX;
        this._startScrollLeft = this.track.scrollLeft;
        this._dragSamples = [{ x: e.pageX, t: Date.now() }];
        this.track.style.scrollSnapType = "none";
        this.setAttribute("data-dragging", "");
      };

      this._onMouseMove = (e) => {
        if (!this._isDragging) return;
        e.preventDefault();
        const delta = e.pageX - this._startX;
        if (Math.abs(delta) > 5) this._hasDragged = true;
        this.track.scrollLeft = this._startScrollLeft - delta;

        const now = Date.now();
        this._dragSamples.push({ x: e.pageX, t: now });
        if (this._dragSamples.length > 3) this._dragSamples.shift();
      };

      this._onMouseUp = () => {
        if (!this._isDragging) return;
        this._isDragging = false;
        this.removeAttribute("data-dragging");

        const samples = this._dragSamples;
        let velocity = 0;
        if (samples.length >= 2) {
          const first = samples[0];
          const last = samples[samples.length - 1];
          const dt = last.t - first.t;
          if (dt > 0) velocity = (last.x - first.x) / dt;
        }

        if (Math.abs(velocity) > 0.5) {
          const friction = 0.95;
          let lastFrame = Date.now();
          const animate = () => {
            const now = Date.now();
            const elapsed = now - lastFrame;
            lastFrame = now;
            velocity *= friction;
            this.track.scrollLeft -= velocity * elapsed;
            if (Math.abs(velocity) > 0.5) {
              this._momentumRaf = requestAnimationFrame(animate);
            } else {
              this._momentumRaf = null;
              this._snapToNearest();
            }
          };
          this._momentumRaf = requestAnimationFrame(animate);
        } else {
          this._snapToNearest();
        }
      };

      this._onClickCapture = (e) => {
        if (this._hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          this._hasDragged = false;
        }
      };

      this.track.addEventListener("mousedown", this._onMouseDown);
      window.addEventListener("mousemove", this._onMouseMove);
      window.addEventListener("mouseup", this._onMouseUp);
      this.track.addEventListener("click", this._onClickCapture, true);
    }

    // After a drag, settle on the snap closest to the current position, then
    // restore native snapping.
    _snapToNearest() {
      const pos = this._scrollPos();
      let best = this.snaps[0] || 0;
      let bestDist = Infinity;
      for (const snap of this.snaps) {
        const dist = Math.abs(snap - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = snap;
        }
      }
      this.track.style.scrollSnapType = "";
      this._scrollTo(best);

      this._snapTimer = setTimeout(() => {
        this._snapTimer = null;
        this._commit();
      }, 350);
    }

    _destroyClickDrag() {
      if (!this._onMouseDown) return;
      if (this._momentumRaf) {
        cancelAnimationFrame(this._momentumRaf);
        this._momentumRaf = null;
      }
      if (this._snapTimer) {
        clearTimeout(this._snapTimer);
        this._snapTimer = null;
      }
      this.track?.removeEventListener("mousedown", this._onMouseDown);
      window.removeEventListener("mousemove", this._onMouseMove);
      window.removeEventListener("mouseup", this._onMouseUp);
      this.track?.removeEventListener("click", this._onClickCapture, true);
    }
  }

  // The component registry can load this script before or alongside rendered
  // carousels, so guard the custom element definition.
  if (!customElements.get("x-carousel")) {
    customElements.define("x-carousel", XCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-line-item"] && !Shopify.designMode) return;
  try {
    class XCartLineItem extends HTMLElement {
    connectedCallback() {
      if (!this._onSizeChange) this._onSizeChange = this._dispatchVariantChange.bind(this);
      // The shared `size-select` snippet emits size-select:change (and mirrors its own
      // visible value); re-dispatch it as the cart's variant-change contract.
      this.addEventListener("size-select:change", this._onSizeChange);
    }

    disconnectedCallback() {
      this.removeEventListener("size-select:change", this._onSizeChange);
    }

    // Line identity and quantity are read at dispatch time, never cached: the cart
    // runtime reconciles a re-render INTO this element, so a cart change updates these
    // attributes in place without the element being constructed again.
    _dispatchVariantChange(event) {
      var to = event.detail ? event.detail.value : null;
      if (!to) return;
      var quantity = parseInt(this.dataset.quantity, 10);
      if (isNaN(quantity)) quantity = 1;
      this.dispatchEvent(
        new CustomEvent("cart-line-item:change-variant", {
          bubbles: true,
          detail: {
            lineId: this.dataset.lineId || null,
            fromVariantId: this.dataset.variantId || null,
            toVariantId: String(to),
            quantity: quantity,
          },
        }),
      );
    }
  }

  if (!customElements.get("x-cart-line-item")) {
    customElements.define("x-cart-line-item", XCartLineItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkbox"] && !Shopify.designMode) return;
  try {
    // The .checkbox--indeterminate class is a STATIC render hint for the dash
  // visual (HTML cannot express indeterminate declaratively). The moment the
  // user clicks, the browser sets checked = true and clears the input's
  // indeterminate property -- but the static class would linger and conflict
  // with the now-live :checked state, rendering BOTH a tick and a dash. Drop
  // the marker (and its data flag) on first change so the real DOM state alone
  // drives the visual from then on. Delegated once at the document level.
  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(".checkbox__input")) return;
    var control = input.closest(".checkbox--indeterminate");
    if (control) {
      control.classList.remove("checkbox--indeterminate");
      input.removeAttribute("data-indeterminate");
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coveo-density-toggle"] && !Shopify.designMode) return;
  try {
    /*
   * Delegated clicks keep the nearest `.coveo-results` density and the buttons'
   * `aria-pressed` states in sync. A guarded IIFE works in local theme dev where
   * custom elements do not upgrade; Liquid renders the default `multi` state.
   */
  (function () {
    if (window.__coveoDensityToggleBound) return;
    window.__coveoDensityToggleBound = true;

    function apply(container, density) {
      var results = container.closest(".coveo-results");
      if (results) results.setAttribute("data-grid-density", density);
      var btns = container.querySelectorAll("[data-coveo-density-set]");
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var on = b.getAttribute("data-coveo-density-set") === density;
        b.setAttribute("aria-pressed", on ? "true" : "false");
      }
    }

    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest("[data-coveo-density-set]");
      if (!btn) return;
      var container = btn.closest("[data-coveo-density-toggle]");
      if (!container) return;
      apply(container, btn.getAttribute("data-coveo-density-set"));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coveo-filters-drawer"] && !Shopify.designMode) return;
  try {
    /*
   * Deferred/staged controller for the Coveo filters drawer. It owns sort, string facets,
   * price brackets and the chip row while sharing the commerce engine the results surface uses.
   *
   * A second surface controller is a pure observer. Apply/Clear dispatch the required state
   * actions and then one search/listing request; success rehydrates from the fulfilled response,
   * while failure keeps the staged target available for retry.
   */
  (function () {
    var HEADLESS_CDN = "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
    var DRAWER_ID = "coveo-filters-drawer";
    // Sortable field names (org-index config). ec_promo_price = the effective price
    // (promotional price when on sale, else the regular price; populated for every product),
    // so price sort matches the price facet and the card's displayed price. shpcreatedat =
    // the Shopify connector's product-creation date.
    var PRICE_SORT_FIELD = "ec_promo_price";
    var DATE_SORT_FIELD = "shpcreatedat";
    // Rows a dynamic facet shows before its "Show More" toggle; the design fixes it at five.
    var FACET_VISIBLE_LIMIT = 5;

    // Fields whose facet values render colour swatches instead of checkboxes. Values are
    // `Name-HEX`; the option composes the `swatch` component as the selectable control.
    var COLOUR_FACET_FIELDS = {
      ec_color: true,
      true_colour: true,
      colour: true,
      color: true,
    };
    // Fields whose facet values are sizes. Coveo orders facet values by count, alphabet or
    // relevance only, none of which puts "4 / XXXS" before "12 / M" or keeps shoe sizes
    // together, so these facets are re-ordered client-side (see compareSizeValues).
    var SIZE_FACET_FIELDS = {
      size_facet: true,
      shp_variant_title: true,
      cat_size: true,
      size: true,
    };
    // Letter-size rank shared with the size-sort snippet and the quick-add sorter, so the
    // facet lists letters in the same order as every other size surface.
    var SIZE_ALPHA_ORDER = ["xxxxs", "xxxs", "xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl", "xxxxl"];

    if (window.__coveoFiltersBound) return;
    window.__coveoFiltersBound = true;

    // Resolve the shared engine without a timeout: the drawer may stay inert if Coveo never
    // publishes, but it must bind after a slow token mint. The event is deterministic; the poll
    // below only catches an engine published just before the listener attaches.
    function resolveEngine() {
      if (window.__coveoEngine) return Promise.resolve(window.__coveoEngine);
      return new Promise(function (resolve) {
        var settled = false;
        function done(engine) {
          if (settled || !engine) return;
          settled = true;
          resolve(engine);
        }
        document.addEventListener(
          "coveo:engine-ready",
          function (e) {
            done((e && e.detail && e.detail.engine) || window.__coveoEngine);
          },
          { once: true },
        );
        // Stop polling after a generous window, leaving the event listener armed for late engines.
        var waited = 0,
          step = 100,
          cap = 15000;
        var timer = setInterval(function () {
          waited += step;
          if (window.__coveoEngine) {
            clearInterval(timer);
            done(window.__coveoEngine);
          } else if (waited >= cap) {
            clearInterval(timer);
          }
        }, step);
      });
    }

    function parseJSON(str, fallback) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return fallback;
      }
    }

    function FiltersController() {
      this.host = document.querySelector("x-coveo-filters");
      var cfgEl = document.querySelector("[data-coveo-facet-config]");
      var cfg = cfgEl ? parseJSON(cfgEl.textContent, {}) : {};
      this.labels = cfg.labels || {};
      this.captions = cfg.captions || {};

      // Merchant facet-value denylist, parsed once from the raw textarea. `excludeAll` holds
      // values hidden from every facet; `excludeByField` scopes a value to one facet field/id.
      // Keys are lowercased so matching is case-insensitive, mirroring valueCaption().
      this.excludeAll = {};
      this.excludeByField = {};
      var excludeRaw = cfg.excludeRaw;
      if (typeof excludeRaw === "string" && excludeRaw) {
        excludeRaw.split(/\r?\n/).forEach(function (line) {
          var entry = line.trim();
          if (!entry) return;
          var idx = entry.indexOf(":");
          if (idx > 0) {
            var field = entry.slice(0, idx).trim().toLowerCase();
            var scoped = entry.slice(idx + 1).trim().toLowerCase();
            if (!scoped) return;
            (this.excludeByField[field] = this.excludeByField[field] || {})[scoped] = true;
          } else {
            this.excludeAll[entry.toLowerCase()] = true;
          }
        }, this);
      }

      this.overlay = document.querySelector('[data-overlay-id="' + DRAWER_ID + '"]');
      var content = this.overlay ? this.overlay.querySelector("[data-overlay-content]") : null;
      this.content = content;

      // Chips reflect the pending selection and head the drawer's scroll region.
      this.chips = this.overlay ? this.overlay.querySelector("[data-coveo-chips]") : null;
      this.list = this.chips ? this.chips.querySelector("[data-coveo-chips-list]") : null;
      this.chipTpl = this.list ? this.list.querySelector("[data-coveo-chip-template]") : null;
      this.viewAll = this.chips ? this.chips.querySelector("[data-coveo-chips-toggle]") : null;

      // Sort (markup-only accordion + radios).
      this.sortWrap = content ? content.querySelector("[data-coveo-sort]") : null;
      this.sortRadios = this.sortWrap
        ? Array.prototype.slice.call(
            this.sortWrap.querySelectorAll('input[type="radio"][name="sort"]'),
          )
        : [];
      this.sortDefault = (this.sortWrap && this.sortWrap.dataset.default) || "relevance";

      // Price (markup-only accordion + fixed bracket checkboxes).
      this.priceWrap = content ? content.querySelector("[data-coveo-price]") : null;
      this.priceInputs = this.priceWrap
        ? Array.prototype.slice.call(
            this.priceWrap.querySelectorAll('input[type="checkbox"][name="coveo-price"]'),
          )
        : [];
      this.priceField = (this.priceWrap && this.priceWrap.dataset.field) || "ec_price";
      this.priceMaxCap = this.priceWrap ? parseFloat(this.priceWrap.dataset.maxCap) : NaN;
      if (isNaN(this.priceMaxCap)) this.priceMaxCap = 9999999.99;

      // Dynamic string-facet container + clone templates.
      this.facetsBox = content ? content.querySelector("[data-coveo-facets]") : null;
      var facetTplEl = content ? content.querySelector("[data-coveo-facet-template]") : null;
      var optTplEl = content ? content.querySelector("[data-coveo-option-template]") : null;
      var colourOptTplEl = content
        ? content.querySelector("[data-coveo-colour-option-template]")
        : null;
      this.facetTplHTML = facetTplEl ? facetTplEl.innerHTML.trim() : "";
      this.optTplHTML = optTplEl ? optTplEl.innerHTML.trim() : "";
      this.colourOptTplHTML = colourOptTplEl ? colourOptTplEl.innerHTML.trim() : "";

      // Footer controls + trigger-bar badge outside the overlay.
      this.clearBtn = this.overlay ? this.overlay.querySelector("[data-coveo-clear]") : null;
      this.applyBtn = this.overlay ? this.overlay.querySelector("[data-coveo-apply]") : null;
      this.badge = document.querySelector("[data-coveo-active-filter-count]");

      // Coveo controllers (set once the engine resolves). Every dispatch goes through the SAME
      // engine the controllers were built from: reading window.__coveoEngine again at commit
      // time would silently split staged state from the store the request is built out of.
      this.engine = null;
      this.mod = null;
      this.listing = null;
      this.parameterManager = null;
      this.facetGen = null;
      this.summary = null;
      this.sort = null;

      // Staged state is the source of truth for controls and chips; the trigger-bar badge mirrors
      // committed state. `price` stores one entry per selected Coveo range value.
      this.pending = { facets: {}, price: [], sort: this.sortDefault };
      this.facetSig = ""; // structural signature so counts-only changes don't rebuild
      this.expanded = false; // chip "View all" expanded flag

      // Commit lifecycle: one request at a time, with pending state retained on failure.
      this.committing = false;
      this.drawerOpen = !!(this.overlay && this.overlay.querySelector("dialog[open]"));
      this.dirty = false;
      this.failed = false;
      this.facetsReady = false;
      this.responsePending = false;
    }

    FiltersController.prototype.start = function () {
      // Chrome wiring is engine-independent so the overlay still opens when Coveo is unavailable.
      this.wireChrome();
      var self = this;
      resolveEngine().then(function (engine) {
        if (!engine) return;
        self.engine = engine;
        import(HEADLESS_CDN)
          .then(function (mod) {
            self.mod = mod;
            // Use the controller for this drawer's surface. Search and product-listing controllers
            // expose the same facet/summary/sort/parameterManager family; only the builder differs.
            var surface =
              (self.host && self.host.dataset && self.host.dataset.surface) || "product-listing";
            var buildController = surface === "search" ? mod.buildSearch : mod.buildProductListing;
            if (typeof buildController !== "function") return;
            self.listing = buildController(engine);
            self.facetGen = self.listing.facetGenerator();
            self.summary = self.listing.summary();
            if (typeof self.listing.sort === "function") self.sort = self.listing.sort();
            if (typeof self.listing.parameterManager === "function") {
              self.parameterManager = self.listing.parameterManager();
            }
            var state = self.listing.state || {};
            var summaryState = self.summary.state || {};
            self.responsePending = !!state.isLoading;
            if (!state.isLoading && !state.error && summaryState.firstRequestExecuted) {
              self.facetsReady = true;
              self.initPending();
            }
            self.listing.subscribe(self.onStateChange.bind(self));
            self.render();
          })
          .catch(function () {
            /* module/engine unavailable - drawer stays inert chrome */
          });
      });
    };

    // ---- controller lookups -------------------------------------------------

    FiltersController.prototype.facets = function () {
      return (this.facetGen && this.facetGen.facets) || [];
    };
    // Regular string facets (checkbox lists), price + non-regular types excluded, ordered.
    // Facet order follows the Coveo response: the generator instantiates controllers in the
    // order the Commerce API returns facets, which is the Merchandising Hub order including pins.
    // Price is not here; it renders as a separate fixed slot after the dynamic facets.
    FiltersController.prototype.stringFacets = function () {
      var self = this;
      return this.facets().filter(function (f) {
        var s = f && f.state;
        return s && s.type === "regular" && s.field !== self.priceField;
      });
    };
    FiltersController.prototype.priceFacet = function () {
      var self = this;
      return (
        this.facets().find(function (f) {
          return f && f.state && f.state.field === self.priceField;
        }) || null
      );
    };

    // ---- init / hydrate pending from the APPLIED state ----------------------

    FiltersController.prototype.initPending = function () {
      this.pending = { facets: {}, price: [], sort: this.sortDefault };
      if (this.sort && this.sort.state) {
        this.pending.sort = this.valueForApplied(this.sort.state.appliedSort);
      }
      this.stringFacets().forEach(function (f) {
        var sel = (f.state.values || [])
          .filter(function (v) {
            return v.state === "selected";
          })
          .map(function (v) {
            return String(v.value);
          });
        if (sel.length) this.pending.facets[f.state.facetId] = toSet(sel);
      }, this);
      // Hydrate price from every applied Coveo range value.
      this.pending.price = this.bracketsSelected();
    };

    // Only a completed request can replace the structural facet set. URL-restored initial
    // responses hydrate a closed/clean drawer, while dirty or failed pending targets survive.
    FiltersController.prototype.onStateChange = function () {
      var state = (this.listing && this.listing.state) || {};
      var summaryState = (this.summary && this.summary.state) || {};
      if (state.isLoading) {
        this.responsePending = true;
        this.facetsReady = false;
      } else if (state.error) {
        this.responsePending = false;
        this.facetsReady = false;
      } else if (this.responsePending && summaryState.firstRequestExecuted) {
        this.responsePending = false;
        this.facetsReady = true;
        if (!this.committing && !this.failed && (!this.drawerOpen || !this.dirty)) {
          this.initPending();
        }
      }
      this.render();
    };

    // ---- render (controls reflect PENDING; badge reflects APPLIED) ----------

    FiltersController.prototype.render = function () {
      this.renderFacets();
      this.syncSort();
      this.syncPrice();
      this.renderChips();
      this.updateBadge();
    };

    FiltersController.prototype.syncSort = function () {
      var val = this.pending.sort;
      this.sortRadios.forEach(function (r) {
        var on = r.value === val;
        if (r.checked !== on) r.checked = on;
      });
    };

    FiltersController.prototype.syncPrice = function () {
      var sel = this.pending.price || [];
      this.priceInputs.forEach(function (inp) {
        var on = sel.some(function (p) {
          return this.priceInputMatches(inp, p);
        }, this);
        if (inp.checked !== on) inp.checked = on;
      }, this);
    };

    FiltersController.prototype.priceInputMatches = function (inp, p) {
      var rs = parseFloat(inp.dataset.rangeStart);
      var reRaw = inp.dataset.rangeEnd;
      var open = reRaw === "" || reRaw == null;
      if (rs !== p.start) return false;
      if (open) return p.end == null || p.end >= this.priceMaxCap || p.end >= rs;
      return parseFloat(reRaw) === p.end;
    };

    // Build/refresh the dynamic string-facet accordions. Full rebuild only when the facet SET
    // (ids + value labels) changes; otherwise just refresh counts, so an Apply/Clear that only
    // changes counts never collapses an accordion the shopper opened.
    FiltersController.prototype.renderFacets = function () {
      if (!this.facetsBox || !this.facetTplHTML || !this.optTplHTML) return;
      if (!this.facetsReady || this.committing || (this.drawerOpen && this.dirty)) {
        this.syncFacetControls();
        return;
      }
      var facets = this.stringFacets();
      var sig = facets
        .map(function (f) {
          return (
            f.state.facetId +
            ":" +
            (f.state.values || [])
              .map(function (v) {
                return v.value;
              })
              .join(",")
          );
        })
        .join("|");

      if (sig !== this.facetSig) {
        // Preserve open accordions and "Show Less" states across a rebuild.
        var openIds = this.openFacetIds();
        var expandedIds = this.expandedFacetIds();
        this.facetsBox.textContent = "";
        facets.forEach(function (f) {
          this.buildFacet(f, openIds, expandedIds);
        }, this);
        this.facetSig = sig;
      } else {
        this.refreshCounts(facets);
      }
      this.syncFacetControls();
    };

    FiltersController.prototype.syncFacetControls = function () {
      if (!this.facetsBox) return;
      var inputs = this.facetsBox.querySelectorAll("input[data-facet-id]");
      for (var i = 0; i < inputs.length; i++) {
        var fid = inputs[i].getAttribute("data-facet-id");
        var want = this.pending.facets[fid];
        var on = !!want && want[String(inputs[i].value)] === true;
        if (inputs[i].checked !== on) inputs[i].checked = on;
      }
      var swatches = this.facetsBox.querySelectorAll("[data-swatch][data-facet-id]");
      for (var j = 0; j < swatches.length; j++) {
        var swatchFid = swatches[j].getAttribute("data-facet-id");
        var swatchWant = this.pending.facets[swatchFid];
        this.setSwatchSelected(
          swatches[j],
          !!swatchWant &&
            swatchWant[String(swatches[j].getAttribute("data-swatch-value"))] === true,
        );
      }
    };

    FiltersController.prototype.openFacetIds = function () {
      var out = {};
      if (!this.facetsBox) return out;
      var accs = this.facetsBox.querySelectorAll("x-accordion[data-facet-id]");
      for (var i = 0; i < accs.length; i++) {
        if (accs[i].classList.contains("accordion--open"))
          out[accs[i].getAttribute("data-facet-id")] = true;
      }
      return out;
    };

    FiltersController.prototype.expandedFacetIds = function () {
      var out = {};
      if (!this.facetsBox) return out;
      var toggles = this.facetsBox.querySelectorAll('[data-facet-toggle][aria-expanded="true"]');
      for (var i = 0; i < toggles.length; i++) {
        var acc = toggles[i].closest("x-accordion[data-facet-id]");
        if (acc) out[acc.getAttribute("data-facet-id")] = true;
      }
      return out;
    };

    // A collapsed facet hides rows past FACET_VISIBLE_LIMIT through one class on the value list,
    // so toggling is a class flip plus the button's label and aria-expanded. Nothing here touches
    // pending state or the engine. A hidden toggle means the facet has no overflow to clamp.
    FiltersController.prototype.setFacetExpanded = function (acc, expanded) {
      if (!acc) return;
      var toggle = acc.querySelector("[data-facet-toggle]");
      var valuesBox = acc.querySelector("[data-facet-values]");
      if (!toggle || !valuesBox) return;
      if (toggle.hidden) {
        valuesBox.classList.remove("coveo-facet__values--collapsed");
        return;
      }
      valuesBox.classList.toggle("coveo-facet__values--collapsed", !expanded);
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      var more = toggle.getAttribute("data-label-more") || "Show More";
      var less = toggle.getAttribute("data-label-less") || "Show Less";
      var labelEl = toggle.querySelector(".btn__label");
      if (labelEl) labelEl.textContent = expanded ? less : more;
    };

    FiltersController.prototype.collapseAllFacets = function () {
      if (!this.facetsBox) return;
      var accs = this.facetsBox.querySelectorAll("x-accordion[data-facet-id]");
      for (var i = 0; i < accs.length; i++) this.setFacetExpanded(accs[i], false);
    };

    // Marks rows past FACET_VISIBLE_LIMIT as overflow and shows the toggle only when there is
    // overflow. Each option template renders one root element per value, so a child index is a
    // value index; if the two counts ever diverge the facet renders unclamped rather than hiding
    // the wrong rows.
    FiltersController.prototype.applyFacetLimit = function (acc, valuesBox, count, fid, expanded) {
      var toggle = acc.querySelector("[data-facet-toggle]");
      if (!toggle || !valuesBox) return;
      var rows = valuesBox.children;
      var clampable = count > FACET_VISIBLE_LIMIT && rows.length === count;
      valuesBox.id = "facet-values-" + fid;
      toggle.setAttribute("aria-controls", valuesBox.id);
      for (var i = 0; i < rows.length; i++) {
        if (clampable && i >= FACET_VISIBLE_LIMIT) rows[i].setAttribute("data-facet-overflow", "");
        else rows[i].removeAttribute("data-facet-overflow");
      }
      toggle.hidden = !clampable;
      this.setFacetExpanded(acc, expanded);
    };

    FiltersController.prototype.buildFacet = function (facet, openIds, expandedIds) {
      var s = facet.state;
      var fid = s.facetId;
      var self = this;
      // Drop denylisted values before rendering. When a facet's every value is denylisted,
      // render no accordion rather than an empty one.
      var vals = (s.values || []).filter(function (v) {
        return !self.isExcluded(fid, s.field, v.value);
      });
      if (!vals.length) return;
      // Size facets sort on the caption-resolved label so a caption can never break the order.
      if (SIZE_FACET_FIELDS[s.field]) {
        vals.sort(function (a, b) {
          return compareSizeValues(
            self.valueCaption(fid, s.field, a.value),
            self.valueCaption(fid, s.field, b.value),
          );
        });
      }
      var title = this.facetTitle(fid, s.field, s.displayName);
      var wrap = document.createElement("div");
      wrap.innerHTML = this.facetTplHTML
        .split("__TITLE__")
        .join(escapeHTML(title))
        .split("__FID__")
        .join(escapeAttr(fid));
      var acc = wrap.firstElementChild;
      if (!acc) return;
      acc.setAttribute("data-facet-id", fid);

      var valuesBox = acc.querySelector("[data-facet-values]");
      // Colour facets render the `swatch` component in place of checkboxes: split the
      // `Name-HEX` value into the family name and dot colour.
      var isColour = this.isColourFacet(facet) && !!this.colourOptTplHTML;
      var optHTML = vals
        .map(function (v, i) {
          if (isColour) {
            var parts = splitColourValue(v.value);
            return self.colourOptTplHTML
              .split("__HEX__")
              .join(escapeAttr(parts.hex || "transparent"))
              .split("__VALUE__")
              .join(escapeAttr(v.value))
              .split("__LABEL__")
              .join(escapeHTML(parts.name))
              .split("__COUNT__")
              .join(escapeHTML(v.numberOfResults != null ? v.numberOfResults : ""));
          }
          var caption = self.valueCaption(fid, s.field, v.value);
          return self.optTplHTML
            .split("__NAME__")
            .join(escapeAttr("facet-" + fid))
            .split("__VALUE__")
            .join(escapeAttr(v.value))
            .split("__LABEL__")
            .join(escapeHTML(caption))
            .split("__COUNT__")
            .join(escapeHTML(v.numberOfResults != null ? v.numberOfResults : ""));
        })
        .join("");
      if (valuesBox) valuesBox.innerHTML = optHTML;
      this.applyFacetLimit(acc, valuesBox, vals.length, fid, !!(expandedIds && expandedIds[fid]));

      if (isColour) {
        // Stamp data-facet-id on each swatch <button> so the click delegate + pending sync
        // map it back to its facet (the button already carries data-swatch-value).
        var swatches = acc.querySelectorAll("[data-swatch]");
        for (var si = 0; si < swatches.length; si++) {
          swatches[si].setAttribute("data-facet-id", fid);
        }
      } else {
        // Stamp data-facet-id + unique ids on each option so the change delegate + pending
        // sync can map an input back to its facet + value.
        var labels = acc.querySelectorAll(".checkbox");
        for (var i = 0; i < labels.length; i++) {
          var input = labels[i].querySelector(".checkbox__input");
          if (!input) continue;
          input.setAttribute("data-facet-id", fid);
          var uid = "facet-" + fid + "-" + i;
          input.id = uid;
          labels[i].setAttribute("for", uid);
        }
      }

      this.facetsBox.appendChild(acc); // appending upgrades <x-accordion> (collapsed by default)
      if (openIds && openIds[fid] && typeof acc.open === "function") acc.open();
    };

    FiltersController.prototype.refreshCounts = function (facets) {
      facets.forEach(function (f) {
        var fid = f.state.facetId;
        var isColour = this.isColourFacet(f) && !!this.colourOptTplHTML;
        (f.state.values || []).forEach(function (v) {
          if (isColour) {
            var btn = this.facetsBox.querySelector(
              '[data-swatch][data-facet-id="' +
                cssEsc(fid) +
                '"][data-swatch-value="' +
                cssEsc(String(v.value)) +
                '"]',
            );
            var row = btn ? btn.closest("[data-coveo-swatch-option]") : null;
            var cEl = row ? row.querySelector(".coveo-facet__swatch-count") : null;
            if (cEl)
              cEl.textContent = "(" + (v.numberOfResults != null ? v.numberOfResults : "") + ")";
            return;
          }
          var input = this.facetsBox.querySelector(
            'input[data-facet-id="' + cssEsc(fid) + '"][value="' + cssEsc(String(v.value)) + '"]',
          );
          if (!input) return;
          var label = input.closest(".checkbox");
          var countEl = label ? label.querySelector(".checkbox__count") : null;
          if (countEl)
            countEl.textContent = "(" + (v.numberOfResults != null ? v.numberOfResults : "") + ")";
        }, this);
      }, this);
    };

    FiltersController.prototype.facetTitle = function (facetId, field, displayName) {
      return this.labels[facetId] || this.labels[field] || displayName || facetId;
    };
    FiltersController.prototype.valueCaption = function (facetId, field, value) {
      var byField = this.captions[field] || this.captions[facetId];
      if (byField) {
        var key = String(value).toLowerCase();
        if (byField[key] != null) return byField[key];
      }
      return String(value);
    };
    FiltersController.prototype.isExcluded = function (facetId, field, value) {
      var v = String(value).toLowerCase();
      if (this.excludeAll[v]) return true;
      var byField =
        this.excludeByField[String(field).toLowerCase()] ||
        this.excludeByField[String(facetId).toLowerCase()];
      return !!(byField && byField[v]);
    };

    // ---- chips (mirror PENDING) --------------------------------------------

    FiltersController.prototype.renderChips = function () {
      if (!this.chips || !this.chipTpl) return;
      var entries = [];
      var self = this;
      Object.keys(this.pending.facets).forEach(function (fid) {
        var set = self.pending.facets[fid];
        Object.keys(set).forEach(function (val) {
          if (set[val] !== true) return;
          entries.push({ key: fid + "::" + val, label: self.chipLabelFor(fid, val) });
        });
      });
      (this.pending.price || []).forEach(function (p) {
        entries.push({ key: "price::" + p.start, label: p.label });
      });

      // Clear previous pills (keep the template).
      if (this.list) {
        var stale = this.list.querySelectorAll("[data-tag]");
        for (var i = 0; i < stale.length; i++) stale[i].parentNode.removeChild(stale[i]);
      }
      if (!entries.length) {
        this.chips.hidden = true;
        this.applyOverflow();
        return;
      }
      this.chips.hidden = false;

      var html = this.chipTpl.innerHTML;
      entries.forEach(function (e) {
        var markup = html
          .split("__LABEL__")
          .join(escapeHTML(e.label))
          .split("__VALUE__")
          .join(escapeAttr(e.key));
        var holder = document.createElement("div");
        holder.innerHTML = markup.trim();
        var chip = holder.firstElementChild;
        if (chip && self.list) self.list.appendChild(chip);
      });

      var c = this;
      requestAnimationFrame(function () {
        c.applyOverflow();
      });
    };

    // The chip label for a pending facet value: the value's caption (found in the rendered
    // option), else the raw value.
    FiltersController.prototype.chipLabelFor = function (facetId, value) {
      var f = this.stringFacets().find(function (x) {
        return x.state.facetId === facetId;
      });
      // Colour chips show the family name, not the raw `Name-HEX` value.
      if (f && this.isColourFacet(f)) return splitColourValue(value).name;
      var input = this.facetsBox
        ? this.facetsBox.querySelector(
            'input[data-facet-id="' + cssEsc(facetId) + '"][value="' + cssEsc(value) + '"]',
          )
        : null;
      if (input) {
        var label = input.closest(".checkbox");
        var text = label ? label.querySelector(".checkbox__label") : null;
        if (text && text.textContent) return text.textContent.trim();
      }
      if (f) return this.valueCaption(facetId, f.state.field, value);
      return value;
    };

    // ---- badge (mirrors APPLIED / committed state) --------------------------

    // The trigger-bar badge reflects the APPLIED (committed) filter count. WHILE a commit is
    // draining, it holds at the intended (pending) count instead, so a multi-step commit doesn't
    // flicker through the intermediate per-step counts (it jumps straight to the final total).
    FiltersController.prototype.updateBadge = function () {
      if (!this.badge) return;
      var n = this.committing ? this.pendingBadgeCount() : this.appliedBadgeCount();
      if (n > 0) {
        this.badge.textContent = String(n);
        this.badge.hidden = false;
      } else {
        this.badge.textContent = "";
        this.badge.hidden = true;
      }
    };
    FiltersController.prototype.appliedBadgeCount = function () {
      var n = 0;
      this.stringFacets().forEach(function (f) {
        n += (f.state.values || []).filter(function (v) {
          return v.state === "selected";
        }).length;
      });
      var pf = this.priceFacet();
      if (pf)
        n += (pf.state.values || []).filter(function (v) {
          return v.state === "selected";
        }).length;
      return n;
    };
    FiltersController.prototype.pendingBadgeCount = function () {
      var n = 0,
        self = this;
      Object.keys(this.pending.facets).forEach(function (fid) {
        Object.keys(self.pending.facets[fid]).forEach(function (v) {
          if (self.pending.facets[fid][v] === true) n += 1;
        });
      });
      // Price counts each staged bracket, matching appliedBadgeCount so the badge holds steady during commit.
      if (this.pending.price && this.pending.price.length) n += this.pending.price.length;
      return n;
    };

    // ---- sort criterion mapping --------------------------------------------

    FiltersController.prototype.criterionFor = function (value) {
      var mod = this.mod;
      if (!mod) return null;
      switch (value) {
        case "relevance":
          return mod.buildRelevanceSortCriterion();
        case "price_asc":
          return mod.buildFieldsSortCriterion([{ name: PRICE_SORT_FIELD, direction: "asc" }]);
        case "price_desc":
          return mod.buildFieldsSortCriterion([{ name: PRICE_SORT_FIELD, direction: "desc" }]);
        case "newest":
          return mod.buildFieldsSortCriterion([{ name: DATE_SORT_FIELD, direction: "desc" }]);
        default:
          return null;
      }
    };
    FiltersController.prototype.valueForApplied = function (applied) {
      if (!applied) return this.sortDefault;
      if (applied.by === "relevance") return "relevance";
      if (applied.by === "fields" && applied.fields && applied.fields.length) {
        var f = applied.fields[0] || {};
        var name = f.name || f.field;
        var dir = f.direction === "desc" ? "desc" : "asc";
        if (name === PRICE_SORT_FIELD) return dir === "desc" ? "price_desc" : "price_asc";
        if (name === DATE_SORT_FIELD) return "newest";
      }
      return this.sortDefault;
    };

    // ---- price bracket labels ----------------------------------------------

    // Hydrate pending price brackets from applied Coveo range values. Each selected bracket stays
    // discrete so non-adjacent ranges do not collapse into one span.
    FiltersController.prototype.bracketsSelected = function () {
      var pf = this.priceFacet(),
        out = [],
        self = this;
      if (!pf) return out;
      (pf.state.values || []).forEach(function (v) {
        if (v.state !== "selected") return;
        var end = v.end == null || v.end >= self.priceMaxCap ? null : v.end;
        for (var i = 0; i < self.priceInputs.length; i++) {
          if (self.priceInputMatches(self.priceInputs[i], { start: v.start, end: end })) {
            out.push({
              start: v.start,
              end: end,
              label: self.priceLabelForInput(self.priceInputs[i]),
            });
            break;
          }
        }
      });
      return out;
    };

    // ---- commit path (single-flight, exactly one request) -------------------
    //
    // Public facet/sort actions update request state without fetching. Apply and Clear validate
    // every loader first, dispatch the required state actions synchronously, then dispatch one
    // surface thunk. Its resolved RTK action is the only completion signal: success rehydrates
    // from the authoritative response, while failure retains the pending target for an
    // idempotent retry against the current live controller state.

    // Snapshot the staged target so it cannot change while its request is in flight.
    FiltersController.prototype.clonePending = function () {
      var facets = {};
      for (var k in this.pending.facets) {
        if (!Object.prototype.hasOwnProperty.call(this.pending.facets, k)) continue;
        facets[k] = {};
        for (var v in this.pending.facets[k]) {
          if (this.pending.facets[k][v] === true) facets[k][v] = true;
        }
      }
      var priceArr = (this.pending.price || []).map(function (p) {
        return { start: p.start, end: p.end, label: p.label };
      });
      return {
        facets: facets,
        price: priceArr,
        sort: this.pending.sort,
      };
    };

    FiltersController.prototype.apply = function () {
      if (this.committing) return;
      this.commit("apply", this.clonePending(), true);
    };

    FiltersController.prototype.clear = function () {
      if (this.committing) return;
      this.pending = { facets: {}, price: [], sort: this.sortDefault };
      this.dirty = true;
      this.render();
      this.commit("clear", this.clonePending(), false);
    };

    FiltersController.prototype.loadCommitActions = function () {
      var mod = this.mod;
      var engine = this.engine;
      var surface =
        (this.host && this.host.dataset && this.host.dataset.surface) || "product-listing";
      var surfaceLoader = surface === "search" ? "loadSearchActions" : "loadProductListingActions";
      var surfaceAction = surface === "search" ? "executeSearch" : "fetchProductListing";
      if (
        !mod ||
        !engine ||
        typeof mod.loadRegularFacetActions !== "function" ||
        typeof mod.loadNumericFacetActions !== "function" ||
        typeof mod.loadCoreFacetActions !== "function" ||
        typeof mod.loadSortActions !== "function" ||
        typeof mod[surfaceLoader] !== "function"
      ) {
        throw new Error("Coveo commit action loaders are unavailable");
      }
      var actions = {
        surface: surface,
        regular: mod.loadRegularFacetActions(engine),
        numeric: mod.loadNumericFacetActions(engine),
        core: mod.loadCoreFacetActions(engine),
        sort: mod.loadSortActions(engine),
        fetch: mod[surfaceLoader](engine)[surfaceAction],
      };
      if (
        !actions.regular ||
        typeof actions.regular.toggleSelectFacetValue !== "function" ||
        !actions.numeric ||
        typeof actions.numeric.toggleSelectNumericFacetValue !== "function" ||
        !actions.core ||
        typeof actions.core.clearAllCoreFacets !== "function" ||
        !actions.sort ||
        typeof actions.sort.applySort !== "function" ||
        typeof actions.fetch !== "function"
      ) {
        throw new Error("Coveo commit actions are unavailable");
      }
      return actions;
    };

    // Diff Apply against live request parameters on every attempt. If a rejected attempt already
    // changed some Redux state, retry produces no duplicate toggles for those values.
    FiltersController.prototype.stateActionsFor = function (kind, pending, actions) {
      var managerState = this.parameterManager && this.parameterManager.state;
      var parameters = managerState && managerState.parameters;
      if (!parameters) throw new Error("Coveo parameter manager is unavailable");

      var currentFacets = parameters.f || {};
      var currentNumeric = parameters.nf || {};
      var out = [];
      var self = this;
      if (kind === "clear") {
        out.push(actions.core.clearAllCoreFacets());
      } else {
        this.stringFacets().forEach(function (f) {
          var facetId = f.state.facetId;
          var selectedValues = currentFacets[facetId] || [];
          var want = pending.facets[facetId] || {};
          (f.state.values || []).forEach(function (v) {
            var selected = selectedValues.indexOf(String(v.value)) !== -1;
            var shouldSelect = want[String(v.value)] === true;
            if (selected !== shouldSelect) {
              out.push(
                actions.regular.toggleSelectFacetValue({
                  facetId: facetId,
                  selection: v,
                }),
              );
            }
          });
        });
        var priceFacet = this.priceFacet();
        if (priceFacet) {
          var priceFacetId = priceFacet.state.facetId;
          var selectedPrices = currentNumeric[priceFacetId] || [];
          var wantedPrices = pending.price || [];
          (priceFacet.state.values || []).forEach(function (v) {
            var end = v.end == null || v.end >= self.priceMaxCap ? null : v.end;
            var selected = selectedPrices.some(function (p) {
              var selectedEnd = p.end == null || p.end >= self.priceMaxCap ? null : p.end;
              return p.start === v.start && selectedEnd === end;
            });
            var shouldSelect = wantedPrices.some(function (p) {
              return p.start === v.start && p.end === end;
            });
            if (selected !== shouldSelect) {
              out.push(
                actions.numeric.toggleSelectNumericFacetValue({
                  facetId: priceFacetId,
                  selection: v,
                }),
              );
            }
          });
        }
      }
      if (pending.sort !== this.valueForApplied(parameters.sortCriteria)) {
        var criterion = this.criterionFor(pending.sort);
        if (!criterion) throw new Error("Coveo sort criterion is unavailable");
        out.push(actions.sort.applySort(criterion));
      }
      return out;
    };

    FiltersController.prototype.commit = function (kind, target, closeOnSuccess) {
      if (this.committing) return Promise.resolve(false);
      var engine = this.engine;
      var actions;
      var stateActions;
      var fetchThunk;
      try {
        actions = this.loadCommitActions();
        stateActions = this.stateActionsFor(kind, target, actions);
        // Both surfaces return products only through the action's no-option path; passing
        // `enableResults` to search yields a response carrying a count but an empty product list.
        fetchThunk = actions.fetch();
      } catch (error) {
        this.commitFailed(target, error);
        return Promise.resolve(false);
      }

      var request;
      try {
        for (var i = 0; i < stateActions.length; i++) engine.dispatch(stateActions[i]);
        request = engine.dispatch(fetchThunk);
        if (!request || typeof request.then !== "function") {
          throw new Error("Coveo request is not thenable");
        }
      } catch (error) {
        this.commitFailed(target, error);
        return Promise.resolve(false);
      }
      this.pending = target;
      this.committing = true;
      this.failed = false;
      this.facetsReady = false;
      this.setBusy(true);
      this.updateBadge();

      var self = this;
      try {
        return request.then(
          function (result) {
            if (!result || !result.meta || result.meta.requestStatus !== "fulfilled") {
              self.commitFailed(
                target,
                (result && result.error) || new Error("Coveo request did not fulfill"),
              );
              return false;
            }
            var payload = result.payload;
            if (!payload || !payload.response || !Array.isArray(payload.response.facets)) {
              self.commitFailed(target, new Error("Coveo fulfilled response has no facet set"));
              return false;
            }
            self.commitSucceeded(closeOnSuccess);
            return true;
          },
          function (error) {
            self.commitFailed(target, error);
            return false;
          },
        );
      } catch (error) {
        this.commitFailed(target, error);
        return Promise.resolve(false);
      }
    };

    FiltersController.prototype.commitSucceeded = function (closeOnSuccess) {
      this.committing = false;
      this.failed = false;
      this.dirty = false;
      this.responsePending = false;
      this.facetsReady = true;
      this.initPending();
      this.setBusy(false);
      this.render();
      if (closeOnSuccess) this.closeDrawer();
    };

    FiltersController.prototype.commitFailed = function (target, error) {
      this.pending = target;
      this.committing = false;
      this.failed = true;
      this.dirty = true;
      this.responsePending = false;
      this.facetsReady = false;
      this.setBusy(false);
      this.render();
      this.openDrawer();
      if (window.console && typeof window.console.error === "function") {
        window.console.error("[coveo-filters] commit failed", error);
      }
    };

    FiltersController.prototype.setBusy = function (busy) {
      if (this.applyBtn) this.applyBtn.disabled = busy;
      if (this.clearBtn) this.clearBtn.disabled = busy;
      if (this.overlay) this.overlay.setAttribute("aria-busy", busy ? "true" : "false");
    };

    // Chip removal only UNSTAGES (deferred - no query). A `price::<start>` key
    // clears the staged bracket.
    FiltersController.prototype.removeValue = function (key) {
      if (!key || this.committing) return;
      if (key.indexOf("price::") === 0) {
        var start = parseFloat(key.slice(7));
        this.pending.price = (this.pending.price || []).filter(function (p) {
          return p.start !== start;
        });
        this.dirty = true;
        this.render();
        return;
      }
      var sep = key.indexOf("::");
      if (sep < 0) return;
      var fid = key.slice(0, sep);
      var val = key.slice(sep + 2);
      if (this.pending.facets[fid]) {
        delete this.pending.facets[fid][val];
        if (!Object.keys(this.pending.facets[fid]).length) delete this.pending.facets[fid];
      }
      this.dirty = true;
      this.render();
    };

    // ---- chrome wiring ------------------------------------------------------

    FiltersController.prototype.wireChrome = function () {
      var self = this;
      if (!this.overlay) return;

      // Keep the trigger aria-expanded in sync. Clean drawers rehydrate on open; dirty edits and
      // failed targets remain untouched until commit succeeds or the shopper abandons them.
      var trigger = document.querySelector("[data-coveo-filters-trigger]");
      document.addEventListener("overlay:open", function (e) {
        if (!e.detail || e.detail.id !== DRAWER_ID) return;
        self.drawerOpen = true;
        if (trigger) trigger.setAttribute("aria-expanded", "true");
        self.expanded = false;
        self.collapseAllFacets();
        if (self.facetsReady && !self.committing && !self.dirty && !self.failed) {
          self.initPending();
        }
        self.render();
      });
      document.addEventListener("overlay:close", function (e) {
        if (!e.detail || e.detail.id !== DRAWER_ID) return;
        self.drawerOpen = false;
        if (!self.committing && !self.failed) self.dirty = false;
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      });

      // Staged edits (no query): sort radio, price brackets (multi-select union), facet checkboxes.
      if (this.content) {
        this.content.addEventListener("change", function (e) {
          var t = e.target;
          if (!t || !t.matches) return;
          // If the engine/facets never resolve, the drawer is inert chrome: native control toggles
          // do not become chips or pending values.
          if (!self.facetGen || self.committing) return;
          if (t.matches('input[type="radio"][name="sort"]')) {
            if (t.checked) {
              self.pending.sort = t.value;
              self.dirty = true;
            }
            return;
          }
          if (t.matches('input[type="checkbox"][name="coveo-price"]')) {
            self.onPriceChange(t);
            return;
          }
          if (t.matches(".checkbox__input[data-facet-id]")) {
            self.onFacetChange(t);
            return;
          }
        });

        // Colour swatches use click, not change. Delegate from the row so the full option is the
        // hit target while the swatch button remains the accessible control.
        this.content.addEventListener("click", function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          // "Show More" / "Show Less" is drawer-local, so it works even while a commit is in flight.
          var toggle = t.closest("[data-facet-toggle]");
          if (toggle) {
            self.setFacetExpanded(
              toggle.closest("x-accordion[data-facet-id]"),
              toggle.getAttribute("aria-expanded") !== "true",
            );
            return;
          }
          if (!self.facetGen || self.committing) return;
          var row = t.closest("[data-coveo-swatch-option]");
          if (!row) return;
          var btn = row.querySelector("[data-swatch][data-facet-id]");
          if (btn) self.onSwatchFacetClick(btn);
        });
      }

      // Chip removal (tag:remove bubbles { value, label }).
      this.chips &&
        this.chips.addEventListener("tag:remove", function (e) {
          if (!self.committing) self.removeValue(e.detail && e.detail.value);
        });

      // "View all" chip overflow toggle.
      this.viewAll &&
        this.viewAll.addEventListener("click", function () {
          self.expanded = !self.expanded;
          self.applyOverflow();
        });

      this.clearBtn &&
        this.clearBtn.addEventListener("click", function () {
          if (!self.committing) self.clear();
        });
      this.applyBtn &&
        this.applyBtn.addEventListener("click", function () {
          if (!self.committing) self.apply();
        });
    };

    FiltersController.prototype.onPriceChange = function (input) {
      // Multi-select price brackets are a union of Coveo numerical-range values, not one
      // merged span; each checkbox toggles independently.
      var rs = parseFloat(input.dataset.rangeStart);
      var reRaw = input.dataset.rangeEnd;
      var re = reRaw === "" || reRaw == null ? null : parseFloat(reRaw);
      if (!input.checked) {
        this.pending.price = (this.pending.price || []).filter(function (p) {
          return p.start !== rs;
        });
      } else if (
        !this.pending.price.some(function (p) {
          return p.start === rs;
        })
      ) {
        this.pending.price.push({ start: rs, end: re, label: this.priceLabelForInput(input) });
      }
      this.dirty = true;
      this.syncPrice();
      this.renderChips();
    };
    FiltersController.prototype.priceLabelForInput = function (input) {
      var label = input.closest(".checkbox");
      var text = label ? label.querySelector(".checkbox__label") : null;
      return text && text.textContent ? text.textContent.trim() : input.value;
    };

    FiltersController.prototype.onFacetChange = function (input) {
      var fid = input.getAttribute("data-facet-id");
      var val = String(input.value);
      if (!this.pending.facets[fid]) this.pending.facets[fid] = {};
      if (input.checked) this.pending.facets[fid][val] = true;
      else {
        delete this.pending.facets[fid][val];
        if (!Object.keys(this.pending.facets[fid]).length) delete this.pending.facets[fid];
      }
      this.dirty = true;
      this.renderChips();
    };

    // ---- colour swatch facets ----------------------------------------------

    FiltersController.prototype.isColourFacet = function (facet) {
      var s = facet && facet.state;
      if (!s) return false;
      return COLOUR_FACET_FIELDS[s.field] === true || COLOUR_FACET_FIELDS[s.facetId] === true;
    };

    // The swatch is passive (it never manages its own state): set the Selected ring +
    // aria-pressed from the pending selection, mirroring how the checkbox reflects :checked.
    FiltersController.prototype.setSwatchSelected = function (button, on) {
      if (!button) return;
      button.classList.toggle("swatch--selected", !!on);
      button.setAttribute("aria-pressed", on ? "true" : "false");
    };

    // A colour option click toggles pending selection and the swatch's selected ring. Pending
    // is keyed by the full `Name-HEX` Coveo value, so commit/counts stay unchanged.
    FiltersController.prototype.onSwatchFacetClick = function (button) {
      var fid = button.getAttribute("data-facet-id");
      var val = String(button.getAttribute("data-swatch-value") || "");
      if (!fid) return;
      if (!this.pending.facets[fid]) this.pending.facets[fid] = {};
      var willSelect = this.pending.facets[fid][val] !== true;
      if (willSelect) this.pending.facets[fid][val] = true;
      else {
        delete this.pending.facets[fid][val];
        if (!Object.keys(this.pending.facets[fid]).length) delete this.pending.facets[fid];
      }
      this.dirty = true;
      this.setSwatchSelected(button, willSelect);
      this.renderChips();
    };

    FiltersController.prototype.openDrawer = function () {
      if (this.drawerOpen) return;
      if (typeof this.overlay.open === "function") this.overlay.open();
    };

    FiltersController.prototype.closeDrawer = function () {
      if (typeof this.overlay.close === "function") {
        this.overlay.close();
        return;
      }
      var closeBtn = this.overlay.querySelector("[data-overlay-close]");
      if (closeBtn) closeBtn.click();
    };

    // ---- chip overflow "View all" ------------------------------------------

    FiltersController.prototype.applyOverflow = function () {
      if (!this.list || !this.viewAll) return;
      // Measure at FULL (unclamped) height: drop the clamp first so rowCount sees real rows.
      this.list.classList.remove("coveo-filters__chips--collapsed");
      this.list.style.removeProperty("--chips-clamp");
      var rows = this.rowCount();
      var overflows = rows > 2;
      this.viewAll.hidden = !overflows;
      if (!overflows) {
        this.expanded = false;
        this.setToggleLabel();
        return;
      }
      if (this.expanded) {
        this.list.classList.remove("coveo-filters__chips--collapsed");
      } else {
        var clamp = this.twoRowClampHeight();
        if (clamp > 0) this.list.style.setProperty("--chips-clamp", clamp + "px");
        this.list.classList.add("coveo-filters__chips--collapsed");
      }
      this.setToggleLabel();
    };

    // Count distinct wrapped rows by bucketing each pill's top offset (4px tolerance)
    // so wrapped rows whose layout nudges by sub-pixels still collapse to one bucket.
    FiltersController.prototype.rowCount = function () {
      if (!this.list) return 0;
      var pills = this.list.querySelectorAll("[data-tag]");
      if (!pills.length) return 0;
      var listTop = this.list.getBoundingClientRect().top;
      var buckets = [];
      for (var i = 0; i < pills.length; i++) {
        var top = pills[i].getBoundingClientRect().top - listTop;
        var placed = false;
        for (var j = 0; j < buckets.length; j++) {
          if (Math.abs(buckets[j] - top) <= 4) {
            placed = true;
            break;
          }
        }
        if (!placed) buckets.push(top);
      }
      return buckets.length;
    };

    // The pixel height that clips the list to exactly the first 2 rows: the top
    // offset of the 3rd row (sorted ascending), or 0 when there are <=2 rows.
    FiltersController.prototype.twoRowClampHeight = function () {
      if (!this.list) return 0;
      var pills = this.list.querySelectorAll("[data-tag]");
      if (!pills.length) return 0;
      var listTop = this.list.getBoundingClientRect().top;
      var buckets = [];
      for (var i = 0; i < pills.length; i++) {
        var top = pills[i].getBoundingClientRect().top - listTop;
        var placed = false;
        for (var j = 0; j < buckets.length; j++) {
          if (Math.abs(buckets[j] - top) <= 4) {
            placed = true;
            break;
          }
        }
        if (!placed) {
          buckets.push(top);
        }
      }
      buckets.sort(function (a, b) {
        return a - b;
      });
      if (buckets.length <= 2) return 0;
      return buckets[2];
    };

    // Labels come from data attrs so the cloned button keeps localized copy.
    FiltersController.prototype.setToggleLabel = function () {
      if (!this.viewAll) return;
      var more = this.viewAll.getAttribute("data-label-more") || "View all";
      var less = this.viewAll.getAttribute("data-label-less") || "View less";
      var labelEl = this.viewAll.querySelector(".btn__label");
      if (labelEl) labelEl.textContent = this.expanded ? less : more;
    };

    // ---- helpers ------------------------------------------------------------

    function toSet(arr) {
      var o = {};
      arr.forEach(function (x) {
        o[String(x)] = true;
      });
      return o;
    }
    // Split a `Name-HEX` colour value on the LAST hyphen: a trailing 6-hex segment is the
    // family hex (prepend `#`), the rest is the family name; otherwise the whole string is a
    // name with no dot. Last-hyphen rule survives hyphenated names ("Off White-F4EFE6").
    function splitColourValue(value) {
      var s = String(value);
      var idx = s.lastIndexOf("-");
      if (idx > 0) {
        var tail = s.slice(idx + 1);
        if (/^[0-9a-fA-F]{6}$/.test(tail)) {
          return { name: s.slice(0, idx), hex: "#" + tail.toUpperCase() };
        }
      }
      return { name: s, hex: "" };
    }
    function sizeAlphaRank(token) {
      var i = SIZE_ALPHA_ORDER.indexOf(String(token || "").trim().toLowerCase());
      return i === -1 ? SIZE_ALPHA_ORDER.length : i;
    }

    // Bare numbers from this value up are unconverted EU shoe sizes: apparel numerics are
    // merged into "N / Letter" labels and child ages stop at 16 Yrs, so nothing else is left.
    var SIZE_BARE_SHOE_FROM = 17;

    // Sort key for a size facet label: [band, primary, secondary, label]. Each size scale
    // stays contiguous and the scales run youngest to oldest, then the merchant's table
    // order for the rest: baby zeros, child "N Yrs", bare teen numbers, merged adult
    // "N / Letter", One Size, letter sizes, S/M-style pairs, EU shoe sizes, watch case
    // sizes, numeric ranges, letter ranges, anything else alphabetically, then No Size last.
    // A descending range such as the sock size "13-3" (child 13 to adult 3) is the smallest
    // of its scale and leads the ranges.
    function rankSizeValue(label) {
      var s = String(label == null ? "" : label).trim();
      var lower = s.toLowerCase();
      var m;
      var n;
      if (/^0+$/.test(s)) return [0, -s.length, 0, s];
      if ((m = /^eu\s*(\d+)\s*\/\s*au\s*([\d.]+)$/i.exec(s))) {
        return [7, parseInt(m[1], 10), parseFloat(m[2]) || 0, s];
      }
      if ((m = /^(\d+)(?:\s*-\s*(\d+))?\s*mm$/i.exec(s))) {
        return [8, parseInt(m[1], 10), m[2] ? parseInt(m[2], 10) : 0, s];
      }
      if ((m = /^(\d+)\s*-\s*(\d+)$/.exec(s))) {
        var lo = parseInt(m[1], 10);
        var hi = parseInt(m[2], 10);
        return lo > hi ? [9, -1, lo, s] : [9, lo, hi, s];
      }
      if ((m = /^(\d+)\s+yrs?$/i.exec(s))) return [1, parseInt(m[1], 10), 0, s];
      if ((m = /^(\d+)$/.exec(s))) {
        n = parseInt(m[1], 10);
        return n >= SIZE_BARE_SHOE_FROM ? [7, n, 0, s] : [2, n, 0, s];
      }
      if ((m = /^(\d+)\s*\/\s*[a-z]+$/i.exec(s))) return [3, parseInt(m[1], 10), 0, s];
      if (lower === "one size") return [4, 0, 0, s];
      if (lower === "no size") return [12, 0, 0, s];
      if (sizeAlphaRank(s) < SIZE_ALPHA_ORDER.length) return [5, sizeAlphaRank(s), 0, s];
      if ((m = /^([a-z]+)\s*\/\s*([a-z]+)$/i.exec(s))) return [6, sizeAlphaRank(m[1]), sizeAlphaRank(m[2]), s];
      if ((m = /^([a-z]+)\s*-\s*([a-z]+)$/i.exec(s))) return [10, sizeAlphaRank(m[1]), sizeAlphaRank(m[2]), s];
      return [11, 0, 0, s];
    }

    function compareSizeValues(a, b) {
      var ka = rankSizeValue(a);
      var kb = rankSizeValue(b);
      for (var i = 0; i < 3; i++) {
        if (ka[i] !== kb[i]) return ka[i] - kb[i];
      }
      return ka[3].localeCompare(kb[3], undefined, { numeric: true, sensitivity: "base" });
    }

    function escapeHTML(str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }
    // Attribute-context escape (same set; kept separate for intent/clarity).
    function escapeAttr(str) {
      return escapeHTML(str);
    }
    // Escape a value for use inside a CSS attribute selector "...[value="X"]". Prefer the
    // platform CSS.escape (handles quotes, backslashes, line terminators + every CSS-special
    // char) so a facet value with a newline or quote can't throw a querySelector SyntaxError;
    // fall back to a hardened regex on ancient engines.
    function cssEsc(str) {
      if (window.CSS && typeof window.CSS.escape === "function")
        return window.CSS.escape(String(str));
      return String(str)
        .replace(/(["\\\]])/g, "\\$1")
        .replace(/[\n\r\f]/g, function (c) {
          return "\\" + c.charCodeAt(0).toString(16) + " ";
        });
    }

    function boot() {
      new FiltersController().start();
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coveo-load-more"] && !Shopify.designMode) return;
  try {
    /*
   * Observes the shared Coveo engine and turns Atomic's load-more component into infinite
   * scroll. The controller only reads `state.isLoading` and clicks the component's real
   * `load-more-results-button`; Coveo owns every request.
   */
  (function () {
    var HEADLESS_CDN = "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
    // Start loading before the host reaches the viewport to avoid an empty gap while scrolling.
    var PREFETCH_MARGIN = "600px";

    if (window.__coveoPaginationBound) return;
    window.__coveoPaginationBound = true;

    function resolveEngine() {
      if (window.__coveoEngine) return Promise.resolve(window.__coveoEngine);
      /* Event-first: the engine builder dispatches `coveo:engine-ready` on publish. A slow
         poll remains only as a backstop for a publish that raced the listener attach. */
      return new Promise(function (resolve) {
        var done = false;
        var timer = null;
        function finish(engine) {
          if (done) return;
          done = true;
          document.removeEventListener("coveo:engine-ready", onReady);
          if (timer) clearInterval(timer);
          resolve(engine);
        }
        function onReady(event) {
          finish((event.detail && event.detail.engine) || window.__coveoEngine || null);
        }
        document.addEventListener("coveo:engine-ready", onReady);
        var waited = 0;
        timer = setInterval(function () {
          waited += 1000;
          if (window.__coveoEngine) finish(window.__coveoEngine);
          else if (waited >= 8000) finish(null);
        }, 1000);
      });
    }

    class PlpPagination extends HTMLElement {
      connectedCallback() {
        this.loadMore = this.querySelector("atomic-commerce-load-more-products");
        this.busy = this.querySelector("[data-plp-busy]");
        this.listing = null;
        this.unsubscribe = null;
        this.observer = null;
        this.lastCount = 0;
        // Scope the builder to the interface this pager lives inside so search and product
        // listing surfaces can share the controller without grabbing another Atomic surface.
        var ifaceEl = this.closest("atomic-commerce-interface");
        this.isSearch = !!(ifaceEl && ifaceEl.getAttribute("type") === "search");

        var self = this;
        resolveEngine().then(function (engine) {
          if (!engine || !self.isConnected) return; // Coveo unavailable: leave the region inert.
          import(HEADLESS_CDN)
            .then(function (mod) {
              // A second controller over the same engine is a pure observer; it does not fetch.
              // Both search and product-listing controllers expose `state.isLoading`.
              var buildController = self.isSearch ? mod.buildSearch : mod.buildProductListing;
              if (typeof buildController !== "function") return;
              self.listing = buildController(engine);
              self.unsubscribe = self.listing.subscribe(self.render.bind(self));
              self.setupAutoLoad();
              self.render();
            })
            .catch(function () {
              /* module/engine unavailable - leave the region in its initial state */
            });
        });
      }

      // Atomic's progress UI is hidden, so mirror loading state into the Design System spinner.
      render() {
        if (!this.listing || !this.listing.state) return;
        var state = this.listing.state;
        if (this.busy) this.busy.hidden = !state.isLoading;
        var count = state.products ? state.products.length : 0;
        // A facet/sort change resets the grid to a fresh first page, shrinking the loaded
        // count below where auto-load last ran. That re-opens the accessible-results
        // window, so re-arm the observer the dead-end latch below may have permanently
        // disconnected -- otherwise infinite scroll stays dead for the rest of the page
        // view once a shopper has loaded a collection to its accessible boundary.
        if (!this.observer && this.loadMore && count > 0 && count < this.lastCount) {
          this.awaitingGrowth = false;
          this.setupAutoLoad();
        }
        this.lastCount = count;
        if (state.isLoading) {
          this.sawLoad = true;
        } else if (this.sawLoad) {
          this.sawLoad = false;
          // Past the index's accessible-results window the API returns an EMPTY
          // success while the summary still advertises more products; retriggering
          // would refire that empty request on every approach to the footer,
          // forever. One auto-triggered load that completes without error and
          // without growth marks the dead end; the manual button stays.
          if (this.awaitingGrowth && count <= this.countAtTrigger && !state.error) {
            if (this.observer) this.observer.disconnect();
            this.observer = null;
          }
          this.awaitingGrowth = false;
        }
      }

      // Watch the host and click its shadow trigger near the viewport. Coveo removes the
      // trigger when results are exhausted; if the shadow trigger is inaccessible, auto-load no-ops.
      setupAutoLoad() {
        if (!this.loadMore || typeof IntersectionObserver === "undefined") return;
        var self = this;
        this.observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              // While a back-navigation restore is replaying chunks it owns every
              // fetch; a concurrent auto-trigger would race fetchMoreProducts'
              // page counter and append a duplicate batch. The cooldown covers the
              // settle window right after the restore hands fetching back.
              if (
                window.__coveoPlpRestore ||
                (window.__coveoPlpRestoreCooldownUntil &&
                  Date.now() < window.__coveoPlpRestoreCooldownUntil)
              ) {
                self.deferLoadUntilClear();
                return;
              }
              if (self.listing && self.listing.state && self.listing.state.isLoading) return;
              self.triggerLoadMore();
            });
          },
          { rootMargin: PREFETCH_MARGIN },
        );
        this.observer.observe(this.loadMore);
      }

      // Click Atomic's real "Load more" button inside the host's shadow root. `pagination`
      // (which owns fetchMoreProducts) is internal to the component, so clicking the rendered
      // `load-more-results-button` part is the only reachable trigger. No-op if not present.
      triggerLoadMore() {
        if (!this.loadMore) return;
        var root = this.loadMore.shadowRoot;
        if (!root) return;
        var btn = root.querySelector('[part~="load-more-results-button"]');
        if (btn) {
          this.countAtTrigger =
            this.listing && this.listing.state && this.listing.state.products
              ? this.listing.state.products.length
              : 0;
          this.awaitingGrowth = true;
          btn.click();
        }
      }

      // An intersection swallowed while the restore owned fetching never recurs on
      // its own: the observer only reports crossings, and a host that landed inside
      // the margin stays there. So poll until the restore has handed fetching back
      // (not replaying, past the brief commit cooldown, not loading) and then fire
      // directly -- fetchMoreProducts derives the right page from the committed
      // count. Firing directly, rather than re-observing and waiting on the
      // observer's async re-delivery, is what makes the footer feel immediate.
      // Guarded so it only fires while the host is genuinely near the viewport; if
      // the shopper has scrolled it away, re-observe and let the next crossing win.
      deferLoadUntilClear() {
        if (this.deferTimer) return;
        var self = this;
        this.deferTimer = setInterval(function () {
          if (!self.observer || !self.loadMore || !self.isConnected) {
            clearInterval(self.deferTimer);
            self.deferTimer = null;
            return;
          }
          if (window.__coveoPlpRestore) return;
          if (
            window.__coveoPlpRestoreCooldownUntil &&
            Date.now() < window.__coveoPlpRestoreCooldownUntil
          )
            return;
          var st = self.listing && self.listing.state;
          if (st && st.isLoading) return;
          clearInterval(self.deferTimer);
          self.deferTimer = null;
          var rect = self.loadMore.getBoundingClientRect();
          if (rect.top < window.innerHeight + 600) {
            self.triggerLoadMore();
          } else {
            self.observer.unobserve(self.loadMore);
            self.observer.observe(self.loadMore);
          }
        }, 50);
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === "function") this.unsubscribe();
        this.unsubscribe = null;
        if (this.observer) this.observer.disconnect();
        this.observer = null;
        if (this.deferTimer) clearInterval(this.deferTimer);
        this.deferTimer = null;
      }
    }

    if (!customElements.get("x-plp-pagination")) {
      customElements.define("x-plp-pagination", PlpPagination);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coveo-product-card"] && !Shopify.designMode) return;
  try {
    /* Coveo card delegator: document-level handlers cross open Atomic shadow roots for
       wishlist, quick-add, swatches, gallery, price, badges, promo, analytics, and late-card healing. */
  (function () {
    if (window.__coveoProductCardBound) return;
    window.__coveoProductCardBound = true;

    var productCache = {}; /* live /products/<handle>.js payloads, keyed by handle */
    /* A long hover session across a large grid would otherwise cache one full payload per
       hovered card forever; evict oldest-first past the cap. The evicted handle re-fetches
       on the next interaction. */
    var PRODUCT_CACHE_MAX = 40;
    var productCacheOrder = [];
    var liveWaiters =
      {}; /* pending callbacks per in-flight handle (dedupes the ONE interaction fetch) */
    var bundlePairCache = {}; /* {price, compareAt} (dollars) or null per bundle handle */
    var bundleWaiters = {}; /* pending callbacks per in-flight bundle handle */
    /* One MutationObserver per host runs all per-host re-heals, so a shadow mutation
       wakes a single callback for swatches, pricing, badges, promo, chips, gallery, and
       wishlist. Keyed to the observer instance so a removed host's observer can be
       disconnected alongside the Intersection/Resize releases. */
    var hostObservers = new WeakMap();

    /* Card label strings live on the light-DOM `[data-pc-card-l10n]` carrier (one per
       render site, all byte-identical -- the first suffices); per-card data attributes
       remain only as the compact-card fallback. */
    function cardLabel(fallbackEl, name) {
      var l10n = document.querySelector("[data-pc-card-l10n]");
      var value = l10n ? l10n.getAttribute(name) : null;
      if (value == null && fallbackEl) value = fallbackEl.getAttribute(name);
      return value || "";
    }

    /* The card CSS is parsed ONCE into a constructed sheet per card kind and adopted by
       reference into every card root. The full card's source is the light-DOM
       `template[data-pc-card-css]` (the stamped template carries no style at all); the
       compact card still stamps its own `<style data-pc-card-css>`, which is lifted the same
       way and removed. The shared sheet is PREPENDED so Atomic's own adopted sheets stay
       after it -- the vendor sheet must keep winning its documented equal-specificity ties
       (desktop sale price stacking), exactly as it did when the card CSS was a tree
       stylesheet. Engines without constructed sheets get one cloned <style> per root. */
    var cardSheets = typeof Map !== "undefined" ? new Map() : null;
    var cardCssText = {};
    /* An EMPTY root (host inserted, template not yet stamped) resolves to the full card:
       the sheet must be adopted before the stamp, because Atomic forces a layout of the
       freshly stamped card ahead of any microtask -- an unstyled first layout collapses
       every card to a few dozen pixels, the document shrinks and the browser moves the
       scroll position before the styles land. The compact card stamps its own style and
       lifts it separately, and its class names never collide with the full card's, so
       pre-adopting the full sheet there is inert. */
    function cardKindOf(root, styleEl) {
      if (styleEl) return styleEl.getAttribute("data-pc-card-css") || "pcard";
      if (root.querySelector(".pcard-c")) return "pcard-c";
      return "pcard";
    }
    function cardCssFor(kind, styleEl) {
      if (styleEl) return styleEl.textContent;
      if (cardCssText[kind] != null) return cardCssText[kind];
      var tpl = document.querySelector('template[data-pc-card-css="' + kind + '"]');
      var src = tpl && tpl.content ? tpl.content.querySelector("style") : null;
      cardCssText[kind] = src ? src.textContent : "";
      return cardCssText[kind];
    }
    /* See the `:host([data-pc-settling])` rule in the card sheet: transitions are
       disabled for the two frames after a root first receives its styles, so
       controls that start hidden settle instantly rather than fading out. */
    function markSettling(host) {
      host.setAttribute("data-pc-settling", "");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          host.removeAttribute("data-pc-settling");
        });
      });
    }
    function adoptCardStyles(host) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var styleEl = root.querySelector("style[data-pc-card-css]");
      var constructed =
        cardSheets && typeof CSSStyleSheet !== "undefined" && "adoptedStyleSheets" in root;
      try {
        if (!constructed) {
          /* Fallback: one cloned <style> per root, once the card is stamped (a clone
             placed into an empty root could be swept by the vendor's first render). */
          if (styleEl || root.__pcCardStyleCloned || !root.firstElementChild) return;
          var kindF = cardKindOf(root, null);
          var cssF = kindF ? cardCssFor(kindF, null) : "";
          if (!cssF) return;
          var clone = document.createElement("style");
          clone.textContent = cssF;
          root.insertBefore(clone, root.firstChild);
          root.__pcCardStyleCloned = true;
          markSettling(host);
          return;
        }
        var kind = cardKindOf(root, styleEl);
        var known = root.__pcCardSheet;
        /* A root styled while its shadow tree was still empty resolves to the full card
           (cardKindOf's empty-root default), so a compact card whose host is pre-adopted
           before Atomic stamps its template latches the full sheet. Once the stamp reveals
           its own `data-pc-card-css`, drop the mismatched sheet and adopt the right one --
           otherwise the compact card keeps only the inert `.pcard*` rules and loses its own
           `<style>` to the removal below. */
        if (known && kind && root.__pcCardKind !== kind) {
          var stale = Array.prototype.slice.call(root.adoptedStyleSheets);
          var at = stale.indexOf(known);
          if (at !== -1) {
            stale.splice(at, 1);
            root.adoptedStyleSheets = stale;
          }
          known = root.__pcCardSheet = null;
        }
        var adopted = Array.prototype.slice.call(root.adoptedStyleSheets);
        if (!known) {
          if (!kind) return;
          var sheet = cardSheets.get(kind);
          if (!sheet) {
            var css = cardCssFor(kind, styleEl);
            if (!css) return;
            sheet = new CSSStyleSheet();
            sheet.replaceSync(css);
            cardSheets.set(kind, sheet);
          }
          known = root.__pcCardSheet = sheet;
          root.__pcCardKind = kind;
          markSettling(host);
        }
        /* Re-assert membership on every pass in case the vendor reassigned the adopted
           list, so a card can never lose its styles. */
        if (adopted.indexOf(known) === -1) root.adoptedStyleSheets = [known].concat(adopted);
        /* Lift the inline <style> only once the adopted sheet is this style's own kind, so a
           pre-adopted compact card never has its rules stripped before its real sheet lands. */
        if (styleEl && root.__pcCardKind === styleEl.getAttribute("data-pc-card-css")) {
          styleEl.remove();
        }
      } catch (err) {
        /* constructed sheets blocked -- a stamped inline style, where present, keeps working */
      }
    }

    /* `style_group_siblings` parse memo. Keyed off the product object itself: store products
       arrive frozen, so writing the memo onto the product silently fails and the multi-KB
       JSON would re-parse on every heal. */
    var siblingsMemo = typeof WeakMap !== "undefined" ? new WeakMap() : null;

    /* Deferred slide images: a far-from-viewport gallery build stores every slide's URL
       in data attributes instead of `src` (browser lazy-loading cannot hold these back --
       see initGallery). Hydrating a card's lead grants it an eager src and returns its
       sibling slides to ordinary lazy loading, restoring the near-viewport behaviour. */
    function grantImgSrc(img, loading) {
      if (!img || !img.dataset || !img.dataset.pcSrc) return;
      if (img.dataset.pcSrcset) {
        img.srcset = img.dataset.pcSrcset;
        img.sizes = img.dataset.pcSizes || "";
        delete img.dataset.pcSrcset;
        delete img.dataset.pcSizes;
      }
      img.loading = loading;
      img.src = img.dataset.pcSrc;
      delete img.dataset.pcSrc;
    }
    function hydrateLeadImg(img) {
      grantImgSrc(img, "eager");
    }
    /* Low-priority grant for the hover/swipe swap target: loads the second slide
       before the shopper reveals it, but behind the eager visible leads so it never
       delays them. */
    function preloadSwapImg(img) {
      if (!img || !img.dataset || !img.dataset.pcSrc) return;
      try {
        img.fetchPriority = "low";
      } catch (e) {
        /* attribute unsupported -- the load still happens, just not deprioritised */
      }
      // Eager, not lazy: proximity is already decided by swapIO, and a translated
      // off-axis slide never satisfies the browser's own lazy heuristic, so it would
      // otherwise never load until interaction -- the very gap this preload closes.
      // fetchPriority low keeps it behind the visible leads.
      grantImgSrc(img, "eager");
    }
    /* Non-lead slides stay deferred until the shopper interacts with the gallery
       (hover, arrow, swipe, keys): granting them any earlier lets slow-connection lazy
       thresholds prefetch whole carousels and starve the visible images. */
    function grantTrackSlides(track) {
      if (!track || track.__pcSlidesGranted) return;
      track.__pcSlidesGranted = true;
      var pending = track.querySelectorAll("img[data-pc-src]");
      for (var i = 0; i < pending.length; i++) {
        // Interaction beat the proximity preload: release the swap observer's
        // pending reference so it does not fire on an already-granted image.
        if (swapIO) {
          try {
            swapIO.unobserve(pending[i]);
          } catch (e) {}
        }
        grantImgSrc(pending[i], "eager");
      }
    }
    var leadIO = window.IntersectionObserver
      ? new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              leadIO.unobserve(entries[i].target);
              hydrateLeadImg(entries[i].target);
            }
          },
          { rootMargin: "900px", threshold: 0 },
        )
      : null;
    /* Preloads the hover/swipe swap target (slide 1) when the card is genuinely
       near the viewport -- a tighter margin than the lead's, so a deep grid does not
       preload every card's second image, only the ones about to be interactable.
       Same on desktop (hover) and touch (swipe): the swap is instant, no white gap. */
    var swapIO = window.IntersectionObserver
      ? new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              swapIO.unobserve(entries[i].target);
              preloadSwapImg(entries[i].target);
            }
          },
          { rootMargin: "250px", threshold: 0 },
        )
      : null;
    window.__pcHydrateLeadImg = hydrateLeadImg;

    /* One ResizeObserver serves every gallery track. Tracks are unobserved when a rebuild
       or Lit re-render replaces them, so the observer never pins a detached track alive. */
    var galleryROCallbacks = typeof WeakMap !== "undefined" ? new WeakMap() : null;
    var galleryRO =
      window.ResizeObserver && galleryROCallbacks
        ? new ResizeObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              var fn = galleryROCallbacks.get(entries[i].target);
              if (fn) fn();
            }
          })
        : null;

    /* Hover tier is pointer-capability based, not width-only. Wide touch devices cannot
       reliably use hover-revealed controls, while a newly connected mouse should work
       without a reload. */
    function hoverTier() {
      if (!window.matchMedia) return true;
      return (
        window.matchMedia("(min-width: 769px)").matches &&
        window.matchMedia("(hover: hover)").matches
      );
    }

    /* The live /products/<handle>.js fetch is reserved for quick-add interactions that need
       current stock and numeric ids. It is deduped per handle and never runs on card load. */
    function ensureLiveProduct(handle, cb) {
      if (!handle) {
        if (cb) cb(null);
        return;
      }
      if (productCache[handle]) {
        if (cb) cb(productCache[handle]);
        return;
      }
      if (liveWaiters[handle]) {
        if (cb) liveWaiters[handle].push(cb);
        return;
      }
      liveWaiters[handle] = cb ? [cb] : [];
      fetch(rootUrl() + "products/" + handle + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.ok ? res.json() : Promise.reject(res);
        })
        .then(function (product) {
          productCache[handle] = product;
          productCacheOrder.push(handle);
          while (productCacheOrder.length > PRODUCT_CACHE_MAX) {
            var evicted = productCacheOrder.shift();
            if (evicted !== handle) delete productCache[evicted];
          }
          var waiters = liveWaiters[handle] || [];
          delete liveWaiters[handle];
          for (var i = 0; i < waiters.length; i++) waiters[i](product);
        })
        .catch(function () {
          var waiters = liveWaiters[handle] || [];
          delete liveWaiters[handle];
          for (var i = 0; i < waiters.length; i++) waiters[i](null);
        });
    }

    /* Bundle cards use the shared bundle-price lookup because indexed parent price is not the bundle total. */
    function ensureBundlePair(handle, cb) {
      if (!handle) {
        cb(null);
        return;
      }
      if (bundlePairCache[handle] !== undefined) {
        cb(bundlePairCache[handle]);
        return;
      }
      if (bundleWaiters[handle]) {
        bundleWaiters[handle].push(cb);
        return;
      }
      bundleWaiters[handle] = [cb];
      var settle = function (pair) {
        bundlePairCache[handle] = pair;
        var waiters = bundleWaiters[handle] || [];
        delete bundleWaiters[handle];
        for (var i = 0; i < waiters.length; i++) waiters[i](pair);
      };
      fetch(rootUrl() + "products/" + handle + "?view=bundle-price")
        .then(function (res) {
          return res.ok ? res.text() : Promise.reject(res);
        })
        .then(function (text) {
          var parts = String(text).trim().split("|");
          var show = parseInt(parts[0], 10);
          var compare = parseInt(parts[1], 10);
          if (isNaN(show)) {
            settle(null);
            return;
          } /* blank body -- not a bundle after all */
          settle({ price: show / 100, compareAt: compare > show ? compare / 100 : null });
        })
        .catch(function () {
          settle(null);
        });
    }

    function rootUrl() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return "/";
    }

    /* Resolve the product handle from the card's atomic-product-link <a> href
       (.../products/<handle>[?...]). */
    function handleForCard(card) {
      var anchor = card.querySelector("atomic-product-link a, .pcard__name a");
      if (!anchor) return "";
      var href = anchor.getAttribute("href") || "";
      var match = href.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : "";
    }

    /* ---- Coveo product access -------------------------------------
       Read host.product fresh because Lit can update it without replacing the host. */
    function hostFor(card) {
      return (card && card.getRootNode && card.getRootNode().host) || null;
    }
    function coveoProduct(host) {
      return host && host.product ? host.product : null;
    }
    /* Coveo returns custom fields under additionalFields; a few standard ec_*
       fields also sit top-level. Read additionalFields first, fall back to
       top-level so either shape resolves. */
    function cfield(product, key) {
      if (!product) return undefined;
      var a = product.additionalFields;
      if (a && a[key] != null) return a[key];
      return product[key];
    }

    /* Tags usually arrive as an array; accept comma-strings defensively. */
    function coveoTags(product) {
      var tags = cfield(product, "tags");
      if (typeof tags === "string") tags = tags.split(",");
      if (!Array.isArray(tags)) return [];
      return tags
        .map(function (t) {
          return String(t).trim();
        })
        .filter(Boolean);
    }
    function tagsHave(product, needle) {
      var n = String(needle).toLowerCase();
      return coveoTags(product).some(function (t) {
        return t.toLowerCase() === n;
      });
    }
    /* Tagged bundles are purchasable even when Shopify does not inventory-track them; Coveo
       quantity can otherwise look sold out. */
    function coveoInStock(src, parent) {
      if (!src) return false;
      if (tagsHave(src, "bundle") || (parent && tagsHave(parent, "bundle"))) return true;
      return !(src.ec_in_stock === false || src.ec_in_stock === "false");
    }
    /* Product-level stock: purchasable when the parent variant, any variant of the product's
       own sibling entry, or any child of the same product is in stock. The pipeline filters by
       product, so the variant Coveo promotes as the parent can itself be a sold-out size; the
       entry carries every variant of the product and `children` the indexed ones, so the union
       is the product's true state whichever of the two the response carries. */
    function productInStock(product) {
      if (!product) return false;
      if (coveoInStock(product)) return true;
      var entry = ownSiblingEntry(product);
      if (entry && !siblingOOS(entry)) return true;
      var own = ownHandleOf(product);
      var kids = product.children || [];
      for (var i = 0; i < kids.length; i++) {
        var kidHandle = String(cfield(kids[i], "product_handle") || "");
        if (own && kidHandle && kidHandle !== own) continue;
        if (coveoInStock(kids[i], product)) return true;
      }
      return false;
    }
    /* Numeric id from a Shopify GID (…/ProductVariant/52604653535552 -> 52604653535552).
       SeedWishlist + the cart controller key on numeric ids, but Coveo carries GIDs. */
    function numericId(gid) {
      var m = String(gid == null ? "" : gid).match(/(\d+)\s*$/);
      return m ? m[1] : "";
    }

    /* First available variant id (numeric) from a sibling entry, else the first variant's.
       Shared by wishlist identity and select-item analytics so both key on the same variant. */
    function siblingVariantNum(entry) {
      var vs = (entry && entry.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (vs[i] && vs[i].available !== false && vs[i].variantId)
          return numericId(vs[i].variantId);
      }
      return vs[0] && vs[0].variantId ? numericId(vs[0].variantId) : "";
    }

    /* First available variant GID from a sibling entry, else the first variant's. The Coveo
       product click needs the ProductVariant GID (matching ec_product_id's shape); the GA4 and
       wishlist paths use the numeric form above. */
    function siblingVariantGid(entry) {
      var vs = (entry && entry.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (vs[i] && vs[i].available !== false && vs[i].variantId) return String(vs[i].variantId);
      }
      return vs[0] && vs[0].variantId ? String(vs[0].variantId) : "";
    }

    /* Coveo product-click attribution. Cart events are not attribution touchpoints, so a direct
       Add to Bag or a sibling-swapped card click must emit ec.productClick through the Headless
       interactive-product controller. One product-listing observer over the shared engine serves
       every surface: position and responseId are passed explicitly from the ranked result, which
       bypasses the controller's surface-specific responseId selector. Absent engine (native
       fallback / non-Coveo page) is a silent no-op. */
    var COVEO_HEADLESS_CDN = "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
    var coveoClickCtlPromise = null;
    function coveoClickController() {
      var engine = window.__coveoEngine;
      if (!engine) return Promise.resolve(null);
      if (!coveoClickCtlPromise) {
        coveoClickCtlPromise = import(COVEO_HEADLESS_CDN)
          .then(function (mod) {
            if (mod && typeof mod.buildProductListing === "function") {
              return mod.buildProductListing(engine);
            }
            /* Don't cache an unusable result -- let a later click retry the import. */
            coveoClickCtlPromise = null;
            return null;
          })
          .catch(function () {
            coveoClickCtlPromise = null;
            return null;
          });
      }
      return coveoClickCtlPromise;
    }

    /* Pending direct-adds awaiting their cart:added, each tagged with a unique token (and the
       product id it will add) so concurrent adds from different cards resolve to the right host.
       The shared add-core echoes the token on both cart:added and cart:add-failed, so a
       successful add emits its click and a failed add's entry is removed precisely -- without
       evicting a different, still-in-flight add. */
    var pendingCoveoAdds = [];
    var coveoAddSeq = 0;
    function stashCoveoAdd(host) {
      if (!host) return "";
      var product = coveoProduct(host);
      if (!product) return "";
      var sel = activeSiblingEntry(host);
      var pid = sel ? numericId(sel.productId) : String(cfield(product, "ec_item_group_id") || "");
      var token = "cv" + ++coveoAddSeq + "-" + Date.now().toString(36);
      /* One pending entry per host: a "+"-opens-flyout stash and the later add stash for the same
         card must collapse to a single entry, or the unmatched one would linger. */
      for (var i = pendingCoveoAdds.length - 1; i >= 0; i--) {
        if (pendingCoveoAdds[i].host === host) pendingCoveoAdds.splice(i, 1);
      }
      pendingCoveoAdds.push({ host: host, pid: String(pid || ""), token: token });
      if (pendingCoveoAdds.length > 8) pendingCoveoAdds.shift();
      return token;
    }

    /* Emit exactly one ec.productClick for the ranked result the shopper engaged with. When a
       sibling colour is active the click carries that sibling's identity while retaining the ranked
       style's position and responseId (the documented attribution split); own colour uses
       host.product unchanged. variantGid, when given, is the actually-added variant and wins as the
       productId. A fresh interactiveProduct per call clears its once-only emit guard. */
    function emitCoveoProductClick(host, variantGid) {
      var product = coveoProduct(host);
      if (!product) return Promise.resolve();
      var sel = activeSiblingEntry(host);
      var name = sel
        ? String(sel.title || cfield(product, "ec_name") || "")
        : cfield(product, "ec_name") || "";
      var price;
      if (sel) {
        var sp = siblingPricing(sel);
        price = sp ? sp.price : null;
      } else {
        price = cfield(product, "ec_promo_price");
        if (price == null) price = cfield(product, "ec_price");
      }
      var productId =
        variantGid || (sel ? siblingVariantGid(sel) : cfield(product, "ec_product_id")) || "";
      if (!productId) return Promise.resolve();
      var clickProduct = {
        ec_name: name,
        ec_price: price,
        ec_promo_price: price,
        ec_product_id: productId,
        permanentid: productId,
        position: cfield(product, "position"),
        responseId: cfield(product, "responseId"),
      };
      return coveoClickController().then(function (ctl) {
        if (!ctl) return;
        ctl.interactiveProduct({ options: { product: clickProduct } }).select();
      });
    }

    /* ProductVariant GID from a Shopify AJAX cart line, whose ids are numeric. */
    function variantGidFromCartLine(item) {
      if (!item) return "";
      var id = item.variant_id != null ? item.variant_id : item.id;
      if (id == null && item.items && item.items[0]) id = item.items[0].variant_id;
      return id == null ? "" : "gid://shopify/ProductVariant/" + id;
    }

    /* Publish GA4 select_item for Atomic cards. When a sibling colour is displayed the item
       is built from that sibling, so demand reporting follows the colour the shopper engaged
       with; otherwise from host.product with the mapper's SKU-first id precedence. Sibling
       entries carry no SKU (siblings_json is parity-locked to the indexing extension's
       shape), so a sibling keys on its variant id, the pixel's own next fallback. `index`
       is the zero-based rank from Coveo's 1-based `position`. */
    function publishSelectItem(card, listName, listId) {
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== "function") return;
      var host = hostFor(card);
      var product = coveoProduct(host);
      if (!product) return;
      var sel = activeSiblingEntry(host);
      var item;
      if (sel) {
        var pricing = siblingPricing(sel);
        item = {
          item_id: String(siblingVariantNum(sel) || numericId(sel.productId) || ""),
          item_name: String(sel.title || cfield(product, "ec_name") || ""),
          item_brand: cfield(product, "ec_brand") || "",
          item_category: cfield(product, "product_type") || "",
          item_variant: colourLabel(sel),
        };
        if (pricing && pricing.price != null) item.price = pricing.price;
      } else {
        var price = cfield(product, "ec_promo_price");
        if (price == null) price = cfield(product, "ec_price");
        item = {
          item_id: String(
            cfield(product, "sku") ||
              numericId(cfield(product, "permanentid")) ||
              cfield(product, "ec_item_group_id") ||
              "",
          ),
          item_name: cfield(product, "ec_name") || "",
          item_brand: cfield(product, "ec_brand") || "",
          item_category: cfield(product, "product_type") || "",
          item_variant: cfield(product, "shp_variant_title") || "",
        };
        if (price != null) item.price = price;
      }
      var position = Number(cfield(product, "position"));
      item.index = position >= 1 ? position - 1 : 0;
      item.quantity = 1;
      if (listId) item.item_list_id = listId;
      if (listName) item.item_list_name = listName;
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
      var ecommerce = { currency: currency, items: [item] };
      if (listId) ecommerce.item_list_id = listId;
      if (listName) ecommerce.item_list_name = listName;
      api.publish("custom_select_item", { ecommerce: ecommerce });
    }

    /* The GA4 list mount (`[data-ga4-list-name]`) from the composed click path, which crosses
       the shadow boundary between the card and its light-DOM section wrapper. */
    function listMountIn(path) {
      for (var s = 0; s < path.length; s++) {
        var se = path[s];
        if (se && se.nodeType === 1 && se.matches && se.matches("[data-ga4-list-name]")) return se;
      }
      return null;
    }

    /* Publish a dedicated colour-selection event so swatch demand is reportable independently
       of the PDP click-through: the ranked result the shopper started from, the sibling colour
       chosen, and its position in the row. `entry` is the clicked sibling (own colour included). */
    function publishSelectSwatch(host, entry, position, mount) {
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== "function") return;
      var product = coveoProduct(host);
      if (!product || !entry) return;
      api.publish("custom_select_swatch", {
        ranked_item_id: numericId(cfield(product, "permanentid")),
        ranked_item_group_id: String(cfield(product, "ec_item_group_id") || ""),
        selected_product_id: numericId(entry.productId),
        selected_variant_id: siblingVariantNum(entry),
        colour: colourLabel(entry),
        colour_code: String(entry.colourCode || ""),
        swatch_position: position,
        item_list_id: mount ? mount.getAttribute("data-ga4-list-id") || "" : "",
        item_list_name: mount ? mount.getAttribute("data-ga4-list-name") || "" : "",
      });
    }

    /* Shopify product options may be objects or strings; read `.name` before matching patterns. */
    function optionIndex(options, pattern) {
      if (!options) return -1;
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        var name = opt && typeof opt === "object" ? opt.name : opt;
        if (pattern.test(String(name))) return i;
      }
      return -1;
    }

    /* Map a /products/<handle>.js payload to the controller's variant shape. */
    function mapVariants(product) {
      var sizeIdx = optionIndex(product.options, /size/i);
      var colorIdx = optionIndex(product.options, /colou?r/i);
      var out = [];
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [];
        var mapped = { id: v.id, available: v.available, price: v.price };
        if (sizeIdx !== -1 && opts[sizeIdx] != null) mapped.size = opts[sizeIdx];
        if (colorIdx !== -1 && opts[colorIdx] != null) mapped.color = opts[colorIdx];
        out.push(mapped);
      }
      return out;
    }

    /* Optimistic cart-line metadata: publish structured colour and formatted price so the
       shared quick-add code never has to scrape the Lit price node or infer colour from styles. */

    /* Active market currency code suffix, stamped on `<html>` by Liquid outside this script. */
    function currencySuffix() {
      var code = document.documentElement.getAttribute("data-currency-code") || "";
      return code ? " " + code : "";
    }

    /* Format cents for optimistic cart-line metadata with the storefront's `$` plus market suffix. */
    function centsToMoney(cents) {
      var n = Number(cents);
      if (cents == null || isNaN(n)) return "";
      return fmtMoney(Math.abs(n) / 100, { prefix: "$", suffix: currencySuffix() });
    }

    /* Sibling payload prices are indexed in dollars, unlike /products.js cents. */
    function dollarsToMoney(amount) {
      var n = Number(amount);
      if (amount == null || isNaN(n)) return "";
      return fmtMoney(Math.abs(n), { prefix: "$", suffix: currencySuffix() });
    }

    /* Colour NAME by product-colour-name's rule (kept in lockstep): a colour-named option's
       value, else the `colour:` / `color:` tag. Blank for a product with no colourway. */
    function deriveColorName(product) {
      var options = product.options || [];
      var v0 = (product.variants || [])[0] || {};
      var vopts = v0.options || [];
      for (var i = 0; i < options.length; i++) {
        var name = options[i] && typeof options[i] === "object" ? options[i].name : options[i];
        if (/colou?r/i.test(String(name)) && vopts[i] != null) return String(vopts[i]);
      }
      var tags = product.tags || [];
      for (var j = 0; j < tags.length; j++) {
        var t = String(tags[j]);
        if (/^\s*colou?r\s*:/i.test(t))
          return t.slice(t.indexOf(":") + 1).replace(/^\s+|\s+$/g, "");
      }
      return "";
    }

    /* Displayed price from the cheapest variant and that variant's own compare-at price;
       never pair the minimum price with another size's discount. */
    function priceLabelsFor(product) {
      var vs = product.variants || [];
      var minP = null,
        minV = null;
      for (var i = 0; i < vs.length; i++) {
        var p = Number(vs[i].price);
        if (isNaN(p)) continue;
        if (minP === null || p < minP) {
          minP = p;
          minV = vs[i];
        }
      }
      if (minP === null) return { price: "", compare: "" };
      var cmp = minV && minV.compare_at_price != null ? Number(minV.compare_at_price) : null;
      var onSale = cmp != null && cmp > minP;
      return { price: centsToMoney(minP), compare: onSale ? centsToMoney(cmp) : "" };
    }

    /* Shared quick-add carrier population for mobile plus and desktop size buttons. The
       in-shadow carrier serves local code; the light-DOM mirror matches the controller's fallback lookup. */
    function ensureVariants(card, host, handle, product) {
      var priceLabels = priceLabelsFor(product);
      var productTags = product.tags || [];
      return writeCarrier(card, host, handle, {
        variants: mapVariants(product),
        /* Colourway swatches + swap payloads for the shared flyout. */
        colourways: flyoutColourways(coveoProduct(host)),
        product: {
          id: product.id,
          handle: handle,
          url: product.url || "/products/" + handle,
          title: product.title || "",
          image: product.featured_image || (product.images && product.images[0]) || "",
          /* Structured colour and formatted price for the optimistic cart line. */
          color: deriveColorName(product),
          priceLabel: priceLabels.price,
          compareLabel: priceLabels.compare,
          /* Restock-alert eligibility, read from the same two product tags the buy box gates
             its Notify Me on, so a sold-out size offers it on exactly the same products. A
             coming-soon product routes to register-interest instead of notify. */
          notify:
            productTags.indexOf("comingSoon:true") === -1 &&
            productTags.indexOf("notifyMe:disable") === -1,
        },
      });
    }

    /* Number of `size:` tags on a product: the full size range, one tag per size, present on
       the parent regardless of which variants the response carries. */
    function sizeTagCount(tags) {
      var n = 0;
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]).indexOf("size:") === 0) n++;
      }
      return n;
    }

    /* Cheapest of an indexed full/promo pair, in dollars; null when neither is a number. */
    function indexPrice(full, promo) {
      var f = typeof full === "number" ? full : null;
      var p = typeof promo === "number" ? promo : null;
      if (p != null && (f == null || p < f)) return p;
      return f;
    }

    /* Variant rows for the displayed colour from the Coveo index alone. A swapped sibling,
       and the own colour whenever its entry exists, read the pre-baked sibling entry (every
       size, sold-out included); a product with no entry falls back to `children` plus the
       parent's own variant, each carrying its own stock. Index prices are dollars; the carrier
       carries cents like the live payload. */
    function indexVariants(host, handle) {
      var product = coveoProduct(host);
      if (!product) return [];
      var entry = activeSiblingEntry(host) || ownSiblingEntry(product);
      var out = [];
      var seen = {};
      function push(id, size, available, dollars) {
        if (!id || seen[id]) return;
        seen[id] = true;
        var row = {
          id: Number(id),
          available: available,
          price: dollars == null ? 0 : Math.round(Number(dollars) * 100),
        };
        if (size != null && String(size).trim() !== "") row.size = String(size).trim();
        out.push(row);
      }
      if (entry) {
        var vs = entry.variants || [];
        for (var v = 0; v < vs.length; v++) {
          push(numericId(vs[v].variantId), vs[v].size, vs[v].available !== false, vs[v].price);
        }
        return out;
      }
      var kids = product.children || [];
      for (var i = 0; i < kids.length; i++) {
        if (String(cfield(kids[i], "product_handle") || "") !== handle) continue;
        push(
          numericId(cfield(kids[i], "permanentid")),
          cfield(kids[i], "shp_variant_title"),
          coveoInStock(kids[i], product),
          indexPrice(cfield(kids[i], "ec_price"), cfield(kids[i], "ec_promo_price")),
        );
      }
      /* The parent document is itself one variant and is not repeated in `children`. */
      if (ownHandleOf(product) === handle) {
        push(
          numericId(cfield(product, "permanentid")),
          cfield(product, "shp_variant_title"),
          coveoInStock(product),
          indexPrice(cfield(product, "ec_price"), cfield(product, "ec_promo_price")),
        );
      }
      return out;
    }

    /* Carrier from the Coveo index for the displayed colour, so an add can dispatch before the
       live payload lands. Returns the variant count; zero means the index has nothing to add
       from and the caller should wait for live data instead. */
    function ensureIndexVariants(card, host, handle) {
      var product = coveoProduct(host);
      if (!product) return 0;
      var variants = indexVariants(host, handle);
      if (!variants.length) return 0;
      var entry = activeSiblingEntry(host) || ownSiblingEntry(product);
      var tags = entry ? entryTags(entry) : coveoTags(product);
      /* A lone row without an entry on a product that has several sizes means the index is
         missing sizes (children narrowed by a size facet, absent from the response, or not
         returned at all). The controller direct-adds a one-row carrier, which would put a size
         in the bag the shopper never chose, so leave that case to the live payload. Sizes are
         known from the `size:` tags, or from the child count Coveo reports even when it
         returns no children. */
      if (
        !entry &&
        variants.length === 1 &&
        (sizeTagCount(tags) > 1 || Number(product.totalNumberOfChildren) > 0)
      )
        return 0;
      var pricing = entry ? siblingPricing(entry) : ownPricing(product);
      var images = entry ? entry.images || [] : cfield(product, "ec_images");
      /* Parent ec_images are capped to the 180px placeholder rendition at response time; the
         flyout thumb wants the CDN original so it can pick its own size. */
      var image = Array.isArray(images) ? images[0] || "" : String(images || "");
      image = image.replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, "");
      writeCarrier(card, host, handle, {
        variants: variants,
        colourways: flyoutColourways(product),
        product: {
          id: entry
            ? numericId(entry.productId)
            : wlProductId(product) || String(cfield(product, "ec_item_group_id") || ""),
          handle: handle,
          url: rootUrl() + "products/" + handle,
          title: entry ? String(entry.title || "") : String(cfield(product, "ec_name") || ""),
          image: image,
          color: entry ? colourLabel(entry) : tagValue(tags, "colour:") || tagValue(tags, "color:"),
          priceLabel: dollarsToMoney(pricing.price),
          compareLabel: pricing.compareAt != null ? dollarsToMoney(pricing.compareAt) : "",
          notify:
            !tagsHaveExact(tags, "comingSoon:true") && !tagsHaveExact(tags, "notifyMe:disable"),
        },
      });
      return variants.length;
    }

    /* Tells the quick-add controller the carrier changed, so a flyout already open for this
       product can refresh its sizes in place once live stock replaces the index guess. */
    function announceCarrier(card, handle) {
      card.dispatchEvent(
        new CustomEvent("quick-add:carrier-updated", {
          bubbles: true,
          composed: true,
          detail: { handle: handle },
        }),
      );
    }

    /* Returns whether the carrier content actually changed, so callers announce a refresh
       only once per new payload rather than for every queued live callback. */
    function writeCarrier(card, host, handle, payload) {
      var json = JSON.stringify(payload);
      var carrier = card.querySelector("[data-quick-add-variants]");
      var previous = carrier ? carrier.textContent : null;
      if (carrier) carrier.textContent = json;

      if (host) {
        host.dataset.productId = handle;
        var mirror = document.querySelector(
          '[data-quick-add-variants="' + window.CSS.escape(handle) + '"]',
        );
        if (!mirror) {
          mirror = document.createElement("script");
          mirror.type = "application/json";
          mirror.setAttribute("data-quick-add-variants", handle);
          document.body.appendChild(mirror);
        }
        /* A card rendered without its own carrier still has the mirror as its previous state. */
        if (previous === null) previous = mirror.textContent;
        mirror.textContent = json;
      }
      return previous !== json;
    }

    /* Mobile "+": populate the carrier (so the controller resolves variants), then
       dispatch product-card:add with detail {} -> the controller opens the flyout
       (multi-colour) or direct-adds (single colour axis). Without a live product the
       carrier comes from the index; the caller refreshes it when live stock lands. */
    function openQuickAdd(card, plusBtn, product, handle, coveoToken) {
      var host = plusBtn.getRootNode && plusBtn.getRootNode().host;
      if (product) ensureVariants(card, host, handle, product);
      else if (!ensureIndexVariants(card, host, handle)) return false;
      plusBtn.dispatchEvent(
        new CustomEvent("product-card:add", {
          bubbles: true,
          composed: true,
          detail: { coveoToken: coveoToken || "" },
        }),
      );
      return true;
    }

    document.addEventListener(
      "click",
      function (event) {
        var path = (event.composedPath && event.composedPath()) || [];
        var wishlistBtn = null;
        var quickAddBtn = null;
        var sizeBtn = null;
        var swatchBtn = null;
        var inQuickAdd = null;
        for (var i = 0; i < path.length; i++) {
          var el = path[i];
          if (!el || el.nodeType !== 1 || !el.matches) continue;
          if (!wishlistBtn && el.matches("[data-pc-wishlist]")) wishlistBtn = el;
          if (!quickAddBtn && el.matches("[data-pc-quickadd-toggle]")) quickAddBtn = el;
          if (!sizeBtn && el.matches("[data-pc-size]")) sizeBtn = el;
          if (!swatchBtn && el.matches("[data-pc-swatch]")) swatchBtn = el;
          /* Swallow clicks anywhere in the quick-add panel so they never bubble to Coveo's
           whole-card link; actionable buttons still run their branches below. */
          if (!inQuickAdd && el.matches("[data-pc-quickadd-strip]")) inQuickAdd = el;
        }
        /* Stop card controls from bubbling to Coveo's host click-to-navigate handler inside the
           open shadow root; document-level cancellation would arrive too late. */
        if (wishlistBtn || quickAddBtn || sizeBtn || swatchBtn || inQuickAdd) {
          event.stopPropagation();
          event.preventDefault();
        }

        /* GA4 select_item for genuine PDP click-throughs. Ignore card controls, then read the
         clicked link, card root, and list context from the composed path across shadow roots. */
        if (!wishlistBtn && !quickAddBtn && !sizeBtn && !swatchBtn && !inQuickAdd) {
          var selLink = null,
            selCard = null,
            selMount = listMountIn(path);
          for (var s = 0; s < path.length; s++) {
            var se = path[s];
            if (!se || se.nodeType !== 1 || !se.matches) continue;
            if (
              !selLink &&
              se.matches("a[href]") &&
              /\/products\//.test(se.getAttribute("href") || "")
            )
              selLink = se;
            if (!selCard && se.matches(".pcard, .pcard-c")) selCard = se;
          }
          if (selLink && selCard) {
            publishSelectItem(
              selCard,
              selMount ? selMount.getAttribute("data-ga4-list-name") : "",
              selMount ? selMount.getAttribute("data-ga4-list-id") || "" : "",
            );
            /* A swapped sibling must attribute the Coveo click to that sibling, not the ranked
               style Atomic's link carries. This capture handler runs before the link's own click,
               so suppress the native ranked click, emit the sibling click, then navigate to the
               displayed sibling PDP once the click is queued. Own colour keeps Atomic's native
               click and navigation untouched. */
            var selHost = hostFor(selCard);
            if (activeSiblingEntry(selHost)) {
              event.preventDefault();
              event.stopPropagation();
              var selHref = selLink.getAttribute("href");
              var go = function () {
                if (selHref) window.location.assign(selHref);
              };
              emitCoveoProductClick(selHost, "").then(go, go);
            }
          }
        }

        /* Bundle products route quick-add interactions to the PDP because the card cannot
         add the parent plus child set safely. */
        if (quickAddBtn || sizeBtn) {
          var bundleCard = (quickAddBtn || sizeBtn).closest(".pcard");
          var bundleHost = bundleCard ? hostFor(bundleCard) : null;
          if (bundleCard && tagsHave(coveoProduct(bundleHost), "bundle")) {
            var bundleHandle = handleForCard(bundleCard);
            if (bundleHandle) {
              window.location.assign(rootUrl() + "products/" + bundleHandle);
              return;
            }
          }
        }

        /* Swatch clicks swap the displayed colour in place while host.product remains the stable
           identity for re-render recovery. */
        if (swatchBtn) {
          if (swatchBtn.getAttribute("aria-pressed") === "true") return;
          var swCard = swatchBtn.closest(".pcard, .pcard-c");
          var swHost = swCard ? hostFor(swCard) : null;
          var swProduct = coveoProduct(swHost);
          var swHandle = swatchBtn.getAttribute("data-pc-swatch-handle") || "";
          if (!swProduct || !swHandle) return;
          var swOwnHandle = ownHandleOf(swProduct);
          /* Resolve the clicked sibling (own colour included) and its swatch position from the
             pre-swap row -- applyColour can rebuild the row and detach the clicked button, so
             analytics must read the colour and slot before the swap. */
          var swClicked = null;
          var swEntries = parseSiblings(swProduct);
          for (var se2 = 0; se2 < swEntries.length; se2++) {
            if (String(swEntries[se2].handle) === swHandle) {
              swClicked = swEntries[se2];
              break;
            }
          }
          var swRow = swatchBtn.closest("[data-pc-swatches]");
          var swPos = swRow
            ? Array.prototype.indexOf.call(swRow.querySelectorAll("[data-pc-swatch]"), swatchBtn)
            : -1;
          var swMount = listMountIn(path);
          if (swHandle === swOwnHandle) delete swatchSelection[swOwnHandle];
          else swatchSelection[swOwnHandle] = swHandle;
          applyColour(swHost);
          publishSelectSwatch(swHost, swClicked, swPos, swMount);
          return;
        }

        /* Size buttons dispatch product-card:add after hover-prefetch prepares the shared carrier. */
        if (sizeBtn) {
          /* Ensure the live variant payload is cached before dispatching size-chip quick-add. */
          var scard = sizeBtn.closest(".pcard");
          var shandle = scard ? handleForCard(scard) : "";
          /* Pair a Coveo product click to the add this dispatches; resolved on cart:added,
             cleared on cart:add-failed. The token correlates the shared add-core's cart event
             back to this pending entry. */
          var sizeToken = stashCoveoAdd(scard ? hostFor(scard) : null);
          var dispatchSize = function () {
            sizeBtn.dispatchEvent(
              new CustomEvent("product-card:add", {
                bubbles: true,
                composed: true,
                detail: { size: sizeBtn.dataset.pcSize, coveoToken: sizeToken },
              }),
            );
          };
          if (scard && shandle && !productCache[shandle]) {
            /* The index is enough to add from now; live stock then corrects the strip and any
               open flyout, and a stale pick surfaces as the cart's own error. Only an empty
               index (no variants to add) waits for the live payload. */
            var shost = hostFor(scard);
            if (ensureIndexVariants(scard, shost, shandle)) {
              dispatchSize();
              ensureLiveProduct(shandle, function (product) {
                applyLive(scard, shost, shandle, product);
              });
            } else {
              ensureLiveProduct(shandle, function (product) {
                if (product) applyLive(scard, shost, shandle, product);
                dispatchSize();
              });
            }
          } else {
            dispatchSize();
          }
          return;
        }

        if (quickAddBtn) {
          var card = quickAddBtn.closest(".pcard");
          if (!card) return;
          var handle = handleForCard(card);
          if (!handle) return;
          /* Coming Soon routes to register-interest; shadow retargeting requires a direct overlay API call. */
          if (displayedState(hostFor(card)) === "coming-soon") {
            ensureLiveProduct(handle, function (product) {
              if (!product || !window.SeedComingSoon) return;
              var csPrice = priceLabelsFor(product);
              window.SeedComingSoon.open({
                productId: product.id,
                title: product.title || "",
                price: csPrice.price,
                compare: csPrice.compare,
                url: wlDu(handle),
                image: product.featured_image || (product.images && product.images[0]) || "",
              });
            });
            return;
          }
          /* Pair a Coveo product click to the add this opens; resolved on cart:added (the token
             persists through the flyout for the multi-colour path), cleared on cart:add-failed. */
          var addToken = stashCoveoAdd(hostFor(card));
          if (productCache[handle]) {
            openQuickAdd(card, quickAddBtn, productCache[handle], handle, addToken);
            return;
          }
          /* Open from the index at once rather than holding the tap on the network; the live
             payload then refreshes the carrier and any open flyout. An index with no variants
             falls back to waiting, and a failed fetch keeps the flyout path over a blind add. */
          var qhost = hostFor(card);
          if (openQuickAdd(card, quickAddBtn, null, handle, addToken)) {
            ensureLiveProduct(handle, function (product) {
              applyLive(card, qhost, handle, product);
            });
            return;
          }
          ensureLiveProduct(handle, function (product) {
            if (product) openQuickAdd(card, quickAddBtn, product, handle, addToken);
          });
          return;
        }

        if (!wishlistBtn) return;
        /* Wishlist taps are customer-only and product-level. Hide hearts when SWYM is unavailable;
         guests use the normal wishlist login path. */
        if (!window.SeedWishlist || window.SeedWishlist.isUnavailable()) return;
        if (!window.SeedWishlist.isLoggedIn()) {
          if (window.SeedWishlistGate && window.SeedWishlistGate.prompt)
            window.SeedWishlistGate.prompt();
          return;
        }
        var wcard = wishlistBtn.closest(".pcard, .pcard-c");
        var whandle = wcard ? handleForCard(wcard) : "";
        if (!whandle) return;
        /* Wishlist identity normally resolves from the card's Coveo product with no live fetch. */
        var whost = hostFor(wcard);
        var identity = wlIdentity(whost, whandle);
        /* Optimistic flip; the wishlist:content re-hydrate reconciles against the server
         (and reverts it if the toggle never lands). */
        wishlistBtn.setAttribute(
          "aria-pressed",
          wishlistBtn.getAttribute("aria-pressed") !== "true" ? "true" : "false",
        );
        /* Stamp tap-animation classes only for real taps. Hydration and Lit re-renders change
         aria-pressed directly and must not trigger motion. */
        if (!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) {
          var wlSaved = wishlistBtn.getAttribute("aria-pressed") === "true";
          wishlistBtn.classList.remove("pcard__wishlist--anim-add", "pcard__wishlist--anim-remove");
          void wishlistBtn.offsetWidth;
          wishlistBtn.classList.add(
            wlSaved ? "pcard__wishlist--anim-add" : "pcard__wishlist--anim-remove",
          );
        }
        /* Keep the optimistic fill until SWYM resolves authoritatively. Interim hydrations skip
         pending handles so a just-tapped heart does not flicker blank before the server confirms. */
        wlPending[whandle] = wishlistBtn.getAttribute("aria-pressed") === "true";
        var wlSettle = function () {
          delete wlPending[whandle];
          hydrateWishlist();
        };
        if (identity.empi) {
          window.SeedWishlist.toggle(identity, wlSettle);
          return;
        }
        /* Race fallback: if host.product has not attached yet, resolve wishlist identity from
         the live payload so a shopper click is never a silent no-op. */
        ensureLiveProduct(whandle, function (product) {
          if (!product) {
            wlSettle();
            return;
          }
          window.SeedWishlist.toggle(wlIdentityFromLive(product, whandle), wlSettle);
        });
      },
      true,
    );

    /* atomic-product-link commits its ranked-style product click on the pointer press, before the
       capture-phase click handler above can suppress it -- so a sibling-swapped card click would
       emit both the ranked native click and the sibling click. For a card showing a sibling colour,
       swallow the pointer events on the product link so only the sibling click (emitted on click
       above) reaches Coveo. Own colour is never intercepted, so its native click still fires. */
    function siblingLinkPress(event) {
      var path = (event.composedPath && event.composedPath()) || [];
      var link = null;
      var card = null;
      var control = false;
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1 || !el.matches) continue;
        if (
          el.matches(
            "[data-pc-wishlist], [data-pc-quickadd-toggle], [data-pc-size], [data-pc-swatch], [data-pc-quickadd-strip]",
          )
        )
          control = true;
        if (!link && el.matches("a[href]") && /\/products\//.test(el.getAttribute("href") || ""))
          link = el;
        if (!card && el.matches(".pcard, .pcard-c")) card = el;
      }
      if (control || !link || !card) return false;
      return !!activeSiblingEntry(hostFor(card));
    }
    ["pointerdown", "mousedown", "pointerup", "mouseup"].forEach(function (type) {
      document.addEventListener(
        type,
        function (event) {
          if (siblingLinkPress(event)) event.stopPropagation();
        },
        true,
      );
    });

    /* Locate the pending entry a cart event belongs to: the correlation token the add-core
       echoed back is authoritative; the added product id is the fallback when a token is absent.
       An event with neither a matching token nor a matching product id is a non-Coveo-card add
       (or an identifier-free event) and matches nothing -- never the newest entry, so a stale
       failed-add entry can never be consumed by an unrelated later add. */
    function matchPendingCoveoAdd(token, pid) {
      var i;
      if (token) {
        for (i = pendingCoveoAdds.length - 1; i >= 0; i--) {
          if (pendingCoveoAdds[i].token === token) return i;
        }
      }
      if (pid) {
        /* Newest entry for this product id: a not-yet-reclaimed entry for the same product
           (e.g. the same product on a PLP card and a rec-rail card) is older than the add just
           completed, so the freshest carries the right host -- and thus position/responseId. */
        for (i = pendingCoveoAdds.length - 1; i >= 0; i--) {
          if (pendingCoveoAdds[i].pid === pid) return i;
        }
      }
      return -1;
    }

    /* Resolve the paired Coveo product click when a Coveo-card add succeeds, keyed on the ranked
       result stashed at product-card:add. The added variant (from the cart response) is the
       attributed product; an active sibling colour still contributes its position + responseId. */
    document.addEventListener("cart:added", function (event) {
      if (!pendingCoveoAdds.length) return;
      var item = event.detail && event.detail.item;
      var token = event.detail && event.detail.coveoToken;
      var line = item && (item.items ? item.items[0] : item);
      var addedPid = line && line.product_id != null ? String(line.product_id) : "";
      var idx = matchPendingCoveoAdd(token, addedPid);
      if (idx === -1) return;
      var host = pendingCoveoAdds[idx].host;
      pendingCoveoAdds.splice(idx, 1);
      emitCoveoProductClick(host, variantGidFromCartLine(item));
    });

    /* A failed add fires cart:add-failed instead of cart:added. Remove its pending entry by the
       token the add-core echoed, so no click is emitted for it and it cannot be consumed later.
       A failure with no token (bundle / buy-box, which never stash a Coveo entry) is a no-op. */
    document.addEventListener("cart:add-failed", function (event) {
      if (!pendingCoveoAdds.length) return;
      var token = event.detail && event.detail.coveoToken;
      if (!token) return;
      var idx = matchPendingCoveoAdd(token, "");
      if (idx !== -1) pendingCoveoAdds.splice(idx, 1);
    });

    /* Clear tap-animation classes when the longest-running keyframe ends; clearing earlier
       would cut the sequence short. Delegated capture catches shadow-root animations. */
    (function () {
      var FINAL = { "pcard-wl-ring": 1, "pcard-wl-dip": 1 };
      document.addEventListener(
        "animationend",
        function (e) {
          if (!FINAL[e.animationName]) return;
          var btn = e.target && e.target.closest ? e.target.closest("[data-pc-wishlist]") : null;
          if (!btn) return;
          btn.classList.remove("pcard__wishlist--anim-add", "pcard__wishlist--anim-remove");
        },
        true,
      );
    })();

    /* ================= Wishlist: live SWYM wiring ==========================
       Full and compact cards share one customer-only, product-level wishlist delegator. */
    /* Build SWYM identity from Coveo fields; live payload fallback covers missing product ids. */
    function wlProductId(product) {
      var m = String((product && product.clickUri) || "").match(/^gid:\/\/shopify\/Product\/(\d+)/);
      return m ? m[1] : "";
    }
    function wlIdentity(host, handle) {
      /* A swapped card must save the displayed sibling colour, not the card's own product. */
      var sel = activeSiblingEntry(host);
      if (sel) {
        return { empi: numericId(sel.productId), epi: siblingVariantNum(sel), du: wlDu(handle) };
      }
      var product = coveoProduct(host);
      var empi = product ? wlProductId(product) : "";
      var epi = product ? numericId(cfield(product, "permanentid")) : "";
      return { empi: empi, epi: epi, du: wlDu(handle) };
    }

    /* du is always built on the CURRENT origin (never the myshopify-hardcoded clickUri
       host, which would poison stored entries at the custom-domain cutover) and respects
       the locale root. Shared by both identity paths. */
    function wlDu(handle) {
      var root = rootUrl();
      if (root.charAt(root.length - 1) !== "/") root += "/";
      return location.origin + root + "products/" + handle;
    }

    /* Fallback identity from a live payload, used only when host.product is missing at click time. */
    function wlIdentityFromLive(product, handle) {
      var epi = "";
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available !== false && variants[i].id) {
          epi = variants[i].id;
          break;
        }
      }
      if (!epi && variants[0]) epi = variants[0].id;
      return { empi: String(product.id), epi: epi ? String(epi) : "", du: wlDu(handle) };
    }

    /* Handles with an in-flight optimistic wishlist tap; hydration skips them until SWYM settles. */
    var wlPending = {};

    /* Hydrate one host's wishlist heart from SWYM: saved handles fill the icon, unavailable
       SWYM hides it, gift cards stay hidden, and pending taps keep their optimistic state. */
    /* Gift cards are not wishlistable. Coveo has no `product.gift_card` equivalent, so match
       the indexed gift-card tag or product type and hide the heart in the wishlist hydrate path. */
    function isGiftCardProduct(product) {
      if (!product) return false;
      if (tagsHave(product, "gift card")) return true;
      var ptype = cfield(product, "ec_product_type");
      if (Array.isArray(ptype)) ptype = ptype.join(" ");
      return typeof ptype === "string" && ptype.toLowerCase().indexOf("gift card") !== -1;
    }

    function hydrateWishlistHost(host, handles, unavailable) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var btns = root.querySelectorAll("[data-pc-wishlist]");
      var giftCard = isGiftCardProduct(coveoProduct(host));
      for (var j = 0; j < btns.length; j++) {
        var btn = btns[j];
        if (unavailable || giftCard) {
          btn.style.display = "none";
          continue;
        }
        btn.style.display = "";
        var card = btn.closest(".pcard, .pcard-c");
        var handle = card ? handleForCard(card) : "";
        /* Preserve an in-flight optimistic tap by applying the pending target state until
           SWYM confirms and the toggle callback clears it. */
        if (handle && wlPending.hasOwnProperty(handle)) {
          btn.setAttribute("aria-pressed", wlPending[handle] ? "true" : "false");
          continue;
        }
        btn.setAttribute("aria-pressed", handle && handles[handle] ? "true" : "false");
      }
      /* Re-hydration on Lit re-render is driven by the unified per-host observer
         (ensureHostObserver -> runHostHeals), not a wishlist-specific observer. */
      ensureHostObserver(host);
    }

    /* Hydration traverses Coveo interface shadow trees because atomic-product hosts are not
       visible to a flat document query. */
    function collectAtomicHosts() {
      var hosts = [];
      var lists = [];
      var ifaces = document.querySelectorAll(
        "atomic-commerce-interface, atomic-commerce-recommendation-interface",
      );
      for (var i = 0; i < ifaces.length; i++) {
        /* The header predictive panel never enters the gallery IntersectionObserver (its
           interface is excluded from grid discovery), so its handful of cards hydrate
           eagerly instead of waiting for a viewport arm that would never come. */
        var eager = ifaces[i].classList.contains("coveo-predictive__search-interface");
        var found = deepFind(
          ifaces[i],
          function (el) {
            if (el.shadowRoot) {
              if (
                el.tagName === "ATOMIC-COMMERCE-PRODUCT-LIST" ||
                el.tagName === "ATOMIC-COMMERCE-RECOMMENDATION-LIST"
              )
                lists.push(el);
            }
            return el.tagName === "ATOMIC-PRODUCT";
          },
          [],
        );
        for (var f = 0; f < found.length; f++) {
          if (eager) found[f].__pcEagerHeal = true;
          adoptCardStyles(found[f]);
          hosts.push(found[f]);
        }
      }
      for (var l = 0; l < lists.length; l++) armListObserver(lists[l]);
      return hosts;
    }

    /* Accept a pre-collected host list, but ignore event payloads when used as a raw callback. */
    function hydrateWishlist(hosts) {
      if (!window.SeedWishlist || !window.SeedWishlist.savedHandles) return;
      var handles = window.SeedWishlist.savedHandles();
      var unavailable = window.SeedWishlist.isUnavailable();
      if (!Array.isArray(hosts)) hosts = collectAtomicHosts();
      for (var k = 0; k < hosts.length; k++) {
        /* Far-offscreen cards stay cold (template default) until the shared gallery
           IntersectionObserver arms them; arming hydrates the heart immediately. */
        if (!hosts[k].__pcGalleryArmed && !hosts[k].__pcEagerHeal) continue;
        hydrateWishlistHost(hosts[k], handles, unavailable);
      }
    }

    /* Re-hydrate on every list change (add/remove, initial resolve). */
    document.addEventListener("wishlist:content", hydrateWishlist);

    /* Watch every Coveo interface for inserted or replaced cards, including predictive and
       recommendation surfaces. Predictive results can arrive long after page load. */
    var wlWatched = new WeakSet();
    var wlDebounce = null;
    function wlScanSoon() {
      if (wlDebounce) return;
      /* `hydrateCards` is the shared traversal for wishlist and swatch hydration. */
      wlDebounce = setTimeout(function () {
        wlDebounce = null;
        // Under a veiled restore the sweep waits: the restore hydrates its landing
        // cards directly, and everything else is re-swept once at hand-back.
        if (restoreVeiled()) {
          afterRestore(wlScanSoon);
          return;
        }
        hydrateCards();
      }, 120);
    }
    function watchWishlistInterfaces() {
      var ifaces = document.querySelectorAll(
        "atomic-commerce-interface, atomic-commerce-recommendation-interface",
      );
      for (var i = 0; i < ifaces.length; i++) {
        var iface = ifaces[i];
        if (wlWatched.has(iface)) continue;
        wlWatched.add(iface);
        new MutationObserver(wlScanSoon).observe(iface, { childList: true, subtree: true });
        if (iface.shadowRoot)
          new MutationObserver(wlScanSoon).observe(iface.shadowRoot, {
            childList: true,
            subtree: true,
          });
      }
    }

    /* Swatch rows come from `siblings_json`: visible siblings only (see siblingVisible),
       own colour first, the rest by product id, capped with a "+N" overflow chip that
       counts visible siblings alone. */

    var SWATCH_ALNUM = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var SWATCH_MAX = 4; /* native card cap (product-swatches.liquid default) */

    /* Selection state: displayed colour handle keyed by the card's own product handle. The
       host product stays unchanged during in-place swaps, so this survives Lit re-renders
       without per-host state. */
    var swatchSelection = {};

    /* First tag value for a prefix (e.g. 'colour:') off a product's tags -- the colour-label
       fallback when no sibling entry supplies a name. */
    function tagValue(tags, prefix) {
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].indexOf(prefix) === 0) return tags[i].slice(prefix.length).trim();
      }
      return "";
    }

    /* Promo-message rules, read once from the light-DOM JSON carrier the layout renders
       (`promo-rules-json`). Liquid already dropped scheduled-out and wrong-market entries
       and ordered the rest highest priority first, so this array is walked top to bottom
       and the first match wins. Any parse failure resolves to no rules, never to a throw. */
    var promoRulesCache = null;
    function promoRules() {
      if (promoRulesCache) return promoRulesCache;
      var rules = [];
      var carrier = document.querySelector("[data-promo-rules]");
      if (carrier) {
        try {
          var parsed = JSON.parse(carrier.textContent || "[]");
          if (Array.isArray(parsed)) rules = parsed;
        } catch (e) {
          rules = [];
        }
      }
      promoRulesCache = rules;
      return rules;
    }
    /* Rules are fixed for the page and a colourway's tags do not change, so each handle is
       matched once; every later heal or swap is a lookup. */
    var promoMemo = new Map();
    function tagListHasAll(tags, needles) {
      for (var i = 0; i < needles.length; i++) {
        if (tags.indexOf(needles[i]) === -1) return false;
      }
      return true;
    }
    function tagListHasAny(tags, needles) {
      for (var i = 0; i < needles.length; i++) {
        if (tags.indexOf(needles[i]) !== -1) return true;
      }
      return false;
    }
    /* Same four match steps as promo-resolver.liquid, schedule and market having been
       applied server side: every `all` tag must be present, one `any` tag when the list is
       non-empty, no `excludeTags` tag, and the handle not excluded. Exact, case-insensitive matching:
       rule tags arrive downcased, product tags are downcased once per handle. */
    function resolvePromo(tags, handle) {
      var key = String(handle || "");
      if (key && promoMemo.has(key)) return promoMemo.get(key);
      var rules = promoRules();
      var label = "";
      if (rules.length) {
        var lower = [];
        for (var t = 0; t < tags.length; t++) lower.push(String(tags[t]).toLowerCase());
        for (var i = 0; i < rules.length; i++) {
          var r = rules[i] || {};
          var all = Array.isArray(r.all) ? r.all : [];
          var any = Array.isArray(r.any) ? r.any : [];
          var exc = Array.isArray(r.excludeTags) ? r.excludeTags : [];
          var exh = Array.isArray(r.excludeHandles) ? r.excludeHandles : [];
          if (!tagListHasAll(lower, all)) continue;
          if (any.length && !tagListHasAny(lower, any)) continue;
          if (tagListHasAny(lower, exc)) continue;
          if (key && exh.indexOf(key) !== -1) continue;
          label = String(r.label || "").trim();
          break;
        }
      }
      if (key) promoMemo.set(key, label);
      return label;
    }

    /* Pre-baked source for colour swaps: media, swatch, tags, price, variants, promo, and
       sibling ids. `siblings_json` (the worker-written metafield, exposed directly) is the
       primary source; `style_group_siblings` (the same payload under the legacy field name)
       is the fallback until the field is retired, so the read works whichever the index
       exposes. Both carry an identical payload shape. */
    function parseSiblings(product) {
      if (!product) return [];
      var raw = cfield(product, "siblings_json");
      if (raw == null || raw === "") raw = cfield(product, "style_group_siblings");
      if (raw == null || raw === "") return [];
      if (typeof raw !== "string") return Array.isArray(raw) ? raw : [];
      /* Memoise per product object, keyed by the raw string; parsing this multi-KB field
         repeatedly is the hot path during Lit re-renders. The memo lives in a WeakMap
         because store products arrive frozen -- a property write would silently no-op. */
      var cache = siblingsMemo && siblingsMemo.get(product);
      if (cache && cache.raw === raw) return cache.parsed;
      var parsed;
      try {
        parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) parsed = [];
      } catch (e) {
        parsed = [];
      } /* malformed => no group (row hidden, no swap), as empty children did */
      if (siblingsMemo) siblingsMemo.set(product, { raw: raw, parsed: parsed });
      return parsed;
    }

    /* A sibling entry's tag array, used so tag-driven card behaviour follows the displayed colour. */
    function entryTags(entry) {
      return entry && Array.isArray(entry.tags) ? entry.tags : [];
    }
    function tagsHaveExact(tags, needle) {
      for (var i = 0; i < tags.length; i++) {
        if (tags[i] === needle) return true;
      }
      return false;
    }

    /* Displayed-colour tags are the single source for badge painting and quick-add routing. */
    function displayedTags(host, sel) {
      if (sel === undefined) sel = activeSiblingEntry(host);
      return sel ? entryTags(sel) : coveoTags(coveoProduct(host));
    }
    function stateFromTags(tags) {
      return tagsHaveExact(tags, "comingSoon:true")
        ? "coming-soon"
        : tagsHaveExact(tags, "preSale:true")
          ? "pre-sale"
          : "";
    }
    function displayedState(host) {
      return stateFromTags(displayedTags(host));
    }

    /* Numeric product id from a sibling entry's GID -- the id-ascending order key.
       Unparseable => sorts last. */
    function siblingProductNum(entry) {
      var n = numericId(entry && entry.productId);
      return n ? parseInt(n, 10) : Number.MAX_SAFE_INTEGER;
    }

    /* Order the own colourway first, then the rest by numeric product id. Pinning the own
       handle freezes swatch positions so switching colour moves only the ring. Siblings are
       not deduped: each product handle owns its swatch. */
    function orderSiblings(entries, pinnedHandle) {
      var rest = entries.slice().sort(function (a, b) {
        return siblingProductNum(a) - siblingProductNum(b);
      });
      var pin = null,
        ordered = [];
      for (var i = 0; i < rest.length; i++) {
        if (pinnedHandle && String(rest[i].handle) === pinnedHandle && !pin) pin = rest[i];
        else ordered.push(rest[i]);
      }
      if (pin) ordered.unshift(pin);
      return ordered;
    }

    /* Colour labels prefer payload names, then a readable colourCode suffix, then the
       entry's product title (an ungrouped product has neither a `colour:` nor a
       `colourCode:` tag) so swatches always get an aria-label/title. */
    function colourLabel(entry) {
      var name = entry && entry.colourName ? String(entry.colourName).trim() : "";
      if (name) return name;
      var code = entry && entry.colourCode ? String(entry.colourCode) : "";
      var tail = code.indexOf("-") !== -1 ? code.slice(code.lastIndexOf("-") + 1) : code;
      tail = tail.toLowerCase();
      if (tail) return tail.charAt(0).toUpperCase() + tail.slice(1);
      return entry && entry.title ? String(entry.title).trim() : "";
    }

    /* A colour is out of stock when it has variants and every one is unavailable. A sold-out
       sibling is hidden from the row (siblingVisible); the own or displayed colour still
       renders, struck, and the strike never gates the click. */
    function siblingOOS(entry) {
      var vs = (entry && entry.variants) || [];
      if (!vs.length) return false;
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].available !== false) return false;
      }
      return true;
    }

    /* A swatch code names a library colour (or a letter glyph); a colour whose library entry
       has no image and no hex still draws as the neutral fallback dot, so the code alone is
       a visual. */
    function hasSwatchCode(swatchCode) {
      var code = swatchCode ? String(swatchCode) : "";
      return !!code.split(".")[0].trim();
    }

    /* The one eligibility rule for a sibling to appear as a swatch (product-swatch-members'
       Liquid rule, mirrored): it needs a visual (swatch code, image or hex), and it must be
       purchasable unless it is the card's own or displayed colour (a sold-out product still
       shows itself) or a pre-launch colour (coming soon / pre-sale keep their own state).
       Hidden siblings take no capped slot and never count toward "+N". */
    function siblingVisible(entry, ownHandle, selectedHandle) {
      if (!entry || !entry.handle) return false;
      var hasVisual =
        hasSwatchCode(entry.swatchCode) ||
        (typeof entry.swatchImageUrl === "string" && !!entry.swatchImageUrl) ||
        (typeof entry.swatchHex === "string" && !!entry.swatchHex);
      if (!hasVisual) return false;
      if (!siblingOOS(entry)) return true;
      var handle = String(entry.handle);
      if (handle === ownHandle || handle === selectedHandle) return true;
      return stateFromTags(entryTags(entry)) !== "";
    }

    function visibleSiblings(entries, ownHandle, selectedHandle) {
      var out = [];
      for (var i = 0; i < entries.length; i++) {
        if (siblingVisible(entries[i], ownHandle, selectedHandle)) out.push(entries[i]);
      }
      return out;
    }

    /* Aggregate a colourway's price across its variants. The displayed price is the minimum
       variant price; sale compare-at only appears when that same cheapest variant is discounted. */
    function siblingPricing(entry) {
      var vs = (entry && entry.variants) || [];
      var minPrice = null,
        maxPrice = null,
        minVar = null;
      for (var i = 0; i < vs.length; i++) {
        var p = typeof vs[i].price === "number" ? vs[i].price : null;
        if (p == null) continue;
        if (minPrice == null || p < minPrice) {
          minPrice = p;
          minVar = vs[i];
        }
        if (maxPrice == null || p > maxPrice) maxPrice = p;
      }
      var minCompare =
        minVar && typeof minVar.compareAtPrice === "number" ? minVar.compareAtPrice : null;
      var minOnSale = minCompare != null && minPrice != null && minCompare > minPrice;
      return {
        price: minPrice,
        compareAt: minOnSale ? minCompare : null,
        onSale: minOnSale,
        priceVaries: minPrice != null && maxPrice != null && minPrice !== maxPrice,
      };
    }

    /* Own-colour price spread. The product's own sibling entry carries every variant, so when
       it exists the aggregate is the same one a swapped colour renders (`siblingPricing`);
       otherwise the parent is folded with its indexed variant `children`, each using its promo
       price only when that undercuts full price. The parent is ONE representative variant, so
       its own price is not necessarily the group's lowest -- `undercuts` marks the case where
       the price Atomic renders is above the minimum, and `priceVaries` drives the "From"
       prefix. */
    function ownPricing(product) {
      var entry = ownSiblingEntry(product);
      if (entry) {
        var agg = siblingPricing(entry);
        var rendered = product
          ? indexPrice(cfield(product, "ec_price"), cfield(product, "ec_promo_price"))
          : null;
        return {
          price: agg.price,
          compareAt: agg.compareAt,
          onSale: agg.onSale,
          priceVaries: agg.priceVaries,
          undercuts: agg.price != null && rendered != null && agg.price < rendered,
        };
      }
      var min = null,
        max = null,
        minFull = null,
        minPromo = null;
      function num(v) {
        return typeof v === "number" ? v : null;
      }
      function fold(full, promo) {
        var p = promo != null && (full == null || promo < full) ? promo : full;
        if (p == null) return null;
        if (min == null || p < min) {
          min = p;
          minFull = full;
          minPromo = promo;
        }
        if (max == null || p > max) max = p;
        return p;
      }
      var parent = product
        ? fold(num(cfield(product, "ec_price")), num(cfield(product, "ec_promo_price")))
        : null;
      var kids = (product && product.children) || [];
      for (var i = 0; i < kids.length; i++) {
        fold(num(kids[i].ec_price), num(kids[i].ec_promo_price));
      }
      var onSale = minPromo != null && minFull != null && minPromo < minFull;
      return {
        price: min,
        compareAt: onSale ? minFull : null,
        onSale: onSale,
        priceVaries: min != null && max != null && min !== max,
        undercuts: min != null && parent != null && min < parent,
      };
    }

    /* Bundle pricing is shaped like sibling pricing so healPrice can paint one replacement node
       before and after the async bundle-price lookup resolves. */
    function bundlePricing(host) {
      var product = coveoProduct(host);
      if (!product || !tagsHave(product, "bundle")) return null;
      var pair = bundlePairCache[selectedHandleFor(product)];
      if (pair === undefined) {
        ensureBundlePair(selectedHandleFor(product), function () {
          healColour(host);
        });
        return null;
      }
      if (!pair) return null;
      return {
        price: pair.price,
        compareAt: pair.compareAt,
        onSale: pair.compareAt != null,
        priceVaries: false /* a bundle is one price, never a "From" */,
      };
    }

    /* Own handle is the stable colourway identity. `colourCode` is only a label source because
       multiple entries can share a colour code. */
    function ownHandleOf(product) {
      return String(cfield(product, "product_handle") || "");
    }
    function selectedHandleFor(product) {
      var own = ownHandleOf(product);
      return swatchSelection[own] || own;
    }
    /* The product's own colourway entry: the parsed sibling whose handle is the card's own and
       that carries variants. Primary source for the own colour's stock, price spread, sizes and
       variant ids; Coveo `children` are the fallback and may be absent. */
    function ownSiblingEntry(product) {
      if (!product) return null;
      var own = ownHandleOf(product);
      var entries = parseSiblings(product);
      for (var e = 0; e < entries.length; e++) {
        if (String(entries[e].handle) === own && (entries[e].variants || []).length) {
          return entries[e];
        }
      }
      return null;
    }
    /* Active sibling entry drives every in-place override; null means the own colour renders normally. */
    function activeSiblingEntry(host) {
      var product = coveoProduct(host);
      if (!product) return null;
      var entries = parseSiblings(product);
      if (!entries.length) return null;
      var own = ownHandleOf(product);
      var selH = selectedHandleFor(product);
      if (!selH || selH === own) return null;
      for (var i = 0; i < entries.length; i++) {
        if (String(entries[i].handle) === selH) return entries[i];
      }
      return null;
    }

    /* One-codepoint swatch codes render as glyph tiles; Array.from handles emoji correctly. */
    function letterGlyph(swatchCode) {
      var code = swatchCode ? String(swatchCode) : "";
      if (!code) return null;
      code = code.split(".")[0].trim();
      if (Array.from(code).length !== 1) return null;
      var glyph = code.toUpperCase();
      return { glyph: glyph, emoji: SWATCH_ALNUM.indexOf(glyph) === -1 };
    }

    /* Own colour's swatch, from the product's OWN indexed fields (swatch_image_url /
       swatch_hex) and its own `swatch:` tag (letter glyph). Used when the product carries
       no `siblings_json` yet (its payload has not reached the index); this mirrors
       product-swatches.liquid's SOLO branch, which draws the product's own single swatch
       from its own swatch fields. */
    function ownSwatchCode(product) {
      var tags = coveoTags(product);
      var raw = "";
      /* Last `swatch:` tag wins, matching product-swatch-members' own scan. */
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].indexOf("swatch:") === 0) raw = tags[i].slice(7);
      }
      return raw ? raw.split(".")[0].trim() : "";
    }
    /* Colour label: the `colour:` tag name, else the indexed title (ec_name) -- the native
       `colour:` tag -> title fallback, used only for the swatch aria-label/title. */
    function ownColourLabel(product) {
      var tags = coveoTags(product);
      var name = "";
      for (var i = 0; i < tags.length; i++) {
        if (tags[i].indexOf("colour:") === 0) name = tags[i].slice(7).trim();
      }
      if (name) return name;
      var ec = cfield(product, "ec_name");
      return ec ? String(ec) : "";
    }
    function ownSwatchMember(product) {
      var code = ownSwatchCode(product);
      var glyph = letterGlyph(code);
      var imageRaw = cfield(product, "swatch_image_url");
      var image = typeof imageRaw === "string" ? imageRaw : "";
      var hexRaw = cfield(product, "swatch_hex");
      var hex = typeof hexRaw === "string" ? hexRaw : "";
      /* Visual gate (native ps_render): a colour with no swatch code, image or hex is not a
         swatch; a coded colour with no image or hex draws the neutral fallback dot. */
      if (!glyph && !image && !hex && !code) return null;
      return {
        handle: ownHandleOf(product),
        colourCode: "",
        selected: true,
        label: ownColourLabel(product),
        glyph: glyph,
        image: image,
        hex: hex,
        fallback: !glyph && !image && !hex,
        oos: !productInStock(product),
      };
    }

    /* Derive visible swatches from the pre-baked sibling set: one swatch per visible sibling
       handle, own colour first, capped at the native card limit with a "+N" chip. */
    function swatchMembers(product) {
      var raw = parseSiblings(product);
      /* No sibling data (the product's payload has not reached the index): render the
         product's OWN single swatch from its own fields, mirroring product-swatches.liquid's
         SOLO branch. A product with no swatch visual still yields no row (ownSwatchMember
         returns null). */
      if (!raw.length) {
        var own = ownSwatchMember(product);
        if (!own) return null;
        return { members: [own], overflow: 0, handle: own.handle, colourCode: "" };
      }
      var ownHandle = ownHandleOf(product);
      var selectedHandle = selectedHandleFor(product);
      /* The displayed colour resolves over the FULL set so the "+N" chip still points at the
         own PDP when the own colour has no swatch of its own. */
      var all = orderSiblings(raw, ownHandle);
      var displayed = all[0];
      for (var d = 0; d < all.length; d++) {
        if (String(all[d].handle) === selectedHandle) {
          displayed = all[d];
          break;
        }
      }
      /* Pin the OWN colourway first (frozen layout); the ring follows the SELECTED colour.
         Hidden siblings are dropped before ordering so they take no slot. */
      var entries = orderSiblings(visibleSiblings(raw, ownHandle, selectedHandle), ownHandle);
      var members = [];
      for (var o = 0; o < entries.length && o < SWATCH_MAX; o++) {
        var e = entries[o];
        var glyph = letterGlyph(e.swatchCode);
        var image = typeof e.swatchImageUrl === "string" ? e.swatchImageUrl : "";
        var hex = typeof e.swatchHex === "string" ? e.swatchHex : "";
        members.push({
          handle: String(e.handle || ""),
          colourCode: String(e.colourCode || ""),
          selected: String(e.handle) === selectedHandle,
          label: colourLabel(e),
          glyph: glyph,
          image: image,
          hex: hex,
          fallback: !glyph && !image && !hex,
          oos: siblingOOS(e),
        });
      }
      return {
        members: members,
        overflow: Math.max(0, entries.length - SWATCH_MAX),
        handle: String((displayed && displayed.handle) || ""),
        colourCode: String((displayed && displayed.colourCode) || ""),
      };
    }

    /* Shopify Files CDN accepts a width param -- request a swatch-sized rendition
       instead of the full upload (mirrors swatch.liquid's image_url: width: 48). */
    function swatchImageSrc(url) {
      if (url.indexOf("cdn.shopify.com") === -1) return url;
      return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=48";
    }

    /* Uncapped colourway set for the shared quick-add flyout, carried on the variant
       carrier because an atomic-product shadow root can hold neither the mapper scope nor a
       server-rendered swatch template. Each entry pairs a swatch visual with that colour's
       swap payload, so the drawer renders the same row + sibling map the native card's
       `product-swatches ... max: 0` template gives it, and one swap handler serves both.
       A product whose group is its own single colourway still yields that one swatch from
       its one-entry payload, and so does a product whose payload has not reached the index
       yet: its own swatch comes from its own indexed fields, the same SOLO branch the card
       face takes, so the drawer row matches the card and the native `product-swatches`
       template.

       Prices, sizes and stock come from the indexed sibling payload -- the same source the
       card face already swaps colours from -- not a live fetch per colourway. */
    function flyoutColourways(product) {
      var raw = parseSiblings(product);
      if (!raw.length) {
        var own = ownSwatchMember(product);
        if (!own) return [];
        /* The drawer already shows this product, so its own entry is never swapped to; the
           payload only has to be well-formed. Sizes stay with the carrier's own variants. */
        var ownTags = coveoTags(product);
        var ownPrice = ownPricing(product);
        var ownImages = cfield(product, "ec_images");
        return [
          {
            handle: own.handle,
            label: own.label,
            glyph: own.glyph ? own.glyph.glyph : "",
            glyphEmoji: !!(own.glyph && own.glyph.emoji),
            image: own.image ? swatchImageSrc(own.image) : "",
            hex: own.hex,
            fallback: own.fallback,
            oos: own.oos,
            selected: true,
            title: String(cfield(product, "ec_name") || ""),
            price: dollarsToMoney(ownPrice.price),
            compare: dollarsToMoney(ownPrice.compareAt),
            thumb: Array.isArray(ownImages) ? ownImages[0] || "" : String(ownImages || ""),
            colour: own.label,
            available: !own.oos,
            id: numericId(cfield(product, "ec_product_id")),
            url: rootUrl() + "products/" + own.handle,
            action: tagsHaveExact(ownTags, "comingSoon:true")
              ? "coming-soon"
              : tagsHaveExact(ownTags, "notifyMe:disable")
                ? "disabled"
                : "default",
            variants: [],
          },
        ];
      }
      var selected = selectedHandleFor(product);
      /* Same visibility rule as the card face, so the drawer never offers a colour the row hid. */
      var entries = visibleSiblings(raw, ownHandleOf(product), selected);
      var out = [];
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        var glyph = letterGlyph(e.swatchCode);
        var image = typeof e.swatchImageUrl === "string" ? e.swatchImageUrl : "";
        var hex = typeof e.swatchHex === "string" ? e.swatchHex : "";
        var pricing = siblingPricing(e);
        var tags = entryTags(e);
        var vs = e.variants || [];
        var variants = [];
        for (var v = 0; v < vs.length; v++) {
          var vid = numericId(vs[v].variantId);
          if (!vid) continue;
          variants.push({
            id: Number(vid),
            size: vs[v].size,
            available: vs[v].available !== false,
          });
        }
        out.push({
          handle: String(e.handle || ""),
          label: colourLabel(e),
          glyph: glyph ? glyph.glyph : "",
          glyphEmoji: !!(glyph && glyph.emoji),
          image: image ? swatchImageSrc(image) : "",
          hex: hex,
          fallback: !glyph && !image && !hex,
          oos: siblingOOS(e),
          selected: String(e.handle) === selected,
          /* Swap payload: what the drawer repaints when this swatch is chosen. */
          title: String(e.title || ""),
          price: dollarsToMoney(pricing.price),
          compare: dollarsToMoney(pricing.compareAt),
          thumb: (e.images || [])[0] || "",
          colour: colourLabel(e),
          available: !siblingOOS(e),
          id: numericId(e.productId),
          url: rootUrl() + "products/" + String(e.handle || ""),
          action: tagsHaveExact(tags, "comingSoon:true")
            ? "coming-soon"
            : tagsHaveExact(tags, "notifyMe:disable")
              ? "disabled"
              : "default",
          variants: variants,
        });
      }
      /* Uncapped rows are alphabetical (product-swatches sorts glyph-or-colour-name when
         there is no stacked-card order to preserve). */
      out.sort(function (a, b) {
        var ka = (a.glyph || a.label).toLowerCase();
        var kb = (b.glyph || b.label).toLowerCase();
        return ka < kb ? -1 : ka > kb ? 1 : 0;
      });
      return out;
    }

    function buildSwatchRow(host) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var container = root.querySelector("[data-pc-swatches]");
      if (!container) return; /* show_swatches:false render, or a non-card template */
      var product = coveoProduct(host);
      if (!product) return; /* host.product not attached yet -- the per-host observer retries */
      var data = swatchMembers(product);
      if (!data) return;
      /* Structure and full signatures separate node rebuilds from ring-only selection patches. */
      var structure =
        data.members
          .map(function (m) {
            return (
              m.handle +
              "~" +
              (m.glyph
                ? "g" + m.glyph.glyph
                : m.image
                  ? "i" + m.image
                  : m.fallback
                    ? "f"
                    : "x" + m.hex) +
              (m.oos ? "!" : "")
            );
          })
          .join(",") +
        "|+" +
        data.overflow;
      var full = structure + "|@" + data.handle;
      if (container.getAttribute("data-pc-swatches-full") === full) return;
      if (
        container.getAttribute("data-pc-swatches-structure") === structure &&
        container.children.length
      ) {
        /* Ring-only change: move aria-pressed + the selected class, repoint the "+N"
           chip at the newly displayed colour's PDP. No node churn -- images persist. */
        var btns = container.querySelectorAll("[data-pc-swatch]");
        /* Persistent buttons would animate the selection ring, unlike the native card's
           instant re-render. Suppress the transition for this ring move only. */
        var pRings = [];
        for (var pr = 0; pr < btns.length; pr++) {
          var pRing = btns[pr].querySelector(".pc-swatch__ring");
          if (pRing) {
            pRing.style.transition = "none";
            pRings.push(pRing);
          }
        }
        for (var pb = 0; pb < btns.length; pb++) {
          var pSel = btns[pb].getAttribute("data-pc-swatch-handle") === data.handle;
          btns[pb].classList.toggle("pc-swatch--selected", pSel);
          btns[pb].setAttribute("aria-pressed", pSel ? "true" : "false");
        }
        /* Restore the stylesheet transition after the instant ring change has painted,
           so subsequent hover fades still run. */
        requestAnimationFrame(function () {
          for (var rr = 0; rr < pRings.length; rr++) pRings[rr].style.transition = "";
        });
        var pChip = container.querySelector(".pc-swatch-more");
        if (pChip) pChip.setAttribute("href", rootUrl() + "products/" + data.handle);
        container.setAttribute("data-pc-swatches-full", full);
        return;
      }
      container.setAttribute("data-pc-swatches-structure", structure);
      container.setAttribute("data-pc-swatches-full", full);
      container.innerHTML = "";
      if (!data.members.length) {
        container.setAttribute("hidden", "");
        return;
      }
      var oosLabel = cardLabel(container, "data-pc-oos-label");
      var frag = document.createDocumentFragment();
      for (var i = 0; i < data.members.length; i++) {
        var m = data.members[i];
        var btn = document.createElement("button");
        btn.type = "button";
        var cls = "pc-swatch";
        if (m.glyph) {
          cls += " pc-swatch--glyph";
          if (m.glyph.emoji) cls += " pc-swatch--glyph-emoji";
        }
        if (m.selected) cls += " pc-swatch--selected";
        if (m.oos) cls += " pc-swatch--oos";
        btn.className = cls;
        btn.setAttribute("data-pc-swatch", "");
        btn.setAttribute("data-pc-swatch-handle", m.handle);
        btn.setAttribute("aria-pressed", m.selected ? "true" : "false");
        btn.setAttribute("aria-label", m.oos && oosLabel ? m.label + ", " + oosLabel : m.label);
        var ring = document.createElement("span");
        ring.className = "pc-swatch__ring";
        ring.setAttribute("aria-hidden", "true");
        if (m.glyph) {
          var glyphEl = document.createElement("span");
          glyphEl.className = "pc-swatch__glyph";
          glyphEl.textContent = m.glyph.glyph;
          ring.appendChild(glyphEl);
        } else if (m.image) {
          var dot = document.createElement("span");
          dot.className = "pc-swatch__dot pc-swatch__dot--image";
          var img = document.createElement("img");
          img.className = "pc-swatch__img";
          img.src = swatchImageSrc(m.image);
          img.alt = "";
          img.loading = "lazy";
          /* Sync decode: a 48px swatch is trivial to decode, and async decode paints an
             empty dot for a frame on rebuilds (the pop the patch path above avoids). */
          img.decoding = "sync";
          dot.appendChild(img);
          ring.appendChild(dot);
        } else if (m.fallback) {
          var dot3 = document.createElement("span");
          dot3.className = "pc-swatch__dot pc-swatch__dot--fallback";
          ring.appendChild(dot3);
        } else {
          var dot2 = document.createElement("span");
          dot2.className = "pc-swatch__dot";
          dot2.style.setProperty("--pcsw-color", m.hex);
          ring.appendChild(dot2);
        }
        btn.appendChild(ring);
        frag.appendChild(btn);
      }
      if (data.overflow > 0) {
        var more = document.createElement("a");
        more.className = "pc-swatch-more";
        more.href = rootUrl() + "products/" + data.handle;
        more.textContent = "+" + data.overflow;
        var moreLabel = cardLabel(container, "data-pc-more-label");
        if (moreLabel)
          more.setAttribute("aria-label", moreLabel.replace("%d", String(data.overflow)));
        frag.appendChild(more);
      }
      container.appendChild(frag);
      container.removeAttribute("hidden");
    }

    /* Swatch clicks re-skin visible DOM while host.product stays unchanged; observers reapply
       the selected handle after Lit rebuilds. */

    /* Derive money formatting from Atomic's own price text, then reuse it for sibling prices
       so locale symbols and suffixes stay aligned. */
    function moneyTemplate(priceEl) {
      var txt = "";
      if (priceEl) {
        var cur = priceEl.querySelector("div > div");
        txt = ((cur ? cur.textContent : priceEl.textContent) || "").replace(/​/g, "").trim();
      }
      var m = txt.match(/[\d.,]+/);
      if (!m) return { prefix: "$", suffix: "" };
      return { prefix: txt.slice(0, m.index), suffix: txt.slice(m.index + m[0].length) };
    }
    function fmtMoney(amount, tpl) {
      if (amount == null) return "";
      var s = Math.abs(amount).toFixed(2).split(".");
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (amount < 0 ? "-" : "") + tpl.prefix + s.join(".") + tpl.suffix;
    }

    /* Patching the in-card PDP links makes wishlist, quick-add, analytics, and the compact
       view-details link follow the displayed colour. */
    function healName(host, sel) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var product = coveoProduct(host);
      if (!product) return;
      var href = rootUrl() + "products/" + (sel ? String(sel.handle) : ownHandleOf(product));
      var nameA = root.querySelector(".pcard__name a, .pcard-c__name a");
      if (nameA) {
        if (sel) {
          if (nameA.getAttribute("href") !== href) nameA.setAttribute("href", href);
          var t = String(sel.title || "");
          if (t && nameA.textContent.trim() !== t) nameA.textContent = t;
          nameA.setAttribute("data-pc-name-swapped", "1");
        } else if (nameA.getAttribute("data-pc-name-swapped") === "1") {
          if (nameA.getAttribute("href") !== href) nameA.setAttribute("href", href);
          var ownT = String(cfield(product, "ec_name") || "");
          if (ownT && nameA.textContent.trim() !== ownT) nameA.textContent = ownT;
          nameA.removeAttribute("data-pc-name-swapped");
        }
      }
      /* Href-only links also follow the displayed colour: compact "View details" and Coveo's
         whole-card wrapper link. */
      var hrefLinks = root.querySelectorAll(".pcard-c__view a, .link-container a");
      for (var i = 0; i < hrefLinks.length; i++) {
        var a = hrefLinks[i];
        if (sel) {
          if (a.getAttribute("href") !== href) a.setAttribute("href", href);
          a.setAttribute("data-pc-name-swapped", "1");
        } else if (a.getAttribute("data-pc-name-swapped") === "1") {
          if (a.getAttribute("href") !== href) a.setAttribute("href", href);
          a.removeAttribute("data-pc-name-swapped");
        }
      }
    }

    /* Displayed sibling and bundle prices replace the Lit-owned Atomic price so cards show
       the selected colour or resolved bundle total instead of the indexed parent price. */
    function healPrice(host, sel) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var wrap = root.querySelector(".pcard__price, .pcard-c__price");
      if (!wrap) return;
      var apPrice = wrap.querySelector("atomic-product-price");
      var fromEl = wrap.querySelector(".pcard__from, .pcard-c__from");
      var sib = wrap.querySelector("[data-pc-price-sib]");
      var pricing = bundlePricing(host);
      if (!pricing && !sel) {
        var own = ownPricing(coveoProduct(host));
        /* "From" has to name the group's lowest price, and the parent document Atomic prices is
           one representative variant. Paint the aggregate minimum when it undercuts that price;
           otherwise the Atomic node already shows the lowest and stays untouched. */
        if (!own.undercuts) {
          if (sib) wrap.removeChild(sib);
          if (apPrice) apPrice.style.removeProperty("display");
          if (fromEl) fromEl.hidden = !own.priceVaries;
          return;
        }
        pricing = own;
      }
      if (!pricing) pricing = siblingPricing(sel);
      var tpl = moneyTemplate(apPrice);
      var sig =
        pricing.price +
        "|" +
        pricing.compareAt +
        "|" +
        pricing.onSale +
        "|" +
        tpl.prefix +
        "|" +
        tpl.suffix;
      if (!sib) {
        sib = document.createElement("span");
        sib.className = "pc-price-sib";
        sib.setAttribute("data-pc-price-sib", "");
        wrap.appendChild(sib);
      }
      if (sib.getAttribute("data-pc-price-sig") !== sig) {
        sib.setAttribute("data-pc-price-sig", sig);
        sib.innerHTML = "";
        var cur = document.createElement("span");
        cur.className = "pc-price-sib__cur" + (pricing.onSale ? " pc-price-sib__cur--sale" : "");
        cur.textContent = fmtMoney(pricing.price, tpl);
        sib.appendChild(cur);
        if (pricing.onSale && pricing.compareAt != null) {
          var cmp = document.createElement("span");
          cmp.className = "pc-price-sib__cmp";
          cmp.textContent = fmtMoney(pricing.compareAt, tpl);
          sib.appendChild(cmp);
        }
      }
      if (apPrice) apPrice.style.display = "none";
      /* Same prefix node, now gated on the DISPLAYED pricing: a swapped colourway whose sizes are
         priced differently keeps "From" (native parity); a bundle (priceVaries false) drops it. */
      if (fromEl) fromEl.hidden = !pricing.priceVaries;
    }

    /* Compact card single image (no gallery): overlay the displayed colour's first image and
       hide the Lit-owned atomic-product-image; restore on the own colour. */
    function healCompactImage(host, sel) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var media = root.querySelector(".pcard-c__media");
      if (!media) return;
      var atomicImg = media.querySelector(".pcard-c__image");
      var sib = media.querySelector("[data-pc-cimg-sib]");
      if (!sel) {
        if (sib) media.removeChild(sib);
        if (atomicImg) atomicImg.style.removeProperty("display");
        return;
      }
      var src = sel.images && sel.images[0] ? String(sel.images[0]) : "";
      /* A sibling with no image uses the neutral placeholder, never the own colour's photo. */
      if (!src && atomicImg) src = atomicImg.getAttribute("fallback") || "";
      if (src.indexOf("//") === 0) src = "https:" + src;
      var sibSrcset = gallerySrcset(src);
      src = withImageWidth(src, GALLERY_IMG_WIDTH);
      if (!src) {
        /* no sibling image AND no placeholder -> last-resort own image */
        if (sib) media.removeChild(sib);
        if (atomicImg) atomicImg.style.removeProperty("display");
        return;
      }
      if (!sib) {
        sib = document.createElement("img");
        sib.className = "pcard-c__image-sib";
        sib.setAttribute("data-pc-cimg-sib", "");
        sib.loading = "lazy";
        media.appendChild(sib);
      }
      if (sib.getAttribute("src") !== src) sib.setAttribute("src", src);
      if (sibSrcset && sib.getAttribute("srcset") !== sibSrcset) {
        sib.setAttribute("srcset", sibSrcset);
        sib.setAttribute("sizes", gallerySizes());
      }
      sib.alt = String(sel.title || "");
      if (atomicImg) atomicImg.style.display = "none";
    }

    /* Badge and quick-add mode follow the displayed colour's tags. Runtime badges take over
       when optional Coveo badge/state fields are missing. */
    function healBadges(host, sel) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var overlay = root.querySelector(".pcard__overlay");
      if (!overlay) return; /* compact / no overlay */
      var product = coveoProduct(host);
      if (!product) return;
      var labels = overlay.querySelector("[data-pc-badges]");
      var decl = overlay.querySelectorAll(".pcard__badge:not([data-pc-badge-sib])");
      var strip = root.querySelector("[data-pc-quickadd-strip]");
      var plus = root.querySelector(".pcard__plus");
      var prior = overlay.querySelector("[data-pc-badge-sib]");
      var d;
      /* Displayed colour's tags -> badge. Precedence: state > sale > new. */
      var tags = displayedTags(host, sel);
      var state = stateFromTags(tags);
      var type =
        state ||
        (tagsHaveExact(tags, "priceType:Sale")
          ? "sale"
          : tagsHaveExact(tags, "newIn:Yes")
            ? "new"
            : "");
      /* Hide the superseded declarative badges + set the quick-add mode. Only `display`
         is ever cleared to '' (never a concrete value), so the >=1025px rule that hides
         the "+" in favour of the hover strip keeps winning. */
      for (d = 0; d < decl.length; d++) decl[d].style.display = "none";
      var register = state === "coming-soon";
      var suppress = !!state && !register;
      if (strip) strip.style.display = suppress ? "none" : "";
      if (plus) plus.style.display = suppress ? "none" : "";
      /* Relabel both entry points for the mode. The textContent write re-enters the shadow
         observer, so it is change-gated -- the re-entrant pass is an immediate no-op. */
      if (labels) {
        var riLabel = cardLabel(labels, "data-register-interest");
        var action = strip ? strip.querySelector("[data-pc-quickadd-action]") : null;
        if (action) {
          var actionLabel = register ? riLabel : cardLabel(labels, "data-add-to-bag");
          if (action.textContent !== actionLabel) action.textContent = actionLabel;
          action.setAttribute("aria-label", actionLabel);
        }
        if (plus)
          plus.setAttribute(
            "aria-label",
            register ? riLabel : cardLabel(labels, "data-quickadd-toggle"),
          );
      }
      /* childList write (append/remove the custom badge) ONLY when the badge changed, so the
         shadow observer's re-entry is an immediate no-op -- no loop. */
      var have = prior ? prior.getAttribute("data-pc-badge-type") || "" : "";
      if (have === type) return;
      if (prior) overlay.removeChild(prior);
      if (type && labels) {
        var span = document.createElement("span");
        span.className = "pcard__badge pcard__badge--" + type;
        span.setAttribute("data-pc-badge-sib", "");
        span.setAttribute("data-pc-badge-type", type);
        span.appendChild(document.createTextNode(cardLabel(labels, "data-" + type)));
        if (state) {
          var a11y = cardLabel(labels, "data-" + type + "-a11y");
          if (a11y) {
            var sr = document.createElement("span");
            sr.className = "pcard__badge-sr";
            sr.textContent = a11y;
            span.appendChild(sr);
          }
        }
        overlay.appendChild(span);
      }
    }

    /* Normalize Atomic AUD/NZD symbols to storefront `$` plus active market code, editing
       text nodes idempotently. */
    function healPriceSymbol(host) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var wrap = root.querySelector(".pcard__price, .pcard-c__price");
      if (!wrap) return;
      var code = document.documentElement.getAttribute("data-currency-code") || "";
      var walker = document.createTreeWalker(wrap, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (!t) continue;
        var next = t;
        if (next.indexOf("A$") !== -1 || next.indexOf("NZ$") !== -1) {
          next = next.replace(/A\$/g, "$").replace(/NZ\$/g, "$");
        }
        /* Append the market currency code after the last digit run; leave nodes already carrying it untouched. */
        if (code && next.indexOf(code) === -1 && /\d/.test(next)) {
          next = next.replace(/([\d.,]*\d)(?![\s\S]*\d)/, "$1 " + code);
        }
        if (next !== t) node.nodeValue = next;
      }
    }

    /* Re-heal observer-owned parts for the selected colour; gallery, chips, and wishlist
       have their own healers. */
    function healColour(host) {
      adoptCardStyles(host); /* lift (or re-assert) the shared card stylesheet first */
      var sel = activeSiblingEntry(host);
      healPriceSymbol(host); /* strip the A$/NZ$ prefix before healPrice reads the price */
      healName(host, sel);
      buildSwatchRow(host);
      healPrice(host, sel);
      healBadges(host, sel);
      healCompactImage(host, sel);
      buildPromoLine(host);
    }

    /* Click-time gallery rebuild resets stale slides/listeners, restores the Atomic-image
       baseline, and reruns gallery initialisation for the selected colour. */
    function rebuildGallery(host) {
      var card = currentCard(host);
      if (!card) return;
      var oldTrack = card.querySelector("[data-pc-gallery-track]");
      if (oldTrack && (leadIO || swapIO)) {
        var staleLeads = oldTrack.querySelectorAll("img[data-pc-src]");
        for (var sl = 0; sl < staleLeads.length; sl++) {
          try {
            if (leadIO) leadIO.unobserve(staleLeads[sl]);
            if (swapIO) swapIO.unobserve(staleLeads[sl]);
          } catch (e) {}
        }
      }
      if (oldTrack) oldTrack.parentNode.replaceChild(oldTrack.cloneNode(false), oldTrack);
      ["[data-pc-gallery-prev]", "[data-pc-gallery-next]"].forEach(function (s) {
        var b = card.querySelector(s);
        if (b) b.parentNode.replaceChild(b.cloneNode(true), b);
      });
      card.dataset.pcGalleryInit = "";
      card.dataset.pcGalleryTotal = "";
      var gallery = card.querySelector("[data-pc-gallery]");
      if (gallery) gallery.setAttribute("hidden", "");
      var atomicImg = card.querySelector(".pcard__image");
      if (atomicImg) atomicImg.style.removeProperty("display");
      var arrows = card.querySelectorAll(".pcard__arrow");
      for (var a = 0; a < arrows.length; a++) arrows[a].setAttribute("hidden", "");
      var progress = card.querySelector("[data-pc-gallery-progress]");
      if (progress) progress.setAttribute("hidden", "");
      initGallery(card, host);
    }

    /* Apply swatch clicks immediately, then refresh gallery, size chips, and wishlist identity
       that would otherwise wait for a Lit re-render. */
    function applyColour(host) {
      if (!host || !host.shadowRoot) return;
      healColour(host);
      rebuildGallery(host);
      refillStrip(host);
      /* Only the clicked card's heart changed identity -- re-hydrate just it, not a full-page
         collectAtomicHosts() BFS + every heart on the grid. */
      hydrateWishlist([host]);
    }

    /* One per-host observer re-heals all swatch-owned card parts after Lit replaces nodes;
       each healer is signature-gated to avoid mutation loops. */
    function runHostHeals(host) {
      healColour(host); /* swatch row + name/links + price + badges + promo + compact image */
      refillStrip(host); /* size chips (no-op for cards without a strip) */
      if (host.__pcGalleryArmed) initGallery(currentCard(host), host);
      if (window.SeedWishlist && window.SeedWishlist.savedHandles) {
        hydrateWishlistHost(
          host,
          window.SeedWishlist.savedHandles(),
          window.SeedWishlist.isUnavailable(),
        );
      }
    }
    function ensureHostObserver(host) {
      if (!host || !host.shadowRoot || hostObservers.has(host)) return;
      bindHostIntent(host);
      var observer = new MutationObserver(function () {
        runHostHeals(host);
      });
      hostObservers.set(host, observer);
      observer.observe(host.shadowRoot, { childList: true, subtree: true });
    }

    /* Promo line renders the displayed colour's winning promo-message rule; signature gating
       keeps observer re-entry idempotent and lets Lit rebuilds self-heal. */
    function buildPromoLine(host) {
      var root = host && host.shadowRoot;
      if (!root) return;
      var el = root.querySelector("[data-pc-promo]");
      if (!el) return; /* show-details:false or a non-card template */
      var product = coveoProduct(host);
      if (!product) return; /* host.product not attached yet -- the observer retries */
      /* When a sibling colour is shown, the rules run on the sibling's tags and handle. */
      var sel = activeSiblingEntry(host);
      var promoTags = sel ? entryTags(sel) : coveoTags(product);
      var promoHandle = sel ? String(sel.handle || "") : ownHandleOf(product);
      var promo = resolvePromo(promoTags, promoHandle);
      if (el.getAttribute("data-pc-promo-text") === promo) return; /* unchanged -- no-op */
      el.setAttribute("data-pc-promo-text", promo);
      el.textContent = promo;
      if (promo) {
        el.removeAttribute("hidden");
      } else {
        el.setAttribute("hidden", "");
      }
    }

    /* Build swatch rows on every Coveo surface, including predictive and compact drawer cards.
       List-observer arming rides the shared host traversal so replacement hosts are healed
       before paint. */
    function hydrateSwatches(hosts) {
      if (!Array.isArray(hosts)) hosts = collectAtomicHosts();
      for (var k = 0; k < hosts.length; k++) {
        /* Healing (sibling parse, swatch imgs, badge/price walks) is deferred until the
           card approaches the viewport; the arm path runs the same heals then. */
        if (!hosts[k].__pcGalleryArmed && !hosts[k].__pcEagerHeal) continue;
        ensureHostObserver(hosts[k]);
        healColour(hosts[k]);
      }
    }

    /* The shared hydrate pass: one traversal feeding both consumers. Returns the host count so
       the boot sweep can back off once discovery has settled. */
    function hydrateCards() {
      var hosts = collectAtomicHosts();
      hydrateWishlist(hosts);
      hydrateSwatches(hosts);
      return hosts.length;
    }

    /* Size-chip enhancement starts from static quick-add markup; Coveo supplies labels and
       index stock, while live product fetches are reserved for interaction-time certainty. */
    /* Size labels come from the displayed colour's pre-baked sibling entry, falling back to
       Coveo children. `availOut` records labels with at least one in-stock variant so the same
       walk can mark sold-out chips. */
    function coveoSizes(host, availOut) {
      var product = coveoProduct(host);
      var sizes = [];
      /* Displayed sibling variants are the complete size source. For the own colour, prefer its
         pre-baked entry because Coveo children can be narrowed by variant-level facets or be
         absent altogether. */
      var sel = activeSiblingEntry(host) || ownSiblingEntry(product);
      if (sel) {
        var vs = sel.variants || [];
        for (var v = 0; v < vs.length; v++) {
          var s = vs[v] && vs[v].size != null ? String(vs[v].size).trim() : "";
          if (!s || s.toLowerCase() === "default title" || s.indexOf("/") !== -1) continue;
          if (sizes.indexOf(s) === -1) sizes.push(s);
          if (availOut && vs[v].available !== false) availOut[s] = true;
        }
      } else {
        var kids = (product && product.children) || [];
        /* children now span this colour's variants (grouping repointed ec_item_group_id to
           the per-colour product id); filter to the DISPLAYED product's handle defensively. */
        var parentHandle = product ? String(cfield(product, "product_handle") || "") : "";
        for (var i = 0; i < kids.length; i++) {
          if (parentHandle && String(cfield(kids[i], "product_handle") || "") !== parentHandle)
            continue;
          var label = cfield(kids[i], "shp_variant_title");
          if (label == null) continue;
          label = String(label).trim();
          if (!label || label.toLowerCase() === "default title" || label.indexOf("/") !== -1)
            continue;
          if (sizes.indexOf(label) === -1) sizes.push(label);
          if (availOut && coveoInStock(kids[i], product)) availOut[label] = true;
        }
      }
      if (window.SeedQuickAdd && typeof window.SeedQuickAdd.sortSizes === "function") {
        sizes = window.SeedQuickAdd.sortSizes(sizes);
      }
      return sizes;
    }

    /* Chip presence switches the strip from the single action to label-plus-size chips. */
    function enhanceSizes(card, host, handle) {
      var container = card.querySelector("[data-pc-quickadd-sizes]");
      if (!container) return;
      var indexAvail = {};
      var sizes = coveoSizes(host, indexAvail);
      /* State colours never get chips; the strip stays as the relabelled single action or hidden. */
      if (sizes.length < 2 || displayedState(host)) {
        if (container.children.length) container.innerHTML = "";
        container.removeAttribute("data-pc-sizes-key");
        return;
      }
      var key = handle + "|" + sizes.join("|");
      if (
        container.getAttribute("data-pc-sizes-key") === key &&
        container.children.length === sizes.length
      ) {
        return;
      }
      var frag = document.createDocumentFragment();
      for (var s = 0; s < sizes.length; s++) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "pcard__quickadd-size";
        btn.setAttribute("data-pc-size", sizes[s]);
        btn.textContent = sizes[s];
        frag.appendChild(btn);
      }
      container.innerHTML = "";
      container.appendChild(frag);
      container.setAttribute("data-pc-sizes-key", key);
      /* Live stock wins for the own colour; sibling colours keep pre-baked availability. If
         index stock has no usable signal, leave chips unmarked until the live fetch decides. */
      var sizeSel = activeSiblingEntry(host);
      if (!sizeSel && productCache[handle]) markSoldOut(card, productCache[handle]);
      else if (Object.keys(indexAvail).length) applySoldOut(container, indexAvail);
    }

    /* One availability applier serves Coveo index data and the live payload, so treatment
       cannot drift and live stock can re-enable index-missed sizes. */
    function applySoldOut(container, availBySize) {
      if (!container) return;
      var chips = container.querySelectorAll("[data-pc-size]");
      for (var c = 0; c < chips.length; c++) {
        var chip = chips[c];
        var soldOut = !availBySize[String(chip.getAttribute("data-pc-size"))];
        chip.classList.toggle("pcard__quickadd-size--sold-out", soldOut);
        chip.disabled = soldOut;
      }
    }

    /* Mark sold-out size chips from the live product payload; leave chips enabled when the
       payload has no size axis to gate against. */
    function markSoldOut(card, product) {
      if (!product) return;
      var container = card.querySelector("[data-pc-quickadd-sizes]");
      if (!container) return;
      var sizeIdx = optionIndex(product.options, /size/i);
      if (sizeIdx === -1) return;
      var availBySize = {};
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var size = (v.options || [])[sizeIdx];
        if (size == null) continue;
        if (v.available) availBySize[String(size)] = true;
      }
      applySoldOut(container, availBySize);
    }

    /* The .pcard currently inside a host's shadow root. The shadowRoot persists across
       Lit re-renders (which replace the .pcard node), so this always returns the live
       card. */
    function currentCard(host) {
      return host && host.shadowRoot ? host.shadowRoot.querySelector(".pcard") : null;
    }

    /* Re-apply size chips to the host's current card. When Lit briefly drops the card link,
       fall back to the handle stamped during discovery so chips do not wait for the next hover. */
    function refillStrip(host) {
      var card = currentCard(host);
      if (!card) return;
      var handle = handleForCard(card) || (host && host.dataset ? host.dataset.pcHandle : "");
      if (handle) enhanceSizes(card, host, handle);
    }

    /* Render size chips from Coveo data and wire the unified host observer. The observer
       restores chips after Lit re-renders, and signature keys keep re-entry a no-op. */
    function enhanceStrip(card, host) {
      /* Only enhance cards that actually carry a size strip. */
      if (!card || !card.querySelector("[data-pc-quickadd-strip]")) return;
      var handle = handleForCard(card);
      if (!handle) return;
      if (host) {
        host.dataset.pcHandle = handle;
        ensureHostObserver(host);
        /* Enhance the LIVE card via the host (refillStrip re-derives currentCard + handle):
           Lit may have replaced `card`, so target the host's CURRENT card. */
        refillStrip(host);
      } else {
        enhanceSizes(card, host, handle);
      }
    }

    /* Apply the live payload to a card's strip: populate the add carrier + mark sold-out.
       `currentCard` guards against a Lit re-render having replaced the node. */
    function applyLive(card, host, handle, product) {
      if (!product) return;
      var live = currentCard(host) || card;
      var changed = ensureVariants(live, host, handle, product);
      markSoldOut(live, product);
      if (changed) announceCarrier(live, handle);
    }

    function cardFromPath(event) {
      var path = (event.composedPath && event.composedPath()) || [];
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (el && el.nodeType === 1 && el.matches && el.matches(".pcard, .pcard-c")) return el;
      }
      return null;
    }

    /* Warm the deduped live product fetch by handle so later add actions have current stock
       and variant ids. This must not depend on the strip node being present during a Lit render. */
    function warmLive(card, host) {
      var handle = handleForCard(card) || (host && host.dataset ? host.dataset.pcHandle : "");
      if (!handle) return;
      ensureLiveProduct(handle, function (product) {
        applyLive(currentCard(host) || card, host, handle, product);
      });
    }

    /* Hover and keyboard focus are quick-add interactions: they warm live stock and re-apply
       chip enhancement without waiting for click. The compact card has no strip and nothing
       to warm, but still announces intent so the PDP prefetch bridge can act on it. */
    function hostIntent(host, warm) {
      var root = host && host.shadowRoot;
      var card = root ? root.querySelector(".pcard, .pcard-c") : null;
      if (!card) return;
      if (warm !== false && card.matches(".pcard")) {
        /* Ensure chips exist (idempotent; usually already done at discovery). */
        enhanceStrip(card, host);
        /* Warm independently of the strip enhancement above. */
        warmLive(card, host);
      }
      card.dispatchEvent(new CustomEvent("product-card:intent", { bubbles: true, composed: true }));
    }

    /* Intent is bound on each atomic-product host, not delegated from document. Every card
       sits inside its list's shadow root, so when the pointer (or focus) moves from one card
       to the next, the event's target and relatedTarget both retarget to the same list host
       at document scope and dispatch truncates the path there: a document-level mouseover or
       focusin only ever fires for the first card entered from outside the grid. The host
       hears its own entries directly (mouseenter is dispatched per element; at host scope the
       focusin relatedTarget is the previous host, so no truncation), and it persists across
       Lit re-renders of its shadow content, so one bind per host is enough. */
    function bindHostIntent(host) {
      if (!host || host.__pcIntentBound) return;
      host.__pcIntentBound = true;
      /* Mouse warming is hover-only; touch uses pointerdown below so shadow-DOM mutations
         do not happen mid-tap. The intent itself is announced on every pointer entry so the
         PDP prefetch bridge keeps working in a narrow desktop window; only the live stock
         warm and the strip enhancement are gated on the hover tier. */
      host.addEventListener(
        "mouseenter",
        function () {
          hostIntent(host, hoverTier());
        },
        { passive: true },
      );
      host.addEventListener(
        "focusin",
        function () {
          hostIntent(host);
        },
        { passive: true },
      );
    }

    /* Document-level fallback for a host hovered or focused before it has been armed and
       bound. It reaches document only on entry from outside the grid; it binds the host so
       every later entry is heard directly. */
    function onIntentFallback(event) {
      var card = cardFromPath(event);
      if (!card) return;
      var host = hostFor(card);
      if (!host || host.__pcIntentBound) return;
      bindHostIntent(host);
      hostIntent(host, event.type !== "mouseover" || hoverTier());
    }
    document.addEventListener("mouseover", onIntentFallback, { passive: true });
    document.addEventListener("focusin", onIntentFallback, { passive: true });
    /* Touch has no hover/focus prewarm, so pointerdown warms the live payload before click. */
    document.addEventListener(
      "pointerdown",
      function (event) {
        var path = (event.composedPath && event.composedPath()) || [];
        var onCtrl = false,
          card = null;
        for (var i = 0; i < path.length; i++) {
          var el = path[i];
          if (!el || el.nodeType !== 1 || !el.matches) continue;
          if (
            !onCtrl &&
            el.matches("[data-pc-quickadd-toggle], [data-pc-quickadd-sizes], [data-pc-size]")
          )
            onCtrl = true;
          if (!card && el.matches(".pcard")) card = el;
          if (onCtrl && card) break;
        }
        if (onCtrl && card) warmLive(card, hostFor(card));
      },
      { passive: true },
    );

    /* ---- Custom image-gallery carousel ----
       Builds slides from indexed `product_media`: native scroll-snap, desktop hover arrows,
       and a touch progress line. Atomic image stays as the no-JS and fallback media path. */
    function deepFind(root, predicate, acc, limit) {
      acc = acc || [];
      /* Uncapped by default: a bounded default silently stopped card discovery at 200,
         leaving deeper infinite-scroll cards without galleries, swatches, or size chips. */
      limit = limit || Infinity;
      if (!root) return acc;
      var queue = [root];
      while (queue.length && acc.length < limit) {
        var el = queue.shift();
        if (!el || el.nodeType !== 1) continue;
        /* A matched element's subtree never contains further matches (cards do not nest
           and lists do not nest), so stop descending there -- at hundreds of loaded
           cards this keeps the walk proportional to the card COUNT, not the card DOM. */
        if (predicate(el)) {
          acc.push(el);
          continue;
        }
        if (el.children) {
          for (var i = 0; i < el.children.length; i++) queue.push(el.children[i]);
        }
        if (el.shadowRoot) {
          for (var j = 0; j < el.shadowRoot.children.length; j++)
            queue.push(el.shadowRoot.children[j]);
        }
      }
      return acc;
    }

    /* Wire scroll to the progress bar and boundary state; arrow clicks page to the adjacent
       snap offset based on the live scroll position, so smooth-scroll mid-flight clicks stay
       aligned to real slides. */
    function wireGallery(card, track, total, host) {
      // A rail-hosted card's gallery is a horizontal scroller nested in the rail's own
      // scroller; the arbiter below needs to know which it is. host drives the shared
      // ResizeObserver track-keying either way.
      var inRail = inRecommendationRail(host);
      var reduce =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var behavior = reduce ? "auto" : "smooth";
      var bar = card.querySelector("[data-pc-gallery-progress-bar]");
      var prev = card.querySelector("[data-pc-gallery-prev]");
      var next = card.querySelector("[data-pc-gallery-next]");
      /* Geometry is read lazily: the slides were appended a moment ago, so reading
         offsets here would force a layout for every card armed in the same task (a
         batch of cards arms together on append and on scroll). The shared
         ResizeObserver delivers an initial notification after layout, which is where
         these get their real values for free; an interaction that arrives first
         measures on demand. */
      var base = 0;
      var maxScroll = -1;
      var measured = false;
      var rendered = -1;
      function measure() {
        measured = true;
        base = track.offsetLeft;
        maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      }

      /* Active slide from the live scroll position (rounds to the nearest slide,
         so this stays correct while a smooth scroll is still settling). A gallery
         that has never scrolled is on slide 0 without measuring anything. */
      function activeIndex() {
        if (!track.scrollLeft) return 0;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx < 0) idx = 0;
        if (idx > total - 1) idx = total - 1;
        return idx;
      }

      /* `instant` makes progress jumps non-animated for hover swaps and rebuilt galleries.
         The transition is suppressed for one frame (restored in the next animation frame)
         rather than flushed with a synchronous layout read. */
      function setBar(idx, instant) {
        if (!bar) return;
        var w = ((idx + 1) / total) * 100 + "%";
        if (!instant) {
          bar.style.width = w;
          return;
        }
        bar.style.transition = "none";
        bar.style.width = w;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.style.transition = "";
          });
        });
      }

      /* `knownIdx` lets the initial paint state at slide 0 be set without touching
         scroll geometry (even `scrollLeft` is a layout read on a freshly built track). */
      function update(instant, knownIdx) {
        var idx = typeof knownIdx === "number" ? knownIdx : activeIndex();
        if (idx === rendered) return;
        rendered = idx;
        setBar(idx, instant === true);
        /* Disable the arrow that has nowhere to go (matches multi-column.liquid's
           data-at-start/end -> button.disabled convention). `disabled` also drops
           it from the tab order; the :disabled style below dims it on hover. */
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= total - 1 || (measured && maxScroll <= 0);
      }

      /* Page to the adjacent slide's snap offset (each slide is flex:0 0 100%, so
         slide.offsetLeft - base is its scroll target). Nowhere to page -> no-op. */
      function pageTo(dir) {
        grantTrackSlides(track);
        var target = activeIndex() + dir;
        if (target < 0 || target > total - 1) return;
        var slide = track.children[target];
        if (!slide) return;
        if (!measured) measure();
        track.scrollTo({ left: slide.offsetLeft - base, behavior: behavior });
      }

      /* Scroll to an absolute slide using the same snap offsets as arrow paging. For instant
         moves, suppress the progress transition, commit the new state, then restore transitions. */
      function goToSlide(idx) {
        grantTrackSlides(track);
        if (idx < 0 || idx > total - 1) return;
        var slide = track.children[idx];
        if (!slide) return;
        if (!measured) measure();
        var prevSB = track.style.scrollBehavior;
        track.style.scrollBehavior = "auto";
        track.scrollTo({ left: slide.offsetLeft - base });
        track.style.scrollBehavior = prevSB;
        /* Sync the progress bar + arrow state to the jump INSTANTLY (no width animation),
           and mark `rendered` so the async scroll-event update() is a no-op for this move. */
        update(true);
      }

      /* Hover-capable media swaps to slide 2 without rebinding stale swatch-gallery handlers. */
      var media = card.querySelector(".pcard__media") || card;
      card.__pcGoToSlide = goToSlide;
      if (!media.__pcHoverBound) {
        media.__pcHoverBound = true;
        media.addEventListener("mouseenter", function () {
          if (!hoverTier()) return;
          var liveTrack = card.querySelector("[data-pc-gallery-track]");
          if (liveTrack) grantTrackSlides(liveTrack);
          /* Video-first cards do not swap on hover; slide 0 must stay visible so playback
             remains active while the pointer is over the media. */
          if (card.dataset.pcGalleryVideoFirst === "1") return;
          if (parseInt(card.dataset.pcGalleryTotal || "1", 10) > 1 && card.__pcGoToSlide)
            card.__pcGoToSlide(1);
        });
        media.addEventListener("mouseleave", function () {
          if (!hoverTier()) return;
          if (card.__pcGoToSlide) card.__pcGoToSlide(0);
        });
      }

      function onArrowClick(e, dir) {
        /* stopPropagation: prevent the click from bubbling to atomic-product's host
           click-to-navigate handler (Coveo navigates to the card link's href on card click). */
        e.stopPropagation();
        e.preventDefault();
        pageTo(dir);
      }

      /* Re-measure on resize: slide width (and thus maxScroll) changes across
         breakpoints; reset `rendered` so boundary state re-evaluates. One shared
         ResizeObserver serves all tracks; the host keys the current track so a rebuilt
         or re-rendered card releases its stale one. */
      if (galleryRO && host) {
        if (host.__pcGalleryTrack && host.__pcGalleryTrack !== track) {
          try {
            galleryRO.unobserve(host.__pcGalleryTrack);
          } catch (e) {}
        }
        host.__pcGalleryTrack = track;
        galleryROCallbacks.set(track, function () {
          measure();
          rendered = -1;
          update();
        });
        galleryRO.observe(track);
      }
      track.addEventListener("scroll", update, { passive: true });
      /* Swipes reach here without any of the wrapped entry points above. */
      track.addEventListener(
        "touchstart",
        function () {
          grantTrackSlides(track);
        },
        { passive: true, once: true },
      );
      /* Keyboard path: the focusable carousel track owns ArrowLeft/ArrowRight. Prev/next
         buttons stay mouse-only so disabling a boundary arrow never drops keyboard focus. */
      track.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          pageTo(1);
        } else if (e.key === "ArrowLeft") {
          e.preventDefault();
          pageTo(-1);
        }
      });
      if (prev)
        prev.addEventListener("click", function (e) {
          onArrowClick(e, -1);
        });
      if (next)
        next.addEventListener("click", function (e) {
          onArrowClick(e, 1);
        });

      /* Gesture arbiter for a rail-hosted card. This gallery is a horizontal scroller inside
         the recommendation rail's horizontal scroller, and a touch gesture stays latched to
         whichever scroller it started in -- so once the gallery hits its last image the rail
         does not move until the finger lifts, which reads as a dead swipe.
         `overscroll-behavior-x` keeps the browser from chaining unpredictably, and the arbiter
         forwards the hand-off exactly once per gesture: a committed horizontal swipe with no
         image left in that direction pages the rail (`coveo-recs:page`, composed so it crosses
         the Atomic shadow roots to the rail's own paging). Listeners are passive -- the gallery
         keeps its native scroll and a tap still opens the card. */
      if (inRail) {
        track.style.overscrollBehaviorX = "contain";
        var HANDOFF_PX = 24; /* a committed swipe, past the tap slop the browser allows */
        var gestureX = 0;
        var gestureY = 0;
        var handedOff = true;
        track.addEventListener(
          "touchstart",
          function (e) {
            handedOff = e.touches.length !== 1;
            if (handedOff) return;
            gestureX = e.touches[0].clientX;
            gestureY = e.touches[0].clientY;
          },
          { passive: true },
        );
        track.addEventListener(
          "touchmove",
          function (e) {
            if (handedOff || e.touches.length !== 1) return;
            var dx = e.touches[0].clientX - gestureX;
            var dy = e.touches[0].clientY - gestureY;
            if (Math.abs(dx) < HANDOFF_PX || Math.abs(dx) <= Math.abs(dy)) return;
            var forward = dx < 0;
            var max = Math.max(0, track.scrollWidth - track.clientWidth);
            /* Another image in the swipe direction: the gallery keeps the gesture. */
            if (forward ? track.scrollLeft < max - 1 : track.scrollLeft > 1) return;
            handedOff = true;
            card.dispatchEvent(
              new CustomEvent("coveo-recs:page", {
                bubbles: true,
                composed: true,
                detail: { dir: forward ? 1 : -1 },
              }),
            );
          },
          { passive: true },
        );
      }
      /* Initial/rebuild paint is INSTANT: a swatch switch replaces the card, so its fresh
         progress bar must not animate 0 -> first-slide fill (Liquid parity). */
      update(true, 0);
    }

    /* PLP video is opt-in via the `plpVideo` product tag already present in the Coveo payload. */
    var PLP_VIDEO_TAG = "plpVideo";

    /* Gallery slides render into a grid cell of at most ~360 CSS px, so a width-capped
       rendition replaces the raw upload master (2000x3000, hundreds of KB each): 720 covers
       every cell at 2x DPR, 1080 serves the mobile single-column density on high-DPR
       screens via srcset. Shopify's image CDN ignores unknown hosts, so foreign URLs pass
       through untouched. */
    // A grid cell is ~354px wide desktop / ~191px mobile. The 720 rung covers a
    // 2x cell; 1080 covers a 3x mobile cell or a wide single-column view. The 480
    // rung is the floor for sub-1.5x displays (1x desktop, 2x phones), which would
    // otherwise over-fetch the 720 into a box that never needs it -- roughly half
    // the bytes on that large display segment, with the browser stepping up to 720
    // on its own for anything denser.
    var GALLERY_IMG_WIDTH_SM = 480;
    var GALLERY_IMG_WIDTH = 720;
    var GALLERY_IMG_WIDTH_LG = 1080;
    function withImageWidth(url, width) {
      if (typeof url !== "string") return url;
      if (url.indexOf("cdn.shopify.com") === -1 && url.indexOf("/cdn/shop/") === -1) return url;
      // Any width transform flattens an animated GIF to a static frame on the CDN.
      if (/\.gif([?#]|$)/i.test(url)) return url;
      if (/[?&]width=/.test(url)) return url;
      return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
    }
    /* The full responsive ladder for a gallery source, or "" when the CDN passed the
       URL through untouched (foreign host / GIF / already-sized). */
    function gallerySrcset(src) {
      var sm = withImageWidth(src, GALLERY_IMG_WIDTH_SM);
      if (sm === src) return "";
      return (
        sm +
        " " +
        GALLERY_IMG_WIDTH_SM +
        "w, " +
        withImageWidth(src, GALLERY_IMG_WIDTH) +
        " " +
        GALLERY_IMG_WIDTH +
        "w, " +
        withImageWidth(src, GALLERY_IMG_WIDTH_LG) +
        " " +
        GALLERY_IMG_WIDTH_LG +
        "w"
      );
    }
    /* `sizes` mirrors the grid columns (4-up desktop / 3-up tablet / 2-up mobile), widening
       to the full viewport when the mobile density toggle is on single-column. */
    function gallerySizes() {
      var results = document.querySelector(".coveo-results");
      var single = results && results.getAttribute("data-grid-density") === "single";
      return "(min-width: 1025px) 25vw, (min-width: 769px) 33vw, " + (single ? "100vw" : "50vw");
    }
    /* Density changes re-evaluate `sizes` on already-built slides so a single-column swap
       can upgrade to the larger rendition; browsers only ever upgrade, never downgrade. */
    var densityWatched = false;
    function watchDensity() {
      if (densityWatched || !window.MutationObserver) return;
      var results = document.querySelector(".coveo-results");
      if (!results) return;
      densityWatched = true;
      new MutationObserver(function () {
        var sizes = gallerySizes();
        var hosts = collectAtomicHosts();
        for (var h = 0; h < hosts.length; h++) {
          if (!hosts[h].__pcGalleryArmed || !hosts[h].shadowRoot) continue;
          var imgs = hosts[h].shadowRoot.querySelectorAll(".pcard__gallery-slide img[sizes]");
          for (var i = 0; i < imgs.length; i++) imgs[i].sizes = sizes;
          var deferred = hosts[h].shadowRoot.querySelectorAll(
            ".pcard__gallery-slide img[data-pc-sizes]",
          );
          for (var d = 0; d < deferred.length; d++) deferred[d].dataset.pcSizes = sizes;
        }
      }).observe(results, { attributes: true, attributeFilter: ["data-grid-density"] });
    }

    /* Parse Coveo `product_media`, a semicolon-joined set of Shopify Media `{node}` objects.
       Bad nodes are skipped; total failure returns empty so Atomic image remains the fallback. */
    function parseProductMedia(raw) {
      var out = { images: [], video: null };
      if (!raw || typeof raw !== "string") return out;
      var parts = raw.split(/;(?=\s*\{)/);
      for (var i = 0; i < parts.length; i++) {
        var node;
        try {
          node = JSON.parse(parts[i]).node;
        } catch (e) {
          continue;
        }
        if (!node) continue;
        var type = node.mediaContentType || "";
        if (type === "IMAGE" && node.image && node.image.url) {
          out.images.push(node.image.url);
        } else if (type === "VIDEO" && !out.video) {
          /* Video nodes carry a playable CDN mp4 on originalSource.url (or sources[]); no
             poster -- the first product image is the poster (below). */
          var url = "";
          if (node.originalSource && node.originalSource.url) url = node.originalSource.url;
          else if (node.sources && node.sources.length) {
            for (var s = 0; s < node.sources.length; s++) {
              if (node.sources[s] && node.sources[s].url) {
                url = node.sources[s].url;
                break;
              }
            }
          }
          if (url) out.video = { url: url };
        }
      }
      return out;
    }

    /* A rail card sits in a recommendation list's shadow root; walk the shadow ancestry because
       `closest` stops at the boundary. Placement only -- the rail owns its own paging. */
    function inRecommendationRail(host) {
      var node = host;
      while (node) {
        var root = node.getRootNode();
        if (!root || !root.host) return false;
        if (root.host.tagName === "ATOMIC-COMMERCE-RECOMMENDATION-LIST") return true;
        node = root.host;
      }
      return false;
    }

    /* Build the indexed gallery without a live fetch; Atomic image remains the fallback path. */
    function initGallery(card, host) {
      if (!card || card.dataset.pcGalleryInit === "1") return;
      var product = coveoProduct(host);
      /* If host.product is late, leave init unmarked so the unified observer can retry. */
      if (!product) return;
      card.dataset.pcGalleryInit = "1";
      /* Media follows the displayed colour: selected siblings use their pre-baked media,
         own colour reads `product_media` with the runtime video tag gate. */
      var sel = activeSiblingEntry(host);
      var imgs,
        videoUrl = "",
        videoPoster = "",
        title;
      if (sel) {
        imgs = (sel.images || []).slice();
        videoUrl = sel.video && sel.video.src ? String(sel.video.src) : "";
        videoPoster = sel.video && sel.video.poster ? String(sel.video.poster) : imgs[0] || "";
        title = String(sel.title || "");
      } else {
        var media = parseProductMedia(cfield(product, "product_media"));
        imgs = media.images;
        /* A product indexed without `product_media` still builds its gallery from
           `ec_images`, so it is never left on the Atomic fallback -- whose URLs the
           engine middleware caps to a small placeholder rendition. That cap is
           stripped here so the gallery ladder applies its own widths. */
        if (!imgs.length) {
          var ecImgs = cfield(product, "ec_images");
          if (typeof ecImgs === "string") ecImgs = [ecImgs];
          if (Array.isArray(ecImgs)) {
            for (var ei = 0; ei < ecImgs.length; ei++) {
              if (typeof ecImgs[ei] !== "string" || !ecImgs[ei]) continue;
              imgs.push(ecImgs[ei].replace(/([?&])width=\d+&?/, "$1").replace(/[?&]$/, ""));
            }
          }
        }
        videoUrl = media.video && tagsHave(product, PLP_VIDEO_TAG) ? String(media.video.url) : "";
        videoPoster = imgs[0] || "";
        title = String(cfield(product, "ec_name") || "");
      }
      /* A sibling with no usable media uses the neutral placeholder instead of showing
         the own colour's image under sibling details. */
      if (sel && !imgs.length && !videoUrl) {
        var atomicFb = card.querySelector(".pcard__image");
        var fb = atomicFb ? atomicFb.getAttribute("fallback") : "";
        if (fb) imgs = [fb];
      }
      var wantVideo = !!videoUrl && imgs.length >= 1;
      /* Single-image products render through the gallery too (chrome self-hides at one
         slide): the Atomic image is a low-res placeholder, so the gallery lead is the
         ONLY full-resolution path -- and it participates in deferred loading, which
         keeps every real image request under the viewport-priority system. */
      if (imgs.length < 1 && !wantVideo) return; /* media-less: keep the Atomic fallback */
      var track = card.querySelector("[data-pc-gallery-track]");
      if (!track) return;
      /* Slide 0 gets a real src only when the card is near the viewport at build time.
         Galleries normally build on viewport approach, but a back-navigation restore
         hydrates the whole region above its landing in one pass -- and `loading="lazy"`
         cannot defer those loads, because slow connections widen the browser's lazy
         threshold to thousands of px and the restore veil lays out the entire grid. The
         far leads therefore carry their URL in data attributes and load via leadIO on
         approach (or via the restore's landing-image wait), so an off-screen burst can
         never starve the images the shopper is looking at. Proximity comes from the
         host's discovery verdict (measured once per batch in a single read pass) or
         its IntersectionObserver crossing, never from a fresh measurement here: a
         read after the slide append would force a layout per card. A host with no
         verdict yet (first-viewport boot cards, the predictive panel) counts as near. */
      var nearNow = !host || host.__pcNear !== false;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < imgs.length; i++) {
        var src = imgs[i];
        if (src.indexOf("//") === 0) src = "https:" + src; /* protocol-relative -> https */
        var slide = document.createElement("div");
        slide.className = "pcard__gallery-slide";
        var img = document.createElement("img");
        var capped = withImageWidth(src, GALLERY_IMG_WIDTH);
        var srcset = gallerySrcset(src);
        if (i === 0 && nearNow) {
          img.src = capped;
          if (srcset) {
            img.srcset = srcset;
            img.sizes = gallerySizes();
          }
          img.loading = "eager";
        } else {
          /* Everything else defers its src: horizontally-clipped non-first slides (and
             far-built leads) still count as viewport-near for browser lazy-loading --
             especially on slow connections, whose thresholds cover whole pages -- so a
             bulk hydration (deep restore) would otherwise fetch every card's entire
             carousel. Leads are granted by leadIO on approach; non-leads by the first
             gallery interaction. */
          img.dataset.pcSrc = capped;
          if (srcset) {
            img.dataset.pcSrcset = srcset;
            img.dataset.pcSizes = gallerySizes();
          }
          img.loading = "lazy";
          if (i === 0 && leadIO) leadIO.observe(img);
          // The immediate swap target is preloaded on viewport proximity so the
          // hover/swipe reveal never lands on an unloaded image.
          if (i === 1 && swapIO) swapIO.observe(img);
        }
        /* Per-image alt text is unavailable in `product_media`; use the product title for
           every slide until the index exposes per-media alt text. */
        img.alt = title;
        img.decoding = "async";
        slide.appendChild(img);
        frag.appendChild(slide);
      }
      var videoAdded = false;
      if (wantVideo) {
        var poster = videoPoster;
        if (poster && poster.indexOf("//") === 0) poster = "https:" + poster;
        poster = withImageWidth(poster, GALLERY_IMG_WIDTH);
        var videoSlide = document.createElement("div");
        videoSlide.className = "pcard__gallery-slide pcard__gallery-slide--video";
        var galleryEl = card.querySelector("[data-pc-gallery]");
        var videoLabel = cardLabel(galleryEl, "data-pc-video-label");
        if (videoLabel && title) videoLabel = videoLabel.replace(/\s+$/, "") + " " + title;
        if (videoLabel) videoSlide.setAttribute("aria-label", videoLabel);
        var v = document.createElement("video");
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.preload = "none";
        if (poster) v.poster = poster;
        var source = document.createElement("source");
        source.src = videoUrl;
        source.type = "video/mp4";
        v.appendChild(source);
        /* `x-ambient-video` gates playback and download by visibility and respects reduced motion.
           `display: contents` is inline because shared snippet CSS cannot pierce this shadow root. */
        var vHost = document.createElement("x-ambient-video");
        vHost.style.display = "contents";
        vHost.appendChild(v);
        videoSlide.appendChild(vHost);
        /* Insert video before the first image so an eligible video is visible at rest.
           `insertBefore(node, null)` still appends when the fragment is otherwise empty. */
        frag.insertBefore(videoSlide, frag.firstChild);
        videoAdded = true;
      }
      var total = imgs.length + (videoAdded ? 1 : 0);
      track.appendChild(frag);
      var gallery = card.querySelector("[data-pc-gallery]");
      if (gallery) gallery.removeAttribute("hidden");
      var atomicImg = card.querySelector(".pcard__image");
      if (atomicImg) atomicImg.style.display = "none";
      /* Arrows + progress scrub only when there's more than one slide to page through
         (a single-image sibling shows just the image -- native single-image parity). */
      var arrows = card.querySelectorAll(".pcard__arrow");
      for (var a = 0; a < arrows.length; a++) {
        if (total > 1) arrows[a].removeAttribute("hidden");
        else arrows[a].setAttribute("hidden", "");
      }
      var progress = card.querySelector("[data-pc-gallery-progress]");
      if (progress) {
        if (total > 1) progress.removeAttribute("hidden");
        else progress.setAttribute("hidden", "");
      }
      card.dataset.pcGalleryTotal = String(total);
      /* Record whether slide 0 is video so hover-swap can avoid paging away from active playback.
         Store "0" explicitly to clear stale state across swatch rebuilds. */
      card.dataset.pcGalleryVideoFirst = videoAdded ? "1" : "0";
      wireGallery(card, track, total, host);
    }

    var galleryObserved = new WeakSet();
    /* The single hydration entry point for a grid/rail card: gallery, per-host observer,
       size chips, heals, and wishlist state all start here, when the card nears the
       viewport (or immediately, for cards inserted near it). Until armed, a card is the
       stamped template plus Atomic's own rendering -- render-offloaded and never painted. */
    function armHost(host) {
      if (!host || host.__pcGalleryArmed || !host.shadowRoot) return;
      host.__pcGalleryArmed = true;
      var card = host.shadowRoot.querySelector(".pcard, .pcard-c");
      healColour(host);
      ensureHostObserver(host);
      if (card) {
        initGallery(card, host);
        enhanceStrip(card, host);
      }
      if (window.SeedWishlist && window.SeedWishlist.savedHandles) {
        hydrateWishlistHost(
          host,
          window.SeedWishlist.savedHandles(),
          window.SeedWishlist.isUnavailable(),
        );
      }
    }
    /* While a back-navigation restore is veiled, the page is pinned at the top of the
       grid and the shopper sees only the skeleton, yet the cards parked under that top
       still intersect the viewport and would arm -- and load their images -- for a
       region the shopper is about to be scrolled away from. Hold those arms until the
       restore hands back: a deferred host is re-observed then, and arms only if it is
       still near the landed viewport. The restore hydrates its own landing region
       through `__pcArmHost`, which is not gated. */
    function restoreVeiled() {
      return !!window.__coveoPlpRestore;
    }
    /* Runs fn once the restore hands back. Full-grid sweeps scheduled under the veil
       would walk every replayed card for nothing visible; one sweep at hand-back covers
       them all. */
    function afterRestore(fn) {
      document.addEventListener("coveo:plp-restore-done", fn, { once: true });
    }
    var deferredArms = [];
    document.addEventListener("coveo:plp-restore-done", function () {
      var hosts = deferredArms;
      deferredArms = [];
      for (var i = 0; i < hosts.length; i++) {
        if (hosts[i].isConnected && !hosts[i].__pcGalleryArmed) galleryIO.observe(hosts[i]);
      }
    });
    var galleryIO = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) continue;
          galleryIO.unobserve(e.target);
          if (restoreVeiled()) {
            deferredArms.push(e.target);
            continue;
          }
          e.target.__pcNear = true;
          armHost(e.target);
        }
      },
      { rootMargin: "300px", threshold: 0 },
    );
    /* Arming a card can grow it (the swatch row adds height) -- invisible below the
       viewport, but a jump into an unarmed region would land amid popping cards. The
       back-navigation restore is the one path that jumps deep, and it uses this hook to
       hydrate the grid through its landing viewport before it positions the shopper. */
    window.__pcArmHost = function (host) {
      if (host) host.__pcNear = true;
      armHost(host);
    };

    /* Product-list shadow roots own card replacement on re-query/sort/pagination; observe them
       directly and ignore the header predictive list. */
    function eachInterface(fn) {
      var ifaces = document.querySelectorAll(
        "atomic-commerce-interface:not(.coveo-predictive__search-interface), atomic-commerce-recommendation-interface",
      );
      for (var i = 0; i < ifaces.length; i++) fn(ifaces[i]);
    }

    /* A card inserted within (or near) the viewport must be healed before paint -- an
       in-place re-query (sort, facet change) would otherwise flash the unhealed template
       for a frame, because the IntersectionObserver delivers after paint. Cards inserted
       far offscreen defer their whole hydration to the observer instead: with the grid
       cells render-offloaded they cannot be seen before they arm. */
    var ARM_MARGIN_PX = 600;
    /* Cards discovered before the interface reveals (data-state still loading) measure a
       zero rect, which would read as "near" and arm the entire batch -- fatal on a deep
       back-navigation restore that seeds hundreds of products in one response. A small
       unconditional budget keeps the first viewport of cards healed before first paint
       (24 covers six 4-up rows, taller than any common desktop viewport); everything past
       it waits for the IntersectionObserver. */
    var eagerArmBudget = 24;
    /* Discovery is batched: hosts queue as the mutation records arrive and one flush,
       still ahead of paint, measures them all in a single read pass before any of them
       is armed. Measuring inside the loop instead would interleave a layout read with
       the previous card's heal writes and force a fresh layout per host -- at a few
       hundred loaded products that was the single largest cost of every append. */
    var pendingDiscovery = [];
    var discoveryQueued = false;
    /* Atomic inserts the empty product host first and Lit stamps the card template into
       its shadow root in a later render pass. Discovery therefore sees a root with no
       card yet -- nothing to tell the card kind, nothing to style -- and the stamp
       would otherwise paint before any heal adopts the sheet: the quick-add strip and
       arrows flash unstyled, then fade as their transitions kick in. A one-shot
       observer on the root adopts the sheet in the microtask right after the stamp,
       still ahead of paint. */
    function watchFirstStamp(host) {
      var root = host.shadowRoot;
      if (!root || root.__pcCardSheet || root.__pcCardStyleCloned || root.__pcStampWatch) return;
      root.__pcStampWatch = true;
      var observer = new MutationObserver(function (records, obs) {
        adoptCardStyles(host);
        if (root.__pcCardSheet || root.__pcCardStyleCloned || !host.isConnected) {
          obs.disconnect();
          root.__pcStampWatch = false;
        }
      });
      observer.observe(root, { childList: true });
    }
    function discoverHost(host) {
      if (host.__pcGalleryArmed || galleryObserved.has(host)) return;
      galleryObserved.add(host);
      /* Styles attach at discovery, ahead of paint, so even a far card that never arms is
         styled the moment it scrolls in. */
      adoptCardStyles(host);
      watchFirstStamp(host);
      pendingDiscovery.push(host);
      if (discoveryQueued) return;
      discoveryQueued = true;
      if (typeof queueMicrotask === "function") queueMicrotask(flushDiscovery);
      else Promise.resolve().then(flushDiscovery);
    }
    function flushDiscovery() {
      discoveryQueued = false;
      var hosts = pendingDiscovery;
      pendingDiscovery = [];
      var viewBottom = window.innerHeight + ARM_MARGIN_PX;
      var verdicts = [];
      /* Under a veiled restore nothing is visible, so no card is "near" in the sense
         that matters (about to paint): every discovered host waits on the observer,
         which itself defers until the restore lands. The eager budget stays intact
         for the ordinary first paint. */
      var veiled = restoreVeiled();
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        if (host.__pcGalleryArmed || !host.isConnected) {
          verdicts.push(null);
          continue;
        }
        if (veiled) {
          verdicts.push(false);
          continue;
        }
        /* Measure the grid CELL, not the host inside it: the cell is render-offloaded
           (`content-visibility: auto`) and its box is already known, whereas measuring
           anything inside a skipped cell forces that cell's contents to lay out. */
        var cell = host.parentElement;
        var box = cell && cell.hasAttribute("part") ? cell : host;
        var rect = box.getBoundingClientRect();
        var laidOut = rect.width > 0 || rect.height > 0;
        var near = laidOut
          ? rect.bottom > -ARM_MARGIN_PX && rect.top < viewBottom
          : eagerArmBudget > 0;
        if (!laidOut && near) eagerArmBudget--;
        verdicts.push(near);
      }
      for (var j = 0; j < hosts.length; j++) {
        var h = hosts[j];
        var v = verdicts[j];
        if (v === null) continue;
        h.__pcNear = v;
        if (v) armHost(h);
        else galleryIO.observe(h);
      }
    }

    var observedLists = new WeakSet();
    /* Arm one observer per product/recommendation list shadow root. Newly inserted hosts are
       discovered directly from the mutation records (no full-grid traversal per batch); the
       debounced wishlist scan remains as a backstop for missed timing. */
    function armListObserver(list) {
      if (observedLists.has(list)) return;
      observedLists.add(list);
      new MutationObserver(function (records) {
        for (var r = 0; r < records.length; r++) {
          var added = records[r].addedNodes;
          for (var a = 0; a < added.length; a++) {
            var node = added[a];
            if (!node || node.nodeType !== 1) continue;
            var fresh = [];
            if (node.tagName === "ATOMIC-PRODUCT") fresh.push(node);
            else if (node.querySelectorAll)
              fresh = Array.prototype.slice.call(node.querySelectorAll("atomic-product"));
            for (var f = 0; f < fresh.length; f++) discoverHost(fresh[f]);
          }
          /* IntersectionObserver and ResizeObserver hold STRONG references to their
             targets: a host that leaves the tree without being unobserved is pinned in
             memory (with its whole shadow tree) for the page's life -- at hundreds of
             products across re-renders that retention compounds fast. Release both here. */
          var removed = records[r].removedNodes;
          for (var d = 0; d < removed.length; d++) {
            var gone = removed[d];
            if (!gone || gone.nodeType !== 1) continue;
            var stale = [];
            if (gone.tagName === "ATOMIC-PRODUCT") stale.push(gone);
            else if (gone.querySelectorAll)
              stale = Array.prototype.slice.call(gone.querySelectorAll("atomic-product"));
            for (var s = 0; s < stale.length; s++) {
              try {
                galleryIO.unobserve(stale[s]);
              } catch (e) {}
              /* A Lit re-render can remove and RE-INSERT the same host; forget it here
                 or the discovery dedupe would skip re-observing it on the way back in,
                 leaving the card permanently unhydrated. */
              galleryObserved.delete(stale[s]);
              if ((leadIO || swapIO) && stale[s].shadowRoot) {
                var pendingLeads = stale[s].shadowRoot.querySelectorAll("img[data-pc-src]");
                for (var pl = 0; pl < pendingLeads.length; pl++) {
                  try {
                    if (leadIO) leadIO.unobserve(pendingLeads[pl]);
                    if (swapIO) swapIO.unobserve(pendingLeads[pl]);
                  } catch (e) {}
                }
              }
              if (galleryRO && stale[s].__pcGalleryTrack) {
                try {
                  galleryRO.unobserve(stale[s].__pcGalleryTrack);
                } catch (e) {}
                stale[s].__pcGalleryTrack = null;
              }
              var hostMO = hostObservers.get(stale[s]);
              if (hostMO) {
                try {
                  hostMO.disconnect();
                } catch (e) {}
                hostObservers.delete(stale[s]);
              }
            }
          }
        }
        wlScanSoon();
      }).observe(list.shadowRoot, { childList: true, subtree: true });
    }
    function ensureProductListObserver(iface) {
      var lists = deepFind(iface, function (el) {
        return (
          (el.tagName === "ATOMIC-COMMERCE-PRODUCT-LIST" ||
            el.tagName === "ATOMIC-COMMERCE-RECOMMENDATION-LIST") &&
          el.shadowRoot
        );
      });
      for (var i = 0; i < lists.length; i++) armListObserver(lists[i]);
    }

    function observeProductCards() {
      eachInterface(function (iface) {
        /* Lazily attach (or re-attach) the list shadow observer so late /
           re-queried cards are re-discovered without relying on the boot sweep. */
        ensureProductListObserver(iface);
        var products = deepFind(iface, function (el) {
          return el.tagName === "ATOMIC-PRODUCT";
        });
        for (var i = 0; i < products.length; i++) discoverHost(products[i]);
      });
    }

    /* Coveo inserts product lists late; observe both the interface light DOM and list shadow roots
       so replacements are rediscovered. */
    var watchedIfaces = new WeakSet();
    /* The interface-level watchers exist to catch a product list that mounts late or is
       replaced wholesale; the list's own shadow observer handles card insertion. Their
       full-grid re-walk is therefore coalesced to one pass per burst of mutations,
       instead of once per record -- an append mutates the interface subtree hundreds
       of times, and each re-walk was a full traversal of every loaded card. */
    var lateScanTimer = null;
    function scheduleLateScan() {
      if (lateScanTimer) return;
      lateScanTimer = setTimeout(function () {
        lateScanTimer = null;
        // The list's own shadow observer discovers replayed cards as they insert; the
        // full re-walk is a backstop, so under a veiled restore it runs once at hand-back.
        if (restoreVeiled()) {
          afterRestore(scheduleLateScan);
          return;
        }
        observeProductCards();
      }, 150);
    }
    function watchForLateCards() {
      eachInterface(function (iface) {
        if (watchedIfaces.has(iface)) return; /* attach the light-DOM watcher once per interface */
        watchedIfaces.add(iface);
        new MutationObserver(scheduleLateScan).observe(iface, { childList: true, subtree: true });
        if (iface.shadowRoot) {
          new MutationObserver(scheduleLateScan).observe(iface.shadowRoot, {
            childList: true,
            subtree: true,
          });
        }
      });
    }

    /* Poll briefly for a real PLP/search/recommendation interface, then attach discovery.
       Header predictive search is excluded, so ordinary pages would otherwise poll forever. */
    var bootAttempts = 0;
    function bootGallery() {
      var iface = document.querySelector(
        "atomic-commerce-interface:not(.coveo-predictive__search-interface), atomic-commerce-recommendation-interface",
      );
      if (!iface || !iface.shadowRoot) {
        if (++bootAttempts <= 50) setTimeout(bootGallery, 300);
        return;
      }
      observeProductCards();
      watchForLateCards();
      watchDensity();
    }
    bootGallery();
    /* Wishlist boots even on non-PLP surfaces, so predictive and recommendation hearts hydrate. */
    watchWishlistInterfaces();
    hydrateCards();
    /* Periodic boot sweep catches missed mutation timing and late recommendation interfaces. */
    var sweeps = 0,
      lastSweepCount = -1,
      stableSweeps = 0;
    var sweepTimer = setInterval(function () {
      sweeps++;
      observeProductCards();
      watchForLateCards();
      watchWishlistInterfaces();
      var count = hydrateCards();
      /* Stop the boot sweep after hosts have appeared and discovery stays stable; observers
       handle later re-queries and the hard cap covers slow Coveo starts. */
      if (count > 0 && count === lastSweepCount) {
        if (++stableSweeps >= 3) {
          clearInterval(sweepTimer);
          return;
        }
      } else {
        stableSweeps = 0;
        lastSweepCount = count;
      }
      if (sweeps > 34) clearInterval(sweepTimer); /* ~12s hard cap */
    }, 350);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coveo-results-layout"] && !Shopify.designMode) return;
  try {
    /*
   * Surface item count ("{N} items"). Reads the live total from the matching
   * Headless commerce summary controller on the same engine the grid uses
   * (window.__coveoEngine, set by coveo-commerce-init). A second surface
   * controller is a pure observer, so this replaces Atomic's default range
   * summary without triggering another request. If the engine is unavailable,
   * the count stays empty.
   */
  (function () {
    if (window.__coveoItemCountBound) return;
    window.__coveoItemCountBound = true;

    var HEADLESS_CDN = "https://static.cloud.coveo.com/shopify/v1/headless/commerce.esm.js";
    var countNode = document.querySelector("[data-coveo-item-count]");
    var surface = countNode && countNode.getAttribute("data-coveo-surface");
    var buildControllerName;
    if (surface === "search") buildControllerName = "buildSearch";
    else if (surface === "product-listing") buildControllerName = "buildProductListing";
    else return;

    function resolveEngine() {
      if (window.__coveoEngine) return Promise.resolve(window.__coveoEngine);
      /* Event-first: the engine builder dispatches `coveo:engine-ready` on publish. A slow
         poll remains only as a backstop for a publish that raced the listener attach. */
      return new Promise(function (resolve) {
        var done = false;
        var timer = null;
        function finish(engine) {
          if (done) return;
          done = true;
          document.removeEventListener("coveo:engine-ready", onReady);
          if (timer) clearInterval(timer);
          resolve(engine);
        }
        function onReady(event) {
          finish((event.detail && event.detail.engine) || window.__coveoEngine || null);
        }
        document.addEventListener("coveo:engine-ready", onReady);
        var waited = 0;
        timer = setInterval(function () {
          waited += 1000;
          if (window.__coveoEngine) finish(window.__coveoEngine);
          else if (waited >= 8000) finish(null);
        }, 1000);
      });
    }

    function render(total) {
      var nodes = document.querySelectorAll("[data-coveo-item-count]");
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (typeof total !== "number") {
          el.textContent = "";
          continue;
        }
        var tpl = el.getAttribute("data-items-template") || "__COUNT__ items";
        el.textContent = tpl.split("__COUNT__").join(String(total));
      }
    }

    resolveEngine().then(function (engine) {
      if (!engine) return; // No engine: the count stays empty.
      import(HEADLESS_CDN)
        .then(function (mod) {
          var buildController = mod[buildControllerName];
          if (typeof buildController !== "function") return;
          var controller = buildController(engine);
          var summary = controller.summary();
          function update() {
            var s = summary.state || {};
            // Gate on firstRequestExecuted: before Coveo's first request for this
            // surface resolves, totalNumberOfProducts is already 0 (a number), so
            // painting it flashes "0 items". Until then the span stays empty.
            if (s.firstRequestExecuted && typeof s.totalNumberOfProducts === "number") {
              render(s.totalNumberOfProducts);
            }
          }
          summary.subscribe(update);
          update();
        })
        .catch(function () {
          /* module/engine unavailable - leave the count empty */
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["date-picker"] && !Shopify.designMode) return;
  try {
    class SeedDatePicker extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector(".date-picker__control");
      this.field = this.querySelector(".form-field");
      this.panel = this.querySelector(".date-picker__panel");
      this.grid = this.querySelector("[data-dp-grid]");
      if (!this.control || !this.panel || !this.grid) return;

      this.prevBtn = this.querySelector("[data-dp-prev]");
      this.nextBtn = this.querySelector("[data-dp-next]");
      this.monthSelect = this.querySelector("[data-dp-month]");
      this.yearSelect = this.querySelector("[data-dp-year]");
      this.monthLabel = this.querySelector("[data-dp-month-label]");
      this.yearLabel = this.querySelector("[data-dp-year-label]");
      this.closeBtn = this.querySelector("[data-dp-close]");
      this.doneBtn = this.querySelector("[data-dp-done]");
      this.calendarToggle = this.querySelector("[data-dp-calendar]");
      // NB: name it `hiddenInput`, never `this.hidden` -- `hidden` is the built-in
      // HTMLElement IDL property; assigning an element to it would set the host's
      // `hidden` attribute and make the whole picker disappear.
      this.hiddenInput = this.querySelector("[data-dp-hidden]");

      this.MONTHS = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      this.minDate = this.parseISO(this.dataset.minDate);
      this.maxDate = this.parseISO(this.dataset.maxDate);

      // Committed value (from `value`, validated against the range); the
      // provisional `selected` tracks the open panel and reverts on discard.
      this.committed = this.parseISO(this.dataset.value);
      if (this.committed && !this.inRange(this.committed)) this.committed = null;
      this.selected = this.committed;

      const base = this.committed || this.clampToRange(this.today());
      this.viewYear = base.getFullYear();
      this.viewMonth = base.getMonth();
      this.focusDate = new Date(base.getFullYear(), base.getMonth(), base.getDate());

      this.requiredError = this.control.getAttribute("data-required-error");
      this.formatError = this.control.getAttribute("data-format-error");
      const msgEl = this.field ? this.field.querySelector(".form-field__message") : null;
      this.defaultMessage = msgEl ? msgEl.textContent.trim() : "";

      this.isStatic = this.hasAttribute("data-dp-static");

      this.buildSelects();
      this.render();

      if (this.isStatic) {
        // Frozen gallery specimen: populated, but no interaction wiring.
        if (this.hasAttribute("data-dp-hover-day")) this.forceHoverDay();
        return;
      }

      this.onControlClick = this.onControlClick.bind(this);
      this.onControlKeydown = this.onControlKeydown.bind(this);
      this.onControlInput = this.onControlInput.bind(this);
      this.onControlFocus = this.onControlFocus.bind(this);
      this.onControlBlur = this.onControlBlur.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onMonthChange = this.onMonthChange.bind(this);
      this.onYearChange = this.onYearChange.bind(this);
      this.onGridClick = this.onGridClick.bind(this);
      this.onGridKeydown = this.onGridKeydown.bind(this);
      this.onDone = this.onDone.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onDocKeydown = this.onDocKeydown.bind(this);
      this.onReposition = this.onReposition.bind(this);
      this.onTabOut = this.onTabOut.bind(this);
      this.onCalendarToggle = this.onCalendarToggle.bind(this);

      this.control.addEventListener("click", this.onControlClick);
      this.control.addEventListener("keydown", this.onControlKeydown);
      this.control.addEventListener("input", this.onControlInput);
      this.control.addEventListener("focus", this.onControlFocus);
      this.control.addEventListener("blur", this.onControlBlur);
      if (this.prevBtn) this.prevBtn.addEventListener("click", this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener("click", this.onNext);
      if (this.monthSelect) this.monthSelect.addEventListener("change", this.onMonthChange);
      if (this.yearSelect) this.yearSelect.addEventListener("change", this.onYearChange);
      this.grid.addEventListener("click", this.onGridClick);
      this.grid.addEventListener("keydown", this.onGridKeydown);
      if (this.doneBtn) this.doneBtn.addEventListener("click", this.onDone);
      if (this.closeBtn) this.closeBtn.addEventListener("click", this.onClose);
      // Capture, so a Tab from the control, the grid, the selects or the footer all
      // arm the keyboard-exit check (see onTabOut).
      this.addEventListener("keydown", this.onTabOut, true);

      // Top-layer panel: promote via the Popover API so it overlays ABOVE an
      // ancestor modal and is never clipped / scroll-trapped by an overflow:auto
      // container or a transformed ancestor. Live pickers only; feature-detected
      // with graceful fallback to the absolute panel. Popover state (not `hidden`)
      // controls visibility, so drop the initial `hidden` attribute.
      this.supportsPopover = typeof this.panel.showPopover === "function";
      if (this.supportsPopover) {
        this.panel.setAttribute("popover", "manual");
        this.panel.removeAttribute("hidden");
      }

      // Touch presentation (pointer:coarse -- phones/tablets, not fine-pointer
      // desktops). Open-on-focus/tap is dropped: focusing the field is for TYPING
      // (soft keyboard), and the calendar opens via the trailing toggle instead, so
      // keyboard and calendar never fight for the screen. The panel also renders as
      // a viewport-anchored bottom sheet (see positionPanel + --sheet CSS) so it
      // cannot drift as the keyboard/URL bar move the layout. Detected ONCE:
      // touch-capability doesn't change at runtime.
      this.isTouch = window.matchMedia
        ? window.matchMedia("(pointer: coarse)").matches
        : "ontouchstart" in window || (navigator.maxTouchPoints || 0) > 0;
      if (this.isTouch) {
        this.classList.add("date-picker--touch");
        if (this.calendarToggle)
          this.calendarToggle.addEventListener("click", this.onCalendarToggle);
      }

      this.open = false;
    }

    disconnectedCallback() {
      if (this.onReposition) {
        window.removeEventListener("scroll", this.onReposition, true);
        window.removeEventListener("resize", this.onReposition);
      }
    }

    today() {
      const n = new Date();
      return new Date(n.getFullYear(), n.getMonth(), n.getDate());
    }

    pad(n) {
      return n < 10 ? "0" + n : "" + n;
    }

    parseISO(s) {
      if (!s) return null;
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
      if (!m) return null;
      return this.makeDate(parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10));
    }

    // Construct a local date and round-trip validate (rejects rollovers).
    makeDate(y, mo, d) {
      const date = new Date(y, mo - 1, d);
      if (date.getFullYear() !== y || date.getMonth() !== mo - 1 || date.getDate() !== d)
        return null;
      return date;
    }

    toISO(d) {
      return d.getFullYear() + "-" + this.pad(d.getMonth() + 1) + "-" + this.pad(d.getDate());
    }

    formatDisplay(d) {
      return this.pad(d.getDate()) + " / " + this.pad(d.getMonth() + 1) + " / " + d.getFullYear();
    }

    sameDay(a, b) {
      return (
        !!a &&
        !!b &&
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
      );
    }

    inRange(d) {
      if (!d) return false;
      if (this.minDate && d < this.minDate) return false;
      if (this.maxDate && d > this.maxDate) return false;
      return true;
    }

    clampToRange(d) {
      if (this.minDate && d < this.minDate)
        return new Date(
          this.minDate.getFullYear(),
          this.minDate.getMonth(),
          this.minDate.getDate(),
        );
      if (this.maxDate && d > this.maxDate)
        return new Date(
          this.maxDate.getFullYear(),
          this.maxDate.getMonth(),
          this.maxDate.getDate(),
        );
      return d;
    }

    buildSelects() {
      if (this.monthSelect) {
        let out = "";
        for (let i = 0; i < 12; i++)
          out += '<option value="' + i + '">' + this.MONTHS[i] + "</option>";
        this.monthSelect.innerHTML = out;
      }
      if (this.yearSelect) {
        const t = this.today().getFullYear();
        let lo = this.minDate ? this.minDate.getFullYear() : t - 100;
        let hi = this.maxDate ? this.maxDate.getFullYear() : t + 10;
        if (this.committed) {
          if (this.committed.getFullYear() < lo) lo = this.committed.getFullYear();
          if (this.committed.getFullYear() > hi) hi = this.committed.getFullYear();
        }
        if (hi < lo) hi = lo;
        let out = "";
        for (let y = lo; y <= hi; y++) out += '<option value="' + y + '">' + y + "</option>";
        this.yearSelect.innerHTML = out;
      }
    }

    render() {
      if (this.monthLabel) this.monthLabel.textContent = this.MONTHS[this.viewMonth];
      if (this.yearLabel) this.yearLabel.textContent = "" + this.viewYear;
      if (this.monthSelect) this.monthSelect.value = "" + this.viewMonth;
      if (this.yearSelect) this.yearSelect.value = "" + this.viewYear;

      // Clamp the nav chevrons against min / max.
      if (this.prevBtn) {
        const prevLast = new Date(this.viewYear, this.viewMonth, 0); // last day of prev month
        this.prevBtn.disabled = this.minDate ? prevLast < this.minDate : false;
      }
      if (this.nextBtn) {
        const nextFirst = new Date(this.viewYear, this.viewMonth + 1, 1);
        this.nextBtn.disabled = this.maxDate ? nextFirst > this.maxDate : false;
      }

      this.renderWeeks();
    }

    renderWeeks() {
      // Drop previously injected weeks; keep the static weekday header row.
      const old = this.grid.querySelectorAll(".date-picker__week");
      for (let i = 0; i < old.length; i++) old[i].remove();

      const firstDow = new Date(this.viewYear, this.viewMonth, 1).getDay(); // 0 = Sunday
      const daysInMonth = new Date(this.viewYear, this.viewMonth + 1, 0).getDate();
      const totalCells = Math.ceil((firstDow + daysInMonth) / 7) * 7;

      let row = null;
      for (let cell = 0; cell < totalCells; cell++) {
        if (cell % 7 === 0) {
          row = document.createElement("div");
          row.className = "date-picker__week";
          row.setAttribute("role", "row");
          this.grid.appendChild(row);
        }
        const dayNum = cell - firstDow + 1;
        const inMonth = dayNum >= 1 && dayNum <= daysInMonth;
        const date = new Date(this.viewYear, this.viewMonth, dayNum); // normalises overflow
        row.appendChild(this.makeCell(date, inMonth));
      }
      this.updateFocusable();
      this.updateDone();
    }

    // Done commits the provisional pick, so it stays disabled until one is
    // VISIBLE in the displayed month. Stepping the month / year carries an
    // earlier pick out of sight; committing that invisible date reads as the
    // picker resetting itself, so require a day in the month on screen.
    updateDone() {
      if (!this.doneBtn || this.isStatic) return;
      const visible =
        !!this.selected &&
        this.selected.getFullYear() === this.viewYear &&
        this.selected.getMonth() === this.viewMonth;
      this.doneBtn.disabled = !visible;
    }

    makeCell(date, inMonth) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "date-picker__day";
      btn.setAttribute("role", "gridcell");
      btn.textContent = "" + date.getDate();
      btn.dataset.date = this.toISO(date);
      btn.setAttribute(
        "aria-label",
        date.getDate() + " " + this.MONTHS[date.getMonth()] + " " + date.getFullYear(),
      );

      const disabled = !inMonth || !this.inRange(date);
      if (disabled) {
        btn.classList.add("date-picker__day--disabled");
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        btn.tabIndex = -1;
      } else {
        btn.tabIndex = -1;
        if (this.sameDay(date, this.selected)) {
          btn.classList.add("date-picker__day--selected");
          btn.setAttribute("aria-selected", "true");
        } else {
          btn.setAttribute("aria-selected", "false");
        }
      }
      return btn;
    }

    cellFor(date) {
      return this.grid.querySelector(
        '.date-picker__day[data-date="' + this.toISO(date) + '"]:not([disabled])',
      );
    }

    updateFocusable() {
      const cells = this.grid.querySelectorAll(".date-picker__day:not([disabled])");
      for (let i = 0; i < cells.length; i++) cells[i].tabIndex = -1;
      let target = this.cellFor(this.focusDate);
      if (!target && cells.length) target = cells[0];
      if (target) {
        target.tabIndex = 0;
        this.focusDate = this.parseISO(target.dataset.date) || this.focusDate;
      }
    }

    forceHoverDay() {
      // Frozen "opened hover" specimen: highlight a representative in-month cell.
      const cells = this.grid.querySelectorAll(
        ".date-picker__day:not([disabled]):not(.date-picker__day--selected)",
      );
      const target = cells[Math.min(9, cells.length - 1)];
      if (target) target.classList.add("is-hover");
    }

    setOpen(open, focusGrid) {
      this.open = open;
      this.control.setAttribute("aria-expanded", open ? "true" : "false");
      if (this.calendarToggle)
        this.calendarToggle.setAttribute("aria-expanded", open ? "true" : "false");
      // The focus ring (--focused) tracks the OPEN state only, so it stays lit
      // while the panel is open even though focus sits in the grid. A value
      // keeps the label floated via --completed (filled), NOT --focused, so a
      // completed field never looks permanently focused; real keyboard focus
      // still lights the ring via the shell's :focus-within rule.
      this.toggleField("focused", open);
      this.toggleField("completed", !!this.control.value);
      if (open) {
        this.selected = this.committed;
        if (this.committed) {
          this.viewYear = this.committed.getFullYear();
          this.viewMonth = this.committed.getMonth();
          this.focusDate = new Date(
            this.committed.getFullYear(),
            this.committed.getMonth(),
            this.committed.getDate(),
          );
        }
        this.render();
        this.showPanel();
        this.positionPanel();
        // Touch: drop the keyboard so the bottom sheet owns the screen. Safe
        // while open -- onControlBlur returns early (it is part of picking),
        // so no validation fires mid-pick.
        if (this.isTouch) this.control.blur();
        document.addEventListener("click", this.onDocClick, true);
        document.addEventListener("keydown", this.onDocKeydown, true);
        // Reposition only matters for the trigger-anchored desktop popover. The
        // touch sheet is viewport-anchored (fixed bottom), so it must NOT track
        // scroll/resize -- that tracking drifts the sheet on mobile (URL-bar
        // collapse + keyboard fire these constantly).
        if (this.supportsPopover && !this.isTouch) {
          window.addEventListener("scroll", this.onReposition, true);
          window.addEventListener("resize", this.onReposition);
        }
        if (focusGrid) {
          const active = this.grid.querySelector('.date-picker__day[tabindex="0"]');
          if (active) active.focus();
        }
      } else {
        this.hidePanel();
        document.removeEventListener("click", this.onDocClick, true);
        document.removeEventListener("keydown", this.onDocKeydown, true);
        if (this.supportsPopover) {
          window.removeEventListener("scroll", this.onReposition, true);
          window.removeEventListener("resize", this.onReposition);
        }
      }
    }

    showPanel() {
      if (this.supportsPopover) {
        if (!this.panel.matches(":popover-open")) {
          try {
            this.panel.showPopover();
          } catch (e) {
            this.panel.hidden = false;
          }
        }
      } else {
        this.panel.hidden = false;
      }
    }

    hidePanel() {
      if (this.supportsPopover) {
        if (this.panel.matches(":popover-open")) {
          try {
            this.panel.hidePopover();
          } catch (e) {}
        }
      } else {
        this.panel.hidden = true;
      }
    }

    positionPanel() {
      const shell = this.field ? this.field.querySelector(".form-field__shell") : null;
      if (this.isTouch && this.supportsPopover) {
        // Bottom sheet: hand placement to CSS (.date-picker__panel--sheet) and
        // clear any inline trigger coords so the panel docks to the viewport,
        // not the (moving) trigger.
        this.panel.classList.add("date-picker__panel--sheet");
        const s = this.panel.style;
        s.position = "";
        s.margin = "";
        s.left = "";
        s.top = "";
        s.width = "";
        s.maxHeight = "";
        return;
      }
      if (this.supportsPopover) {
        // Top-layer popover: anchor to the trigger with fixed viewport coords
        // (CSS anchor positioning isn't universally supported yet). +2 clears the
        // 2px focus ring. Below by default, above when only above fits.
        const trigger = shell || this.control;
        const r = trigger.getBoundingClientRect();
        const s = this.panel.style;
        s.position = "fixed";
        s.margin = "0";
        s.left = r.left + "px";
        s.width = r.width + "px";
        // A fixed top-layer panel sits outside every scroll container, so any
        // part of it below the fold is unreachable -- the footer Close / Done
        // would be unclickable. Cap to the viewport BEFORE measuring (only bites
        // when the panel is taller than the viewport, where it then scrolls
        // internally) and clamp the placement so the panel is always whole.
        s.maxHeight = window.innerHeight + "px";
        const below = window.innerHeight - r.bottom - 2;
        const above = r.top - 2;
        const ph = this.panel.offsetHeight;
        let top;
        if (ph <= below) {
          top = r.bottom + 2;
        } else if (ph <= above) {
          top = r.top - 2 - ph;
        } else {
          // Neither gap fits: sit flush to the viewport bottom, overlapping the
          // trigger. A hidden trigger beats an unreachable Done.
          top = Math.max(0, window.innerHeight - ph);
        }
        s.top = top + "px";
        return;
      }
      // Fallback (no Popover API): absolute panel below the shell; +2 clears the
      // 2px focus ring (--shadow-focus spread) so the open panel does not overlap
      // it. Mirrors the CSS inset-block-start fallback.
      if (shell) this.panel.style.insetBlockStart = shell.offsetTop + shell.offsetHeight + 2 + "px";
    }

    onReposition() {
      if (this.open) this.positionPanel();
    }

    openPanel(focusGrid) {
      if (this.open) {
        if (focusGrid) {
          const active = this.grid.querySelector('.date-picker__day[tabindex="0"]');
          if (active) active.focus();
        }
        return;
      }
      this.setOpen(true, focusGrid);
    }

    discardAndClose(returnFocus) {
      this.selected = this.committed;
      this.setOpen(false, false);
      if (returnFocus) {
        this.returnFocusToControl();
      } else {
        // Focus left the component entirely (clicked outside): run the live
        // check now, the same as a genuine blur. The blur that fired while the
        // panel was still open skipped validation (mid-pick), so without this
        // a typed invalid date would never surface its error on click-away.
        this.validate();
      }
    }

    onControlClick() {
      // Touch: tapping the field is for typing (it raises the soft keyboard);
      // the calendar opens via the trailing toggle, never on field tap.
      if (this.isTouch) return;
      this.openPanel(false);
    }

    onControlFocus() {
      this.toggleField("focused", true);
      // Touch: focusing the field is for typing only -- do not auto-open the
      // calendar (that would fight the soft keyboard). The toggle opens it.
      if (this.isTouch) return;
      // Open on focus (tabbing into the field reveals the calendar). Skip the
      // close-refocus (Done / Close / Escape / outside-click return focus to the
      // control), which would otherwise immediately re-open the panel.
      if (this._suppressFocusOpen) return;
      this.openPanel(false);
    }

    onCalendarToggle() {
      // Touch affordance: toggle the sheet. Closing here does NOT refocus the
      // control (that would re-raise the keyboard); it runs the live check the
      // same as a genuine blur / click-away.
      if (this.open) {
        this.discardAndClose(false);
      } else {
        this.openPanel(false);
      }
    }

    onControlBlur() {
      // While the panel is OPEN, blurring the control is part of picking -- the
      // user has clicked a day cell, a nav chevron, a month / year select or a
      // footer button, all of which steal focus from the text input. That is
      // NOT a commit, so the live required / format check must not fire here
      // (otherwise selecting a date flashes the required error mid-pick). The
      // check runs on Done (commit) and on a genuine blur once the panel has
      // closed. Keep the field visually focused while the panel stays open.
      if (this.open) {
        this.toggleField("focused", true);
        return;
      }
      this.toggleField("focused", false);
      this.toggleField("completed", !!this.control.value);
      this.validate();
    }

    onControlKeydown(event) {
      if (event.key === "ArrowDown") {
        event.preventDefault();
        this.openPanel(true);
      } else if (event.key === "Enter" || event.key === " ") {
        if (!this.open) {
          event.preventDefault();
          this.openPanel(true);
        }
      } else if (event.key === "Escape" && this.open) {
        event.preventDefault();
        this.discardAndClose(true);
      }
    }

    onControlInput(event) {
      const isDelete = event.inputType && event.inputType.indexOf("delete") === 0;
      if (!isDelete) {
        const digits = this.control.value.replace(/\D/g, "").slice(0, 8);
        this.control.value = this.maskDigits(digits);
      }
      const parsed = this.parseTyped(this.control.value);
      if (parsed && this.inRange(parsed)) {
        this.committed = parsed;
        this.selected = parsed;
        this.viewYear = parsed.getFullYear();
        this.viewMonth = parsed.getMonth();
        this.focusDate = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
        if (this.hiddenInput) this.hiddenInput.value = this.toISO(parsed);
        this.render();
      } else {
        // Incomplete / invalid typing drops the provisional pick too, so Done
        // can never commit a date the value on screen no longer says.
        if (this.hiddenInput) this.hiddenInput.value = "";
        this.committed = null;
        this.selected = null;
        this.renderWeeks();
      }
      // Re-validate live only if currently erroring (mirrors input).
      if (this.field && this.field.classList.contains("form-field--error")) this.validate();
    }

    maskDigits(digits) {
      let out = digits.slice(0, 2);
      if (digits.length > 2) out += " / " + digits.slice(2, 4);
      if (digits.length > 4) out += " / " + digits.slice(4, 8);
      return out;
    }

    parseTyped(value) {
      const digits = value.replace(/\D/g, "");
      if (digits.length !== 8) return null;
      return this.makeDate(
        parseInt(digits.slice(4, 8), 10),
        parseInt(digits.slice(2, 4), 10),
        parseInt(digits.slice(0, 2), 10),
      );
    }

    setView(y, m) {
      const d = new Date(y, m, 1);
      this.viewYear = d.getFullYear();
      this.viewMonth = d.getMonth();
      this.render();
    }

    onPrev() {
      this.setView(this.viewYear, this.viewMonth - 1);
    }

    onNext() {
      this.setView(this.viewYear, this.viewMonth + 1);
    }

    onMonthChange() {
      this.setView(this.viewYear, parseInt(this.monthSelect.value, 10));
    }

    onYearChange() {
      this.setView(parseInt(this.yearSelect.value, 10), this.viewMonth);
    }

    onGridClick(event) {
      const btn = event.target.closest(".date-picker__day");
      if (!btn || btn.disabled) return;
      const date = this.parseISO(btn.dataset.date);
      if (date) this.pick(date);
    }

    pick(date) {
      this.selected = date;
      this.focusDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.renderWeeks();
      const cell = this.cellFor(date);
      if (cell) cell.focus();
    }

    onGridKeydown(event) {
      const key = event.key;
      let next = null;
      const f = this.focusDate;
      if (key === "ArrowRight") next = new Date(f.getFullYear(), f.getMonth(), f.getDate() + 1);
      else if (key === "ArrowLeft") next = new Date(f.getFullYear(), f.getMonth(), f.getDate() - 1);
      else if (key === "ArrowDown") next = new Date(f.getFullYear(), f.getMonth(), f.getDate() + 7);
      else if (key === "ArrowUp") next = new Date(f.getFullYear(), f.getMonth(), f.getDate() - 7);
      else if (key === "Home")
        next = new Date(f.getFullYear(), f.getMonth(), f.getDate() - f.getDay());
      else if (key === "End")
        next = new Date(f.getFullYear(), f.getMonth(), f.getDate() + (6 - f.getDay()));
      else if (key === "PageUp") next = new Date(f.getFullYear(), f.getMonth() - 1, f.getDate());
      else if (key === "PageDown") next = new Date(f.getFullYear(), f.getMonth() + 1, f.getDate());
      else if (key === "Enter" || key === " ") {
        event.preventDefault();
        if (this.inRange(f)) this.pick(f);
        return;
      } else if (key === "Escape") {
        event.preventDefault();
        this.discardAndClose(true);
        return;
      } else {
        return;
      }
      event.preventDefault();
      this.moveFocus(next);
    }

    moveFocus(date) {
      if (!this.inRange(date)) return;
      this.focusDate = date;
      if (date.getFullYear() !== this.viewYear || date.getMonth() !== this.viewMonth) {
        this.setView(date.getFullYear(), date.getMonth());
      } else {
        this.updateFocusable();
      }
      const cell = this.cellFor(date);
      if (cell) cell.focus();
    }

    onDone() {
      this.committed = this.selected;
      if (this.committed) {
        this.control.value = this.formatDisplay(this.committed);
        if (this.hiddenInput) this.hiddenInput.value = this.toISO(this.committed);
        this.toggleField("completed", true);
      }
      this.setOpen(false, false);
      this.returnFocusToControl();
      this.validate();
    }

    onClose() {
      this.discardAndClose(true);
    }

    onDocClick(event) {
      // In a touch popover, backdrop taps resolve to the panel element. Treat
      // that as outside only when the press lands outside the panel box; this
      // capture handler runs before sheet controls, so geometry prevents
      // discarding a provisional pick on Done.
      if (this.isTouch && event.target === this.panel) {
        if (this.isBackdropPress(event)) this.discardAndClose(false);
        return;
      }
      if (!this.contains(event.target)) this.discardAndClose(false);
    }

    // True only for a press whose coordinates fall outside the panel's box.
    // Keyboard-synthesised clicks carry no coordinates (0/0), so they are never
    // read as a backdrop press.
    isBackdropPress(event) {
      const x = event.clientX;
      const y = event.clientY;
      if (!x && !y) return false;
      const r = this.panel.getBoundingClientRect();
      return x < r.left || x > r.right || y < r.top || y > r.bottom;
    }

    onDocKeydown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.discardAndClose(true);
      }
    }

    // Close only after a Tab-driven focus exit. `focusout` is unsafe here:
    // WebKit can move focus outside the picker before day / Done click handlers run,
    // which would discard the provisional pick. Pointer exits are handled by
    // onDocClick; Tab keydown is the reliable keyboard-exit signal.
    onTabOut(event) {
      if (event.key !== "Tab" || !this.open) return;
      const self = this;
      // Next frame: after the browser's default Tab move has settled.
      const raf = window.requestAnimationFrame;
      if (!raf) return;
      raf(function () {
        if (!self.open) return;
        const active = document.activeElement;
        if (!active || !self.contains(active)) self.discardAndClose(false);
      });
    }

    returnFocusToControl() {
      // Refocus the control WITHOUT re-triggering open-on-focus: set a one-shot
      // suppress flag that onControlFocus checks, cleared on the next tick (in
      // case .focus() is a no-op because the control is already focused, so no
      // focus event fires to consume it).
      this._suppressFocusOpen = true;
      this.control.focus();
      const self = this;
      setTimeout(function () {
        self._suppressFocusOpen = false;
      }, 0);
    }

    toggleField(name, on) {
      if (this.field) this.field.classList.toggle("form-field--" + name, on);
    }

    setMessage(text) {
      if (!this.field) return;
      const msg = this.field.querySelector(".form-field__message");
      if (msg) msg.textContent = text;
    }

    validate() {
      if (!this.requiredError && !this.formatError) return;
      const value = this.control.value;
      const empty = value.trim() === "";
      let errorMsg = null;
      if (this.requiredError && empty) {
        errorMsg = this.requiredError;
      } else if (!empty && !this.parseTyped(value)) {
        errorMsg = this.formatError;
      } else if (!empty && this.parseTyped(value) && !this.inRange(this.parseTyped(value))) {
        errorMsg = this.formatError;
      }
      this.toggleField("error", !!errorMsg);
      this.control.setAttribute("aria-invalid", errorMsg ? "true" : "false");
      this.setMessage(errorMsg || this.defaultMessage);
    }
  }

  if (!customElements.get("x-date-picker")) {
    customElements.define("x-date-picker", SeedDatePicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dropdown"] && !Shopify.designMode) return;
  try {
    class SeedDropdown extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector("[data-dropdown-trigger]");
      this.panel = this.querySelector(".dropdown__panel");
      this.list = this.querySelector(".dropdown__list");
      this.field = this.querySelector(".form-field");
      this.valueEl = this.querySelector("[data-dropdown-value]");
      this.searchInput = this.querySelector("[data-dropdown-search]");
      this.clearBtn = this.querySelector("[data-dropdown-clear]");
      this.noResults = this.querySelector("[data-dropdown-no-results]");
      this.inputsHost = this.querySelector("[data-dropdown-inputs]");
      if (!this.trigger || !this.list) return;

      this.options = Array.from(this.list.querySelectorAll('[role="option"]'));
      this.options.forEach((opt, i) => {
        if (!opt.id) opt.id = this.id + "-opt-" + i;
      });

      // Static gallery specimens (the "opened" matrix cell) render expanded and
      // are display-only -- leave them as-is, no interaction wiring.
      if (this.classList.contains("dropdown--static")) return;

      this.multiple = this.getAttribute("data-multiple") === "true";
      this.name = this.getAttribute("data-name") || "";
      this.multiLabel = this.getAttribute("data-multi-label") || "{count} selected";
      this.noResultsTpl = this.getAttribute("data-no-results") || "No results for '{query}'";
      // Live required check (input convention): the message lives on a data-*
      // attr ON THE CONTROL (the trigger, matching input / textarea /
      // date-picker) and the field starts neutral; validate() shows it only
      // on failure.
      this.requiredError = this.trigger.getAttribute("data-required-error");
      const msgEl = this.field ? this.field.querySelector(".form-field__message") : null;
      this.defaultMessage = msgEl ? msgEl.textContent.trim() : "";
      this.disabled = this.trigger.hasAttribute("disabled");
      this.isOpen = false;
      this.active = null;
      this.typeahead = "";
      this.typeaheadTimer = null;
      this.focusEl = this.trigger;

      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onTriggerKey = this.onTriggerKey.bind(this);
      this.onDocDown = this.onDocDown.bind(this);
      this.trigger.addEventListener("click", this.onTriggerClick);
      this.trigger.addEventListener("keydown", this.onTriggerKey);

      this.options.forEach((opt) => {
        opt.addEventListener("click", () => this.onOptionClick(opt));
        opt.addEventListener("mousemove", () => {
          if (this.isOpen) this.setActive(opt, false);
        });
      });

      if (this.searchInput) {
        this.onSearch = this.onSearch.bind(this);
        this.onSearchKey = this.onSearchKey.bind(this);
        this.searchInput.addEventListener("input", this.onSearch);
        this.searchInput.addEventListener("keydown", this.onSearchKey);
      }
      if (this.clearBtn) {
        this.onClear = this.onClear.bind(this);
        this.clearBtn.addEventListener("click", this.onClear);
      }

      // Seed the trigger text + completed state from the initial selection.
      this.syncFromSelection(true);
    }

    visibleOptions() {
      return this.options.filter((o) => !o.hidden);
    }

    open() {
      if (this.disabled || this.isOpen) return;
      this.isOpen = true;
      this.classList.add("dropdown--open");
      this.trigger.setAttribute("aria-expanded", "true");
      // Keep the trigger's focus ring lit while open even though focus moves to
      // the search input / panel (the shell is no longer :focus-within), so the
      // input reads as focused for the whole open session.
      if (this.field) this.field.classList.add("form-field--focused");
      document.addEventListener("mousedown", this.onDocDown);

      if (this.searchInput) {
        this.focusEl = this.searchInput;
        this.searchInput.focus();
      } else {
        this.focusEl = this.trigger;
      }
      const vis = this.visibleOptions();
      const selected = vis.find((o) => o.getAttribute("aria-selected") === "true");
      this.setActive(selected || vis[0] || null, true);
    }

    close(silent) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove("dropdown--open");
      this.trigger.setAttribute("aria-expanded", "false");
      // Drop the forced focus ring; if focus returns to the trigger below, the
      // shell's real :focus-within relights it, and a genuine blur clears it.
      if (this.field) this.field.classList.remove("form-field--focused");
      document.removeEventListener("mousedown", this.onDocDown);
      this.clearActive();
      this.focusEl = this.trigger;
      if (!silent) this.trigger.focus();
      this.validate();
    }

    validate() {
      // Only the opt-in live required check runs here; a dropdown without it
      // stays passive (its state/message are whatever form-field rendered).
      if (!this.requiredError) return;
      const empty = !this.options.some((o) => o.getAttribute("aria-selected") === "true");
      if (this.field) {
        this.field.classList.toggle("form-field--error", empty);
        const msg = this.field.querySelector(".form-field__message");
        if (msg) msg.textContent = empty ? this.requiredError : this.defaultMessage;
      }
      this.trigger.setAttribute("aria-invalid", empty ? "true" : "false");
    }

    toggle() {
      if (this.isOpen) this.close();
      else this.open();
    }

    setActive(opt, scroll) {
      this.clearActive();
      this.active = opt || null;
      if (!opt) {
        if (this.focusEl) this.focusEl.removeAttribute("aria-activedescendant");
        return;
      }
      opt.classList.add("dropdown-option--active");
      if (this.focusEl) this.focusEl.setAttribute("aria-activedescendant", opt.id);
      if (scroll && typeof opt.scrollIntoView === "function") {
        opt.scrollIntoView({ block: "nearest" });
      }
    }

    clearActive() {
      if (this.active) this.active.classList.remove("dropdown-option--active");
      this.active = null;
      if (this.focusEl) this.focusEl.removeAttribute("aria-activedescendant");
    }

    move(delta) {
      const vis = this.visibleOptions();
      if (!vis.length) return;
      let idx = this.active ? vis.indexOf(this.active) : -1;
      idx += delta;
      if (idx < 0) idx = 0;
      if (idx > vis.length - 1) idx = vis.length - 1;
      this.setActive(vis[idx], true);
    }

    moveTo(edge) {
      const vis = this.visibleOptions();
      if (!vis.length) return;
      this.setActive(edge === "first" ? vis[0] : vis[vis.length - 1], true);
    }

    onTriggerClick(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.toggle();
    }

    onTriggerKey(event) {
      if (this.disabled) return;
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          if (this.isOpen) this.move(1);
          else this.open();
          break;
        case "ArrowUp":
          event.preventDefault();
          if (this.isOpen) this.move(-1);
          else this.open();
          break;
        case "Home":
          if (this.isOpen) {
            event.preventDefault();
            this.moveTo("first");
          }
          break;
        case "End":
          if (this.isOpen) {
            event.preventDefault();
            this.moveTo("last");
          }
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          if (this.isOpen && this.active) this.selectOption(this.active);
          else if (!this.isOpen) this.open();
          break;
        case "Escape":
          if (this.isOpen) {
            event.preventDefault();
            this.close();
          }
          break;
        case "Tab":
          if (this.isOpen) this.close(true);
          break;
        default:
          if (event.key.length === 1 && !event.metaKey && !event.ctrlKey && !event.altKey) {
            this.onTypeahead(event.key);
          }
      }
    }

    onSearchKey(event) {
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          this.move(1);
          break;
        case "ArrowUp":
          event.preventDefault();
          this.move(-1);
          break;
        case "Enter":
          event.preventDefault();
          if (this.active) this.selectOption(this.active);
          break;
        case "Escape":
          event.preventDefault();
          this.close();
          break;
        case "Tab":
          this.close(true);
          break;
        default:
          break;
      }
    }

    onTypeahead(ch) {
      if (!this.isOpen) this.open();
      window.clearTimeout(this.typeaheadTimer);
      this.typeahead += ch.toLowerCase();
      this.typeaheadTimer = window.setTimeout(() => {
        this.typeahead = "";
      }, 500);
      const match = this.visibleOptions().find((o) =>
        (o.getAttribute("data-label") || "").toLowerCase().startsWith(this.typeahead),
      );
      if (match) this.setActive(match, true);
    }

    onOptionClick(opt) {
      this.setActive(opt, false);
      this.selectOption(opt);
    }

    selectOption(opt) {
      if (this.multiple) {
        const on = opt.getAttribute("aria-selected") === "true";
        opt.setAttribute("aria-selected", on ? "false" : "true");
        this.syncFromSelection(false);
        // Panel stays open while toggling checkboxes.
      } else {
        this.options.forEach((o) => o.setAttribute("aria-selected", o === opt ? "true" : "false"));
        this.syncFromSelection(false);
        this.close();
      }
    }

    onSearch() {
      const q = this.searchInput.value.trim().toLowerCase();
      let visible = 0;
      this.options.forEach((o) => {
        const label = (o.getAttribute("data-label") || "").toLowerCase();
        const match = q === "" || label.indexOf(q) !== -1;
        o.hidden = !match;
        if (match) visible += 1;
      });
      if (this.noResults) {
        if (visible === 0) {
          this.noResults.textContent = this.noResultsTpl.replace(
            "{query}",
            this.searchInput.value.trim(),
          );
          this.noResults.hidden = false;
        } else {
          this.noResults.hidden = true;
        }
      }
      const vis = this.visibleOptions();
      if (!this.active || this.active.hidden) this.setActive(vis[0] || null, false);
    }

    onClear() {
      this.searchInput.value = "";
      this.onSearch();
      this.searchInput.focus();
    }

    syncFromSelection(initial) {
      const selected = this.options.filter((o) => o.getAttribute("aria-selected") === "true");

      if (this.inputsHost && this.name) {
        this.inputsHost.innerHTML = "";
        if (this.multiple) {
          selected.forEach((o) => {
            const inp = document.createElement("input");
            inp.type = "hidden";
            inp.name = this.name + "[]";
            inp.value = o.getAttribute("data-value") || "";
            this.inputsHost.appendChild(inp);
          });
        } else {
          const inp = document.createElement("input");
          inp.type = "hidden";
          inp.name = this.name;
          inp.value = selected[0] ? selected[0].getAttribute("data-value") || "" : "";
          this.inputsHost.appendChild(inp);
        }
      }

      let text;
      if (this.multiple) {
        text = selected.length ? this.multiLabel.replace("{count}", selected.length) : "";
      } else if (selected[0]) {
        text = selected[0].getAttribute("data-label") || "";
      } else {
        text = initial && this.valueEl ? this.valueEl.textContent.trim() : "";
      }
      if (this.valueEl) this.valueEl.textContent = text;
      if (this.field) this.field.classList.toggle("form-field--completed", text !== "");

      // Re-validate immediately only when already erroring (input convention),
      // so a failed required check clears the moment a selection is made --
      // including in multi mode, where the panel stays open and close() (the
      // usual validate moment) has not fired yet.
      if (!initial && this.field && this.field.classList.contains("form-field--error")) {
        this.validate();
      }

      if (!initial) {
        this.dispatchEvent(
          new CustomEvent("dropdown:change", {
            bubbles: true,
            detail: {
              value: this.multiple
                ? selected.map((o) => o.getAttribute("data-value"))
                : selected[0]
                  ? selected[0].getAttribute("data-value")
                  : null,
            },
          }),
        );
      }
    }

    onDocDown(event) {
      if (!this.contains(event.target)) this.close(true);
    }
  }

  if (!customElements.get("x-dropdown")) {
    customElements.define("x-dropdown", SeedDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function wireCarouselDemos() {
      const groups = document.querySelectorAll("[data-ds-carousel-demo]");
      groups.forEach((group) => {
        if (group.dataset.dsWired) return;
        group.dataset.dsWired = "true";
        const carousel = group.querySelector("x-carousel");
        if (!carousel) return;
        const prev = group.querySelector("[data-prev]");
        const next = group.querySelector("[data-next]");
        if (prev) prev.addEventListener("click", () => carousel.prev());
        if (next) next.addEventListener("click", () => carousel.next());
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", wireCarouselDemos);
    } else {
      wireCarouselDemos();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-demo-range-slider"] && !Shopify.designMode) return;
  try {
    // Mirror each demo slider's current value(s) into the visible readout so
  // dragging and keyboard changes are obvious at a glance.
  (function () {
    function initRangeSliderDemos() {
      document.querySelectorAll("[data-rs-demo]").forEach(function (item) {
        var out = item.querySelector("[data-rs-value]");
        if (!out) return;
        var prefix = item.dataset.rsPrefix || "";
        var update = function () {
          var inputs = item.querySelectorAll(".range-slider__input");
          if (inputs.length === 2) {
            out.textContent = prefix + inputs[0].value + " to " + prefix + inputs[1].value;
          } else if (inputs.length === 1) {
            out.textContent = prefix + inputs[0].value;
          }
        };
        item.addEventListener("input", update);
        update();
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initRangeSliderDemos);
    } else {
      initRangeSliderDemos();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["find-in-store"] && !Shopify.designMode) return;
  try {
    class FindInStore extends HTMLElement {
    connectedCallback() {
      this.region = this.dataset.region || "AU";
      this.cc = (this.dataset.cc || this.region).toLowerCase();
      this.variantId = this.dataset.variantId || "";
      this.proxyPath = (this.dataset.proxyPath || "").trim();
      this.radius = parseFloat(this.dataset.radius);
      if (isNaN(this.radius)) this.radius = 100;
      this.lowMin = parseInt(this.dataset.lowMin, 10);
      if (isNaN(this.lowMin)) this.lowMin = 1;
      this.lowMax = parseInt(this.dataset.lowMax, 10);
      if (isNaN(this.lowMax)) this.lowMax = 3;
      this.countTmpl = this.dataset.resultsCountTmpl || "";
      this.searchingLabel = this.dataset.searchingLabel || "";
      this.emptyLabel = this.dataset.emptyLabel || "";
      this.noMatchLabel = this.dataset.noMatchLabel || "";
      this.errorLabel = this.dataset.errorLabel || "";
      this.saleLabel = this.dataset.saleLabel || "";
      this.origLabel = this.dataset.originalLabel || "";
      this.badgeLabels = {
        in_stock: this.dataset.labelInStock || "",
        low_stock: this.dataset.labelLowStock || "",
        out_of_stock: this.dataset.labelOutOfStock || "",
      };

      try {
        const sk = this.querySelector("[data-fis-skus]");
        this.skus = sk ? JSON.parse(sk.textContent) : {};
      } catch (e) {
        this.skus = {};
      }
      try {
        const pr = this.querySelector("[data-fis-prices]");
        this.prices = pr ? JSON.parse(pr.textContent) : {};
      } catch (e) {
        this.prices = {};
      }
      // Live-stock cache keyed by SKU -> { storeId: bufferedLevel }. Populated by the
      // Worker fetch; a re-query for a size already seen is served from here.
      this.inventoryCache = {};

      // Refs (the body lives inside the overlay <dialog>, a descendant of this element).
      this.field = this.querySelector(".find-in-store__field .input__control");
      this.submitBtn = this.querySelector("[data-fis-submit]");
      this.clearBtn = this.querySelector("[data-input-trailing-link]");
      this.results = this.querySelector("[data-fis-results]");
      // The source is an inert <template> (250+ cards never join the live DOM);
      // read its content fragment. Falls back to the element itself if the
      // wrapper is ever a plain node again.
      const sourceEl = this.querySelector("[data-fis-source]");
      this.source = sourceEl && sourceEl.content ? sourceEl.content : sourceEl;
      // Store source starts empty; ensureSource() fills it from the Worker's
      // region store DTO on first drawer open by cloning the card stamp.
      this.cardTpl = this.querySelector("[data-fis-card-tpl]");
      this.urlBase = this.dataset.storeUrlBase || "/pages/store-finder/";
      this.sourceReady = null;
      this.sourceFailed = false;
      this.message = this.querySelector("[data-fis-message]");
      this.statusEl = this.querySelector("[data-fis-status]");
      this.priceEl = this.querySelector("[data-fis-price]");
      this.sizeSelect = this.querySelector("x-size-select");
      this.map = this.querySelector("[data-store-map]");
      this.tooltipTpl = this.map ? this.map.querySelector("[data-store-map-tooltip]") : null;
      this.token = this.map ? this.map.dataset.token || "" : "";

      // State. A monotonic token lets a superseded async geocode bail.
      this.searchActive = false;
      this.origin = null;
      this.loading = false;
      this.errored = false;
      this._seq = 0;
      // The result card whose store is pinned on the desktop map (defaults to the
      // nearest on each search; clicking/focusing another card moves the pin).
      this.selectedCard = null;
      // Last pinned location+label, so updateMap can skip a no-op re-render (avoids
      // the pin rebuilding on a size re-query that keeps the same nearest store).
      this._mapKey = null;

      if (this.field) {
        this.field.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            this.onSearch();
          }
        });
        this.field.addEventListener("input", () => {
          this.classList.toggle("find-in-store--has-query", this.field.value.trim() !== "");
          if (this.searchActive && this.field.value.trim() === "") {
            this.clearSearch();
            this.render();
          }
        });
      }
      if (this.submitBtn) this.submitBtn.addEventListener("click", () => this.onSearch());
      if (this.clearBtn) {
        this.clearBtn.addEventListener("click", () => {
          this.clearSearch();
          this.render();
          if (this.field) this.field.focus();
        });
      }

      // Selecting a result card (click OR keyboard focus into it) moves the desktop
      // map pin to that store and bolds its border. Delegated so it survives re-render.
      if (this.results) {
        this.results.addEventListener("click", (e) => {
          const card = e.target.closest("[data-fis-store-card]");
          if (card) this.selectCard(card);
        });
        this.results.addEventListener("focusin", (e) => {
          const card = e.target.closest("[data-fis-store-card]");
          if (card) this.selectCard(card);
        });
      }

      // In-drawer size selector -> re-render price + re-query stock. Local only:
      // it does NOT drive the PDP variant (one-way, buy-box -> drawer).
      this.addEventListener("size-select:change", (e) => this.onSizeChange(e));

      // Buy-box size/colour change -> keep the drawer summary + selector + badges in sync.
      this._onVariant = (e) => this.onVariantChange(e);
      document.addEventListener("variant:change", this._onVariant);

      // Opening starts the store-source fetch so the list resolves while the
      // shopper types; a search awaits the same promise.
      this._onOverlayOpen = (e) => {
        if (e.detail && e.detail.id === "find-in-store") {
          this.classList.add("find-in-store--open");
          this.ensureSource();
        }
      };
      this._onOverlayClose = (e) => {
        if (e.detail && e.detail.id === "find-in-store")
          this.classList.remove("find-in-store--open");
      };
      document.addEventListener("overlay:open", this._onOverlayOpen);
      document.addEventListener("overlay:close", this._onOverlayClose);

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener("variant:change", this._onVariant);
      document.removeEventListener("overlay:open", this._onOverlayOpen);
      document.removeEventListener("overlay:close", this._onOverlayClose);
    }

    // Region stores come from the Worker on first drawer open; the theme renders
    // no per-store markup during the PDP response. Repeat opens/searches share the
    // same promise. A transient fetch failure drops the memo so the next search
    // retries, while a degraded markup/path failure stays permanent because the
    // markup cannot change mid-page.
    ensureSource() {
      if (this.sourceReady) return this.sourceReady;
      const list = this.source ? this.source.querySelector(".find-in-store__source") : null;
      if (!this.proxyPath || !list || !this.cardTpl || !this.cardTpl.content) {
        // Degraded (blank proxy path) or malformed markup: no store source.
        this.sourceFailed = true;
        this.sourceReady = Promise.resolve();
        return this.sourceReady;
      }
      const init = {};
      if (typeof AbortSignal !== "undefined" && typeof AbortSignal.timeout === "function") {
        // Timebox to match the Worker's upstream budget: a hung proxy hop
        // resolves to the error state instead of "Searching..." forever.
        init.signal = AbortSignal.timeout(10000);
      }
      this.sourceFailed = false;
      this.sourceReady = fetch(
        this.proxyPath + "/stores?region=" + encodeURIComponent(this.region),
        init,
      )
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error("fis_stores_unavailable"))))
        .then((data) => {
          // Prefer the Worker's urlBase (read from the metaobject definition's
          // online-store capability, so admin URL-structure changes propagate);
          // the data attribute stays as the fallback.
          if (data && typeof data.urlBase === "string" && data.urlBase) {
            this.urlBase = data.urlBase;
          }
          const stores = data && Array.isArray(data.stores) ? data.stores : [];
          // A retry repopulates from scratch -- never append onto a partial fill.
          while (list.firstChild) list.removeChild(list.firstChild);
          stores.forEach((store) => {
            const item = this.buildSourceItem(store);
            if (item) list.appendChild(item);
          });
        })
        .catch(() => {
          this.sourceFailed = true;
          this.sourceReady = null;
        });
      return this.sourceReady;
    }

    // Store DTO shape: { id, handle, name, precinct, street, lat, lng }.
    // Blank optional rows are removed so empty fields do not leave whitespace.
    buildSourceItem(store) {
      if (!store || typeof store !== "object") return null;
      const frag = this.cardTpl.content.cloneNode(true);
      const item = frag.querySelector(".find-in-store__source-item");
      const card = frag.querySelector("[data-fis-store-card]");
      if (!item || !card) return null;
      card.dataset.storeId = (store.id || "").trim();
      card.dataset.storeHandle = store.handle || "";
      card.dataset.name = (store.name || "").toLowerCase();
      card.dataset.lat = store.lat != null ? String(store.lat) : "";
      card.dataset.lng = store.lng != null ? String(store.lng) : "";
      const rows = { name: store.name, precinct: store.precinct, street: store.street };
      Object.keys(rows).forEach((key) => {
        const el = card.querySelector('[data-tpl="' + key + '"]');
        if (!el) return;
        const value = (rows[key] || "").trim();
        if (value) {
          el.textContent = value;
        } else {
          el.remove();
        }
      });
      const link = card.querySelector(".fis-store-card__link");
      if (link && store.handle) {
        link.setAttribute("href", this.urlBase + encodeURIComponent(store.handle));
      } else if (link) {
        link.remove();
      }
      return item;
    }

    // --- Live inventory seam ---------------------------------------------
    // The single swap point: POST the selected SKU + region store ids to the
    // same-origin App-Proxy path; Shopify signs + forwards to the Worker, which
    // returns { storeId: { sku: level } }. Cache the flattened { storeId: level }
    // per SKU so a re-query for a seen size is instant.
    currentSku() {
      return this.skus[this.variantId] || "";
    }
    regionStoreIds() {
      if (!this.source) return [];
      const ids = [];
      this.source.querySelectorAll("[data-fis-store-card]").forEach((card) => {
        const id = (card.dataset.storeId || "").trim();
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }
    // Resolve { storeId: level } for a SKU. Cached; blank path or no seeded store
    // ids -> resolves empty (availability degrades to out-of-stock, no console noise).
    fetchInventory(sku) {
      if (!sku) return Promise.resolve({});
      if (this.inventoryCache[sku]) return Promise.resolve(this.inventoryCache[sku]);
      const storeIds = this.regionStoreIds();
      if (!this.proxyPath || !storeIds.length) {
        this.inventoryCache[sku] = {};
        return Promise.resolve(this.inventoryCache[sku]);
      }
      return fetch(this.proxyPath, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ market: this.region, skus: [sku], stores: storeIds }),
      })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error("fis_unavailable"))))
        .then((data) => {
          const stores = data && data.stores ? data.stores : {};
          const flat = {};
          Object.keys(stores).forEach((sid) => {
            const perSku = stores[sid] || {};
            flat[sid] = perSku[sku];
          });
          this.inventoryCache[sku] = flat;
          return flat;
        });
    }
    statusFromLevel(level) {
      if (typeof level !== "number" || isNaN(level) || level <= 0) return "out_of_stock";
      if (level >= this.lowMax) return "in_stock";
      if (level >= this.lowMin) return "low_stock";
      return "out_of_stock";
    }
    badgeFor(storeId) {
      const map = this.inventoryCache[this.currentSku()];
      if (!map) return "out_of_stock";
      return this.statusFromLevel(map[storeId]);
    }

    // --- Geo helpers (shared via window.SeedGeoUtils, snippets/geo-utils.liquid) ---
    haversine(a, b) {
      return window.SeedGeoUtils.haversine(a, b);
    }

    formatKm(d) {
      return window.SeedGeoUtils.formatKm(d);
    }

    geocode(query) {
      return window.SeedGeoUtils.geocode(query, this.token, this.cc);
    }

    onSearch() {
      const q = this.field ? this.field.value.trim() : "";
      if (!q) {
        this.clearSearch();
        this.render();
        return;
      }
      const seq = ++this._seq;
      this.searchActive = true;
      this.loading = true;
      this.errored = false;
      this.origin = null;
      this.setSubmitLoading(true);
      this.render(); // loading: leave prior content, announce searching
      // Store source + geocode resolve in parallel: drawer-open usually started
      // the source fetch already. A failed source is a hard error; showing
      // "no stores near you" over a fetch failure would mislead.
      Promise.all([this.ensureSource(), this.geocode(q)])
        .then((resolved) => {
          const coords = resolved[1];
          if (seq !== this._seq) return;
          if (this.sourceFailed) {
            this.fail(seq);
            return;
          }
          this.origin = coords;
          if (coords) {
            // The map pin is a STORE, not the searched point: fetch stock, then
            // render() selects the nearest card and pins its store (selectCard).
            this.loadInventory(seq);
          } else {
            this.loading = false;
            this.setSubmitLoading(false);
            this.render();
          }
        })
        .catch(() => this.fail(seq));
    }

    // Fetch live stock for the active SKU, then render. Shared by a fresh search
    // and a size/variant re-query (which keeps the resolved origin).
    loadInventory(seq) {
      this.fetchInventory(this.currentSku())
        .then(() => {
          if (seq !== this._seq) return;
          this.loading = false;
          this.setSubmitLoading(false);
          this.render();
        })
        .catch(() => this.fail(seq));
    }

    fail(seq) {
      if (seq !== this._seq) return;
      this.loading = false;
      this.errored = true;
      this.setSubmitLoading(false);
      this.render();
    }

    // Re-query live stock for a new SKU while a search is active (size / variant
    // change). Distance is store-based, so origin + sort are unchanged; the loading
    // announce leaves the current cards in place until the new levels resolve.
    requery() {
      if (!this.searchActive || !this.origin) return;
      const seq = ++this._seq;
      this.loading = true;
      this.errored = false;
      this.setSubmitLoading(true);
      this.render();
      this.loadInventory(seq);
    }

    clearSearch() {
      this._seq++; // invalidate any in-flight geocode
      this.searchActive = false;
      this.origin = null;
      this.loading = false;
      this.errored = false;
      if (this.field) this.field.value = "";
      this.classList.remove("find-in-store--has-query");
      this.setSubmitLoading(false);
    }

    setSubmitLoading(on) {
      if (this.submitBtn) this.submitBtn.classList.toggle("is-loading", !!on);
    }

    onSizeChange(e) {
      const id = e && e.detail ? e.detail.value : null;
      if (!id || id === this.variantId) return;
      this.variantId = id;
      this.renderPrice(id);
      this.requery();
    }

    onVariantChange(e) {
      const id = e && e.detail ? e.detail.id : null;
      if (!id || id === this.variantId) return;
      this.variantId = id;
      this.renderPrice(id);
      this.syncSizeSelector(id);
      this.requery();
    }

    // Mirror an external variant change (buy box) into the size-select WITHOUT
    // emitting size-select:change (the requery is driven separately by onVariantChange).
    syncSizeSelector(id) {
      if (this.sizeSelect && typeof this.sizeSelect.setValue === "function") {
        this.sizeSelect.setValue(id);
      }
    }

    setStatus(text) {
      if (this.statusEl) this.statusEl.textContent = text || "";
    }

    formatCount(n) {
      return this.countTmpl ? this.countTmpl.replace("%c%", n) : "";
    }

    showMessage(text, isError) {
      if (!this.message) return;
      this.message.textContent = text || "";
      this.message.hidden = !text;
      this.message.classList.toggle("find-in-store__message--error", !!isError);
    }

    setBadge(badge, status) {
      if (!badge) return;
      badge.classList.remove(
        "availability-badge--in_stock",
        "availability-badge--low_stock",
        "availability-badge--out_of_stock",
      );
      badge.classList.add("availability-badge--" + status);
      badge.setAttribute("data-status", status);
      const label = badge.querySelector(".availability-badge__label");
      if (label && this.badgeLabels[status]) label.textContent = this.badgeLabels[status];
    }

    renderPrice(id) {
      const entry = this.prices[id];
      if (!entry || !this.priceEl) return;
      let html = '<span class="price' + (entry.onSale ? " price--on-sale" : "") + '" data-price>';
      if (entry.onSale && this.saleLabel)
        html += '<span class="price__a11y">' + this.saleLabel + "</span>";
      html += '<span class="price__current" data-price-current>' + entry.price + "</span>";
      if (entry.onSale && entry.compare) {
        if (this.origLabel) html += '<span class="price__a11y">' + this.origLabel + "</span>";
        html += '<span class="price__compare" data-price-compare>' + entry.compare + "</span>";
      }
      html += "</span>";
      this.priceEl.innerHTML = html;
    }

    // Low-level: pin a single point (a STORE location) with a tooltip label, or
    // clear the pin when coords is null.
    updateMap(coords, label) {
      if (!this.map) return;
      const markers = coords ? [{ lat: coords.lat, lng: coords.lng }] : [];
      // Dedupe: store-map rebuilds its GL marker on every store-map:update (clear +
      // re-add), which reads as a flash/blur. A size re-query keeps the same nearest
      // store, so skip the dispatch when neither the pinned location nor its label
      // changed -- only move the pin when it actually needs to move.
      const key = JSON.stringify(markers) + "|" + (label || "");
      if (key === this._mapKey) return;
      this._mapKey = key;
      if (this.tooltipTpl && label) {
        const t = this.tooltipTpl.content.querySelector(".tooltip__text");
        if (t) t.textContent = label;
      }
      this.map.dataset.markers = JSON.stringify(markers);
      this.map.dispatchEvent(
        new CustomEvent("store-map:update", { bubbles: true, detail: { markers: markers } }),
      );
    }

    // Mark a result card as selected (bold border, desktop) and move the map pin to
    // its store, with the store name as the tooltip. Called for the nearest card on
    // each search and whenever a shopper clicks / focuses another card.
    selectCard(card) {
      if (!card || card === this.selectedCard) return;
      if (this.selectedCard) this.selectedCard.classList.remove("fis-store-card--selected");
      card.classList.add("fis-store-card--selected");
      this.selectedCard = card;
      const lat = parseFloat(card.dataset.lat);
      const lng = parseFloat(card.dataset.lng);
      const nameEl = card.querySelector(".fis-store-card__name");
      const name = nameEl ? nameEl.textContent.trim() : "";
      if (!isNaN(lat) && !isNaN(lng)) {
        this.updateMap({ lat: lat, lng: lng }, name);
      } else {
        this.updateMap(null); // store has no coords -> no pin
      }
    }

    clearSelection() {
      if (this.selectedCard) this.selectedCard.classList.remove("fis-store-card--selected");
      this.selectedCard = null;
      this.updateMap(null);
    }

    render() {
      if (!this.searchActive) {
        if (this.results) this.results.innerHTML = "";
        this.clearSelection();
        this.showMessage("");
        this.setStatus("");
        return;
      }
      // Loading: leave whatever is on screen in place, just announce (deferred swap,
      // mirrors store-finder -- avoids a collapse/flash before results resolve).
      if (this.loading) {
        this.setStatus(this.searchingLabel);
        return;
      }
      if (this.errored) {
        if (this.results) this.results.innerHTML = "";
        this.clearSelection();
        this.showMessage(this.errorLabel, true);
        this.setStatus("");
        return;
      }
      if (!this.origin) {
        if (this.results) this.results.innerHTML = "";
        this.clearSelection();
        this.showMessage(this.noMatchLabel, true);
        this.setStatus("");
        return;
      }

      const cards = this.source
        ? Array.from(this.source.querySelectorAll("[data-fis-store-card]"))
        : [];
      if (!cards.length) {
        if (this.results) this.results.innerHTML = "";
        this.clearSelection();
        this.showMessage(this.emptyLabel);
        this.setStatus("");
        return;
      }

      // Distance-sort ALL region stores nearest-first; missing lat/lng sort last.
      let sorted = cards
        .map((card) => {
          const lat = parseFloat(card.dataset.lat);
          const lng = parseFloat(card.dataset.lng);
          const d =
            !isNaN(lat) && !isNaN(lng)
              ? this.haversine(this.origin, { lat: lat, lng: lng })
              : Infinity;
          return { card: card, d: d };
        })
        .sort((a, b) => a.d - b.d);

      if (this.radius > 0) {
        sorted = sorted.filter((entry) => entry.d <= this.radius);
      }

      if (!sorted.length) {
        if (this.results) this.results.innerHTML = "";
        this.clearSelection();
        this.showMessage(this.emptyLabel);
        this.setStatus("");
        return;
      }

      this.showMessage("");
      if (this.results) this.results.innerHTML = "";
      this.selectedCard = null; // the previously-selected card was just destroyed
      sorted.forEach((entry) => {
        const clone = entry.card.cloneNode(true);
        if (isFinite(entry.d)) {
          const dist = clone.querySelector("[data-fis-distance]");
          if (dist) dist.textContent = this.formatKm(entry.d);
        }
        // Live badge for the active SKU (inventory is pre-fetched before render).
        this.setBadge(
          clone.querySelector("[data-availability-badge]"),
          this.badgeFor((clone.dataset.storeId || "").trim()),
        );
        const li = document.createElement("li");
        li.className = "find-in-store__result-item";
        li.appendChild(clone);
        if (this.results) this.results.appendChild(li);
      });

      this.setStatus(this.formatCount(sorted.length));
      if (this.results) this.selectCard(this.results.querySelector("[data-fis-store-card]"));
    }
  }

  if (!customElements.get("find-in-store")) {
    customElements.define("find-in-store", FindInStore);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["focus-modality"] && !Shopify.designMode) return;
  try {
    (function () {
    "use strict";

    var root = document.documentElement;

    function set(modality) {
      if (root.dataset.inputModality !== modality) root.dataset.inputModality = modality;
    }

    // Capture phase so a handler calling stopPropagation cannot strand the
    // modality on a stale value.
    document.addEventListener(
      "pointerdown",
      function () {
        set("pointer");
      },
      true,
    );

    // Only keys that move focus count as keyboard navigation. Activation keys are
    // deliberately absent: iOS Safari fires keydown for the on-screen keyboard's
    // Return/Go and Backspace, which a touch-only shopper presses while typing a
    // search, and any real keyboard user has already reached the control with one
    // of these keys, so the modality is set by the time they activate it.
    var NAVIGATION_KEYS = {
      Tab: true,
      ArrowUp: true,
      ArrowDown: true,
      ArrowLeft: true,
      ArrowRight: true,
      Home: true,
      End: true,
      PageUp: true,
      PageDown: true,
      Escape: true,
    };

    document.addEventListener(
      "keydown",
      function (event) {
        if (!NAVIGATION_KEYS[event.key]) return;
        set("keyboard");
      },
      true,
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["geo-utils"] && !Shopify.designMode) return;
  try {
    window.SeedGeoUtils = window.SeedGeoUtils || {
    // Great-circle distance in km between two { lat, lng } points.
    haversine(a, b) {
      const R = 6371;
      const toRad = (n) => (n * Math.PI) / 180;
      const dLat = toRad(b.lat - a.lat);
      const dLng = toRad(b.lng - a.lng);
      const la1 = toRad(a.lat);
      const la2 = toRad(b.lat);
      const x =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
    },

    // One decimal below 10km, whole km above; suffixed 'km'.
    formatKm(d) {
      const v = d < 10 ? d.toFixed(1) : String(Math.round(d));
      return v + "km";
    },

    // Mapbox forward geocoding: postcode/suburb -> { lat, lng }, biased to `cc`.
    // Returns null when no token, no match, or the request fails.
    geocode(query, token, cc) {
      if (!token) return Promise.resolve(null);
      const country = (cc || "AU").toLowerCase();
      const url =
        "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
        encodeURIComponent(query) +
        ".json?access_token=" +
        encodeURIComponent(token) +
        "&country=" +
        country +
        "&autocomplete=true&limit=1";
      return fetch(url)
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const c = d && d.features && d.features[0] && d.features[0].center;
          return c ? { lat: c[1], lng: c[0] } : null;
        })
        .catch(() => null);
    },
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-purchase-form"] && !Shopify.designMode) return;
  try {
    /* <gift-card-form> -- shared gift card purchase controller.
     Owns active design / amount-variant resolution, date seeding (today ..
     today + 3 months), char-guard + submit validation, the Vii attribute
     payload and bundled-section AJAX adds. It finds parts by data-attribute so
     the markup can live in either host: one wrapping a design picker, or the
     quick-add drawer, which carries no thumb strip and takes its design from
     the opening tile via prepareForDesign (marked `data-gc-locked`).

     Edit mode (a cart line's `?edit=<key>`) is driven from outside: the host
     resolves the line, calls prepareForDesign then applyEditLine, the CTA
     becomes Update cart, and submit adds the reconfigured line then removes the
     original. */
  class GiftCardForm extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector("[data-gc-variants]");
      try {
        this.data = dataEl ? JSON.parse(dataEl.textContent) : { designs: [], map: {} };
      } catch (err) {
        this.data = { designs: [], map: {} };
      }

      this.form = this.querySelector("form");
      this.idInput = this.querySelector("[data-gc-id]");
      this.itemRefInput = this.querySelector("[data-gc-item-ref]");
      this.addBtn = this.querySelector("[data-gc-add]");
      this.errorEl = this.querySelector("[data-gc-error]");
      this.amountsEl = this.querySelector(".gc-form__amounts");
      this.amountErrorEl = this.querySelector("[data-gc-amount-error]");
      this.carousel = this.querySelector("x-carousel");
      this.prevBtn = this.querySelector("[data-gc-prev]");
      this.nextBtn = this.querySelector("[data-gc-next]");
      this.datePicker = this.querySelector("x-date-picker");

      this.addErrorLabel = this.getAttribute("data-gc-add-error") || "";
      this.throttleErrorLabel = this.getAttribute("data-gc-throttle-error") || this.addErrorLabel;
      this.addLabel = this.getAttribute("data-gc-add-label") || "";
      this.updateLabel = this.getAttribute("data-gc-update-label") || "";
      this.addLabelEl = this.addBtn ? this.addBtn.querySelector(".btn__label") : null;
      this.editLineId = null;
      this.editVariantId = "";
      this.editFromDrawer = false;
      this.activeDesign = this.getAttribute("data-gc-initial-design") || this.data.designs[0] || "";
      this.selectedAmountLabel = null;

      /* JS clears the no-JS seed id so no unchosen variant is POSTed.
         The button stays enabled: tapping with no amount surfaces the inline
         amount error instead of presenting a dead disabled control. */
      if (this.idInput) this.idInput.value = "";

      this.seedDatePicker();

      this.onThumbClick = this.onThumbClick.bind(this);
      this.onChipChange = this.onChipChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onEditClick = this.onEditClick.bind(this);
      this.onOverlayClose = this.onOverlayClose.bind(this);

      /* Document-level, because the cart rows that carry the pencil are rendered
         and re-rendered by the cart runtime on surfaces this element does not
         contain (the cart drawer and the /cart page). */
      document.addEventListener("click", this.onEditClick);
      document.addEventListener("overlay:close", this.onOverlayClose);

      this.querySelectorAll("[data-gc-design]").forEach((btn) => {
        btn.addEventListener("click", this.onThumbClick);
      });
      this.addEventListener("size-chip:change", this.onChipChange);
      if (this.form) {
        /* Inline snippet errors + first-invalid focus own the invalid path
           (native bubbles stay for the no-JS fallback). */
        this.form.noValidate = true;
        this.form.addEventListener("submit", this.onSubmit);
      }
      this.addEventListener("focusout", this.onFocusOut);
      this.addEventListener("input", this.onInput);

      if (this.prevBtn && this.carousel) {
        this.prevBtn.addEventListener("click", () => this.carousel.prev());
      }
      if (this.nextBtn && this.carousel) {
        this.nextBtn.addEventListener("click", () => this.carousel.next());
      }
      if (this.carousel) {
        this.arrowObserver = new MutationObserver(() => this.syncArrows());
        this.arrowObserver.observe(this.carousel, {
          attributes: true,
          attributeFilter: ["data-at-start", "data-at-end"],
        });
        requestAnimationFrame(() => this.syncArrows());
      }

      this.syncAddState();
    }

    disconnectedCallback() {
      if (this.arrowObserver) this.arrowObserver.disconnect();
      document.removeEventListener("click", this.onEditClick);
      document.removeEventListener("overlay:close", this.onOverlayClose);
    }

    /* A cart line's edit pencil. The row element is the only handle taken: it
       carries the row identity the cart runtime mutates by, so nothing captured
       here can be invalidated by a cart write between render and click. */
    onEditClick(event) {
      const trigger = event.target.closest ? event.target.closest("[data-gc-edit-line]") : null;
      if (!trigger) return;
      const row = trigger.closest("x-cart-line-item");
      if (!row) return;
      event.preventDefault();
      this.openForRow(row);
    }

    /* Dismissing the editor (Escape, X, scrim) or submitting from it both close
       this drawer. Opening it closed the cart drawer underneath -- the overlay
       component allows one surface at a time -- so put the cart drawer back
       whenever the edit started there, and drop the pending edit either way. */
    onOverlayClose(event) {
      if (!event.detail || event.detail.id !== this.overlayId()) return;
      const fromDrawer = this.editFromDrawer;
      this.editFromDrawer = false;
      if (this.editLineId) this.exitEditMode();
      if (!fromDrawer) return;
      const drawer = document.querySelector('x-overlay[data-overlay-id="cart-drawer"]');
      if (drawer && typeof drawer.open === "function") drawer.open();
    }

    overlayId() {
      const host = this.closest("x-overlay");
      return host ? host.getAttribute("data-overlay-id") : null;
    }

    /* Open this drawer over the cart surface, prefilled from `row` and in update
       mode. `data-line-props` carries the line's whole property set, so the
       prefill needs no cart read.

       The design comes from the row's VARIANT, not its `_gift_recipient_item_ref`
       property: a variant IS one design x one amount, so the chip carrying that
       variant id names both, and a line stamped by another channel (or with a
       drifted item_ref) still edits against the right artwork. No chip means the
       variant is no longer in the product and there is nothing to edit it
       against, so the pencil stays inert. */
    openForRow(row) {
      const host = this.closest("x-overlay");
      if (!host || typeof host.open !== "function") return;
      const variantId = row.getAttribute("data-variant-id") || "";
      const chip = variantId
        ? this.querySelector('[data-size-chip-value="' + CSS.escape(variantId) + '"]')
        : null;
      const group = chip ? chip.closest("[data-gc-chips]") : null;
      if (!group) return;
      this.editFromDrawer = !!row.closest('x-overlay[data-overlay-id="cart-drawer"]');
      this.prepareForDesign(group.getAttribute("data-gc-chips"));
      this.applyEditLine(
        row.getAttribute("data-line-id"),
        variantId,
        GiftCardForm.propsFromRow(row),
      );
      host.open();
    }

    /* `data-line-props` is Liquid's `properties | json`, i.e. [[key, value], ...]. */
    static propsFromRow(row) {
      let pairs;
      try {
        pairs = JSON.parse(row.getAttribute("data-line-props") || "[]");
      } catch (err) {
        return {};
      }
      const out = {};
      if (!Array.isArray(pairs)) return pairs || {};
      pairs.forEach((pair) => {
        if (Array.isArray(pair) && pair.length) out[pair[0]] = pair[1];
      });
      return out;
    }

    routeRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    }

    /* Drawer entry point: reset the form to a clean state and lock it to `design`
       before the overlay opens, so re-opening on a different tile never carries
       the previous design's amount / typed fields -- nor a pending edit, which
       would otherwise make the next add silently replace an unrelated cart line. */
    prepareForDesign(design) {
      if (this.editLineId) this.exitEditMode();
      /* Clear the carried amount first so switching design on re-open never
         preserves the previous design's denomination (selectDesign's carry
         behaviour is for the PDP thumb strip, not the drawer reset). */
      this.selectedAmountLabel = null;
      if (design) {
        this.selectDesign(design);
      } else {
        this.clearAmount();
      }
      /* Reset each field WITHOUT validating -- clear the value, un-float the
         label and drop any prior error/warning state via the field element's own
         methods. Dispatching a synthetic `blur` here would trip the snippet's
         required-check and flag the empty fields the instant the drawer opens;
         errors must only surface when the shopper actually blurs a field. */
      ["gc-your-name", "gc-recipient-name", "gc-recipient-email", "gc-message"].forEach((id) => {
        const control = this.querySelector("#" + CSS.escape(id));
        if (!control) return;
        control.value = "";
        const host = control.closest("x-input") || control.closest("x-textarea");
        if (host) {
          if (typeof host.updateCounter === "function") host.updateCounter();
          if (typeof host.setState === "function") {
            host.setState("completed", false);
            host.setState("error", false);
            host.setState("warning", false);
            host.setState("focused", false);
          }
          if (typeof host.setMessage === "function") host.setMessage(host.defaultMessage || "");
        }
        control.setAttribute("aria-invalid", "false");
      });
      this.querySelectorAll("[data-gc-guard]").forEach((el) => {
        el.hidden = true;
      });
      if (this.errorEl) this.errorEl.hidden = true;
      if (this.amountErrorEl) this.amountErrorEl.hidden = true;
      this.seedDatePicker(true);
    }

    /* Edit entry point: prefill the whole form from the cart row being edited and
       switch the CTA to Update cart. Run AFTER prepareForDesign, which clears the
       form and locks the design the amount chips are read from. `lineId` is the
       row's identity, not a line key: the cart runtime resolves it to live line
       keys at write time. */
    applyEditLine(lineId, variantId, props) {
      /* Amount: select the chip carrying this row's variant id in the active
         design group (skip if it is now sold out / disabled). */
      variantId = String(variantId || "");
      if (variantId) {
        const group = this.querySelector('[data-gc-chips="' + CSS.escape(this.activeDesign) + '"]');
        const scope = group || this;
        const chip = scope.querySelector('[data-size-chip-value="' + variantId + '"]');
        if (chip && !chip.disabled) this.applyChipSelection(chip);
      }

      /* Personalisation fields: set value + fire input so <x-input> / <x-textarea>
         float their labels (form-field--completed) exactly as typing would. */
      this.setField("gc-your-name", props._gift_sender_name);
      this.setField("gc-recipient-name", props._gift_recipient_name);
      this.setField("gc-recipient-email", props._gift_recipient_email);
      this.setField("gc-message", props._gift_recipient_message);

      /* Delivery date: stored DD/MM/YYYY -> seed the picker if still in range. */
      this.setDeliveryDate(props._gift_recipient_delivery_date);

      this.editLineId = lineId;
      this.editVariantId = variantId;
      if (this.addLabelEl && this.updateLabel) this.addLabelEl.textContent = this.updateLabel;
    }

    setField(id, value) {
      if (value == null || value === "") return;
      const control = this.querySelector("#" + CSS.escape(id));
      if (!control) return;
      control.value = value;
      /* input -> refresh the char counter (message field); blur -> <x-input> /
         <x-textarea> float the label (form-field--completed) and validate, exactly
         as a real edit would (they set `completed` on blur, not on input). */
      control.dispatchEvent(new Event("input", { bubbles: true }));
      control.dispatchEvent(new Event("blur"));
    }

    setDeliveryDate(ddmmyyyy) {
      if (!this.datePicker || !ddmmyyyy) return;
      const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(ddmmyyyy).trim());
      if (!m) return;
      const iso = m[3] + "-" + m[2] + "-" + m[1];
      /* Only within the seeded [today, today + 3mo] range (ISO compares
         chronologically); an original date now in the past keeps today. */
      const min = this.datePicker.dataset.minDate || "";
      const max = this.datePicker.dataset.maxDate || "";
      if (min && iso < min) return;
      if (max && iso > max) return;
      const control = this.datePicker.querySelector(".date-picker__control");
      const hidden = this.datePicker.querySelector("[data-dp-hidden]");
      const field = this.datePicker.querySelector(".form-field");
      this.datePicker.dataset.value = iso;
      if (control) control.value = m[1] + " / " + m[2] + " / " + m[3];
      if (hidden) hidden.value = iso;
      if (field) field.classList.add("form-field--completed");
    }

    exitEditMode() {
      this.editLineId = null;
      this.editVariantId = "";
      if (this.addLabelEl && this.addLabel) this.addLabelEl.textContent = this.addLabel;
    }

    /* Arrows disable at the strip's ends (carousel boundary attrs); both
       disable when everything fits on one page. */
    syncArrows() {
      if (!this.carousel) return;
      if (this.prevBtn) this.prevBtn.disabled = this.carousel.hasAttribute("data-at-start");
      if (this.nextBtn) this.nextBtn.disabled = this.carousel.hasAttribute("data-at-end");
    }

    /* Seed the composed x-date-picker before it upgrades (this ancestor
       connects first): value/min = today, max = today + 3 calendar months.
       Computed at runtime -- a Liquid 'now' would be CDN-cache-stale. `force`
       (drawer re-open) overwrites an existing value back to today. */
    seedDatePicker(force) {
      if (!this.datePicker) return;
      const today = new Date();
      const max = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());
      const iso = (d) =>
        d.getFullYear() +
        "-" +
        String(d.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(d.getDate()).padStart(2, "0");
      const display = (d) =>
        String(d.getDate()).padStart(2, "0") +
        " / " +
        String(d.getMonth() + 1).padStart(2, "0") +
        " / " +
        d.getFullYear();

      this.datePicker.dataset.minDate = iso(today);
      this.datePicker.dataset.maxDate = iso(max);
      this.datePicker.dataset.value = iso(today);

      const control = this.datePicker.querySelector(".date-picker__control");
      const hidden = this.datePicker.querySelector("[data-dp-hidden]");
      const field = this.datePicker.querySelector(".form-field");
      if (control && (force || !control.value)) control.value = display(today);
      if (hidden && (force || !hidden.value)) hidden.value = iso(today);
      if (field) field.classList.add("form-field--completed");
    }

    onThumbClick(event) {
      const btn = event.currentTarget;
      const design = btn.getAttribute("data-gc-design");
      if (!design || design === this.activeDesign) return;
      this.selectDesign(design);
    }

    selectDesign(design) {
      this.activeDesign = design;

      this.querySelectorAll("[data-gc-design]").forEach((btn) => {
        btn.setAttribute(
          "aria-pressed",
          btn.getAttribute("data-gc-design") === design ? "true" : "false",
        );
      });
      this.querySelectorAll("[data-gc-image]").forEach((frame) => {
        frame.hidden = frame.getAttribute("data-gc-image") !== design;
      });
      this.querySelectorAll("[data-gc-chips]").forEach((group) => {
        group.hidden = group.getAttribute("data-gc-chips") !== design;
      });
      if (this.itemRefInput) this.itemRefInput.value = design;

      /* Preserve the chosen denomination when the new design carries it
         (and its chip is orderable); otherwise clear the selection. */
      let carried = null;
      if (this.selectedAmountLabel) {
        const group = this.querySelector('[data-gc-chips="' + CSS.escape(design) + '"]');
        if (group) {
          const chip = group.querySelector(
            '[data-size-chip-label="' + CSS.escape(this.selectedAmountLabel) + '"]:not(:disabled)',
          );
          if (chip) carried = chip;
        }
      }
      if (carried) {
        this.applyChipSelection(carried);
      } else {
        this.clearAmount();
      }
      this.revealActiveThumb();
      this.emitChange();
    }

    /* Bring the now-active design thumb into view when it sits off the end of the
       strip. The carousel owns the scroll; a no-op in the drawer (no carousel)
       and when the thumb is already visible (a plain user tap). */
    revealActiveThumb() {
      if (!this.carousel || typeof this.carousel.scrollToChild !== "function") return;
      const active = this.querySelector('[data-gc-design][aria-pressed="true"]');
      if (active) this.carousel.scrollToChild(active);
    }

    onChipChange(event) {
      if (!event.detail || event.detail.name !== "gc-amount") return;
      const chip = event.target.closest('[data-size-chip-name="gc-amount"]');
      if (!chip || chip.closest("[data-gc-chips]").hidden) return;
      this.applyChipSelection(chip);
      this.emitChange();
    }

    applyChipSelection(chip) {
      const group = chip.closest("[data-gc-chips]");
      if (group) {
        group.querySelectorAll('[data-size-chip-name="gc-amount"]').forEach((c) => {
          const on = c === chip;
          c.setAttribute("aria-pressed", on ? "true" : "false");
          c.classList.toggle("size-chip--selected", on);
        });
      }
      this.selectedAmountLabel = chip.getAttribute("data-size-chip-label") || null;
      if (this.idInput) this.idInput.value = chip.getAttribute("data-size-chip-value") || "";
      this.syncAddState();
    }

    clearAmount() {
      this.selectedAmountLabel = null;
      if (this.idInput) this.idInput.value = "";
      this.querySelectorAll('[data-size-chip-name="gc-amount"]').forEach((c) => {
        c.setAttribute("aria-pressed", "false");
        c.classList.remove("size-chip--selected");
      });
      this.syncAddState();
    }

    /* The Add button stays enabled so a tap with no amount / empty required
       fields surfaces inline errors instead of a dead disabled control. This only
       clears the amount error once an amount is chosen; the OOS `all_unavailable`
       button is separate disabled markup with no [data-gc-add]. */
    syncAddState() {
      if (this.idInput && this.idInput.value && this.amountErrorEl) {
        this.amountErrorEl.hidden = true;
      }
    }

    emitChange() {
      this.dispatchEvent(
        new CustomEvent("giftcard:change", {
          bubbles: true,
          detail: {
            designValue: this.activeDesign,
            variantId: this.idInput && this.idInput.value ? Number(this.idInput.value) : null,
          },
        }),
      );
    }

    /* Char-guard [&"<>] on Your name / Recipient name / Message (never the
       email field) protects the Vii payload. */
    static get GUARDED() {
      return ["gc-your-name", "gc-recipient-name", "gc-message"];
    }

    onFocusOut(event) {
      const control = event.target;
      if (!control || !control.id) return;
      if (GiftCardForm.GUARDED.indexOf(control.id) === -1) return;
      /* Defer so the snippet's own blur validation settles first. */
      setTimeout(() => this.guardField(control.id), 0);
    }

    onInput(event) {
      if (this.errorEl && !this.errorEl.hidden) this.errorEl.hidden = true;
      const control = event.target;
      if (control && control.id && GiftCardForm.GUARDED.indexOf(control.id) !== -1) {
        const errEl = this.querySelector('[data-gc-guard="' + control.id + '"]');
        if (errEl && !errEl.hidden) this.guardField(control.id);
      }
    }

    guardField(id) {
      const control = this.querySelector("#" + CSS.escape(id));
      const errEl = this.querySelector('[data-gc-guard="' + id + '"]');
      if (!control) return true;
      const bad = /[&"<>]/.test(control.value);
      if (errEl) errEl.hidden = !bad;
      const field = control.closest(".form-field");
      if (bad) {
        if (field) field.classList.add("form-field--error");
        control.setAttribute("aria-invalid", "true");
        if (errEl && control.getAttribute("aria-describedby") !== errEl.id) {
          this.guardDescribedBy = this.guardDescribedBy || {};
          if (!(id in this.guardDescribedBy)) {
            this.guardDescribedBy[id] = control.getAttribute("aria-describedby") || "";
          }
          const base = this.guardDescribedBy[id];
          control.setAttribute("aria-describedby", (base + " " + errEl.id).trim());
        }
      } else {
        if (this.guardDescribedBy && id in this.guardDescribedBy) {
          const base = this.guardDescribedBy[id];
          if (base) control.setAttribute("aria-describedby", base);
          else control.removeAttribute("aria-describedby");
        }
        /* Clear the guard-owned error state, then hand back to the snippet's
           own live check (if armed) so it can re-assert its own error. The
           passive guarded fields (Your name, Message) have no live check --
           their validate() early-returns -- so host.validate() alone won't clear
           the guard error; clear it here or the field stays flagged and blocks
           add-to-cart. */
        if (field) field.classList.remove("form-field--error");
        control.removeAttribute("aria-invalid");
        const host = control.closest("x-input") || control.closest("x-textarea");
        if (host && typeof host.validate === "function") host.validate();
      }
      return !bad;
    }

    /* Amount is required but is a chip group with no field-level control, so it
       validates here: surface the inline error below the chips. Returns true when
       an amount variant id is set. */
    validateAmount() {
      const ok = !!(this.idInput && this.idInput.value);
      if (this.amountErrorEl) this.amountErrorEl.hidden = ok;
      return ok;
    }

    /* Run the personalisation-field checks and return whether they all pass.
       Focus/scroll is owned by onSubmit so the amount error (higher in the form)
       can take precedence over the first invalid field. */
    validateAll() {
      this.querySelectorAll("[data-gc-fields] x-input, [data-gc-fields] x-textarea").forEach(
        (el) => {
          if (typeof el.validate === "function") el.validate();
        },
      );
      GiftCardForm.GUARDED.forEach((id) => this.guardField(id));
      return !this.querySelector("[data-gc-fields] .form-field--error");
    }

    deliveryDateDDMMYYYY() {
      const hidden = this.datePicker ? this.datePicker.querySelector("[data-dp-hidden]") : null;
      let iso = hidden && hidden.value ? hidden.value : "";
      if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
        const t = new Date();
        iso =
          t.getFullYear() +
          "-" +
          String(t.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(t.getDate()).padStart(2, "0");
      }
      const parts = iso.split("-");
      return parts[2] + "/" + parts[1] + "/" + parts[0];
    }

    onSubmit(event) {
      event.preventDefault();
      if (this.addBtn && this.addBtn.getAttribute("aria-busy") === "true") return;

      /* The button is always enabled, so a tap validates the amount + every
         required field together and surfaces all errors at once. Anchor to the
         highest error: the amount selector sits above the fields, so a missing
         denomination scrolls the form/drawer to the top; otherwise focus the
         first invalid field. */
      const amountOk = this.validateAmount();
      const fieldsOk = this.validateAll();
      if (!amountOk || !fieldsOk) {
        if (!amountOk) {
          const anchor = this.amountsEl || this.amountErrorEl;
          if (anchor && typeof anchor.scrollIntoView === "function") {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        } else {
          const firstError = this.querySelector("[data-gc-fields] .form-field--error");
          const control =
            firstError && firstError.querySelector('input:not([type="hidden"]), textarea');
          if (control) control.focus();
        }
        return;
      }

      if (this.errorEl) this.errorEl.hidden = true;
      this.setAddBusy(true);

      const body = new FormData(this.form);
      /* The date-picker's native field posts ISO under a non-contract name --
         strip it and send the Vii DD/MM/YYYY key instead. */
      body.delete("gc-delivery");
      body.set("properties[_gift_recipient_delivery_date]", this.deliveryDateDDMMYYYY());
      body.set("properties[_timestamp]", String(Date.now()));
      ["properties[_gift_sender_name]", "properties[_gift_recipient_message]"].forEach((key) => {
        const v = body.get(key);
        if (v === null || String(v).trim() === "") body.delete(key);
      });

      /* Editing an existing cart line is a cart WRITE, not an add: it goes to the
         cart runtime, which owns the row-to-live-keys resolution and the re-render.
         Taken before the render-then-show bundling below, whose prepare event the
         runtime pairs with a cart:added an edit never dispatches. */
      if (this.editLineId) {
        this.submitEdit(body);
        return;
      }

      /* Render-then-show: bundle cart drawer sections into the add call so the
         new line paints in one round-trip. This prepare pairs with the cart:added
         dispatched below, keeping the runtime's in-flight counter balanced. */
      const sectionIds = new Set();
      document.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", { detail: { sections: sectionIds } }),
      );
      const sectionsCsv = sectionIds.size ? Array.from(sectionIds).join(",") : "";
      const sectionsUrl = this.routeRoot() + "cart";

      if (sectionsCsv) {
        body.append("sections", sectionsCsv);
        body.append("sections_url", sectionsUrl);
      }

      /* POST the documented AJAX endpoint, not the form's bare /cart/add action:
         third-party SDKs (Braze et al.) intercept cart mutations by matching the
         `.js` URLs. Same backend handler; response shape is unchanged. */
      fetch(this.routeRoot() + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: body,
      })
        /* Read the body as text first, then try JSON: a throttled cart endpoint can
           reply 429 with a non-JSON body (an edge challenge page), which a bare
           r.json() throws on -- collapsing every failure into the generic catch. */
        .then((r) =>
          r.text().then((text) => {
            let data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch (err) {
              data = null;
            }
            return { ok: r.ok, status: r.status, data: data };
          }),
        )
        .then((res) => {
          this.setAddBusy(false);
          if (res.ok) {
            document.dispatchEvent(
              new CustomEvent("cart:added", { bubbles: true, detail: { item: res.data } }),
            );
            return;
          }
          this.showError(this.messageForFailure(res));
          this.reportAddFailure(res);
        })
        .catch((err) => {
          this.setAddBusy(false);
          this.showError(this.addErrorLabel);
          this.reportAddFailure({ status: 0, error: String(err) });
        });
    }

    /* A 429 is a transient rate-limit, not a dead end, so it gets its own
       "try again shortly" copy; a Shopify item error keeps its own description
       (sold out, etc.); everything else falls back to the generic label. */
    messageForFailure(res) {
      if (res.status === 429) return this.throttleErrorLabel;
      if (res.data && res.data.description) return res.data.description;
      return this.addErrorLabel;
    }

    /* Breadcrumb so an intermittent add failure is identifiable in the field
       (status + body) instead of recurring as a silent generic error. */
    reportAddFailure(res) {
      if (window.console && console.warn)
        console.warn("[gc-add] failed", res.status, res.data || "");
      document.dispatchEvent(
        new CustomEvent("cart:add-error", {
          bubbles: true,
          detail: { source: "gift-card", status: res.status },
        }),
      );
    }

    /* Hand the edit to the cart runtime as ONE intent and close the drawer. The
       runtime resolves the row to its live line keys against server truth and
       writes: a personalisation-only edit keeps the variant, so it is a single
       change.js that replaces the line's properties in place -- no add and no
       removal, so the card cannot be duplicated. Its own busy / error UI on the
       cart surface reports the outcome; a failed write leaves the original line
       exactly as it was, ready for another pass at the pencil. */
    submitEdit(body) {
      const properties = {};
      body.forEach((value, key) => {
        const match = /^properties\[(.+)\]$/.exec(key);
        if (match) properties[match[1]] = String(value);
      });
      const detail = {
        lineId: this.editLineId,
        variantId: this.idInput ? this.idInput.value : "",
        properties: properties,
      };
      this.setAddBusy(false);
      /* Closing dispatches overlay:close, which exits edit mode and restores the
         cart drawer when the pencil was clicked there. */
      const host = this.closest("x-overlay");
      if (host && typeof host.close === "function") host.close();
      document.dispatchEvent(new CustomEvent("cart:request-edit-line", { detail: detail }));
    }

    setAddBusy(on) {
      if (!this.addBtn) return;
      if (on) {
        this.addBtn.setAttribute("aria-busy", "true");
        this.addBtn.setAttribute("aria-disabled", "true");
      } else {
        this.addBtn.removeAttribute("aria-busy");
        this.addBtn.removeAttribute("aria-disabled");
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }
  }

  if (!customElements.get("gift-card-form")) {
    customElements.define("gift-card-form", GiftCardForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    class SeedHeaderSearch extends HTMLElement {
    connectedCallback() {
      this.field = this.querySelector(".header-search-input");
      this.control = this.querySelector("[data-search-control]");
      this.clearBtn = this.querySelector("[data-search-clear]");
      this.closeBtn = this.querySelector("[data-search-close]");
      this.header = this.closest(".header");
      this.trigger = document.querySelector(
        '[data-search-trigger][aria-controls="' + this.id + '"]',
      );

      this.onTrigger = this.onTrigger.bind(this);
      this.onClear = this.onClear.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onInput = this.onInput.bind(this);

      if (this.trigger) this.trigger.addEventListener("click", this.onTrigger);
      if (this.clearBtn) this.clearBtn.addEventListener("click", this.onClear);
      if (this.closeBtn) this.closeBtn.addEventListener("click", this.onClose);
      if (this.control) {
        this.control.addEventListener("keydown", this.onKeydown);
        this.addEventListener("input", this.onInput);
        this.syncFilled();
      }
    }

    /* Desktop/Wide: the trigger is laid out and the field expands in-row.
       Tablet/Mobile: the trigger is hidden (no offsetParent) and the field is a
       persistent bar -- there is nothing to collapse to. */
    get canCollapse() {
      return !!(this.trigger && this.trigger.offsetParent !== null);
    }

    get expanded() {
      return this.header ? this.header.hasAttribute("data-search-expanded") : false;
    }

    get prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    /* Duration of the field's collapse transition, read from the host's
       computed transition-duration so the closing-state cleanup stays in lockstep
       with the CSS --transition-base (no hard-coded ms in JS). */
    transitionMs() {
      var raw = getComputedStyle(this).transitionDuration || "";
      var first = raw.split(",")[0].trim();
      if (first.slice(-2) === "ms") return parseFloat(first) || 300;
      if (first.slice(-1) === "s") return (parseFloat(first) || 0.3) * 1000;
      return 300;
    }

    expand() {
      if (!this.header) return;
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.header.removeAttribute("data-search-closing");
      this.header.setAttribute("data-search-expanded", "");
      if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
      if (this.control) this.control.focus();
      /* Outside-dismiss runs on `click`, NEVER on pointerdown -- do not revert.
         Collapsing on press re-flows the header mid-gesture, and a touch device
         resolves the tap's click by hit-testing at touchend, so the tap either
         activated the wrong control or was cancelled. Bubble phase (not capture)
         so the predictive panel's own stopPropagation still shields a suggestion
         click from collapsing the field underneath it. */
      document.addEventListener("click", this.onDocClick);
    }

    collapse(restoreFocus) {
      if (!this.header) return;
      var wasExpanded = this.expanded;
      this.header.removeAttribute("data-search-expanded");
      if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("click", this.onDocClick);
      /* Announce the collapse so any predictive panel attached to this host
         dismisses in lockstep. The close button, Escape, and outside click all
         route through here, so a dropdown never stays open above a collapsed
         field. */
      this.dispatchEvent(new CustomEvent("header-search:collapse", { bubbles: true }));
      /* Reverse morph: hold the trigger out of flow and fade it back in over the
         transition while the field shrinks, so it never flashes instantly over
         the still-collapsing field. Skipped under reduced motion (instant) and
         on the persistent Tablet/Mobile bar (nothing to collapse to). */
      if (wasExpanded && this.canCollapse && !this.prefersReducedMotion) {
        this.header.setAttribute("data-search-closing", "");
        if (this.closeTimer) clearTimeout(this.closeTimer);
        var self = this;
        this.closeTimer = setTimeout(function () {
          if (self.header) self.header.removeAttribute("data-search-closing");
          self.closeTimer = null;
        }, this.transitionMs());
      }
      if (restoreFocus && this.trigger) this.trigger.focus();
    }

    onTrigger() {
      if (this.expanded) {
        this.collapse(true);
      } else {
        this.expand();
      }
    }

    onClear() {
      if (!this.control) return;
      this.control.value = "";
      /* Fire input so the filled state and predictive results reset together.
         Clear keeps the field open; the close button dismisses the dropdown. */
      this.control.dispatchEvent(new Event("input", { bubbles: true }));
      /* preventScroll matches the predictive panel's mousedown handler: without
         it iOS Safari scrolls the page upward on focus, which jumps the page
         under the scroll lock when Clear reopens a closed panel. */
      this.control.focus({ preventScroll: true });
    }

    onClose() {
      /* The close (x) dismisses the search interface. On Desktop/Wide (the
         expanding field, a trigger present -> canCollapse true) it collapses the
         field back to the trigger. On the persistent Tablet/Mobile bar (no
         trigger -> canCollapse false) there is nothing to collapse to, so it
         closes the predictive takeover via the header-search:collapse event the
         panel listens for and blurs the field so the soft keyboard retracts. */
      this.collapse(true);
      if (!this.canCollapse && this.control) this.control.blur();
    }

    onKeydown(event) {
      if (event.key === "Escape" && this.canCollapse && this.expanded) {
        event.preventDefault();
        this.collapse(true);
      }
    }

    onDocClick(event) {
      if (!this.expanded) return;
      if (this.contains(event.target)) return;
      if (this.trigger && this.trigger.contains(event.target)) return;
      this.collapse(false);
    }

    onInput() {
      this.syncFilled();
    }

    syncFilled() {
      if (!this.control || !this.field) return;
      this.field.toggleAttribute("data-filled", this.control.value.trim() !== "");
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onDocClick);
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    }
  }

  if (!customElements.get("x-header-search")) {
    customElements.define("x-header-search", SeedHeaderSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hotspot"] && !Shopify.designMode) return;
  try {
    (function () {
    var OPEN_CLASS = "hotspot--active";

    function isStatic(root) {
      // Static demo hotspots opt out of interaction.
      return root.closest("[data-hotspot-static]") !== null;
    }

    function close(root) {
      root.classList.remove(OPEN_CLASS);
      var trigger = root.querySelector("[data-hotspot-trigger]");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    }

    function closeAll(except) {
      var open = document.querySelectorAll("." + OPEN_CLASS);
      for (var i = 0; i < open.length; i++) {
        if (open[i] !== except && !isStatic(open[i])) {
          close(open[i]);
        }
      }
    }

    function open(root) {
      closeAll(root);
      root.classList.add(OPEN_CLASS);
      var trigger = root.querySelector("[data-hotspot-trigger]");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "true");
      }
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-hotspot-trigger]");

      if (trigger) {
        var root = trigger.closest("[data-hotspot]");
        if (!root || isStatic(root)) {
          return;
        }
        event.stopPropagation();
        if (root.classList.contains(OPEN_CLASS)) {
          close(root);
        } else {
          open(root);
        }
        return;
      }

      // Click inside an open label must not close it; any other click does.
      if (event.target.closest("[data-hotspot-content]")) {
        return;
      }
      closeAll(null);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") {
        return;
      }
      var open = document.querySelectorAll("." + OPEN_CLASS);
      for (var i = 0; i < open.length; i++) {
        if (isStatic(open[i])) {
          continue;
        }
        var trigger = open[i].querySelector("[data-hotspot-trigger]");
        close(open[i]);
        if (trigger) {
          trigger.focus();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-search"] && !Shopify.designMode) return;
  try {
    class SeedInputSearch extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector(".input__control");
      this.field = this.querySelector(".form-field");
      this.clearBtn = this.querySelector("[data-input-trailing-link]");

      // The Clear link is a search-clear affordance regardless of its label.
      if (this.clearBtn) this.clearBtn.setAttribute("aria-label", "Clear search");

      // Frozen gallery specimens keep their forced state -- skip all wiring.
      if (this.hasAttribute("data-search-static")) return;

      this.submitBtn = this.querySelector(".input-search__submit");
      this.dispatchMode = this.hasAttribute("data-search-dispatch");

      if (this.clearBtn) {
        this.onClear = this.onClear.bind(this);
        this.clearBtn.addEventListener("click", this.onClear);
      }

      if (this.control) {
        this.onInput = this.onInput.bind(this);
        this.control.addEventListener("input", this.onInput);
        this.syncClear();
      }

      if (this.dispatchMode) {
        this.onSubmit = this.onSubmit.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        if (this.submitBtn) this.submitBtn.addEventListener("click", this.onSubmit);
        if (this.control) this.control.addEventListener("keydown", this.onKeydown);
      }
    }

    syncClear() {
      if (!this.control) return;
      // A disabled field is fully inert -- Clear never shows.
      const hasValue = !this.control.disabled && this.control.value.trim() !== "";
      this.classList.toggle("input-search--clear-visible", hasValue);
    }

    onInput() {
      this.syncClear();
    }

    onClear() {
      if (!this.control) return;
      this.control.value = "";
      if (this.field) this.field.classList.remove("form-field--completed");
      this.classList.remove("input-search--clear-visible");
      // Let <x-input> resync (counter etc.) then return focus to the control.
      this.control.dispatchEvent(new Event("input", { bubbles: true }));
      this.control.focus();
    }

    onKeydown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        this.onSubmit();
      }
    }

    onSubmit() {
      if (!this.dispatchMode) return;
      const query = this.control ? this.control.value : "";
      this.dispatchEvent(
        new CustomEvent("search:submit", {
          bubbles: true,
          detail: { query: query },
        }),
      );
    }
  }

  if (!customElements.get("x-input-search")) {
    customElements.define("x-input-search", SeedInputSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input"] && !Shopify.designMode) return;
  try {
    class SeedInput extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector(".input__control");
      if (!this.control) return;
      this.field = this.closest(".form-field");
      this.shell = this.closest(".form-field__shell");

      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onShellDown = this.onShellDown.bind(this);

      this.control.addEventListener("focus", this.onFocus);
      this.control.addEventListener("blur", this.onBlur);
      this.control.addEventListener("input", this.onInput);
      if (this.shell) this.shell.addEventListener("mousedown", this.onShellDown);

      this.counter = this.field ? this.field.querySelector("[data-form-field-counter]") : null;
      this.maxLength = this.control.getAttribute("maxlength");

      // tel fields accept ONLY digits + phone-format chars (+ space - ( )); any
      // other character is stripped live in onInput (typing and paste both fire
      // `input`). Mirrors what the <x-form> AU/NZ validator tolerates.
      this.isTel = this.control.getAttribute("type") === "tel";

      this.toggle = this.querySelector("[data-password-toggle]");
      if (this.toggle) {
        this.onToggle = this.onToggle.bind(this);
        this.toggle.addEventListener("click", this.onToggle);
      }

      this.clearBtn = this.querySelector("[data-input-clear]");
      if (this.clearBtn) {
        this.onClear = this.onClear.bind(this);
        this.clearBtn.addEventListener("click", this.onClear);
      }

      this.emailError = this.control.getAttribute("data-email-error");
      this.requiredError = this.control.getAttribute("data-required-error");
      this.minLength = this.control.getAttribute("data-min-length");
      this.minLengthWarning = this.control.getAttribute("data-min-length-warning");
      this.phoneError = this.control.getAttribute("data-phone-error");
      this.phoneRegion = this.control.getAttribute("data-phone-region") || "au";

      // The message slot starts as the helper text (or empty for reserved
      // slots); live checks swap to their own message on failure and restore
      // this default when the field becomes valid again.
      const msgEl = this.field ? this.field.querySelector(".form-field__message") : null;
      this.defaultMessage = msgEl ? msgEl.textContent.trim() : "";

      // Re-sync the counter from the live value (mirrors x-textarea): browser
      // autofill can land before the element connects, leaving the
      // server-rendered count stale.
      this.updateCounter();

      // A phone / country prefix is an <x-dropdown> picker. Reflect its
      // selection into the visible flag + dial code; the dropdown owns the hidden
      // input + open/close/keyboard itself. The listener is attached to this host
      // (the dropdown:change event bubbles up from the nested prefix dropdown) and
      // re-queries live, so it is immune to custom-element upgrade ordering.
      this.onPrefixChange = this.onPrefixChange.bind(this);
      this.addEventListener("dropdown:change", this.onPrefixChange);

      this.setState("completed", !!this.control.value);

      // Browser form restoration (back-navigation after a submit) repopulates
      // the value AFTER connect without firing `input`, leaving the floating
      // label sitting over the restored text AND the character counter stale --
      // re-sync both once the page shows (mirrors x-textarea's onPageShow).
      this.onPageShow = () => {
        this.setState("completed", !!this.control.value);
        this.updateCounter();
      };
      window.addEventListener("pageshow", this.onPageShow);
    }

    disconnectedCallback() {
      window.removeEventListener("pageshow", this.onPageShow);
    }

    setState(name, on) {
      if (this.field) this.field.classList.toggle("form-field--" + name, on);
    }

    onPrefixChange(event) {
      const prefix = event.target.closest ? event.target.closest(".dropdown--prefix") : null;
      if (!prefix || !this.contains(prefix)) return;
      const sel = prefix.querySelector('[role="option"][aria-selected="true"]');
      if (!sel) return;
      const optionFlag = sel.querySelector(".flag");
      const prefixFlag = prefix.querySelector("[data-prefix-flag] .flag");
      const prefixDial = prefix.querySelector("[data-prefix-dial]");
      if (optionFlag && prefixFlag) {
        prefixFlag.src = optionFlag.src;
        prefixFlag.alt = optionFlag.alt;
      }
      if (prefixDial) prefixDial.textContent = sel.getAttribute("data-value") || "";
    }

    onFocus() {
      this.setState("focused", true);
    }

    onBlur() {
      this.setState("focused", false);
      this.setState("completed", !!this.control.value);
      this.validate();
    }

    onShellDown(event) {
      if (event.target.closest(".input__control, .input__trailing, .input__prefix")) return;
      event.preventDefault();
      this.control.focus();
    }

    onInput() {
      if (this.isTel) this.sanitizeTel();
      this.updateCounter();
      // Edits dismiss caller-set external errors; live checks own state again.
      this.externalError = "";
      if (this.field && this.field.classList.contains("form-field--error")) this.validate();
      if (this.field && this.field.classList.contains("form-field--warning")) this.validate();
    }

    // External (server/API) error: a caller-set sticky error state that survives
    // live blur re-validation. validate() only knows format rules, so a
    // format-valid value must not clear a server-declared error. Cleared when
    // the shopper edits the value (onInput above).
    setExternalError(text) {
      this.externalError = text || "";
      if (!this.externalError) return;
      this.setState("error", true);
      this.control.setAttribute("aria-invalid", "true");
      this.setMessage(this.externalError);
    }

    // Strip anything that isn't a digit or a phone-format char (+ space - ( )),
    // preserving the caret so mid-string edits and pastes don't jump to the end.
    sanitizeTel() {
      const value = this.control.value;
      const cleaned = value.replace(/[^0-9+\-() ]/g, "");
      if (cleaned === value) return;
      const start = this.control.selectionStart;
      const removedBeforeCaret =
        start == null ? 0 : (value.slice(0, start).match(/[^0-9+\-() ]/g) || []).length;
      this.control.value = cleaned;
      if (start != null) {
        const caret = start - removedBeforeCaret;
        this.control.setSelectionRange(caret, caret);
      }
    }

    updateCounter() {
      if (!this.counter || !this.maxLength) return;
      this.counter.textContent = this.control.value.length + "/" + this.maxLength + " characters";
    }

    onToggle() {
      const showing = this.control.getAttribute("type") === "text";
      const next = showing ? "password" : "text";
      this.control.setAttribute("type", next);
      this.toggle.setAttribute("aria-pressed", showing ? "false" : "true");
      const show = this.toggle.querySelector(".input__trailing-icon--show");
      const hide = this.toggle.querySelector(".input__trailing-icon--hide");
      if (show) show.hidden = !showing ? true : false;
      if (hide) hide.hidden = !showing ? false : true;
      this.control.focus();
    }

    onClear() {
      this.control.value = "";
      this.updateCounter();
      this.setState("completed", false);
      this.control.focus();
      this.control.dispatchEvent(new Event("input", { bubbles: true }));
    }

    setMessage(text) {
      if (!this.field) return;
      const msg = this.field.querySelector(".form-field__message");
      if (msg) msg.textContent = text;
    }

    // The AU/NZ mobile-number rule, shared with the `form` section: <x-form>
    // delegates here (block's x-input.isValidPhone) instead of re-implementing
    // the regex, so the rule lives in one place. Strips spaces/hyphens/parens
    // first (mirrors sanitizeTel's tolerated set); empty is treated valid --
    // emptiness is the required check's job, not the format check's.
    isValidPhone(value, region) {
      const cleaned = String(value == null ? "" : value).replace(/[\s()\-]/g, "");
      if (cleaned === "") return true;
      // Country code AND trunk 0 are both optional: with a +61/+64 prefix picker
      // the national number (e.g. 411852213) is the correct entry, so demanding a
      // leading 0 there is wrong; a plain field's 0411…/+61… still validates.
      const re =
        (region || "au") === "nz"
          ? /^(?:\+?64)?0?2\d{7,9}$/ // NZ mobile: 2x… / 02x… / +642x…
          : /^(?:\+?61)?0?4\d{8}$/; // AU mobile: 4……… / 04……… / +614………
      return re.test(cleaned);
    }

    // The email-format rule, shared like isValidPhone: consumers that need a
    // side-effect-free verdict (e.g. the reviews form's submit gate) delegate here
    // (x-input.isValidEmail) instead of re-implementing the regex, so the rule lives
    // in one place. Requires a dotted domain, so name@domain (no TLD) is rejected.
    // Empty is treated valid -- emptiness is the required check's job, not the
    // format check's.
    isValidEmail(value) {
      const v = String(value == null ? "" : value).trim();
      if (v === "") return true;
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    // Public validity verdict for an external orchestrator (e.g. a form that
    // wants a single boolean): runs the field's live checks and reports whether
    // it is currently error-free. A field with no armed check is always valid.
    checkValidity() {
      this.validate();
      return !(this.field && this.field.classList.contains("form-field--error"));
    }

    validate() {
      // A sticky external error (setExternalError) outranks the live checks:
      // re-assert it instead of letting a format-valid value clear it.
      if (this.externalError) {
        this.setState("error", true);
        this.control.setAttribute("aria-invalid", "true");
        this.setMessage(this.externalError);
        return;
      }

      // Only the opt-in live checks run here; a field with none stays passive
      // (its state/message are whatever form-field rendered).
      if (!this.requiredError && !this.emailError && !this.minLengthWarning && !this.phoneError)
        return;

      const value = this.control.value;
      const empty = value.trim() === "";
      let errorMsg = null;
      let warningMsg = null;

      // Error-type checks: required (empty) wins, then format (non-empty) --
      // email or phone, per whichever this field armed.
      if (this.requiredError && empty) {
        errorMsg = this.requiredError;
      } else if (this.emailError && !empty && !this.isValidEmail(value)) {
        errorMsg = this.emailError;
      } else if (this.phoneError && !empty && !this.isValidPhone(value, this.phoneRegion)) {
        errorMsg = this.phoneError;
      }

      // Warning-type check: min-length (only when not already erroring).
      if (!errorMsg && this.minLength && this.minLengthWarning) {
        if (!empty && value.length < parseInt(this.minLength, 10)) {
          warningMsg = this.minLengthWarning;
        }
      }

      if (this.requiredError || this.emailError || this.phoneError) {
        this.setState("error", !!errorMsg);
        this.control.setAttribute("aria-invalid", errorMsg ? "true" : "false");
      }
      if (this.minLengthWarning) {
        this.setState("warning", !!warningMsg);
      }

      // Error message > warning message > restore the default (helper / empty).
      this.setMessage(errorMsg || warningMsg || this.defaultMessage);
    }
  }

  if (!customElements.get("x-input")) {
    customElements.define("x-input", SeedInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["keyboard-focus-shim"] && !Shopify.designMode) return;
  try {
    (function () {
    "use strict";

    // Natively-focusable elements only. `a[href]` deliberately excludes the
    // href-less anchor that button.liquid emits for a disabled link variant --
    // that must stay unfocusable. [tabindex] is never overwritten, so roving-
    // focus widgets and the -1 sentinels focus traps rely on are untouched.
    var SEL = 'a[href],area[href],button,input:not([type="hidden"]),select,textarea,summary';
    var THROTTLE = 250;
    var last = 0;
    var timer = null;

    function tagRoot(root) {
      var els;
      try {
        els = root.querySelectorAll(SEL);
      } catch (e) {
        return;
      }
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.hasAttribute("tabindex")) continue;
        if (el.disabled) continue;
        el.setAttribute("tabindex", "0");
      }
      // Recurse into open shadow roots (Coveo Atomic renders its own controls
      // there). Closed roots are unreachable by design; the theme has none.
      var all;
      try {
        all = root.querySelectorAll("*");
      } catch (e) {
        return;
      }
      for (var j = 0; j < all.length; j++) {
        if (all[j].shadowRoot) tagRoot(all[j].shadowRoot);
      }
    }

    // While a PLP back-navigation restore is veiled, the grid is invisible and grows
    // by hundreds of shadow roots per chunk; walking the whole document on every
    // burst would tag cards nobody can focus yet, at a cost that scales with the
    // depth replayed. One pass when the restore hands back covers all of them.
    var awaitingRestore = false;
    function deferToRestore() {
      if (awaitingRestore) return;
      awaitingRestore = true;
      document.addEventListener(
        "coveo:plp-restore-done",
        function () {
          awaitingRestore = false;
          run();
        },
        { once: true },
      );
    }

    function run() {
      last = Date.now();
      timer = null;
      if (window.__coveoPlpRestore) {
        deferToRestore();
        return;
      }
      tagRoot(document);
    }

    // Leading-edge for an isolated mutation (drawer opens -> tagged at once),
    // trailing-edge throttle during a storm (Coveo re-rendering its card grid).
    function schedule() {
      if (timer) return;
      var since = Date.now() - last;
      if (since >= THROTTLE) run();
      else timer = setTimeout(run, THROTTLE - since);
    }

    run();

    try {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    } catch (e) {}

    // Catches shadow roots attached during late custom-element upgrades.
    window.addEventListener("load", schedule);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-panel"] && !Shopify.designMode) return;
  try {
    /* x-mega-menu -- desktop/tablet/wide mega-menu controller.
     A W3C disclosure: open on hover (debounced, fine pointers) or on the trigger's
     own activation (click / tap / Enter / Space), close on outside-click / Escape /
     pointer-leave; never focus-trapped, no page scrim. Focus alone does not open it.
     One panel opens at a time. A Tier-1 parent is a <button> disclosure that never
     navigates -- activation toggles its panel. Document-level singleton (mirrors
     overlay.liquid's __seedOverlayInit) so theme-editor section reloads never
     double-bind. */
  (function () {
    if (window.__seedMegaMenuInit) {
      return;
    }
    window.__seedMegaMenuInit = true;

    var HOVER = window.matchMedia("(hover: hover)");

    function handleOf(el) {
      return el.getAttribute("data-object-handle") || el.getAttribute("data-handle") || "";
    }

    // The header renders every mega-menu-tile block into an inert <template>
    // ([data-mega-tiles]); nothing in it lays out or fetches media until a
    // surface clones a tile into the live document, so read from its content.
    function storeTiles() {
      var store = document.querySelector("[data-mega-tiles]");
      if (!store) {
        return [];
      }
      return Array.prototype.slice.call(store.content.querySelectorAll("[data-target-handle]"));
    }

    // Guards a panel's tile mount so repeated opens never clone twice.
    function mountOnce(fn) {
      var done = false;
      return function () {
        if (!done) {
          done = true;
          fn();
        }
      };
    }

    customElements.define(
      "x-mega-menu",
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) {
            return;
          }
          this.bound = true;

          this.delay = parseInt(this.getAttribute("data-mega-menu-delay"), 10);
          if (isNaN(this.delay)) {
            this.delay = 150;
          }
          // Optional global lead-group pin (section.settings.lead_handle), matched in
          // setupTabs against each tabs panel's group handles; blank -> menu order.
          this.leadHandle = this.getAttribute("data-mega-lead-handle") || "";
          this.nav = this.querySelector(".header-nav");
          this.bar = this.closest(".header__bar") || document.querySelector(".header__bar");
          this.openTimer = null;
          this.closeTimer = null;
          this.openPanel = null;

          this.panels = Array.prototype.slice.call(this.querySelectorAll(".mega-menu"));
          this.setupPanels();
          this.bindEvents();
        }

        /* Per-panel: match the bound mega-menu-tile blocks (multi / tabs panels show
         them statically, side by side; the no-tier3 New Arrivals panel hands them
         to setupTileSwap for per-category swapping), derive the layout + the
         equal-slot grid track count, and queue the actual clone for first open. */
        setupPanels() {
          var store = storeTiles();
          var self = this;

          this.panels.forEach(function (panel) {
            // Sub-brand panels (Child / Baby 4-level) own a bespoke rail + per-segment
            // details + swapping tiles -- handled entirely by setupSubbrand. They skip
            // the flat single / multi / tabs derivation below.
            if (panel.querySelector(".mega-menu__subrail")) {
              panel.setAttribute("data-layout", "subbrand");
              self.setupSubbrand(panel, store);
              return;
            }

            var slot = panel.querySelector("[data-mega-tile-slot]");
            var groupCount = parseInt(panel.getAttribute("data-group-count"), 10) || 0;
            var noTier3 = panel.getAttribute("data-no-tier3") === "true";

            // Panel-handle tiles: match the PANEL (Tier-1) handle. On multi / tabs
            // panels these are the only tiles, shown statically. On the no-tier3 New
            // Arrivals panel they are the DEFAULT group, and setupTileSwap then also
            // clones each Tier-2 category's own tile(s) for the rail-hover swap.
            var handles = [handleOf(panel)];

            var panelTiles = slot
              ? store.filter(function (tile) {
                  var target = tile.getAttribute("data-target-handle");
                  return !!target && handles.indexOf(target) !== -1;
                })
              : [];
            var tileCount = panelTiles.length;

            if (tileCount > 0) {
              panel.classList.add("has-tile");
              slot.hidden = false;
            }

            // Layout is derived from the group count ALONE; a featured tile takes its
            // own equal slot and NEVER reduces the category cap (binding a tile must
            // not flip a flat item into tabs). Cap = 6 flat category columns; beyond
            // that, fall back to a lead-rail "tabs" panel.
            var cap = 6;
            var colCount = Math.min(groupCount, cap) || 1;
            var layout = "multi";
            if (groupCount <= 1 || noTier3) {
              layout = "single";
              colCount = 1;
            } else if (groupCount > cap) {
              layout = "tabs";
            }
            panel.setAttribute("data-layout", layout);
            panel.style.setProperty("--mega-col-count", colCount);
            panel.style.setProperty("--mega-tile-count", tileCount);

            // The clone itself waits for the panel's first open (open() calls
            // __mountTiles), so tile media only downloads once a shopper opens the
            // panel; the layout above needs only the match count. New Arrivals-style
            // per-category swap: a no-tier3 panel whose rail categories each carry
            // their own featured tile(s) also clones those + wires the rail-hover
            // swap there. Multi / tabs panels keep their fixed editorial tiles.
            if (slot) {
              panel.__mountTiles = mountOnce(function () {
                panelTiles.forEach(function (tile) {
                  slot.appendChild(tile.cloneNode(true));
                });
                if (noTier3) {
                  self.setupTileSwap(panel, slot, store);
                }
              });
            }

            if (layout === "tabs") {
              // Equal slots = rail + the detail span + the tile(s). The active
              // segment's links flow into `detailSpan` columns. NOTE: a Shopify
              // linklist is only 3 tiers, so a tabbed item maps rail=Tier-2 segments,
              // detail=that segment's Tier-3 links -- it cannot reproduce a 4th depth
              // of distinct category-headed sub-columns. This is the documented
              // best-effort within native Shopify navigation.
              var detailSpan = Math.min(4, Math.max(2, groupCount - 1));
              panel.style.setProperty("--mega-tabs-detail", detailSpan);
              panel.style.setProperty("--mega-slot-count", 1 + detailSpan + tileCount);
              self.setupTabs(panel);
            } else {
              panel.style.setProperty("--mega-slot-count", colCount + tileCount);
            }
          });
        }

        /* APG tablist keyboard for the tabs-layout rail, which uses a roving
         tabindex (only the active tab is Tab-focusable; activate() sets
         `tabIndex = on ? 0 : -1`). Without arrow keys the INACTIVE tabs are
         keyboard-unreachable -- a keyboard user could never switch groups, seeing
         only the first group's columns. This wires the standard vertical-tablist
         keys (the rail is aria-orientation="vertical"): Up/Down -- and Left/Right,
         harmless and forgiving -- move to the adjacent tab, Home/End jump to the
         ends, with focus following selection. The sub-brand rail needs none of
         this: its items are plain links, so Tab already reaches every one and
         focus swaps the detail. */
        bindRailKeys(rail, tabs, activate) {
          if (!rail || !tabs.length) {
            return;
          }
          rail.addEventListener("keydown", function (event) {
            var current = tabs.indexOf(document.activeElement);
            if (current === -1) {
              return;
            }
            var key = event.key;
            var next = -1;
            if (key === "ArrowDown" || key === "ArrowRight") {
              next = (current + 1) % tabs.length;
            } else if (key === "ArrowUp" || key === "ArrowLeft") {
              next = (current - 1 + tabs.length) % tabs.length;
            } else if (key === "Home") {
              next = 0;
            } else if (key === "End") {
              next = tabs.length - 1;
            } else {
              return;
            }
            event.preventDefault();
            activate(next);
            tabs[next].focus();
          });
        }

        setupTabs(panel) {
          var rail = panel.querySelector(".mega-menu__rail");
          var tabs = rail
            ? Array.prototype.slice.call(rail.querySelectorAll(".mega-menu__tab"))
            : [];
          var groups = Array.prototype.slice.call(panel.querySelectorAll(".mega-menu__group"));
          if (!tabs.length || !groups.length) {
            return;
          }

          // Lead/first-active group: the pinned lead handle (global), else menu order 0.
          var leadHandle = this.leadHandle;
          var lead = 0;
          if (leadHandle) {
            tabs.forEach(function (tab, i) {
              if (handleOf(tab) === leadHandle) {
                lead = i;
              }
            });
          }

          function activate(index) {
            tabs.forEach(function (tab, i) {
              var on = i === index;
              tab.setAttribute("aria-selected", on ? "true" : "false");
              tab.tabIndex = on ? 0 : -1;
            });
            groups.forEach(function (group, i) {
              group.classList.toggle("is-active", i === index);
            });
          }

          tabs.forEach(function (tab, i) {
            tab.addEventListener("mouseenter", function () {
              if (HOVER.matches) {
                activate(i);
              }
            });
            tab.addEventListener("focus", function () {
              activate(i);
            });
            tab.addEventListener("click", function () {
              activate(i);
            });
          });

          this.bindRailKeys(rail, tabs, activate);
          panel.__activateTab = activate;
          activate(lead);
        }

        /* New Arrivals-style tile swap (no-tier3 rail). Each Tier-2 rail category
         shows its own featured tile(s); opening the panel shows the FIRST
         category's tiles (and hovering it shows the same -- never a separate set).
         Tiles bind panel-scoped ("<panel>/<group>") or by bare group handle;
         panel-scoped wins. Cloning the per-category tiles HERE -- not in
         setupPanels -- keeps the multi / tabs panels' fixed-tile behaviour
         untouched. */
        setupTileSwap(panel, slot, store) {
          var DEFAULT = "__default";
          var groups = Array.prototype.slice.call(panel.querySelectorAll(".mega-menu__group"));

          // Tag the panel-handle tiles already in the slot as the default group.
          Array.prototype.slice.call(slot.children).forEach(function (tile) {
            if (!tile.getAttribute("data-tile-group")) {
              tile.setAttribute("data-tile-group", DEFAULT);
            }
          });

          // Clone each rail category's bound tiles, tagged by the category handle.
          // A tile may bind PANEL-SCOPED ("<panel>/<group>", e.g. new-arrivals/woman)
          // or by the bare group handle ("woman"). Panel-scoped tiles WIN, so the
          // New Arrivals > Woman tile(s) can differ from the top-level Woman panel's
          // tile (both would otherwise share the "woman" handle). When a category has
          // panel-scoped tiles the bare-handle ones are ignored for it.
          var panelHandle = handleOf(panel);
          if (store.length) {
            var storeTiles = store;
            groups.forEach(function (group) {
              var handle = handleOf(group);
              if (!handle) {
                return;
              }
              var scopedKey = panelHandle ? panelHandle + "/" + handle : null;
              var scoped = scopedKey
                ? storeTiles.filter(function (t) {
                    return t.getAttribute("data-target-handle") === scopedKey;
                  })
                : [];
              var matches = scoped.length
                ? scoped
                : storeTiles.filter(function (t) {
                    return t.getAttribute("data-target-handle") === handle;
                  });
              matches.forEach(function (tile) {
                var clone = tile.cloneNode(true);
                clone.setAttribute("data-tile-group", handle);
                slot.appendChild(clone);
              });
            });
          }

          var tiles = Array.prototype.slice.call(slot.querySelectorAll(".mega-tile"));
          if (!tiles.length) {
            return; // nothing bound anywhere on this panel -- leave it tile-less
          }
          // A no-tier3 panel that only gained tiles via per-category cloning still
          // needs the has-tile chrome (rail + divider + tile area) revealed.
          panel.classList.add("has-tile");
          slot.hidden = false;

          // Default group = the FIRST rail category that carries tile(s). Opening the
          // panel and hovering that first item both show the same images; the
          // panel-handle (__default) tiles are only a last resort if no category has
          // its own tile.
          var defaultGroup = null;
          for (var i = 0; i < groups.length; i++) {
            var h = handleOf(groups[i]);
            if (h && slot.querySelector('[data-tile-group="' + h + '"]')) {
              defaultGroup = h;
              break;
            }
          }
          if (!defaultGroup) {
            defaultGroup = DEFAULT;
          }
          panel.__defaultTileGroup = defaultGroup;

          function show(group) {
            var shown = 0;
            tiles.forEach(function (t) {
              var on = t.getAttribute("data-tile-group") === group;
              t.hidden = !on;
              if (on) {
                shown++;
              }
            });
            // A category with no tile of its own falls back to the default group so
            // the area is never blank.
            if (shown === 0 && group !== defaultGroup) {
              show(defaultGroup);
            }
          }

          function mark(activeGroup) {
            groups.forEach(function (group) {
              var heading = group.querySelector(".header-link");
              if (heading) {
                heading.classList.toggle(
                  "is-tile-current",
                  activeGroup != null && handleOf(group) === activeGroup,
                );
              }
            });
          }

          // Rail hover / focus swaps the tiles + marks the active category.
          groups.forEach(function (group) {
            var handle = handleOf(group);
            var heading = group.querySelector(".header-link");
            function activate() {
              show(handle);
              mark(handle);
            }
            group.addEventListener("mouseenter", function () {
              if (HOVER.matches) {
                activate();
              }
            });
            if (heading) {
              heading.addEventListener("focus", activate);
            }
          });

          // Reset to the default group (no active marker); open() calls this on
          // every open so the panel always starts from its default view.
          panel.__resetTiles = function () {
            show(defaultGroup);
            mark(null);
          };
          panel.__resetTiles();
        }

        /* Sub-brand rail. The rail tabs switch which segment's detail (its
         companion-menu categories + featured tile) is shown, matching Child / Baby
         panels where hovering Girl / Boy swaps the columns and image. Each segment's
         tile(s) are cloned into that segment's own slot, so the tile rides with its
         detail. Tabs + details share one segment order, so the index aligns. */
        setupSubbrand(panel, store) {
          var tabs = Array.prototype.slice.call(panel.querySelectorAll(".mega-menu__subtab"));
          var details = Array.prototype.slice.call(panel.querySelectorAll(".mega-menu__detail"));
          if (!tabs.length || !details.length) {
            return;
          }

          // Segment tiles are cloned out of the inert store on the panel's first
          // open (open() calls __mountTiles), so their media downloads only then.
          panel.__mountTiles = mountOnce(function () {
            details.forEach(function (detail) {
              var slot = detail.querySelector("[data-mega-tile-slot]");
              var seg = detail.getAttribute("data-segment");
              if (!slot || !seg) {
                return;
              }
              var n = 0;
              store.forEach(function (tile) {
                if (tile.getAttribute("data-target-handle") === seg) {
                  slot.appendChild(tile.cloneNode(true));
                  n++;
                }
              });
              if (n > 0) {
                slot.hidden = false;
                detail.classList.add("has-tile");
              }
            });
          });

          function activate(index) {
            tabs.forEach(function (tab, i) {
              tab.classList.toggle("is-active", i === index);
            });
            details.forEach(function (detail, i) {
              var on = i === index;
              detail.hidden = !on;
              detail.classList.toggle("is-active", on);
            });
          }

          tabs.forEach(function (tab, i) {
            tab.addEventListener("mouseenter", function () {
              if (HOVER.matches) {
                activate(i);
              }
            });
            tab.addEventListener("focus", function () {
              activate(i);
            });
            // Rail items are links: a click follows them. Coarse pointers get no
            // hover, so there the first tap reveals the segment's detail and only a
            // second tap on the already-revealed segment navigates -- otherwise a
            // touch user at >=1250px could never see the sub-categories.
            tab.addEventListener("click", function (event) {
              if (!HOVER.matches && !tab.classList.contains("is-active")) {
                event.preventDefault();
                activate(i);
              }
            });
          });
          panel.__activateSub = activate;
          activate(0);
        }

        bindEvents() {
          var self = this;
          var items = Array.prototype.slice.call(this.querySelectorAll(".header-nav__item"));

          items.forEach(function (item) {
            var trigger = item.querySelector(".header-link--tier1");
            var panel = item.querySelector(".mega-menu");
            if (!trigger || !panel) {
              return; // a plain Tier-1 link with no panel
            }

            // Hover open (debounced) -- pointer devices only (touch fires no
            // pointerenter/leave while a finger is down, so a tapped panel would stick).
            item.addEventListener("pointerenter", function () {
              if (!HOVER.matches) {
                return;
              }
              self.cancelClose();
              self.openTimer = setTimeout(function () {
                self.open(panel, trigger);
              }, self.delay);
            });
            item.addEventListener("pointerleave", function () {
              if (!HOVER.matches) {
                return;
              }
              self.cancelOpen();
            });

            // A Tier-1 parent never navigates -- it is a pure disclosure. Focus alone
            // does NOT open it (a W3C disclosure toggles on activation, not on focus):
            // that keeps the button's aria-expanded honest and, crucially, stops a
            // focus-open from racing the click that a pointer press fires right after
            // it -- which would open the panel and let the same click read it as open
            // and close it, so a tap/click could never open it.
            trigger.addEventListener("click", function (event) {
              event.preventDefault();
              if (HOVER.matches && event.detail > 0) {
                // Fine-pointer click: hover already owns open (pointerenter) and close
                // (pointer-leave), so only ENSURE the panel is open. Toggling it shut
                // here would strand it -- the pointer stays over the trigger, so no
                // pointerenter refires to reopen it.
                self.open(panel, trigger);
              } else if (self.openPanel === panel) {
                // Coarse pointer, or keyboard Enter/Space (event.detail === 0): a real
                // toggle -- the only way these users open and close the panel.
                self.close();
              } else {
                self.open(panel, trigger);
              }
            });
          });

          // Close-on-leave (geometric). The host is display:contents (a 0x0 box), so
          // host-level pointerleave/enter never fire -- track the pointer GEOMETRICALLY:
          // while a panel is open the "safe zone" is the union of the header-bar box and
          // the open-panel box (contiguous -- the panel anchors to the bar's bottom edge --
          // so no gap to flicker through). Leaving it starts a debounced close; re-entering
          // cancels it. Lateral moves to the logo/search keep it open; moving into the page
          // closes. Bound on `document` (not the dead host) and removed in
          // disconnectedCallback so a section re-render never leaks a listener.
          this.onDocPointerMove = function (event) {
            if (!self.openPanel || !HOVER.matches) {
              return;
            }
            if (self.pointerInSafeZone(event.clientX, event.clientY)) {
              self.cancelClose();
            } else if (!self.closeTimer) {
              self.closeTimer = setTimeout(function () {
                self.close();
              }, 200);
            }
          };
          document.addEventListener("pointermove", this.onDocPointerMove);

          // Escape closes + returns focus to the trigger (mirrors overlay). Bound on
          // `document`, NOT the host: a hover-opened panel leaves focus outside the
          // host's subtree, so a host-bound keydown would never see Escape.
          this.onDocKeydown = function (event) {
            if (event.key === "Escape" && self.openPanel) {
              var trigger = self.openTrigger;
              var panel = self.openPanel;
              // Only RETURN focus if focus was actually inside the disclosure. APG
              // requires Escape to focus the trigger when focus is WITHIN it; this
              // panel is hover-openable, so a pointer user can Escape while
              // activeElement is still <body>. Focusing the trigger then paints
              // --shadow-focus on an element they never focused. A keyboard user's
              // focus is always on the trigger or inside the panel, so their path is
              // unchanged and the ring still shows whenever focus legitimately lands.
              // Focus no longer opens the panel, so returning focus cannot reopen it.
              var focusWasInside =
                (trigger && trigger.contains(document.activeElement)) ||
                (panel && panel.contains(document.activeElement));
              self.close();
              if (trigger && focusWasInside) {
                trigger.focus();
              }
            }
          };
          document.addEventListener("keydown", this.onDocKeydown);

          // Outside-click close. With no scrim, a click outside the header bar + open
          // panel closes the menu; clicks inside keep it open (the trigger's own click
          // handler owns navigate / open / toggle). Bound on document, removed in
          // disconnectedCallback.
          this.onDocClick = function (event) {
            if (!self.openPanel) {
              return;
            }
            if (self.bar && self.bar.contains(event.target)) {
              return;
            }
            if (self.openPanel.contains(event.target)) {
              return;
            }
            self.close();
          };
          document.addEventListener("click", this.onDocClick);

          // The predictive search panel takes the screen when it opens -- never leave
          // a mega panel live underneath it.
          this.onDocSearchOpen = function () {
            self.close();
          };
          document.addEventListener("search-panel:open", this.onDocSearchOpen);
        }

        cancelOpen() {
          if (this.openTimer) {
            clearTimeout(this.openTimer);
            this.openTimer = null;
          }
        }

        cancelClose() {
          if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
          }
        }

        /* The pointer is "in the menu" when it sits over the header bar OR the open
         panel. Their boxes are contiguous (the panel anchors to the bar's bottom
         edge), so the union has no gap to flicker through; testing geometry rather
         than DOM membership keeps the check robust against the display:contents host. */
        pointerInSafeZone(x, y) {
          var boxes = [];
          if (this.bar) {
            boxes.push(this.bar.getBoundingClientRect());
          }
          if (this.openPanel) {
            boxes.push(this.openPanel.getBoundingClientRect());
          }
          for (var i = 0; i < boxes.length; i++) {
            var r = boxes[i];
            if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
              return true;
            }
          }
          return false;
        }

        disconnectedCallback() {
          if (this.onDocPointerMove) {
            document.removeEventListener("pointermove", this.onDocPointerMove);
          }
          if (this.onDocKeydown) {
            document.removeEventListener("keydown", this.onDocKeydown);
          }
          if (this.onDocClick) {
            document.removeEventListener("click", this.onDocClick);
          }
          if (this.onDocSearchOpen) {
            document.removeEventListener("search-panel:open", this.onDocSearchOpen);
          }
          this.cancelOpen();
          this.cancelClose();
        }

        open(panel, trigger) {
          this.cancelOpen();
          this.cancelClose();
          if (this.openPanel === panel) {
            return;
          }
          if (this.openPanel) {
            this.hide(this.openPanel, this.openTrigger);
          }
          panel.hidden = false;
          panel.classList.add("is-open");
          // First open clones this panel's tiles out of the inert store.
          if (panel.__mountTiles) {
            panel.__mountTiles();
          }
          // New Arrivals-style panels start at their default tile group each open.
          if (panel.__resetTiles) {
            panel.__resetTiles();
          }
          // Sub-brand panels open on their first segment (Girl / Baby Girl).
          if (panel.__activateSub) {
            panel.__activateSub(0);
          }
          trigger.setAttribute("aria-expanded", "true");
          this.openPanel = panel;
          this.openTrigger = trigger;
          // The predictive search panel covers this one; tell it to stand down.
          document.dispatchEvent(new CustomEvent("mega-menu:open"));
        }

        hide(panel, trigger) {
          panel.hidden = true;
          panel.classList.remove("is-open");
          if (trigger) {
            trigger.setAttribute("aria-expanded", "false");
          }
        }

        close() {
          this.cancelOpen();
          this.cancelClose();
          if (!this.openPanel) {
            return;
          }
          this.hide(this.openPanel, this.openTrigger);
          this.openPanel = null;
          this.openTrigger = null;
        }
      },
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nav-drawer"] && !Shopify.designMode) return;
  try {
    /* <x-nav-drawer> -- the mobile/tablet drawer's intra-level controller.
     Owns ONLY: the L1<->L2 slide-push state machine, focus move on drill/back,
     reset to L1 when the overlay closes, and cloning the featured tiles bound to
     each panel into that panel's slot. It NEVER re-implements scroll-lock,
     focus-trap, single-overlay, scrim or close-on-Escape -- `overlay` (the
     <dialog>) owns all of that. Defined once (guarded) so theme-editor section
     reloads never double-bind. */
  (function () {
    if (window.__seedNavDrawerInit) {
      return;
    }
    window.__seedNavDrawerInit = true;

    function tokens(value) {
      return (value || "").split(/\s+/).filter(Boolean);
    }

    customElements.define(
      "x-nav-drawer",
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) {
            return;
          }
          this.bound = true;

          this.root = this.querySelector(".nav-drawer__panel--root");
          this.subs = Array.prototype.slice.call(this.querySelectorAll(".nav-drawer__panel--sub"));
          // The drill STACK: the chain of currently-open panels, root first. Drilling
          // pushes a panel on; Back pops one off. Generalising from a single active
          // sub to a stack is what lets the sub-brand panels reach a 3rd drill level
          // (root -> Child -> Girl) rather than dead-ending at Level 2.
          this.stack = [this.root];

          this.bindDrills();
          this.bindClose();
          this.bindHistory();
          this.bindStripForward();
        }

        /* The drawer parks BELOW the header, so that strip stays visible and
         undimmed -- but the drawer is a modal <dialog>, which makes every node
         outside it inert. A tap on the strip therefore retargets to <html> and is
         consumed by the overlay's outside-click dismiss: the control the shopper
         aimed at (search / cart / account / wishlist / logo) needs a SECOND tap.
         Re-hit-test the point once the dialog has left the top layer and forward
         the activation, so the strip answers the first tap.

         Capture phase + stopPropagation because this click is fully handled here:
         the overlay's dismiss must not then read a surface this forward just
         opened (the cart drawer) as an outside click and close it again. The
         forwarded click cannot re-enter -- the dialog is already closed by then.

         Everything runs synchronously inside the gesture: iOS Safari raises the
         keyboard only for a focus() called from a live user gesture, so deferring
         the forward would close the drawer and focus the field with the keyboard
         still down. */
        bindStripForward() {
          var self = this;
          this.onStripClick = function (event) {
            var dialog = self.closest("dialog.overlay");
            if (!dialog || !dialog.open) {
              return;
            }
            // A modal dialog retargets every outside click to the document root.
            if (event.target !== document.documentElement && event.target !== document.body) {
              return;
            }
            var rect = dialog.getBoundingClientRect();
            // Only the strip ABOVE the panel is left visible and undimmed. Anything
            // else an outside click can reach is scrim, where plain dismiss is the
            // whole intent -- so the >=769px scrim keeps its existing behaviour.
            if (event.clientY >= rect.top) {
              return;
            }

            event.stopPropagation();
            var x = event.clientX;
            var y = event.clientY;
            dialog.close();

            var hit = document.elementFromPoint(x, y);
            var control =
              hit &&
              hit.closest("a[href], button, input, select, textarea, summary, [role='button']");
            // Bare strip: the close above is the whole action. The hamburger is the
            // drawer's own X, so closing IS its activation -- forwarding the click
            // would immediately reopen the drawer.
            if (!control || control.matches('[data-overlay-trigger="nav-drawer"]')) {
              return;
            }

            if (control.matches("input, select, textarea")) {
              self.holdOpener();
              control.focus();
            } else {
              // A forwarded link navigates asynchronously, and the sentinel rewind
              // in onClose would cancel that pending navigation. Stand the sentinel
              // down instead: the navigation pushes over it, and the entry it
              // leaves behind carries the URL the shopper came from anyway.
              if (control.matches("a[href]")) {
                self.historyArmed = false;
              }
              control.click();
            }
          };
          document.addEventListener("click", this.onStripClick, true);
        }

        /* A dialog's `close` event is QUEUED, so the overlay returns focus to the
         opener one task after this gesture -- which would blur the field just
         focused and drop the keyboard again. Hold the opener unfocusable across
         that single task (inert has no default styling, and it is gone before the
         next paint); onClose restores it once the return has been and gone. */
        holdOpener() {
          this.held = Array.prototype.slice.call(
            document.querySelectorAll('[data-overlay-trigger="nav-drawer"]'),
          );
          this.held.forEach(function (trigger) {
            trigger.inert = true;
          });
        }

        /* Hardware / gesture back (Android back button, iOS edge-swipe): while the
         drawer is open the back action must step UP one drill level, then close
         the drawer -- never leave the page (the drawer is a modal surface, not a
         navigation). One sentinel history entry is pushed when the overlay opens;
         popping it steps back a level and re-arms, or (at the root) closes the
         drawer. Closing by any OTHER means (scrim / Escape / the close button)
         consumes the sentinel with history.back() so the NEXT back press behaves
         normally -- the guard flag keeps that programmatic pop from re-entering. */
        bindHistory() {
          var self = this;
          this.historyArmed = false;

          this.onOpen = function (event) {
            if (!event.detail || event.detail.id !== "nav-drawer") {
              return;
            }
            self.syncTop();
            if (!self.historyArmed) {
              history.pushState({ seedNavDrawer: true }, "");
              self.historyArmed = true;
            }
          };
          document.addEventListener("overlay:open", this.onOpen);

          this.onPopstate = function () {
            if (!self.historyArmed) {
              return;
            }
            var dialog = self.closest("dialog.overlay");
            if (!dialog || !dialog.open) {
              self.historyArmed = false;
              return;
            }
            if (self.stack.length > 1) {
              // The pop consumed the sentinel; step up one level and re-arm.
              self.back();
              history.pushState({ seedNavDrawer: true }, "");
            } else {
              // At the root: this back press closes the drawer. Disarm FIRST so
              // the overlay:close handler below doesn't also pop real history.
              self.historyArmed = false;
              dialog.close();
            }
          };
          window.addEventListener("popstate", this.onPopstate);
        }

        /* Park the drawer below the header: its measured bottom edge (a viewport
         y, so the announcement bar counts while the page is at the top) drives
         --nav-drawer-top. Published on <html>, not the dialog, so the panel
         rule and its ::backdrop both resolve it under either ::backdrop
         inheritance model. Runs inside the overlay:open dispatch -- same task
         as showModal(), so the drawer's first paint is already offset. */
        syncTop() {
          var header = document.querySelector(".header");
          var bottom = header ? header.getBoundingClientRect().bottom : 0;
          document.documentElement.style.setProperty(
            "--nav-drawer-top",
            Math.max(0, Math.round(bottom)) + "px",
          );
        }

        /* Clone every tile whose data-target-handle matches this panel into its
         slot: an exact panel handle, a panel-scoped "<panel>/..." prefix (New
         Arrivals), or one of the panel's child (Tier-2) handles. Mirrors the
         desktop binding without the per-category hover swap (mobile shows them
         statically at the foot of the panel). Runs once per panel, on its first
         drill: the store is an inert <template>, so tile media only downloads
         once a shopper actually reaches the panel. */
        populateTiles(panel) {
          if (panel.__tilesReady) {
            return;
          }
          panel.__tilesReady = true;

          var store = document.querySelector("[data-mega-tiles]");
          var slot = panel.querySelector("[data-nav-tiles]");
          if (!store || !slot) {
            return;
          }
          var storeTiles = Array.prototype.slice.call(
            store.content.querySelectorAll("[data-target-handle]"),
          );

          var panelHandles = tokens(panel.getAttribute("data-panel-handles"));
          var childHandles = tokens(panel.getAttribute("data-child-handles"));
          var seen = {};
          var added = 0;

          storeTiles.forEach(function (tile) {
            var target = tile.getAttribute("data-target-handle");
            if (!target) {
              return;
            }
            var match =
              panelHandles.indexOf(target) !== -1 ||
              childHandles.indexOf(target) !== -1 ||
              panelHandles.some(function (h) {
                return target.indexOf(h + "/") === 0;
              });
            if (!match) {
              return;
            }
            var key = target + "|" + (tile.getAttribute("href") || "") + "|" + added;
            if (seen[key]) {
              return;
            }
            seen[key] = true;
            slot.appendChild(tile.cloneNode(true));
            added++;
          });

          if (added > 0) {
            slot.hidden = false;
          }
        }

        bindDrills() {
          var self = this;
          Array.prototype.slice
            .call(this.querySelectorAll("[data-nav-drill]"))
            .forEach(function (trigger) {
              trigger.addEventListener("click", function () {
                var panel = document.getElementById(trigger.getAttribute("data-nav-drill"));
                if (panel) {
                  self.drill(panel, trigger);
                }
              });
            });
          Array.prototype.slice
            .call(this.querySelectorAll("[data-nav-back]"))
            .forEach(function (back) {
              back.addEventListener("click", function () {
                self.back();
              });
            });
        }

        bindClose() {
          var self = this;
          // Reset to L1 whenever the overlay closes, so the next open starts at the
          // top level. overlay dispatches overlay:close with the host id.
          this.onClose = function (event) {
            if (event.detail && event.detail.id === "nav-drawer") {
              self.reset();
              // This event is dispatched immediately BEFORE the overlay's
              // focus-return, so the microtask lands immediately after it -- the
              // one deterministic point at which the hold is spent.
              if (self.held) {
                var held = self.held;
                self.held = null;
                queueMicrotask(function () {
                  held.forEach(function (trigger) {
                    trigger.inert = false;
                  });
                });
              }
              // Closed via scrim / Escape / close button while the back sentinel
              // is still armed: consume it so the next back press navigates the
              // page as normal. (A back-button close disarms before closing, so
              // this never double-pops.)
              if (self.historyArmed) {
                self.historyArmed = false;
                // The entry we traverse back to recorded its scroll position while
                // the overlay scroll lock had the page pinned (i.e. 0), so the
                // browser's restore undoes the position the lock just gave back.
                // `history.scrollRestoration` is per-entry, so setting it on the
                // entry we are LEAVING cannot opt out -- re-assert in the task
                // after the traversal's instead.
                var restoreY = window.scrollY;
                history.back();
                setTimeout(function () {
                  if (window.scrollY !== restoreY) window.scrollTo(0, restoreY);
                }, 0);
              }
            }
          };
          document.addEventListener("overlay:close", this.onClose);
        }

        // Show / hide a panel WITHOUT touching display: only the transform (class)
        // moves it, while `inert` alone governs focus + AT. No display change means
        // drilling in is a pure transform transition (smooth), matching the back
        // direction. `inert` removes the parked subtree from the accessibility tree
        // AND makes it unfocusable, so a separate aria-hidden is redundant -- worse,
        // toggling aria-hidden on a panel that still holds focus (the moment before
        // focus is moved out) is BLOCKED by the browser with a console warning. So
        // inert is the single source of truth here (the WAI-ARIA-recommended path).

        // Make `panel` the visible top of the stack: not pushed, and (for a sub)
        // slid to centre. The root's resting transform is already centre, so it
        // only needs `is-pushed` cleared.
        show(panel) {
          panel.classList.remove("is-pushed");
          if (panel !== this.root) {
            panel.classList.add("is-active");
          }
          panel.inert = false;
        }

        // Park `panel` one level LEFT (a deeper panel has drilled in over it). It
        // stays in the tree, just translated off-screen and held out of focus/AT.
        pushLeft(panel) {
          panel.classList.remove("is-active");
          panel.classList.add("is-pushed");
          panel.inert = true;
        }

        // Park `panel` back at its resting off-screen-RIGHT position (popped on Back).
        parkRight(panel) {
          panel.classList.remove("is-active", "is-pushed");
          panel.inert = true;
        }

        drill(panel, trigger) {
          var current = this.stack[this.stack.length - 1];
          if (current === panel) {
            return;
          }
          this.pushLeft(current);
          this.populateTiles(panel);
          this.show(panel);
          if (trigger) {
            trigger.setAttribute("aria-expanded", "true");
          }
          // Remember which trigger opened this panel so Back can restore focus to it.
          panel.__trigger = trigger || null;
          this.stack.push(panel);

          // Move focus into the new panel (its Back control). preventScroll is
          // mandatory: the target is still parked off-screen as the slide starts,
          // so a default focus() would scroll-into-view the track and shift every
          // panel's coordinate system (see the viewport's overflow: clip note).
          var back = panel.querySelector("[data-nav-back]");
          if (back) {
            back.focus({ preventScroll: true });
          }
        }

        back() {
          if (this.stack.length <= 1) {
            return;
          }
          var top = this.stack.pop();
          var current = this.stack[this.stack.length - 1];
          var trigger = top.__trigger;
          // Bring the now-top panel back BEFORE moving focus to its trigger (the
          // trigger must be interactive again first), and move focus OUT of the
          // popped panel BEFORE parking it -- so `inert` never lands on the element
          // that still holds focus (which would blur-then-refocus and warn).
          this.show(current);
          if (trigger) {
            trigger.setAttribute("aria-expanded", "false");
            // preventScroll so returning up a level never nudges the track (see
            // the viewport overflow: clip note).
            trigger.focus({ preventScroll: true });
          }
          this.parkRight(top);
          top.__trigger = null;
        }

        reset() {
          var self = this;
          this.subs.forEach(function (panel) {
            self.parkRight(panel);
            panel.__trigger = null;
          });
          this.show(this.root);
          this.stack = [this.root];
          Array.prototype.slice
            .call(this.querySelectorAll("[data-nav-drill]"))
            .forEach(function (t) {
              t.setAttribute("aria-expanded", "false");
            });
          // Collapse any L2->L3 accordion left open, so each open starts fully
          // fresh at L1 (the "reset to top level" contract is incomplete if a
          // drilled-in accordion stays expanded into the next open). Compose the
          // accordion's own public close() -- the drawer is already hidden, so the
          // height animation is invisible and overlay's focus-return still wins.
          Array.prototype.slice
            .call(this.querySelectorAll("x-accordion.accordion--open"))
            .forEach(function (acc) {
              if (typeof acc.close === "function") {
                acc.close();
              }
            });
        }

        disconnectedCallback() {
          if (this.onClose) {
            document.removeEventListener("overlay:close", this.onClose);
          }
          if (this.onOpen) {
            document.removeEventListener("overlay:open", this.onOpen);
          }
          if (this.onPopstate) {
            window.removeEventListener("popstate", this.onPopstate);
          }
          if (this.onStripClick) {
            document.removeEventListener("click", this.onStripClick, true);
          }
        }
      },
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-form"] && !Shopify.designMode) return;
  try {
    class SeedNewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("form");
      this.field = this.querySelector(".form-field");
      this.input = this.querySelector(".input__control");
      this.buttons = this.querySelectorAll('button[type="submit"]');
      this.invalidMessage = this.getAttribute("data-error-invalid") || "";
      this.genericMessage = this.getAttribute("data-error-generic") || "";
      this.alreadyMessage = this.getAttribute("data-error-already") || "";
      this.proxyPath = this.getAttribute("data-proxy-path") || "/apps/cloud/newsletter";

      if (!this.form || !this.input) return;

      // Take over native validation so an invalid submit shows the field error
      // (not the browser bubble).
      this.form.setAttribute("novalidate", "");

      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener("submit", this.onSubmit);
    }

    isValidEmail(value) {
      var v = (value || "").trim();
      if (!v) return false;
      if (this.input.type === "email" && typeof this.input.checkValidity === "function") {
        if (!this.input.checkValidity()) return false;
      }
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    // Every submit posts to the newsletter Worker via the Shopify App Proxy
    // (same-origin, JSON, not captcha-gated) so the page never reloads. All
    // outcomes render inline; there is deliberately no native form fallback
    // (see the doc header).
    onSubmit(event) {
      event.preventDefault();
      if (this._submitting) return;

      if (!this.isValidEmail(this.input.value)) {
        this.showError(this.invalidMessage);
        return;
      }
      this._submitting = true;
      this.setSubmitting(true);

      var self = this;
      fetch(this.proxyPath, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ email: this.input.value.trim() }),
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              if (body && body.success === true) {
                self.showSuccess();
                return;
              }
              if (body && body.error === "already_subscribed") {
                self.failSubmit(self.alreadyMessage);
                return;
              }
              if (body && body.error === "invalid_email") {
                self.failSubmit(self.invalidMessage);
                return;
              }
              self.failSubmit(self.genericMessage);
            });
        })
        .catch(function () {
          self.failSubmit(self.genericMessage);
        });
    }

    showSuccess() {
      var inner = this.querySelector(".newsletter__inner");
      if (inner) inner.classList.add("newsletter__inner--success");
      // Publishes GA4 generate_lead: connecting the cloned analytics-event
      // (trigger 'load') fires its publish exactly once.
      var lead = this.querySelector("template[data-newsletter-lead]");
      if (lead) this.appendChild(lead.content.cloneNode(true));
      // Braze online_signup logs genuine new signups only; already_subscribed
      // routes through failSubmit and never reaches here. Degrades silently when
      // the wrapper is absent (Braze disabled).
      var braze = window.SeedBraze;
      if (braze) braze.safeLog("online_signup", { source: "footer" });
    }

    failSubmit(message) {
      this._submitting = false;
      this.setSubmitting(false);
      this.showError(message);
      this.input.focus();
    }

    // Errors go through the DS input's sticky external-error API so the
    // field's own blur re-validation (format rules only) can't wipe a
    // Worker-declared error like already_subscribed. Editing the value
    // dismisses it (x-input clears the sticky error on input).
    showError(text) {
      var xinput = this.querySelector("x-input");
      if (xinput && typeof xinput.setExternalError === "function") {
        xinput.setExternalError(text || this.genericMessage);
        return;
      }
      if (this.field) this.field.classList.add("form-field--error");
      this.input.setAttribute("aria-invalid", "true");
      var message = this.querySelector(".form-field__message");
      if (message && text) message.textContent = text;
    }

    setSubmitting(on) {
      this.buttons.forEach(function (btn) {
        btn.disabled = on;
        btn.setAttribute("aria-disabled", on ? "true" : "false");
      });
    }
  }

  if (!customElements.get("x-newsletter-form")) {
    customElements.define("x-newsletter-form", SeedNewsletterForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    // Guard: the behaviour is a document-level singleton, defined once even
    // though the snippet's JS is bundled once and may back many overlays.
    if (window.__seedOverlayInit) return;
    window.__seedOverlayInit = true;

    var lastFocused = null;
    var lockCount = 0;
    var savedScrollY = 0;

    // Counted so nested / queued surfaces (a drawer that hands off to a modal)
    // cannot release the lock early. Published on window as the theme's dialog
    // scroll lock: non-dialog surfaces that need it call it rather than forking
    // another `overflow: hidden` rule. (The predictive-search panel is the
    // exception -- it uses its own lockScroll, see coveo-predictive-search.liquid,
    // because the body-pin here un-sticks the sticky header it hangs off.)
    function lockScroll() {
      lockCount += 1;
      if (lockCount > 1) return;
      var root = document.documentElement;
      savedScrollY = window.scrollY || root.scrollTop || 0;
      var gutter = window.innerWidth - root.clientWidth;
      root.style.setProperty("--overlay-scrollbar-gutter", gutter > 0 ? gutter + "px" : "0px");
      root.style.setProperty("--overlay-scroll-y", "-" + savedScrollY + "px");
      root.classList.add("overlay-scroll-lock");
    }

    function unlockScroll() {
      if (lockCount === 0) return;
      lockCount -= 1;
      if (lockCount > 0) return;
      var root = document.documentElement;
      root.classList.remove("overlay-scroll-lock");
      root.style.removeProperty("--overlay-scrollbar-gutter");
      root.style.removeProperty("--overlay-scroll-y");
      // Un-pinning the body drops the document back to scrollY 0; put the
      // reader where they were, synchronously, so the release is invisible.
      window.scrollTo(0, savedScrollY);
    }

    window.SeedScrollLock = { lock: lockScroll, unlock: unlockScroll };
    // Open path for consumers that hold a <dialog> but not an upgraded
    // <x-overlay> -- going through here is what keeps the lock balanced.
    window.SeedOverlay = {
      open: function (dialog, options) {
        openDialog(dialog, options);
      },
      close: function (dialog, options) {
        closeDialog(dialog, options);
      },
    };

    function openDialog(dialog, options) {
      if (!dialog || dialog.open) return;
      var openDialogs = document.querySelectorAll("dialog.overlay[open]");
      var preserveCurrent = !!(options && options.preserveCurrent && openDialogs.length);
      if (!preserveCurrent) {
        Array.prototype.forEach.call(openDialogs, function (existing) {
          if (existing !== dialog) existing.close();
        });
      }

      if (!preserveCurrent) lastFocused = document.activeElement;
      dialog.removeAttribute("data-overlay-instant-close");
      dialog.showModal();
      lockScroll();

      // Initial focus on the dialog container, not the close control. The
      // dialog carries tabindex="-1" so showModal()'s own autofocus lands on
      // it (no focus ring on a non-button), keeping the X clear on pointer/touch
      // open while the close control stays the first Tab stop for keyboard users.
      dialog.focus();

      var host = dialog.closest("x-overlay");
      var openId = host ? host.dataset.overlayId : null;
      syncTriggers(openId, "true");
      document.dispatchEvent(new CustomEvent("overlay:open", { detail: { id: openId } }));
    }

    function closeDialog(dialog, options) {
      if (!dialog || !dialog.open) return;
      if (options && options.instant) dialog.setAttribute("data-overlay-instant-close", "");
      dialog.close();
    }

    // Every trigger carries its surface's open state, so AT announces it and
    // state-keyed CSS can react (the header hamburger swaps to an X). Done here
    // rather than per-consumer: a surface can also be closed by Escape, the
    // scrim, or the single-overlay rule, none of which the trigger sees.
    function syncTriggers(id, expanded) {
      if (!id) return;
      var triggers = document.querySelectorAll('[data-overlay-trigger="' + id + '"]');
      Array.prototype.forEach.call(triggers, function (trigger) {
        trigger.setAttribute("aria-expanded", expanded);
      });
    }

    // Delegated open + close-button handling (survives section reloads).
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-overlay-trigger]");
      if (trigger) {
        event.preventDefault();
        var id = trigger.getAttribute("data-overlay-trigger");
        var host = document.querySelector('x-overlay[data-overlay-id="' + id + '"]');
        openDialog(host ? host.querySelector("dialog.overlay") : null);
        return;
      }
      var closer = event.target.closest("[data-overlay-close]");
      if (closer) {
        var dialog = closer.closest("dialog.overlay");
        if (dialog) closeDialog(dialog);
      }
    });

    // Backdrop click: a click outside the panel's bounding rect closes it.
    // The target is NOT always the <dialog>: under a modal dialog everything
    // outside the top layer is inert, so a click on the scrim -- or on anything
    // it covers, e.g. the header strip the nav drawer leaves visible --
    // retargets to the document root. Accept both, then verify the point really
    // is outside the panel.
    document.addEventListener("click", function (event) {
      var target = event.target;
      var dialog = null;
      if (target.nodeName === "DIALOG" && target.classList.contains("overlay")) {
        dialog = target;
      } else if (target === document.documentElement || target === document.body) {
        var active = document.activeElement;
        dialog = active && active.closest ? active.closest("dialog.overlay[open]") : null;
        if (!dialog) dialog = document.querySelector("dialog.overlay[open]");
      }
      if (!dialog) return;
      var rect = dialog.getBoundingClientRect();
      var inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inside) closeDialog(dialog);
    });

    // Native close (Escape, .close(), backdrop) -> release lock, restore focus,
    // announce. `close` does not bubble, so listen in the capture phase.
    document.addEventListener(
      "close",
      function (event) {
        var dialog = event.target;
        if (dialog.nodeName !== "DIALOG" || !dialog.classList.contains("overlay")) return;
        unlockScroll();
        var host = dialog.closest("x-overlay");
        var closedId = host ? host.dataset.overlayId : null;
        syncTriggers(closedId, "false");
        document.dispatchEvent(new CustomEvent("overlay:close", { detail: { id: closedId } }));
        var remaining = document.querySelector("dialog.overlay[open]");
        if (remaining) {
          remaining.focus();
          return;
        }
        if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
        lastFocused = null;
      },
      true,
    );

    // Programmatic API for consumers (e.g. geo logic, timed triggers).
    if (!customElements.get("x-overlay")) {
      customElements.define(
        "x-overlay",
        class extends HTMLElement {
          get dialog() {
            return this.querySelector("dialog.overlay");
          }
          open(options) {
            openDialog(this.dialog, options);
          }
          close(options) {
            closeDialog(this.dialog, options);
          }
        },
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-bottomline"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedPdpBottomlineInit) return;
    window.__seedPdpBottomlineInit = true;

    customElements.define(
      "pdp-bottomline",
      class extends HTMLElement {
        connectedCallback() {
          if (this._hydrated) return;
          this._hydrated = true;
          this.fetchRating();
        }

        fetchRating() {
          var appkey = this.dataset.appkey;
          var productId = this.dataset.productId;
          if (!appkey || !productId) return;

          var url =
            "https://api-cdn.yotpo.com/v3/storefront/store/" +
            appkey +
            "/product/" +
            encodeURIComponent(productId) +
            "/ratings";

          fetch(url, { headers: { Accept: "application/json" } })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(
              function (data) {
                if (!data || !data.bottomline) return;
                this.hydrate(
                  Number(data.bottomline.averageScore) || 0,
                  Number(data.bottomline.totalReviews) || 0,
                );
              }.bind(this),
            )
            .catch(function () {
              /* leave the empty placeholder in place */
            });
        }

        hydrate(score, total) {
          var fill = this.querySelector("[data-bl-fill]");
          var count = this.querySelector("[data-bl-count]");
          var label = this.querySelector("[data-bl-label]");

          var pct = Math.max(0, Math.min(100, (score / 5) * 100));
          if (fill) fill.style.setProperty("--bl-fill", pct + "%");

          if (count) {
            count.textContent = "(" + total + ")";
          }

          if (label) {
            if (total > 0) {
              var tpl = this.dataset.ariaTemplate || "{score} out of 5, {count} reviews";
              label.textContent = tpl
                .replace("{score}", String(Math.round(score * 10) / 10))
                .replace("{count}", String(total));
            } else {
              label.textContent = this.dataset.noReviews || "";
            }
          }

          this.setAttribute("data-bl-state", total > 0 ? "rated" : "empty");
        }
      },
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-group"] && !Shopify.designMode) return;
  try {
    class XProductCardGroup extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll("[data-pcg-item]"));
      // A swatch in any member's row bubbles swatch:change { value: <sibling handle> };
      // show the matching member card, hide the rest. The "+N" chip is an <a> (no
      // swatch:change), so it navigates instead of swapping -- nothing to handle here.
      this._onSwatch = (e) => {
        const handle = e.detail && e.detail.value;
        if (!handle) return;
        const target = this.items.find((el) => el.dataset.pcgHandle === handle);
        if (!target) return;
        // The target card is already under the cursor (you hover the card to reach its
        // swatch row), so its hover-reveal controls -- carousel arrows + quick-add panel --
        // must SNAP in on a swap, not transition from opacity:0. Suppress their transition
        // for this frame only; a real hover in/out still animates (class dropped next frame).
        target.classList.add("product-card-group__item--no-anim");
        this.items.forEach((el) => {
          el.hidden = el !== target;
        });
        // Flush the no-transition state (forced reflow), then restore transitions next
        // frame so nothing animates as a side effect of the swap.
        void target.offsetWidth;
        requestAnimationFrame(() => {
          target.classList.remove("product-card-group__item--no-anim");
        });
      };
      this.addEventListener("swatch:change", this._onSwatch);
    }

    disconnectedCallback() {
      this.removeEventListener("swatch:change", this._onSwatch);
    }
  }

  if (!customElements.get("x-product-card-group")) {
    customElements.define("x-product-card-group", XProductCardGroup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class XProductCard extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector("x-carousel");
      this.prevBtn = this.querySelector("[data-pc-prev]");
      this.nextBtn = this.querySelector("[data-pc-next]");
      this.plusBtn = this.querySelector("[data-pc-quickadd]");

      this._onPrev = () => this._call("prev");
      this._onNext = () => this._call("next");
      if (this.prevBtn) this.prevBtn.addEventListener("click", this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener("click", this._onNext);

      // Disable the arrow that has nowhere to go at edge slides. x-carousel keeps
      // live data-at-start / data-at-end attrs (set before carousel:change), so
      // reflecting them onto buttons stays in sync through arrow nav and hover
      // swap. Initial sync + one rAF catches first measure; the change listener
      // covers subsequent crossings.
      if (this.carousel) {
        this._syncArrows = () => {
          if (this.prevBtn) this.prevBtn.disabled = this.carousel.hasAttribute("data-at-start");
          if (this.nextBtn) this.nextBtn.disabled = this.carousel.hasAttribute("data-at-end");
        };
        this._onCarouselChange = () => this._syncArrows();
        this.carousel.addEventListener("carousel:change", this._onCarouselChange);
        this._syncArrows();
        requestAnimationFrame(this._syncArrows);
      }

      // Desktop hover image-swap: reveal the 2nd slide on hover, return to the 1st
      // on hover-out (parity with the Coveo card). Uses x-carousel's public scrollToChild
      // (no-op when the target is already fully visible). INSTANT ({ instant: true }) --
      // only subsequent arrow nav animates. Bound to the media box (not the whole card)
      // so hovering the title/price/swatches below never swaps. Gated on pointer capability,
      // not width: touch browsers synthesize mouseenter on a tap, so a width-only
      // gate can swap the image under the finger and spend the tap on hover. Re-checked
      // per event so plugging in a mouse takes effect without a reload. mouseenter/
      // mouseleave don't bubble, so moving across overlay controls never fires a spurious swap.
      this.media = this.querySelector(".product-card__media");
      const slides = this.querySelectorAll(".carousel__slide");
      if (this.carousel && this.media && slides.length > 1) {
        this._firstSlide = slides[0];
        this._secondSlide = slides[1];
        this._isDesktopHover = () =>
          !window.matchMedia ||
          (window.matchMedia("(min-width: 769px)").matches &&
            window.matchMedia("(hover: hover)").matches);
        this._onHoverEnter = () => {
          if (this._isDesktopHover() && this.carousel.scrollToChild) {
            this.carousel.scrollToChild(this._secondSlide, { instant: true });
          }
        };
        this._onHoverLeave = () => {
          if (this._isDesktopHover() && this.carousel.scrollToChild) {
            this.carousel.scrollToChild(this._firstSlide, { instant: true });
          }
        };
        this.media.addEventListener("mouseenter", this._onHoverEnter);
        this.media.addEventListener("mouseleave", this._onHoverLeave);
      }

      // Mobile/tablet quick-add "+": open the shared quick-add drawer (the SAME flyout
      // the Coveo card uses) for size selection, instead of toggling an in-card strip.
      // Dispatch product-card:add with NO size -- the shared quick-add consumer resolves
      // a single-variant product to a direct add and opens the drawer for a multi-size
      // one (identical to the Coveo fall-through). Desktop hides the "+" and reveals the
      // hover size strip instead, so this only fires at and below the tablet tier.
      this._onPlus = () => {
        this.dispatchEvent(
          new CustomEvent("product-card:add", { bubbles: true, detail: { size: "" } }),
        );
      };
      if (this.plusBtn) this.plusBtn.addEventListener("click", this._onPlus);

      // Size buttons -> product-card:add (UI-only; cart wiring is the consumer's job).
      this._onClick = (e) => {
        const sizeBtn = e.target.closest("[data-pc-size]");
        if (sizeBtn && this.contains(sizeBtn)) {
          this.dispatchEvent(
            new CustomEvent("product-card:add", {
              bubbles: true,
              detail: { size: sizeBtn.dataset.pcSize || "" },
            }),
          );
        }
      };
      this.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener("click", this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener("click", this._onNext);
      if (this.plusBtn) this.plusBtn.removeEventListener("click", this._onPlus);
      if (this.media && this._onHoverEnter)
        this.media.removeEventListener("mouseenter", this._onHoverEnter);
      if (this.media && this._onHoverLeave)
        this.media.removeEventListener("mouseleave", this._onHoverLeave);
      if (this.carousel && this._onCarouselChange)
        this.carousel.removeEventListener("carousel:change", this._onCarouselChange);
      this.removeEventListener("click", this._onClick);
    }

    _call(method) {
      if (this.carousel && typeof this.carousel[method] === "function") {
        this.carousel[method]();
        return true;
      }
      return false;
    }
  }

  // Guarded define: this JS is force-bundled globally (component-js-registry, so
  // client-injected recently-viewed cards upgrade on every page) AND again wherever a
  // real card renders -- the guard stops the two on one page from re-defining.
  if (!customElements.get("x-product-card")) {
    customElements.define("x-product-card", XProductCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-coming-soon"] && !Shopify.designMode) return;
  try {
    class XComingSoonForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-coming-soon-submit]");
      this.formPanel = this.querySelector('[data-coming-soon-panel="form"]');
      this.successPanel = this.querySelector('[data-coming-soon-panel="success"]');
      this.emailInput = this.querySelector('input[type="email"]');
      this.consentInput = this.querySelector('input[name="marketing_consent"]');
      this.submitBtn = this.querySelector(".coming-soon-form__submit");
      this.loading = false;
      // Consent is locked on because the launch email requires opt-in. aria-disabled
      // keeps the control focusable/discoverable for keyboard + AT users; native
      // `disabled` would remove it from the Tab order, so toggling is blocked here.
      if (this.consentInput) {
        this.consentInput.addEventListener("click", function (e) {
          e.preventDefault();
        });
        this.consentInput.addEventListener("keydown", function (e) {
          if (e.key === " " || e.key === "Spacebar") e.preventDefault();
        });
      }
      if (!this.form) return;

      this._onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener("submit", this._onSubmit);

      // Reset only this instance's overlay; PDP and shared-card shells can coexist
      // on one page.
      this._onOpen = (event) => {
        var host = this.closest("x-overlay");
        if (event.detail && host && event.detail.id === host.dataset.overlayId) this.reset();
      };
      document.addEventListener("overlay:open", this._onOpen);
    }

    disconnectedCallback() {
      if (this.form && this._onSubmit) this.form.removeEventListener("submit", this._onSubmit);
      document.removeEventListener("overlay:open", this._onOpen);
    }

    reset() {
      this.setSubmitLoading(false);
      if (this.formPanel) this.formPanel.hidden = false;
      if (this.successPanel) this.successPanel.hidden = true;
    }

    onSubmit(event) {
      event.preventDefault();
      // Block re-entry while a request is in flight (double-submit guard).
      if (this.loading) return;
      var email = this.emailInput ? this.emailInput.value.trim() : "";
      if (!email || !this.emailInput.checkValidity()) {
        if (this.emailInput) this.emailInput.reportValidity();
        return;
      }

      var productId = this.dataset.productId || "";
      // Consent is always true because the launch email is a Braze marketing send;
      // an unsubscribed signup could never receive it. The checkbox renders
      // pre-ticked and read-only as the opt-in disclosure.
      var consent = true;

      this.setSubmitLoading(true);
      this._dispatch({ email: email, productId: productId, marketingConsent: consent })
        .then((body) => {
          this.setSubmitLoading(false);
          if (this.formPanel) this.formPanel.hidden = true;
          if (this.successPanel) this.successPanel.hidden = false;
          this._logBraze(body);
        })
        .catch(() => {
          this.setSubmitLoading(false);
          // Generic failure: surface in the field's native validity.
          if (this.emailInput) {
            this.emailInput.setCustomValidity(
              this.dataset.errorMessage || "Something went wrong. Please try again.",
            );
            this.emailInput.reportValidity();
            this.emailInput.setCustomValidity("");
          }
        });
    }

    // Tracks the pending request on the button and exposes aria-busy for AT.
    setSubmitLoading(on) {
      this.loading = !!on;
      if (!this.submitBtn) return;
      this.submitBtn.classList.toggle("is-loading", !!on);
      if (on) {
        this.submitBtn.setAttribute("aria-busy", "true");
      } else {
        this.submitBtn.removeAttribute("aria-busy");
      }
    }

    // Braze: identify + tag the signup after a successful subscription. Degrades
    // silently when the wrapper is absent (Braze disabled) -- the success UX never
    // depends on it.
    _logBraze(body) {
      var braze = window.SeedBraze;
      if (!braze) return;
      if (body && body.customerId) braze.changeUser(body.customerId);
      braze.safeLog("online_signup", { source: "coming_soon" });
      braze.safeLog("coming_soon_signup", {
        product_id: this.dataset.productId || "",
        product_name: this.dataset.productName || "",
        product_url: this.dataset.productUrl || "",
        product_image_url: this.dataset.productImageUrl || "",
      });
    }

    // Posts the pre-launch subscription to the Coming Soon Worker through the
    // Shopify App Proxy. Resolves with the response body on success, rejects on any
    // failure so onSubmit shows the inline error.
    _dispatch(payload) {
      return fetch("/apps/cloud/coming-soon", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            // A returning subscriber is a SUCCESS from the shopper's point of
            // view: the worker replies 200 { success:false, error:'already_subscribed' }
            // but they ARE on the list, so resolve (show the success panel) rather
            // than surfacing the generic failure that invites a pointless resubmit.
            if (response.ok && body && body.error === "already_subscribed") {
              return body;
            }
            if (!response.ok || !body || body.success !== true) {
              throw new Error((body && body.error) || "coming_soon_failed");
            }
            return body;
          });
      });
    }
  }

  if (!customElements.get("x-coming-soon-form")) {
    customElements.define("x-coming-soon-form", XComingSoonForm);
  }

  // Populate-then-open for the shared `register-interest` shell. The shell keeps
  // whatever the last trigger wrote, so every open re-stamps first; a missing
  // productId is a no-op because the Worker tags `comingSoon:{productId}` and a
  // blank id would mis-tag a real customer.
  // The shell rebuilds `price` snippet markup so struck compare-at only appears
  // when the card reports one.
  function comingSoonPriceHtml(form, price, compare) {
    var onSale = !!compare;
    var html = '<span class="price' + (onSale ? " price--on-sale" : "") + '" data-price>';
    if (onSale)
      html += '<span class="price__a11y">' + (form.dataset.labelSalePrice || "") + "</span>";
    html += '<span class="price__current" data-price-current>' + (price || "") + "</span>";
    if (onSale) {
      html += '<span class="price__a11y">' + (form.dataset.labelOriginalPrice || "") + "</span>";
      html += '<span class="price__compare" data-price-compare>' + compare + "</span>";
    }
    return html + "</span>";
  }

  window.SeedComingSoon = {
    getTriggerLabel: function () {
      var form = document.querySelector(
        'x-overlay[data-overlay-id="register-interest"] [data-coming-soon-form]',
      );
      return form ? form.dataset.triggerLabel || "" : "";
    },
    open: function (meta) {
      var productId = meta && meta.productId ? String(meta.productId) : "";
      if (!productId) return;
      var host = document.querySelector('x-overlay[data-overlay-id="register-interest"]');
      var form = host && host.querySelector("[data-coming-soon-form]");
      if (!form) return;
      // Shopify serves featured_image protocol-relative; Braze needs it absolute.
      var image = String(meta.image || "");
      if (image.indexOf("//") === 0) image = "https:" + image;
      var url = meta.url ? new URL(meta.url, window.location.origin).href : "";
      form.dataset.productId = productId;
      form.dataset.productName = meta.title || "";
      form.dataset.productUrl = url;
      form.dataset.productImageUrl = image;
      var title = form.querySelector(".coming-soon-form__product");
      var price = form.querySelector(".coming-soon-form__price");
      if (title) title.textContent = meta.title || "";
      if (price) price.innerHTML = comingSoonPriceHtml(form, meta.price, meta.compare);
      if (host.open) host.open();
    },
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-video"] && !Shopify.designMode) return;
  try {
    class XProductVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector("video");
      if (!this.video) return;

      const wantsAutoplay = this.dataset.autoplay === "true";
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (!wantsAutoplay || reduceMotion) return;

      this.video.muted = true;
      const played = this.video.play();
      if (played && typeof played.catch === "function") {
        played.catch(() => {});
      }
    }
  }

  if (!customElements.get("x-product-video")) {
    customElements.define("x-product-video", XProductVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-notify"] && !Shopify.designMode) return;
  try {
    class XNotifyForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-notify-submit]");
      this.formPanel = this.querySelector('[data-notify-panel="form"]');
      this.successPanel = this.querySelector('[data-notify-panel="success"]');
      this.emailInput = this.querySelector('input[type="email"]');
      this.consentInput = this.querySelector('input[name="marketing_consent"]');
      this.priceEl = this.querySelector(".notify-form__price");
      // Consent is locked on. aria-disabled keeps the control focusable/discoverable
      // for keyboard + AT users (native `disabled` drops it from the Tab order), so
      // toggling is blocked here instead.
      if (this.consentInput) {
        this.consentInput.addEventListener("click", function (e) {
          e.preventDefault();
        });
        this.consentInput.addEventListener("keydown", function (e) {
          if (e.key === " " || e.key === "Spacebar") e.preventDefault();
        });
      }
      if (!this.form) return;

      this._onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener("submit", this._onSubmit);

      // Reset only this instance's overlay; PDP and shared card shells can coexist
      // on one page.
      this._onOpen = (event) => {
        var host = this.closest("x-overlay");
        if (event.detail && host && event.detail.id === host.dataset.overlayId) this.reset();
      };
      document.addEventListener("overlay:open", this._onOpen);
    }

    disconnectedCallback() {
      if (this.form && this._onSubmit) this.form.removeEventListener("submit", this._onSubmit);
      document.removeEventListener("overlay:open", this._onOpen);
    }

    reset() {
      this.syncPrice();
      if (this.formPanel) this.formPanel.hidden = false;
      if (this.successPanel) this.successPanel.hidden = true;
    }

    // Mirror the buy box's live price into the flyout because the shopper may
    // choose a sold-out variant after the server-rendered default loads. The shared
    // shell is skipped: its product is whichever card opened it, not the PDP's.
    syncPrice() {
      if (this.hasAttribute("data-notify-shell")) return;
      var live = document.querySelector("[data-buy-box-price] [data-price]");
      if (live && this.priceEl) this.priceEl.innerHTML = live.outerHTML;
    }

    onSubmit(event) {
      event.preventDefault();
      var email = this.emailInput ? this.emailInput.value.trim() : "";
      if (!email || !this.emailInput.checkValidity()) {
        if (this.emailInput) this.emailInput.reportValidity();
        return;
      }

      // The shell is stamped with the variant the opener chose; the PDP instance reads
      // the buy box's live selection.
      var idInput = document.querySelector("[data-buy-box-id]");
      var variantId = this.dataset.variantId || (idInput ? idInput.value : "");

      // Always true because the restock alert is a Braze marketing send; an
      // unsubscribed signup could never receive it. Read off the locked checkbox so
      // the payload can never disagree with what the shopper was shown.
      var consent = this.consentInput ? this.consentInput.checked : true;

      this._dispatch({ email: email, variantId: variantId, marketingConsent: consent })
        .then((body) => {
          // A card flow may retain its source overlay under this modal. Dismiss only
          // that exact source after the subscription succeeds; validation and request
          // failures leave both surfaces unchanged for correction or retry.
          var sourceOverlay = this.sourceOverlay;
          if (
            sourceOverlay &&
            sourceOverlay.isConnected &&
            sourceOverlay.dialog &&
            sourceOverlay.dialog.open
          ) {
            sourceOverlay.close({ instant: true });
          }
          this.sourceOverlay = null;
          if (this.formPanel) this.formPanel.hidden = true;
          if (this.successPanel) this.successPanel.hidden = false;
          this._logBraze(body, variantId);
        })
        .catch(() => {
          // Generic failure: surface in the field's native validity.
          if (this.emailInput) {
            this.emailInput.setCustomValidity(
              this.dataset.errorMessage || "Something went wrong. Please try again.",
            );
            this.emailInput.reportValidity();
            this.emailInput.setCustomValidity("");
          }
        });
    }

    // Posts the subscription to the Worker via the App Proxy. Resolves with the
    // response body on success, rejects on any failure so onSubmit shows the
    // inline error.
    _dispatch(payload) {
      return fetch("/apps/cloud/back-in-stock", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (body) {
            if (!response.ok || !body || body.success !== true) {
              throw new Error((body && body.error) || "back_in_stock_failed");
            }
            return body;
          });
      });
    }

    // Braze: identify + tag the signup after success. Degrades silently when the
    // wrapper is absent (Braze disabled) -- the success UX never depends on it.
    _logBraze(body, variantId) {
      var braze = window.SeedBraze;
      if (!braze) return;
      if (body && body.customerId) braze.changeUser(body.customerId);
      braze.safeLog("online_signup", { source: "back_in_stock" });
      var catalogName = this.dataset.brazeCatalog || "";
      if (catalogName) {
        braze.safeLog("catalog_subscription", {
          id: String(variantId),
          catalog_name: catalogName,
          type: ["back_in_stock"],
        });
      }
    }
  }

  if (!customElements.get("x-notify-form")) {
    customElements.define("x-notify-form", XNotifyForm);
  }

  // Populate-then-open for the shared `notify-me` shell used by card surfaces. The
  // shell keeps whatever the last opener wrote, so every open re-stamps first; a
  // missing variantId is a no-op because the Worker subscribes the shopper to that
  // variant and a blank id would register the wrong alert. The shell rebuilds
  // `price` snippet markup so a struck compare-at only appears when the opener
  // reports one.
  function notifyPriceHtml(form, price, compare) {
    var onSale = !!compare;
    var html = '<span class="price' + (onSale ? " price--on-sale" : "") + '" data-price>';
    if (onSale)
      html += '<span class="price__a11y">' + (form.dataset.labelSalePrice || "") + "</span>";
    html += '<span class="price__current" data-price-current>' + (price || "") + "</span>";
    if (onSale) {
      html += '<span class="price__a11y">' + (form.dataset.labelOriginalPrice || "") + "</span>";
      html += '<span class="price__compare" data-price-compare>' + compare + "</span>";
    }
    return html + "</span>";
  }

  window.SeedNotify = {
    open: function (meta, options) {
      var variantId = meta && meta.variantId ? String(meta.variantId) : "";
      if (!variantId) return;
      var host = document.querySelector('x-overlay[data-overlay-id="notify-me"]');
      var form = host && host.querySelector("[data-notify-form]");
      if (!form) return;
      var sourceOverlay = options && options.sourceOverlay;
      form.sourceOverlay =
        sourceOverlay && sourceOverlay.dialog && sourceOverlay.dialog.open ? sourceOverlay : null;
      form.dataset.variantId = variantId;
      var title = form.querySelector(".notify-form__product");
      var price = form.querySelector(".notify-form__price");
      if (title) title.textContent = meta.title || "";
      if (price) price.innerHTML = notifyPriceHtml(form, meta.price, meta.compare);
      if (host.open) host.open({ preserveCurrent: !!form.sourceOverlay });
    },
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-picker"] && !Shopify.designMode) return;
  try {
    class QuantityPicker extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".quantity-picker__input");
      this.decreaseButton = this.querySelector('[data-action="decrease"]');

      /* Value as first rendered -- the revert target. A successful AJAX change
         re-renders the whole line (fresh element, fresh lastValue), so this only
         holds the pre-change server-truth value for one element's lifetime;
         revert() restores it after a rejected change. */
      this.lastValue = this.input ? this.input.value : "";
      this.increaseButton = this.querySelector('[data-action="increase"]');

      this.min = parseInt(this.dataset.min, 10);
      if (isNaN(this.min)) this.min = 1;

      this.step = parseInt(this.dataset.step, 10);
      if (isNaN(this.step) || this.step < 1) this.step = 1;

      this.max = null;
      if (this.dataset.max !== undefined && this.dataset.max !== "") {
        var parsedMax = parseInt(this.dataset.max, 10);
        if (!isNaN(parsedMax)) this.max = parsedMax;
      }

      this.onDecrease = this.onDecrease.bind(this);
      this.onIncrease = this.onIncrease.bind(this);
      this.onInputChange = this.onInputChange.bind(this);
      this.onInputKeydown = this.onInputKeydown.bind(this);
    }

    connectedCallback() {
      if (this.decreaseButton) this.decreaseButton.addEventListener("click", this.onDecrease);
      if (this.increaseButton) this.increaseButton.addEventListener("click", this.onIncrease);
      if (this.input) this.input.addEventListener("change", this.onInputChange);
      if (this.input) this.input.addEventListener("keydown", this.onInputKeydown);
      this.refreshButtons();
    }

    disconnectedCallback() {
      if (this.decreaseButton) this.decreaseButton.removeEventListener("click", this.onDecrease);
      if (this.increaseButton) this.increaseButton.removeEventListener("click", this.onIncrease);
      if (this.input) this.input.removeEventListener("change", this.onInputChange);
      if (this.input) this.input.removeEventListener("keydown", this.onInputKeydown);
    }

    get currentValue() {
      var raw = parseInt(this.input.value, 10);
      if (isNaN(raw)) raw = this.min;
      return raw;
    }

    clamp(value) {
      if (isNaN(value)) value = this.min;
      var steps = Math.round((value - this.min) / this.step);
      var snapped = this.min + steps * this.step;
      if (snapped < this.min) snapped = this.min;
      if (this.max !== null && snapped > this.max) snapped = this.max;
      return snapped;
    }

    commit(value) {
      var clamped = this.clamp(value);
      this.input.value = clamped;
      this.refreshButtons();
      this.dispatchEvent(
        new CustomEvent("quantity:change", {
          bubbles: true,
          detail: { value: clamped },
        }),
      );
    }

    revert() {
      if (!this.input) return;
      this.input.value = this.lastValue;
      this.refreshButtons();
    }

    /* Re-cap the control after its ceiling moves under it -- a PDP size switch
       swaps to a variant with different stock. Pass null/'' for no cap. Clamps the
       current value into the new range WITHOUT dispatching quantity:change, so it
       never triggers a mutation the shopper didn't make. */
    setMax(max) {
      var parsed = parseInt(max, 10);
      this.max = isNaN(parsed) ? null : parsed;
      if (this.max === null) {
        delete this.dataset.max;
        if (this.input) this.input.removeAttribute("max");
      } else {
        this.dataset.max = this.max;
        if (this.input) this.input.setAttribute("max", this.max);
      }
      if (this.input) this.input.value = this.clamp(this.currentValue);
      this.refreshButtons();
    }

    onDecrease() {
      this.commit(this.currentValue - this.step);
    }

    onIncrease() {
      this.commit(this.currentValue + this.step);
    }

    onInputChange() {
      this.commit(this.currentValue);
    }

    /* Enter in the field COMMITS the typed number; it must never submit the
       enclosing form. Every consumer sits inside one whose submit button does
       something the shopper did not ask for by typing a quantity -- Add to Bag on
       the PDP, Checkout in the cart form. preventDefault kills that implicit
       submission; blur() then fires the native change that commits + clamps, so
       the value still lands (and the cart still updates) without a double
       dispatch. Submitting stays a deliberate act: click the button, or tab to it
       and press Enter there. */
    onInputKeydown(event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      this.input.blur();
    }

    refreshButtons() {
      if (this.dataset.disabled === "true") return;
      var value = this.currentValue;
      if (this.decreaseButton) this.decreaseButton.disabled = value <= this.min;
      if (this.increaseButton)
        this.increaseButton.disabled = this.max !== null && value >= this.max;
    }
  }

  if (!customElements.get("x-quantity-picker")) {
    customElements.define("x-quantity-picker", QuantityPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Document-level singleton: one init backs every product-card surface and
       survives Section Rendering reloads. */
    if (window.__seedQuickAddInit) return;
    window.__seedQuickAddInit = true;

    /* =====================================================================
       LAYER 1 -- Add-core (SeedQuickAdd).
       ===================================================================== */

    function routeRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return "/";
    }

    function cartAddUrl() {
      return routeRoot() + "cart/add.js";
    }

    function setLoading(el, on) {
      if (!el) return;
      if (on) {
        el.setAttribute("aria-busy", "true");
        el.setAttribute("aria-disabled", "true");
      } else {
        el.removeAttribute("aria-busy");
        el.removeAttribute("aria-disabled");
      }
    }

    /* Write add failures through the shared cart status live region so every
       surface uses the localized fallback and visible error state. */
    function setCartError(message) {
      var els = document.querySelectorAll("[data-cart-status]");
      for (var i = 0; i < els.length; i++) {
        els[i].setAttribute("data-cart-state", "error");
        els[i].textContent = message || els[i].getAttribute("data-error-msg") || "";
      }
    }

    /* Pull the human message off a rejected cart response (the AJAX cart errors
       carry `description`); anything without one yields null so setCartError falls
       back to the static cart.error string. */
    function errMessage(err) {
      if (
        err &&
        typeof err === "object" &&
        typeof err.description === "string" &&
        err.description
      ) {
        return err.description;
      }
      return null;
    }

    /* On a failed add there is no cart:added, so the runtime never opens the drawer.
       Open it on the error path only so the shared [data-cart-status] message is
       visible. open() is idempotent. */
    function openCartDrawer() {
      var host = document.querySelector('x-overlay[data-overlay-id="cart-drawer"]');
      if (host && typeof host.open === "function") {
        host.open();
        return;
      }
      var trigger = document.querySelector('[data-overlay-trigger="cart-drawer"]');
      if (trigger) trigger.click();
    }

    /* Shared add-core: POST an items[] payload, announce cart:added, own the
       control's in-flight + error state, and return the fetch promise so producers
       can chain. Success leaves drawer opening to the cart runtime; errors open it
       here so the shared status is visible. */
    function postItems(items, control, preview, coveoToken) {
      if (!items || !items.length) return Promise.resolve();
      /* In-flight guard: block a second add (mouse OR keyboard) while a request is
         resolving -- aria-disabled dims it but does not stop keyboard activation. */
      if (control && control.getAttribute("aria-busy") === "true") return Promise.resolve();

      setLoading(control, true);

      /* Ask the cart runtime which sections it can render and bundle them into this
         cart/add.js call, so the response carries rendered drawer HTML. sections_url
         is pinned to the cart route because the drawer is a header section-group
         section; rendering it against the referrer page can return empty HTML. No
         section IDs means the add falls back to the normal cart response. */
      var body = { items: items };
      var sectionIds = new Set();
      /* The same prepare event carries an optional stand-in preview so the drawer can
         open with a dimmed product while the add resolves. */
      document.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          detail: { sections: sectionIds, preview: preview || null },
        }),
      );
      if (sectionIds.size) {
        body.sections = Array.from(sectionIds).join(",");
        body.sections_url = routeRoot() + "cart";
      }

      return fetch(cartAddUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(
            function (data) {
              return Promise.reject(data);
            },
            function () {
              return Promise.reject(res);
            },
          );
        })
        .then(function (data) {
          /* coveoToken, when present, correlates this event back to the Coveo card's pending
             product-click attribution; absent on native / bundle adds. */
          document.dispatchEvent(
            new CustomEvent("cart:added", {
              bubbles: true,
              detail: { item: data, coveoToken: coveoToken || "" },
            }),
          );
          return data;
        })
        .catch(function (err) {
          /* No cart:added fires on failure, so drop any pending stand-in before
             opening the drawer onto the error. The echoed coveoToken lets the Coveo card clear
             the matching pending attribution so a failed add emits no product click. */
          document.dispatchEvent(
            new CustomEvent("cart:add-failed", {
              bubbles: true,
              detail: { coveoToken: coveoToken || "" },
            }),
          );
          setCartError(errMessage(err));
          openCartDrawer();
        })
        .finally(function () {
          setLoading(control, false);
        });
    }

    /* Single-variant add. When preview is omitted, derive it from the triggering
       card; flyout adds pass their current title / price / thumb explicitly. */
    function add(variantId, quantity, control, preview, coveoToken) {
      if (!variantId) return Promise.resolve();
      var qty = quantity && quantity > 0 ? quantity : 1;
      return postItems(
        [{ id: variantId, quantity: qty }],
        control,
        preview || previewFor(control, { variantId: variantId, quantity: qty }),
        coveoToken,
      );
    }

    /* Bundle tile add: one child line per item, grouped by the shared `_bundle_id`.
       The stand-in uses the parent bundle title / price / image. */
    function addItems(items, control, preview) {
      return postItems(
        items,
        control,
        preview || previewFor(control, { kind: "bundle", quantity: 1 }),
      );
    }

    window.SeedQuickAdd = window.SeedQuickAdd || {};
    window.SeedQuickAdd.add = add;
    window.SeedQuickAdd.addItems = addItems;

    /* =====================================================================
       Canonical size ordering (shared with size-sort.liquid). Single variants do
       not sort; numeric labels sort ascending with all-zero labels before positives,
       and alpha labels sort by the S/M/L rank. Labels are returned verbatim; only
       order changes. Exposed on SeedQuickAdd so every product-card surface shares
       one ordering.
       ===================================================================== */
    var SIZE_ALPHA_RANK = [
      "xxxxs",
      "xxxs",
      "xxs",
      "xs",
      "s",
      "m",
      "l",
      "xl",
      "xxl",
      "xxxl",
      "xxxxl",
      "os",
      "one size",
    ];

    function sortAlphaSizes(list) {
      return list
        .map(function (v, i) {
          var rank = SIZE_ALPHA_RANK.indexOf(
            String(v == null ? "" : v)
              .toLowerCase()
              .trim(),
          );
          if (rank < 0) rank = 900 + i; /* unrecognised: keep native order, at the end */
          return { v: v, rank: rank, i: i };
        })
        .sort(function (a, b) {
          return a.rank - b.rank || a.i - b.i;
        })
        .map(function (o) {
          return o.v;
        });
    }

    function sortNumericSizes(list) {
      return list
        .map(function (v, i) {
          var raw = String(v == null ? "" : v).trim();
          var num = parseFloat(raw);
          /* All-zero (or non-numeric -> NaN) labels: more chars = smaller, all below
             the positives (negative rank); positive sizes rank by their value. */
          var rank = num ? num : -raw.length;
          return { v: v, rank: rank, i: i };
        })
        .sort(function (a, b) {
          return a.rank - b.rank || a.i - b.i;
        })
        .map(function (o) {
          return o.v;
        });
    }

    function sortSizes(list) {
      if (!list || list.length <= 1) return (list || []).slice();
      var first = "";
      for (var i = 0; i < list.length; i++) {
        if (list[i] != null && String(list[i]).trim() !== "") {
          first = String(list[i]).trim();
          break;
        }
      }
      var isNumeric = first.length > 0 && "0123456789".indexOf(first.charAt(0)) !== -1;
      return isNumeric ? sortNumericSizes(list) : sortAlphaSizes(list);
    }

    window.SeedQuickAdd.sortSizes = sortSizes;

    function getVariants(scopeEl) {
      var node = scopeEl.querySelector("[data-pc-variants]");
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return [];
      }
    }

    function resolveVariant(scopeEl, size) {
      var variants = getVariants(scopeEl);
      if (!variants.length) return null;
      if (size) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].size) === String(size)) return variants[i];
        }
      }
      /* No label match: a genuine one-size product has a single variant -- use it.
         A multi-variant product with no match is unresolved (needs a size); never
         add blindly. */
      if (variants.length === 1) return variants[0];
      return null;
    }

    /* Expose the resolver so producers with their own size controls resolve labels
       through the same variant logic as the listener. */
    window.SeedQuickAdd.resolve = resolveVariant;

    /* Bundle tile payload: the parent `_bundle_id` + each child's first-variant id,
       emitted by product-card-mapper alongside the standard variant island. */
    function getBundlePayload(scopeEl) {
      var node = scopeEl.querySelector("[data-pc-bundle-payload]");
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return null;
      }
    }

    /* =====================================================================
       Card readers + optimistic stand-in payload.

       Title / price / colour come from structured data, never a DOM scrape: the
       Coveo carrier's `product` meta or the native scope's `[data-pc-preview]`
       island, so the stand-in matches the `cart-line-item` it becomes without
       depending on rendered card markup. The image is still read off the card so
       readImage can return an already-decoded `currentSrc`.
       ===================================================================== */

    function cardRoot(card) {
      return (card && card.shadowRoot) || card;
    }

    /* Prefer an already-decoded image and return its `currentSrc`: the cart runtime
       can match that URL against loaded page images and paint the stand-in without
       another request. If multiple images are present, take the first complete one. */
    function readImage(card, meta) {
      var root = cardRoot(card);
      var imgs = card.querySelectorAll(".product-card__slide img, .image-container img");
      if (!imgs.length && root !== card) imgs = root.querySelectorAll("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].complete && imgs[i].naturalWidth > 0) return imgs[i].currentSrc || imgs[i].src;
      }
      if (imgs.length) return imgs[0].currentSrc || imgs[0].src;
      return (meta && meta.image) || "";
    }

    function variantById(variants, variantId) {
      if (!variantId) return null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && String(variants[i].id) === String(variantId)) return variants[i];
      }
      return null;
    }

    /* Whether the cart line will show a size dropdown: only for a real size CHOICE (a size axis
       with >1 distinct value). A single-variant / one-size product renders none (cart-line-item
       `cli_show_size`), so the stand-in must not either. Shared by previewFor + flyoutPreview. */
    function sizeSelectableFrom(variants) {
      var sizes = {};
      for (var i = 0; i < (variants || []).length; i++) {
        var s = variants[i] && variants[i].size;
        if (s != null && s !== "") sizes[String(s)] = 1;
      }
      return Object.keys(sizes).length > 1;
    }

    /* The stand-in's price as { price, compare }, from the surface's structured meta -- the
       two money strings pre-formatted (`priceLabel` / `compareLabel`), the same split the cart
       line's markup needs, so no consumer ever takes a rendered price apart. Shared by
       previewFor + the flyout's populate(). */
    function previewPriceParts(meta) {
      if (!meta) return { price: "", compare: "" };
      return { price: meta.priceLabel || "", compare: meta.compareLabel || "" };
    }

    /* Build the stand-in payload from the triggering surface.

       Deriving it here keeps every card producer on the same optimistic path: the
       add-core already receives the triggering control, and the size comes from the
       same variant island the add resolved through.

       Return null when title or price is missing. A partial stand-in is worse than
       none because the shopper would see missing fields pop in when the real line
       lands. */
    function previewFor(control, opts) {
      if (!control || !control.querySelector) return null;
      opts = opts || {};
      var scope = control.closest ? control.closest("[data-pc-quickadd-scope]") : null;
      var card = scope || control;
      var variants = [];
      if (scope) {
        variants = getVariants(scope);
      } else if (variantsNode(control)) {
        variants = variantsFor(control);
      } else {
        return null; // not a card surface (e.g. the flyout) -- it passes its own preview
      }

      /* Title / price from the surface's structured meta (native scope island or Coveo
         carrier), never a scrape of the rendered card. */
      var meta = previewMeta(control);
      var title = (meta && meta.title) || "";
      var variant = variantById(variants, opts.variantId) || {};

      var priceParts = previewPriceParts(meta);
      var price = priceParts.price;
      var compareAt = priceParts.compare;
      if (!title || !price) return null;

      /* Native colourways are separate products, so the card scope owns the colour
         name. Coveo can only supply it from the variant colour axis or product meta. */
      var colour =
        (scope && scope.getAttribute("data-pc-colour")) ||
        variant.color ||
        (meta && meta.color) ||
        "";

      var preview = {
        title: title,
        price: price,
        compareAt: compareAt,
        image: readImage(card, meta),
        colour: colour,
        size: variant.size == null ? "" : String(variant.size),
        sizeSelectable: sizeSelectableFrom(variants),
        quantity: opts.quantity > 0 ? opts.quantity : 1,
      };
      if (opts.kind) preview.kind = opts.kind;
      return preview;
    }

    /* =====================================================================
       LAYER 2 -- Coveo PLP carrier bridge + variant-selector flyout.
       The add-core has no path for the Coveo card (an atomic-product shadow-DOM
       host that cannot carry a mapper scope), so this layer reads its
       [data-quick-add-variants] carrier and drives the shared quick-add-flyout,
       routing the actual add back through SeedQuickAdd.add.
       ===================================================================== */

    /* Find the [data-quick-add-variants] payload nearest a card. The carrier may
       sit as a sibling inside the card's slot wrapper, or inside the card element
       itself (the Coveo card embeds it). Walk up to the surface wrapper, then fall
       back to a document-level node keyed by the card's product id. */
    function variantsNode(card) {
      var scope =
        card.closest(".product-carousel__slide, .pcard, [data-quick-add-scope]") ||
        card.parentElement;
      var node = scope && scope.querySelector("[data-quick-add-variants]");
      if (!node) node = card.querySelector("[data-quick-add-variants]");
      if (!node) {
        var id = card.dataset && card.dataset.productId;
        if (id) node = document.querySelector('[data-quick-add-variants="' + id + '"]');
      }
      return node || null;
    }

    function variantsFor(card) {
      var node = variantsNode(card);
      if (!node) return [];
      var raw;
      try {
        raw = JSON.parse(node.textContent);
      } catch (e) {
        return [];
      }
      /* Accept both the bare-array and { variants: [] } carrier shapes. */
      if (Array.isArray(raw)) return raw;
      if (raw && Array.isArray(raw.variants)) return raw.variants;
      return [];
    }

    /* One field off the { variants, product, colourways } carrier shape. Null for the
       bare-array shape, which carries variants only. */
    function carrierField(card, key) {
      var node = variantsNode(card);
      if (!node) return null;
      try {
        var raw = JSON.parse(node.textContent);
        return (raw && raw[key]) || null;
      } catch (e) {
        return null;
      }
    }

    /* Optional product meta (the Coveo card supplies it because its title / price / image
       are not reachable as light-DOM `.product-card__*` nodes). */
    function productMetaFor(card) {
      return carrierField(card, "product");
    }

    /* Product meta for stand-ins on any surface: Coveo carries `{ variants, product }`;
       native cards carry `[data-pc-preview]` from the same Liquid values their card
       renders. Without either, previewFor returns no stand-in. */
    function previewMeta(el) {
      if (!el) return null;
      var carrier = productMetaFor(el);
      if (carrier) return carrier;
      var scope = el.closest ? el.closest("[data-pc-quickadd-scope]") : null;
      var host = scope || el;
      var node = host && host.querySelector ? host.querySelector("[data-pc-preview]") : null;
      if (node) {
        try {
          return JSON.parse(node.textContent);
        } catch (e) {
          return null;
        }
      }
      return null;
    }

    function hasColorAxis(variants) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].color) return true;
      }
      return false;
    }

    /* Resolve a chosen size (+ optional colour) to a carrier variant. Single-variant
       carriers resolve immediately; multi-variant carriers require a size, and
       colour-axis carriers must also match colour. Otherwise the caller opens the
       flyout. */
    function resolveCarrier(variants, size, color) {
      if (!variants.length) return null;
      if (variants.length === 1) return variants[0];
      if (!size) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (String(v.size) !== String(size)) continue;
        if (color && v.color && String(v.color) !== String(color)) continue;
        return v;
      }
      return null;
    }

    /* ---- Flyout -------------------------------------------------------------
       Shared quick-add-flyout instance, populated from the triggering card and
       variant payload. */

    var flyoutHost = null;
    var flyout = null;

    function getFlyout() {
      if (flyout) return flyout;
      flyoutHost = document.querySelector('x-overlay[data-overlay-id="quick-add"]');
      flyout = flyoutHost ? flyoutHost.querySelector("[data-quick-add-flyout]") : null;
      return flyout;
    }

    var current = { variants: [], size: "", color: "", hasColor: false };
    /* Coveo product-click correlation token for the currently-open flyout, set on every open
       (empty for native cards) so the flyout's confirm add echoes the token that opened it and
       the Coveo card can pair or clear its pending attribution. Survives in-flyout swatch/size
       swaps (which do not re-open the flyout). */
    var flyoutCoveoToken = "";

    function escapeHtml(s) {
      return String(s == null ? "" : s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    /* Runtime size-chip markup mirrors the snippet contract because Liquid cannot
       render at click time. Sold-out chips stay interactive so the add guard can
       announce the sold-out state instead of silently refusing. */
    function sizeChip(label, inStock) {
      var cls = "size-chip text-body-sm";
      if (!inStock) cls += " size-chip--oos";
      var attrs = 'class="' + cls + '" type="button"';
      attrs += ' data-size-chip-value="' + escapeHtml(label) + '"';
      attrs += ' data-size-chip-name="quick-add-size"';
      attrs += ' data-size-chip-label="' + escapeHtml(label) + '"';
      var inner = '<span class="size-chip__label">' + escapeHtml(label) + "</span>";
      if (!inStock) inner += '<span class="size-chip__sr">, out of stock</span>';
      return "<button " + attrs + ">" + inner + "</button>";
    }

    /* Runtime swatch markup mirrors the DS swatch snippet's contract: `default` 24px for a
       same-product colour axis, `small` 20px for the colourway row. `value` is what rides
       `swatch:change`, so it is the option label for a colour axis and the sibling handle for
       a colourway. Mode precedence follows the snippet: glyph > image > fallback > colour dot. */
    function swatchBtn(opts) {
      var cls = "swatch";
      if (opts.size === "small") cls += " swatch--small";
      if (opts.glyph) {
        cls += " swatch--glyph";
        if (opts.glyphEmoji) cls += " swatch--glyph-emoji";
      }
      if (opts.selected) cls += " swatch--selected";
      if (opts.oos) cls += " swatch--oos";
      var label = opts.label || "";
      var aria = opts.oos && opts.oosLabel ? label + ", " + opts.oosLabel : label;
      var html = '<button type="button" class="' + cls + '"';
      html += ' aria-pressed="' + (opts.selected ? "true" : "false") + '"';
      html += ' aria-label="' + escapeHtml(aria) + '"';
      html += ' data-swatch data-swatch-value="' + escapeHtml(opts.value || label) + '"';
      html += ' data-swatch-label="' + escapeHtml(label) + '"';
      html += ' data-swatch-name="' + escapeHtml(opts.name) + '">';
      html += '<span class="swatch__ring" aria-hidden="true">';
      if (opts.glyph) {
        html += '<span class="swatch__glyph">' + escapeHtml(opts.glyph) + "</span>";
      } else if (opts.image) {
        html +=
          '<span class="swatch__dot swatch__dot--image"><img class="swatch__img" src="' +
          escapeHtml(opts.image) +
          '" alt="" width="48" height="48" loading="lazy" decoding="sync"></span>';
      } else if (opts.fallback) {
        html += '<span class="swatch__dot swatch__dot--fallback"></span>';
      } else {
        html +=
          '<span class="swatch__dot" style="--swatch-color: ' +
          escapeHtml(opts.color || "transparent") +
          ';"></span>';
      }
      html += "</span></button>";
      return html;
    }

    function setStatus(kind) {
      var fly = getFlyout();
      var status = fly && fly.querySelector("[data-qa-status]");
      if (!status) return;
      if (!kind) {
        status.textContent = "";
        return;
      }
      var attr =
        kind === "soldout"
          ? "data-msg-soldout"
          : kind === "needs-size"
            ? "data-msg-needs-size"
            : "data-msg-error";
      status.textContent = status.getAttribute(attr) || "";
    }

    function distinct(list) {
      var seen = {};
      var out = [];
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v == null || v === "") continue;
        var key = String(v);
        if (seen[key]) continue;
        seen[key] = true;
        out.push(v);
      }
      return out;
    }

    /* A size is sold out only when every variant carrying it, for the chosen colour
       when present, is unavailable. */
    function sizeAvailable(variants, size, color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (String(v.size) !== String(size)) continue;
        if (color && v.color && String(v.color) !== String(color)) continue;
        if (v.available !== false) return true;
      }
      return false;
    }

    /* Nothing in the displayed product is buyable, so no size choice can make an add
       succeed. */
    function anyAvailable(variants) {
      return (variants || []).some(function (v) {
        return v && v.available !== false;
      });
    }

    function renderSizes() {
      var fly = getFlyout();
      var grid = fly && fly.querySelector("[data-qa-sizes]");
      if (!grid) return;
      var sizes = sortSizes(
        distinct(
          current.variants.map(function (v) {
            return v.size;
          }),
        ),
      );
      /* One distinct size is no choice to make -- a placeholder axis (the catalogue
         stamps `NOSIZE` on accessories, jewellery and letter products) or a lone real
         size. Render no grid and pre-resolve that size, so the primary action reflects
         its stock instead of the customer having to click a meaningless chip. Mirrors
         the buy box (`values.size > 1`) and product-card-mapper (`one-size`). */
      if (sizes.length < 2) {
        grid.innerHTML = "";
        current.size = sizes.length ? String(sizes[0]) : "";
        reflectSize();
        return;
      }
      var html = "";
      for (var i = 0; i < sizes.length; i++) {
        var inStock = sizeAvailable(
          current.variants,
          sizes[i],
          current.hasColor ? current.color : null,
        );
        html += sizeChip(sizes[i], inStock);
      }
      grid.innerHTML = html;
      reflectSize();
    }

    /* Native colourways are separate sibling products. When the card provides a
       pre-rendered product-swatches template plus sibling map, inject that row and
       use swatch clicks to swap the shown product. Otherwise render same-product
       colour-axis swatches from the carrier payload. */
    function renderFlyoutSwatches(card) {
      var fly = getFlyout();
      var row = fly && fly.querySelector("[data-qa-swatches]");
      if (!row) return;
      current.siblings = null;
      current.handle = "";
      var scope = card && card.closest ? card.closest("[data-pc-quickadd-scope]") : null;
      var tmpl = scope && scope.querySelector("[data-pc-flyout-swatches]");
      var mapNode = scope && scope.querySelector("[data-pc-flyout-siblings]");
      if (tmpl && mapNode) {
        row.innerHTML = tmpl.innerHTML;
        try {
          current.siblings = JSON.parse(mapNode.textContent);
        } catch (e) {
          current.siblings = null;
        }
        /* The current product's swatch is server-marked selected (product-swatches lead);
           record its handle so a click on the already-shown swatch is a clean no-op. */
        var sel =
          row.querySelector("[data-swatch].swatch--selected") || row.querySelector("[data-swatch]");
        current.handle = sel ? sel.getAttribute("data-swatch-value") || "" : "";
        return;
      }
      /* Coveo cards live in an atomic-product shadow root, so they can carry neither the
         mapper scope nor a server-rendered template. Their colourway set rides the variant
         carrier instead, and is rendered here into the same swatch + sibling-map contract
         the native branch injects, so one swap handler serves both surfaces. */
      if (renderCarrierSwatches(card, row)) return;
      renderSwatches(card);
    }

    /* Build the colourway row + swap map from the carrier's `colourways`. Returns false when
       the surface carries none, so the caller can fall back to the colour-axis row. */
    function renderCarrierSwatches(card, row) {
      var ways = carrierField(card, "colourways");
      if (!ways || !ways.length) return false;
      var oosLabel = row.getAttribute("data-msg-oos") || "";
      var html = "";
      var siblings = {};
      for (var i = 0; i < ways.length; i++) {
        var w = ways[i];
        if (!w || !w.handle) continue;
        html += swatchBtn({
          size: "small",
          color: w.hex,
          image: w.image,
          glyph: w.glyph,
          glyphEmoji: w.glyphEmoji,
          fallback: !!w.fallback,
          label: w.label,
          value: w.handle,
          selected: !!w.selected,
          oos: !!w.oos,
          oosLabel: oosLabel,
          name: "swatch",
        });
        /* Swap payload shape is the native sibling map's, keyed by handle. */
        siblings[w.handle] = {
          title: w.title,
          price: w.price,
          compare: w.compare,
          image: w.thumb,
          colour: w.colour,
          available: w.available,
          id: w.id,
          url: w.url,
          action: w.action,
          variants: w.variants || [],
        };
        /* The displayed colourway is a no-op on re-click, the same guard the native
           branch takes from its server-marked selected swatch. */
        if (w.selected) current.handle = w.handle;
      }
      if (!html) return false;
      row.innerHTML = html;
      current.siblings = siblings;
      return true;
    }

    function renderSwatches(card) {
      var fly = getFlyout();
      var row = fly && fly.querySelector("[data-qa-swatches]");
      if (!row) return;
      /* Same-product colour axes can render as quick-add colour swatches. Native
         `.product-card__swatches` dots are cross-product colourways; without a
         sibling map they cannot resolve against this product's variants, so a
         no-axis product stays sizes-only. */
      var html = "";
      var dots = current.hasColor
        ? card.querySelectorAll(".product-card__swatches [data-swatch]")
        : [];
      if (dots.length) {
        for (var i = 0; i < dots.length; i++) {
          var d = dots[i];
          var label = d.getAttribute("data-swatch-label") || d.getAttribute("aria-label") || "";
          var dotEl = d.querySelector(".swatch__dot");
          var hex = dotEl ? (dotEl.style.getPropertyValue("--swatch-color") || "").trim() : "";
          var sel = i === 0;
          if (sel && label) current.color = label;
          html += swatchBtn({
            color: hex || "transparent",
            label: label,
            selected: sel,
            name: "quick-add-color",
          });
        }
      } else if (current.hasColor) {
        var colors = distinct(
          current.variants.map(function (v) {
            return v.color;
          }),
        );
        for (var j = 0; j < colors.length; j++) {
          var s = j === 0;
          if (s) current.color = colors[j];
          html += swatchBtn({ label: colors[j], selected: s, name: "quick-add-color" });
        }
      }
      row.innerHTML = html;
    }

    function reflectSize() {
      var fly = getFlyout();
      var grid = fly && fly.querySelector("[data-qa-sizes]");
      if (!grid) return;
      var chips = grid.querySelectorAll(".size-chip");
      for (var i = 0; i < chips.length; i++) {
        var isSel = chips[i].getAttribute("data-size-chip-value") === current.size;
        chips[i].classList.toggle("size-chip--selected", !!current.size && isSel);
        if (!!current.size && isSel) chips[i].setAttribute("aria-pressed", "true");
        else chips[i].removeAttribute("aria-pressed");
      }
      reflectPrimary();
    }

    /* Derive one primary action from the displayed product and resolved variant.
       Coming soon takes product-level precedence; a product with nothing buyable is
       sold out however the size resolves; otherwise only an unavailable variant swaps
       Add to bag for Notify me or a disabled Add to bag. */
    function primaryAction(variant) {
      if (current.action === "coming-soon") return "register";
      if (!variant) return anyAvailable(current.variants) ? "add" : "soldout";
      if (variant.available !== false) return "add";
      return current.action === "disabled" ? "disabled" : "notify";
    }

    function reflectPrimary() {
      var fly = getFlyout();
      var addBtn = fly && fly.querySelector("[data-qa-add]");
      var actionBtn = fly && fly.querySelector("[data-qa-notify]");
      if (!addBtn || !actionBtn) return false;
      var variant = resolveCarrier(
        current.variants,
        current.size,
        current.hasColor ? current.color : null,
      );
      var mode = primaryAction(variant);
      var alternate = mode === "notify" || mode === "register";
      var label = actionBtn.querySelector(".btn__label");
      if (label && !actionBtn.dataset.notifyLabel)
        actionBtn.dataset.notifyLabel = label.textContent;
      if (label) {
        label.textContent =
          mode === "register" && window.SeedComingSoon
            ? window.SeedComingSoon.getTriggerLabel()
            : actionBtn.dataset.notifyLabel || "";
      }
      actionBtn.hidden = !alternate;
      addBtn.hidden = alternate;
      /* Sold out takes the disabled posture with the buy box's sold-out label. Cache the
         rendered Add to bag text first so swapping back to a stocked colourway restores
         it. */
      var addLabel = addBtn.querySelector(".btn__label");
      if (addLabel && !addBtn.dataset.addLabel) addBtn.dataset.addLabel = addLabel.textContent;
      if (addLabel) {
        addLabel.textContent =
          mode === "soldout" ? addBtn.dataset.labelSoldout || "" : addBtn.dataset.addLabel || "";
      }
      var addDisabled = mode === "disabled" || mode === "soldout";
      addBtn.disabled = addDisabled;
      if (addDisabled) addBtn.setAttribute("aria-disabled", "true");
      else addBtn.removeAttribute("aria-disabled");
      return alternate;
    }

    function populate(card, variants) {
      var fly = getFlyout();
      if (!fly) return;
      current = {
        variants: variants,
        size: "",
        color: "",
        hasColor: hasColorAxis(variants),
        /* Native colourway swaps use a sibling map; Coveo same-product colour variants
           use hasColor instead. */
        siblings: null,
        handle: "",
        /* Display colour name for the stand-in, distinct from `color`, which resolves
           same-product colour variants. Native colourways belong to the product. */
        colour: "",
        /* Coveo product-level colour name is the stand-in fallback when no scope
           colour or variant colour axis is available. */
        metaColour: "",
        /* Product-level primary-action policy. The displayed sibling replaces it on
           native colourway swaps. */
        action: "default",
        productId: "",
        url: "",
      };
      var qaScope = card && card.closest ? card.closest("[data-pc-quickadd-scope]") : null;
      current.colour = qaScope ? qaScope.getAttribute("data-pc-colour") || "" : "";
      setStatus(null);

      /* Structured meta supplies title/price across shadow-DOM and native surfaces;
         readImage still uses the rendered card to reuse an already-decoded currentSrc. */
      var meta = previewMeta(card) || {};
      current.metaColour = meta.color || "";
      current.action = meta.action || (meta.notify === false ? "disabled" : "default");
      current.productId = meta.id || "";
      current.url = meta.url || "";
      /* Title must come from structured meta because Coveo product text can live
         inside nested shadow roots. */
      var title = fly.querySelector("[data-qa-title]");
      if (title) title.textContent = meta.title || "";

      /* Price as two parts from the structured meta -- shared with previewFor. The two money
         strings arrive pre-formatted (`priceLabel` / `compareLabel`), so the flyout never
         takes a rendered price apart. */
      var price = fly.querySelector("[data-qa-price]");
      var flyPrice = previewPriceParts(meta);
      var priceCur = flyPrice.price;
      var priceCmp = flyPrice.compare;
      if (price) {
        if (priceCmp) {
          price.innerHTML =
            '<span class="quick-add-flyout__price-sale">' +
            escapeHtml(priceCur) +
            '</span><span class="quick-add-flyout__price-compare">' +
            escapeHtml(priceCmp) +
            "</span>";
        } else {
          price.textContent = priceCur;
        }
      }

      var thumb = fly.querySelector("[data-qa-thumb] .image-container, [data-qa-thumb]");
      var imgSrc = readImage(card, meta);
      if (thumb && imgSrc) {
        var box = fly.querySelector("[data-qa-thumb]");
        if (box) {
          box.innerHTML =
            '<div class="image-container image-container--portrait" style="--image-container-ratio: 2 / 3;">' +
            '<img src="' +
            escapeHtml(imgSrc) +
            '" alt="" width="82" height="123"></div>';
        }
      }

      renderFlyoutSwatches(card);
      renderSizes();

      /* Stock stays hidden until the carrier exposes inventory data and the caller can
         supply a durable inventory-to-level rule. */
      var stock = fly.querySelector("[data-qa-stock]");
      if (stock) stock.setAttribute("hidden", "");

      current.wishlist = resolveWishlistIdentity(card, meta, variants);
      hydrateWishlist();
    }

    function openFlyout(card, variants, coveoToken) {
      populate(card, variants);
      flyoutCoveoToken = coveoToken || "";
      if (flyoutHost && typeof flyoutHost.open === "function") flyoutHost.open();
    }

    /* ---- Flyout wishlist heart (customer-only, product-level) ----------------
       The flyout heart uses the shared SeedWishlist runtime: hydrate saved state on
       open and wishlist updates, gate guests to login, and add/remove product-level
       entries. Identity comes from Coveo product meta or the triggering native card's
       wishlist button; without identity the heart stays hidden. */
    function firstAvailableVariantId(variants) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available !== false && variants[i].id) return variants[i].id;
      }
      return variants[0] && variants[0].id;
    }

    function absoluteProductUrl(url, handle) {
      if (url) return String(url).indexOf("://") > -1 ? url : window.location.origin + url;
      if (handle) return window.location.origin + "/products/" + handle;
      return "";
    }

    function resolveWishlistIdentity(card, meta, variants) {
      meta = meta || {};
      var empi = meta.id || null;
      var du = meta.url || "";
      if (!empi && card && card.querySelector) {
        var wb = card.querySelector("x-wishlist-button[data-empi]");
        if (wb) {
          empi = wb.getAttribute("data-empi");
          if (!du) du = wb.getAttribute("data-du") || "";
        }
      }
      if (!empi) return null;
      var epi = firstAvailableVariantId(variants || []);
      return {
        empi: String(empi),
        epi: epi ? String(epi) : "",
        du: absoluteProductUrl(du, meta.handle),
      };
    }

    function flyoutWishlistButton() {
      var fly = getFlyout();
      return fly ? fly.querySelector("[data-qa-wishlist]") : null;
    }

    function hydrateWishlist() {
      var btn = flyoutWishlistButton();
      if (!btn) return;
      var wl = current.wishlist;
      /* No identity, no runtime, or SWYM unavailable -> hide the heart (no dead
         control), matching the on-card wishlist-button + Coveo host behaviour. */
      if (
        !wl ||
        !wl.empi ||
        !window.SeedWishlist ||
        (window.SeedWishlist.isUnavailable && window.SeedWishlist.isUnavailable())
      ) {
        btn.hidden = true;
        return;
      }
      btn.hidden = false;
      btn.setAttribute("aria-pressed", window.SeedWishlist.isSaved(wl.empi) ? "true" : "false");
    }

    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-qa-wishlist]");
      if (!btn) return;
      event.preventDefault();
      var wl = current.wishlist;
      if (!wl || !wl.empi || !window.SeedWishlist) return;
      /* Guest -> login gate instead of toggling (wishlist is customer-only). */
      if (!window.SeedWishlist.isLoggedIn()) {
        if (window.SeedWishlistGate && window.SeedWishlistGate.prompt)
          window.SeedWishlistGate.prompt();
        return;
      }
      btn.setAttribute(
        "aria-pressed",
        btn.getAttribute("aria-pressed") !== "true" ? "true" : "false",
      );
      window.SeedWishlist.toggle({ empi: wl.empi, epi: wl.epi, du: wl.du }, hydrateWishlist);
    });

    document.addEventListener("wishlist:content", hydrateWishlist);

    /* =====================================================================
       product-card:add listener -- native and Coveo surfaces.
       ===================================================================== */
    document.addEventListener("product-card:add", function (event) {
      /* --- Native surfaces via product-card-mapper: a [data-pc-quickadd-scope]
         wrapper carrying [data-pc-variants]. Bundle scopes add child lines. Resolved
         through the add-core directly (no flyout -- native cards select size inline). */
      var scopeEl = event.target.closest("[data-pc-quickadd-scope]");
      if (scopeEl) {
        var control = event.target.closest("x-product-card") || event.target;

        /* Bundle tiles add child lines only, grouped by `_bundle_id`; the parent product
           is never added as its own line. Refuse incomplete bundles even if stale
           keyboard state reaches this path. */
        if (scopeEl.hasAttribute("data-pc-bundle")) {
          /* Bundle cards navigate to the bundle PDP when a URL is available.
             Coveo/search cards cannot resolve parent-to-child bundle relationships
             from the card, and the PDP bundle add owns the child-line add. */
          var bundleUrl = scopeEl.getAttribute("data-pc-bundle-url");
          if (bundleUrl) {
            window.location.assign(bundleUrl);
            return;
          }
          /* Fallback (no PDP url stamped): add the child lines in place. */
          var payload = getBundlePayload(scopeEl);
          if (!payload || !payload.children || !payload.children.length) return;
          for (var j = 0; j < payload.children.length; j++) {
            if (payload.children[j].available === false) return;
          }
          var props = payload.properties || {};
          var items = payload.children.map(function (child) {
            return { id: child.id, quantity: 1, properties: props };
          });
          addItems(items, control);
          return;
        }

        var scopeSize = event.detail ? event.detail.size : "";
        var scopeVariant = resolveVariant(scopeEl, scopeSize);
        if (!scopeVariant) {
          /* A native multi-size card can dispatch from the mobile quick-add "+" without
             a size. Open the shared flyout instead of adding blindly; size chips and
             one-size products resolve before this branch. */
          openFlyout(control, getVariants(scopeEl));
          return;
        }
        if (scopeVariant.available === false) return;
        add(scopeVariant.id, 1, control);
        return;
      }

      /* The PLP / Coveo fall-through is the only path behind `quick_add_enabled`.
         Native scopes returned above. Server-side Coveo markup omission is the
         primary gate; this client check is defense-in-depth for stray composed events.
         Strict `=== "false"` keeps the default-on setting fail-open. */
      if (document.documentElement.dataset.quickAddEnabled === "false") return;

      /* Coveo events retarget through shadow DOM, so event.target is the product list
         rather than the atomic-product host. composedPath reaches the host stamped
         with data-product-id; native cards without a carrier still no-op below. */
      var path = (event.composedPath && event.composedPath()) || [];
      var card = null;
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1 || !el.matches) continue;
        if (el.matches("atomic-product, x-product-card, .pcard, [data-quick-add-card]")) {
          card = el;
          break;
        }
      }
      if (!card)
        card =
          event.target.closest("x-product-card, .pcard, [data-quick-add-card]") || event.target;
      /* Shop the Look uses its own add-to-cart singleton and no quick-add carrier; do
         not let its size clicks open an empty flyout here. */
      if (card.closest("[data-stl-product]")) return;
      if (!variantsNode(card)) return;
      var variants = variantsFor(card);
      var size = event.detail ? event.detail.size : "";
      /* Coveo cards echo a product-click correlation token on their add dispatch; native cards
         carry none. It rides the flyout (via openFlyout) or the direct add so the shared add-core
         can pair it back onto cart:added / cart:add-failed. */
      var coveoToken = (event.detail && event.detail.coveoToken) || "";
      /* A choice is still open when the product carries an in-product colour axis, OR when
         the carrier offers a colourway row: letter products hold their 20+ letters as
         sibling products, so their own variant list is a single NOSIZE row that would
         otherwise resolve straight to an add. The card caps its swatches, so an unsized
         dispatch -- the mobile "+" and the desktop one-size action -- is a request to
         choose, never a pick. A size chosen on the card already is one, so it still adds. */
      var colourways = carrierField(card, "colourways");
      var multiAxis = hasColorAxis(variants) || (!size && !!colourways && colourways.length > 1);
      var variant = resolveCarrier(variants, size, null);

      /* Multi-axis (colour) or no resolvable variant -> open the flyout to choose. */
      if (multiAxis || !variant) {
        openFlyout(card, variants, coveoToken);
        return;
      }
      if (variant.available === false) {
        /* Sold-out one-size / size reached programmatically: open the flyout so the
           sold-out state is announced + visible rather than failing quietly. The
           message is redundant once the CTA has swapped to Notify me. */
        openFlyout(card, variants, coveoToken);
        if (!reflectPrimary()) setStatus("soldout");
        return;
      }
      /* Resolved single variant -> direct add through the shared add-core. On failure
         the add-core opens the cart drawer with the [data-cart-status] error. */
      add(variant.id, 1, card, null, coveoToken);
    });

    /* The Coveo card opens the flyout from index data and rewrites its carrier once the live
       product payload lands. Refresh an open flyout for that same product in place, so sizes
       the index omitted appear and a size that live stock says is gone loses its selection. */
    document.addEventListener("quick-add:carrier-updated", function (event) {
      var fly = getFlyout();
      var dialog = flyoutHost && flyoutHost.querySelector("dialog");
      if (!fly || !dialog || !dialog.open) return;
      var path = (event.composedPath && event.composedPath()) || [];
      var card = null;
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el || el.nodeType !== 1 || !el.matches) continue;
        if (el.matches("atomic-product, .pcard, [data-quick-add-card]")) {
          card = el;
          break;
        }
      }
      if (!card) return;
      var meta = productMetaFor(card) || {};
      if (!meta.id || String(meta.id) !== String(current.productId)) return;
      current.variants = variantsFor(card);
      current.hasColor = hasColorAxis(current.variants);
      if (
        current.size &&
        !sizeAvailable(current.variants, current.size, current.hasColor ? current.color : null)
      ) {
        current.size = "";
      }
      current.wishlist = resolveWishlistIdentity(card, meta, current.variants);
      renderSizes();
      hydrateWishlist();
    });

    /* The flyout generates size chips at runtime, so it owns their click handling.
       If the size-chip snippet listener is also loaded, its size-chip:change event is
       idempotent with this handler. */
    document.addEventListener("click", function (event) {
      var chip = event.target.closest("[data-qa-sizes] .size-chip");
      if (!chip) return;
      if (chip.disabled || chip.getAttribute("aria-disabled") === "true") return;
      current.size = chip.dataset.sizeChipValue || "";
      setStatus(null);
      reflectSize();
    });

    /* Accept size-chip:change from snippet-owned or programmatic size chips; the
       click handler above may already have set the same value. */
    document.addEventListener("size-chip:change", function (event) {
      if (!event.detail || event.detail.name !== "quick-add-size") return;
      current.size = event.detail.value;
      setStatus(null);
      reflectSize();
    });

    document.addEventListener("swatch:change", function (event) {
      if (!event.detail || event.detail.name !== "quick-add-color") return;
      current.color = event.detail.label || event.detail.value;
      var fly = getFlyout();
      var row = fly && fly.querySelector("[data-qa-swatches]");
      if (row) {
        var dots = row.querySelectorAll("[data-swatch]");
        for (var i = 0; i < dots.length; i++) {
          var sel = dots[i] === event.target.closest("[data-swatch]");
          dots[i].classList.toggle("swatch--selected", sel);
          dots[i].setAttribute("aria-pressed", sel ? "true" : "false");
        }
      }
      /* A colour change can change which sizes are in stock. If the recorded size is
         no longer available for the new colour, clear it so the customer re-picks
         (rather than leaving a stale sold-out size visually selected). */
      if (
        current.size &&
        !sizeAvailable(current.variants, current.size, current.hasColor ? current.color : null)
      ) {
        current.size = "";
      }
      renderSizes();
    });

    /* Native colourway swatches inside the flyout swap the shown product, not a
       same-product colour filter. Scope to the injected product-swatches row so
       on-page card swatches and quick-add colour-axis swatches are ignored; the
       sibling map supplies the replacement title, price, thumb, variants, and
       wishlist identity. */
    document.addEventListener("swatch:change", function (event) {
      if (!event.detail || event.detail.name !== "swatch") return;
      var fly = getFlyout();
      var row = fly && fly.querySelector("[data-qa-swatches]");
      var target = event.target.closest ? event.target.closest("[data-swatch]") : null;
      if (!row || !target || !row.contains(target)) return;
      var handle = event.detail.value;
      /* sibling_products includes the current handle, so guard re-clicks before the
         map lookup; otherwise the swap would wipe the chosen size. */
      if (handle && handle === current.handle) return;
      var sib = handle && current.siblings ? current.siblings[handle] : null;
      if (!sib) return;

      current.handle = handle;
      current.variants = sib.variants || [];
      current.size = "";
      current.hasColor = false;
      current.colour = sib.colour || ""; // swapped product colour for the stand-in
      current.action = sib.action || "default";
      current.productId = sib.id || "";
      current.url = sib.url || "";

      var titleEl = fly.querySelector("[data-qa-title]");
      if (titleEl) titleEl.textContent = sib.title || "";

      var priceEl = fly.querySelector("[data-qa-price]");
      if (priceEl) {
        if (sib.compare) {
          priceEl.innerHTML =
            '<span class="quick-add-flyout__price-sale">' +
            escapeHtml(sib.price) +
            '</span><span class="quick-add-flyout__price-compare">' +
            escapeHtml(sib.compare) +
            "</span>";
        } else {
          priceEl.textContent = sib.price || "";
        }
      }

      if (sib.image) {
        var box = fly.querySelector("[data-qa-thumb]");
        if (box) {
          box.innerHTML =
            '<div class="image-container image-container--portrait" style="--image-container-ratio: 2 / 3;">' +
            '<img src="' +
            escapeHtml(sib.image) +
            '" alt="" width="82" height="123"></div>';
        }
      }

      /* Move the selected ring (product-swatches marks selection with swatch--selected +
         aria-pressed) to the clicked swatch. */
      var swatches = row.querySelectorAll("[data-swatch]");
      for (var i = 0; i < swatches.length; i++) {
        var isSel = swatches[i] === target;
        swatches[i].classList.toggle("swatch--selected", isSel);
        if (swatches[i].hasAttribute("aria-pressed")) {
          swatches[i].setAttribute("aria-pressed", isSel ? "true" : "false");
        }
      }

      setStatus(null);
      renderSizes();
      current.wishlist = resolveWishlistIdentity(
        null,
        { id: sib.id, url: sib.url, handle: handle },
        current.variants,
      );
      hydrateWishlist();
    });

    /* The flyout stand-in cannot use previewFor: by click time the triggering card may
       be out of scope or replaced by a colourway swap. Read the flyout's current
       title / price / thumb; the on-screen thumb's currentSrc is already decoded. */
    function flyoutPreview(variant) {
      var fly = getFlyout();
      if (!fly) return null;
      var titleEl = fly.querySelector("[data-qa-title]");
      var priceEl = fly.querySelector("[data-qa-price]");
      var imgEl = fly.querySelector("[data-qa-thumb] img");
      var saleEl = priceEl && priceEl.querySelector(".quick-add-flyout__price-sale");
      var compareEl = priceEl && priceEl.querySelector(".quick-add-flyout__price-compare");
      var title = titleEl ? titleEl.textContent.trim() : "";
      var price = saleEl ? saleEl.textContent.trim() : priceEl ? priceEl.textContent.trim() : "";
      if (!title || !price) return null;
      return {
        title: title,
        price: price,
        compareAt: compareEl ? compareEl.textContent.trim() : "",
        image: imgEl ? imgEl.currentSrc || imgEl.src : "",
        colour:
          current.colour ||
          (current.hasColor ? current.color : "") ||
          (variant && variant.color) ||
          current.metaColour ||
          "",
        size: variant && variant.size != null ? String(variant.size) : "",
        sizeSelectable: sizeSelectableFrom(current.variants),
        quantity: 1,
      };
    }

    /* The alternate flyout action delegates to the shared shell for its current
       mode. Register interest is product-level; Notify me carries the resolved
       unavailable variant. */
    document.addEventListener("click", function (event) {
      var actionBtn = event.target.closest("[data-qa-notify]");
      if (!actionBtn) return;
      var variant = resolveCarrier(
        current.variants,
        current.size,
        current.hasColor ? current.color : null,
      );
      var mode = primaryAction(variant);
      var preview = flyoutPreview(variant) || {};
      if (mode === "register") {
        if (!window.SeedComingSoon) return;
        window.SeedComingSoon.open({
          productId: current.productId,
          title: preview.title,
          price: preview.price,
          compare: preview.compareAt,
          url: current.url,
          image: preview.image,
        });
        return;
      }
      if (mode !== "notify" || !variant || !window.SeedNotify) return;
      window.SeedNotify.open(
        {
          variantId: variant.id,
          title: preview.title,
          price: preview.price,
          compare: preview.compareAt,
        },
        { sourceOverlay: flyoutHost },
      );
    });

    /* Flyout adds route through the shared add-core so PLP adds get the same bundled
       sections, cart:added event, and error handling as direct card adds. */
    document.addEventListener("click", function (event) {
      var addBtn = event.target.closest("[data-qa-add]");
      if (!addBtn) return;
      var variant = resolveCarrier(
        current.variants,
        current.size,
        current.hasColor ? current.color : null,
      );
      if (!variant) {
        /* No size chosen -> surface the size group + announce, never a blind add. */
        setStatus("needs-size");
        var fly = getFlyout();
        var firstChip = fly && fly.querySelector(".size-chip:not(.size-chip--oos):not([disabled])");
        if (firstChip) firstChip.focus();
        return;
      }
      if (variant.available === false) {
        setStatus("soldout");
        return;
      }
      setStatus(null);
      add(variant.id, 1, addBtn, flyoutPreview(variant), flyoutCoveoToken).then(function (data) {
        /* postItems resolves with the cart payload on success, undefined on error.
           Close the flyout only on a real success -- the runtime opens the cart drawer
           on cart:added; on error the add-core opens the drawer with the status and the
           flyout stays for a retry. */
        if (data && flyoutHost && typeof flyoutHost.close === "function") flyoutHost.close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["range-slider"] && !Shopify.designMode) return;
  try {
    class XRangeSlider extends HTMLElement {
    constructor() {
      super();
      this.isDouble = false;
      this.inputMin = null;
      this.inputMax = null;
      this.inputSingle = null;
      this.dragging = false;
      this.nearest = null;
      this.onUpdate = this.onUpdate.bind(this);
      this.onPointer = this.onPointer.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
    }

    connectedCallback() {
      this.isDouble =
        this.dataset.type === "double" || this.classList.contains("range-slider--double");

      if (this.isDouble) {
        this.inputMin = this.querySelector("[data-range-min]");
        this.inputMax = this.querySelector("[data-range-max]");
        if (this.inputMin) this.inputMin.addEventListener("input", this.onUpdate);
        if (this.inputMax) this.inputMax.addEventListener("input", this.onUpdate);
        this.addEventListener("pointerdown", this.onPointerDown);
        this.addEventListener("pointermove", this.onPointer);
        this.addEventListener("pointerup", this.onPointerUp);
        this.addEventListener("pointercancel", this.onPointerUp);
      } else {
        this.inputSingle = this.querySelector("[data-range-single]");
        if (this.inputSingle) this.inputSingle.addEventListener("input", this.onUpdate);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.inputMin) this.inputMin.removeEventListener("input", this.onUpdate);
      if (this.inputMax) this.inputMax.removeEventListener("input", this.onUpdate);
      if (this.inputSingle) this.inputSingle.removeEventListener("input", this.onUpdate);
      this.removeEventListener("pointerdown", this.onPointerDown);
      this.removeEventListener("pointermove", this.onPointer);
      this.removeEventListener("pointerup", this.onPointerUp);
      this.removeEventListener("pointercancel", this.onPointerUp);
    }

    fraction(input) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      var val = parseFloat(input.value);
      if (isNaN(min) || isNaN(max) || isNaN(val) || max <= min) return 0;
      var frac = (val - min) / (max - min);
      if (frac < 0) frac = 0;
      if (frac > 1) frac = 1;
      return frac;
    }

    onUpdate() {
      this.update();
    }

    update() {
      if (this.isDouble) {
        if (!this.inputMin || !this.inputMax) return;
        // Clamp so the handles never collide: they must stay at least one step
        // apart (value_min <= value_max - step). Whichever handle the user is
        // driving is the one held back, so it can't meet or cross the other.
        var step = parseFloat(this.inputMin.step);
        if (isNaN(step) || step <= 0) step = 1;
        var lo = parseFloat(this.inputMin.value);
        var hi = parseFloat(this.inputMax.value);
        if (!isNaN(lo) && !isNaN(hi) && hi - lo < step) {
          if (document.activeElement === this.inputMax) {
            // Driving the max handle down: hold it one step above the min.
            this.inputMax.value = lo + step;
          } else {
            // Driving the min handle up (or a programmatic / initial sync):
            // hold it one step below the max.
            this.inputMin.value = hi - step;
          }
        }
        this.style.setProperty("--rs-low", this.fraction(this.inputMin));
        this.style.setProperty("--rs-high", this.fraction(this.inputMax));
      } else {
        if (!this.inputSingle) return;
        this.style.setProperty("--rs-high", this.fraction(this.inputSingle));
      }
    }

    onPointerDown(event) {
      this.dragging = true;
      this.onPointer(event);
      // In double mode the inputs are pointer-events: none (only their native
      // thumbs are clickable), so a plain click beside a handle would leave
      // nothing focused and the arrow keys dead. Hand focus to the handle
      // nearest the pointer so the keyboard can drive it immediately.
      // Defer focus to the next animation tick: mousedown's default action runs
      // after pointerdown and would reassign focus to the nearest focusable ancestor.
      // preventDefault() is not an option because it would break native dragging
      // from a thumb.
      if (this.nearest) {
        var handle = this.nearest;
        requestAnimationFrame(function () {
          handle.focus({ preventScroll: true });
        });
      }
    }

    onPointerUp() {
      this.dragging = false;
    }

    // Raise the z-index of the handle nearest the pointer so that, when the two
    // thumbs overlap, the one the user is reaching for stays grabbable.
    onPointer(event) {
      if (!this.dragging) return;
      if (!this.isDouble || !this.inputMin || !this.inputMax) return;
      var rect = this.getBoundingClientRect();
      if (rect.width <= 0) return;
      var pointer = (event.clientX - rect.left) / rect.width;
      var distMin = Math.abs(pointer - this.fraction(this.inputMin));
      var distMax = Math.abs(pointer - this.fraction(this.inputMax));
      if (distMin <= distMax) {
        this.nearest = this.inputMin;
        this.inputMin.style.zIndex = "3";
        this.inputMax.style.zIndex = "2";
      } else {
        this.nearest = this.inputMax;
        this.inputMax.style.zIndex = "3";
        this.inputMin.style.zIndex = "2";
      }
    }
  }

  if (!customElements.get("x-range-slider")) {
    customElements.define("x-range-slider", XRangeSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["read-more"] && !Shopify.designMode) return;
  try {
    class XReadMore extends HTMLElement {
    connectedCallback() {
      // connectedCallback can fire before children are parsed, so defer init
      // until the document is ready (or run now if added afterwards, e.g. a
      // theme-editor re-render, where children already exist).
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      this.body = this.querySelector("[data-readmore-body]");
      this.control = this.querySelector("[data-readmore-control]");
      this.toggle = this.querySelector("[data-readmore-toggle]");
      if (!this.body || !this.control || !this.toggle) return;

      // Admin rich-text editors emit trailing "<p>&nbsp;</p>" paragraphs (e.g.
      // in collection descriptions). They render as blank lines that open a gap
      // under short copy and inflate the measured height enough to reveal a
      // toggle over copy that visibly fits, so drop them before measuring.
      // Elements with replaced content (an image) are kept even though they
      // have no text.
      let trailing = this.body.lastElementChild;
      while (
        trailing &&
        !trailing.textContent.trim() &&
        !trailing.querySelector("img,svg,iframe,video,embed")
      ) {
        const prev = trailing.previousElementSibling;
        trailing.remove();
        trailing = prev;
      }

      // The toggle is rendered by the `button` snippet, which wraps the visible
      // text in a `.btn__label` span; swap that span's text (not the button's,
      // which would also wipe the span). Falls back to the button itself.
      this.toggleLabel = this.toggle.querySelector(".btn__label") || this.toggle;
      this.moreLabel = this.dataset.labelMore || this.toggleLabel.textContent;
      this.lessLabel = this.dataset.labelLess || this.toggleLabel.textContent;

      // `expanded` is the user's intent, preserved across re-evaluations (e.g. a
      // resize must not silently re-collapse copy the visitor opened).
      this.expanded = false;
      this.lastWidth = null;
      this.toggle.addEventListener("click", () => this.toggleExpanded());

      // Measure only once web fonts have settled: measuring against the fallback
      // font's metrics mis-reports the line count and would reveal the control
      // over copy that actually fits (the "Read more that does nothing" bug).
      const ready = (document.fonts && document.fonts.ready) || Promise.resolve();
      ready.then(() => {
        this.evaluate();
        // Re-evaluate when the body's WIDTH changes (a viewport/container resize
        // re-wraps the copy, changing the line count). Width-gated so the height
        // change from toggling the clamp can't feed back into an observer loop.
        if ("ResizeObserver" in window) {
          this.observer = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (width === this.lastWidth) return;
            this.lastWidth = width;
            this.evaluate();
          });
          this.observer.observe(this.body);
        }
      });
    }

    // Decide whether the copy overflows the 4-line cap at the current width and
    // show/hide the control accordingly, honouring the user's expand intent.
    evaluate() {
      const lineHeight = parseFloat(getComputedStyle(this.body).lineHeight);
      if (!lineHeight) return;
      this.lastWidth = this.body.getBoundingClientRect().width;

      // Measure the natural (unclamped) height: scrollHeight while
      // -webkit-line-clamp is applied is unreliable, so drop the clamp to read it.
      this.removeAttribute("data-collapsed");
      const overflows = this.body.scrollHeight > lineHeight * 4 + 1;

      this.control.hidden = !overflows;
      if (overflows) {
        this.applyState(!this.expanded);
      } else {
        // Fits within the cap: body stays full (clamp already removed above) and
        // the now-hidden toggle is reset to its default "Read more" / collapsed
        // look so it never lingers in a "Read less" state.
        this.expanded = false;
        this.toggle.setAttribute("aria-expanded", "false");
        this.toggleLabel.textContent = this.moreLabel;
      }
    }

    applyState(collapsed) {
      if (collapsed) {
        this.setAttribute("data-collapsed", "");
      } else {
        this.removeAttribute("data-collapsed");
      }
      this.toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
      this.toggleLabel.textContent = collapsed ? this.moreLabel : this.lessLabel;
    }

    toggleExpanded() {
      this.expanded = !this.expanded;
      this.applyState(!this.expanded);
    }
  }

  if (!customElements.get("x-read-more")) {
    customElements.define("x-read-more", XReadMore);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recently-viewed"] && !Shopify.designMode) return;
  try {
    class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.STORAGE_KEY = "seed:recently-viewed";
      this.cap = parseInt(this.dataset.rvCap, 10) || 16;
      // Minimum distinct viewed products required before the rail renders. A
      // shorter history is treated as empty so a host can fall back (the
      // predictive panel sets 3 -> New arrivals). Default 1.
      this.minItems = parseInt(this.dataset.rvMin, 10) || 1;
      this.currentHandle = this.dataset.productHandle || "";
      this.currentId = this.dataset.productId || "";
      // Deferred hosts (predictive panel) suppress the connect-time fetch; the host
      // controller calls hydrate() when it decides the region should show.
      this.deferred = this.hasAttribute("data-rv-deferred");

      this._record();

      // Only fetch from a non-hydrated host (first paint). The search response
      // carries the SAME recently-viewed element; injecting its inner content
      // rather than the wrapper keeps the injected nodes inert.
      if (this._hydrated) return;
      if (this.deferred) return;

      // Lazy hosts keep the SRA fetch + card images off the initial critical path.
      // The skeleton is revealed on connect to reserve height; only the fetch waits
      // for the rail to near the viewport, so the on-scroll swap is skeleton->cards
      // in place. Observe the enclosing section, not the hidden host, and arm after
      // window load because sections above may still be collapsed while images are
      // loading, which would make a below-fold rail look near the viewport.
      if (this.hasAttribute("data-rv-lazy") && "IntersectionObserver" in window) {
        var lazyIds = this._gateAndReveal();
        if (!lazyIds) return;
        var self = this;
        var arm = function () {
          var anchor = self.closest(".shopify-section") || self;
          var io = new IntersectionObserver(
            function (entries, obs) {
              if (
                !entries.some(function (entry) {
                  return entry.isIntersecting;
                })
              )
                return;
              obs.disconnect();
              self._fetchAndSwap(lazyIds);
            },
            { rootMargin: "400px" },
          );
          io.observe(anchor);
        };
        if (document.readyState === "complete") {
          arm();
        } else {
          window.addEventListener("load", arm, { once: true });
        }
        return;
      }

      this._hydrate();
    }

    // Public entry point for deferred hosts. Idempotent -- safe to call on every
    // panel open; the fetch runs at most once.
    hydrate() {
      if (this._hydrated || this._hydrateStarted) return;
      this._hydrateStarted = true;
      this._hydrate();
    }

    get _hydrated() {
      return this.querySelector("[data-rv-card]") !== null;
    }

    _read() {
      try {
        const raw = window.localStorage.getItem(this.STORAGE_KEY);
        if (!raw) return [];
        const list = JSON.parse(raw);
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }

    _write(list) {
      try {
        window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(list));
      } catch (e) {
        // Private mode / quota / disabled -- degrade to no history silently.
      }
    }

    _record() {
      if (!this.currentHandle) return;
      let list = this._read();
      list = list.filter((entry) => entry && entry.handle !== this.currentHandle);
      list.unshift({ handle: this.currentHandle, id: this.currentId, t: Date.now() });
      list = list.slice(0, this.cap);
      this._write(list);
    }

    _renderIds() {
      const seen = {};
      return this._read()
        .filter((entry) => entry && entry.id)
        .map((entry) => String(entry.id))
        .filter((id) => id && id !== String(this.currentId))
        .filter((id) => {
          if (seen[id]) return false;
          seen[id] = true;
          return true;
        });
    }

    _searchUrl(ids) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      const base = root.endsWith("/") ? root : root + "/";
      const wrapper = this.closest(".shopify-section");
      const sectionId = wrapper ? wrapper.id.replace(/^shopify-section-/, "") : "";
      const query = ids.map((id) => "id:" + id).join(" OR ");
      return (
        base +
        "search?q=" +
        encodeURIComponent(query) +
        "&type=product&section_id=" +
        encodeURIComponent(sectionId)
      );
    }

    // Hide + signal "nothing to show" so a host surface (the cart module) can
    // react -- e.g. drop the RV tab. Deferred to a frame so the dispatch lands
    // after any sibling custom element (the cart-recs orchestrator) has upgraded
    // and attached its listener, regardless of the bundle's define order.
    _empty() {
      this.setAttribute("hidden", "");
      requestAnimationFrame(() => {
        this.dispatchEvent(new CustomEvent("recently-viewed:empty", { bubbles: true }));
      });
    }

    _hydrate() {
      const ids = this._gateAndReveal();
      if (!ids) return;
      this._fetchAndSwap(ids);
    }

    // History gate + skeleton reveal (no network). Returns the id list to fetch, or
    // null when the gate fails. Split from the fetch path so lazy hosts can reserve
    // height on connect while the network waits for the viewport; the on-scroll
    // swap then happens in place instead of growing an empty box into view.
    _gateAndReveal() {
      let ids = this._renderIds();
      // Minimum-history gate (`data-rv-min`): require a minimum number of DISTINCT
      // viewed products (the full stored history, before the display cap below)
      // before the rail shows. A shorter history is treated as no history so the
      // host can fall back (the predictive panel requires 3 -> New arrivals).
      if (ids.length < this.minItems) {
        this._empty();
        return null;
      }
      // Optional display cap (`data-rv-max`): a host that shows a fixed row/stack
      // (the predictive grid: one desktop row / the mobile stack) caps the fetched
      // ids so the SRA response carries only what the region shows. Default: the
      // full stored list (PDP/cart rails scroll through all of it).
      const max = parseInt(this.dataset.rvMax, 10);
      if (max > 0) ids = ids.slice(0, max);
      if (!ids.length) {
        this._empty();
        return null;
      }

      // The history gate has passed, so reveal the first-paint skeleton and signal
      // loading so host wrappers reveal their chrome. A history-less rail goes
      // straight to _empty above, so the skeleton never flashes without a fetch.
      this.dataset.rvState = "loading";
      this.removeAttribute("hidden");
      this.dispatchEvent(new CustomEvent("recently-viewed:loading", { bubbles: true }));
      return ids;
    }

    _fetchAndSwap(ids) {
      fetch(this._searchUrl(ids), { priority: "low" })
        .then((res) => (res.ok ? res.text() : ""))
        .then((html) => {
          if (!html) {
            this._empty();
            return;
          }
          const doc = new DOMParser().parseFromString(html, "text/html");
          const source = doc.querySelector("recently-viewed");
          const inner = source ? source.querySelector(".recently-viewed__inner") : null;
          if (!inner || !inner.querySelector("[data-rv-card]")) {
            this._empty();
            return;
          }

          this.replaceChildren(document.importNode(inner, true));
          this.carousel = this.querySelector("x-carousel");
          this.removeAttribute("hidden");
          this._wireArrows();
          // Signal a successful hydrate so a host surface can re-measure (the
          // cart-recs orchestrator re-points its shared arrows + overflow at
          // the freshly injected carousel).
          this.dispatchEvent(new CustomEvent("recently-viewed:hydrated", { bubbles: true }));
        })
        .catch(() => {
          this._empty();
        });
    }

    // Wire the standalone variant's own header arrows. On the cart-recs variant
    // the injected inner has no header, so this finds nothing and no-ops -- the
    // shared cart-recs nav drives the carousel there.
    _wireArrows() {
      this.arrows = this.querySelector(".recently-viewed__arrows");
      this.prevBtn = this.querySelector("[data-rv-prev]");
      this.nextBtn = this.querySelector("[data-rv-next]");
      if (this.prevBtn) {
        this._onPrev = () => this.carousel && this.carousel.prev && this.carousel.prev();
        this.prevBtn.addEventListener("click", this._onPrev);
      }
      if (this.nextBtn) {
        this._onNext = () => this.carousel && this.carousel.next && this.carousel.next();
        this.nextBtn.addEventListener("click", this._onNext);
      }

      // Arrow disabled state, like product-carousel: prev is disabled at the start
      // edge, next at the end edge (and both when there is nothing to scroll).
      // x-carousel toggles data-at-start / data-at-end live and fires
      // carousel:change on each settled page move; mirror those onto the buttons.
      // The whole arrow group is also hidden when the carousel does not overflow:
      // x-carousel reports both edges reached only when content fits, so
      // has-overflow is simply "not (at-start AND at-end)". The CSS gates the group
      // on data-has-overflow (desktop-only). Re-sync on resize (overflow can
      // appear/vanish) and after a layout frame (a freshly injected carousel
      // measures 0-width on connect). The `button` snippet owns the :disabled visual.
      this._syncArrows = () => {
        if (!this.carousel) return;
        const atStart = this.carousel.hasAttribute("data-at-start");
        const atEnd = this.carousel.hasAttribute("data-at-end");
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
        if (this.arrows) this.arrows.toggleAttribute("data-has-overflow", !(atStart && atEnd));
      };
      this.addEventListener("carousel:change", this._syncArrows);
      this._onArrowResize = () => {
        if (this._arrowRaf) cancelAnimationFrame(this._arrowRaf);
        this._arrowRaf = requestAnimationFrame(this._syncArrows);
      };
      window.addEventListener("resize", this._onArrowResize);
      requestAnimationFrame(() => requestAnimationFrame(this._syncArrows));
    }

    disconnectedCallback() {
      if (this.prevBtn && this._onPrev) this.prevBtn.removeEventListener("click", this._onPrev);
      if (this.nextBtn && this._onNext) this.nextBtn.removeEventListener("click", this._onNext);
      if (this._syncArrows) this.removeEventListener("carousel:change", this._syncArrows);
      if (this._onArrowResize) window.removeEventListener("resize", this._onArrowResize);
      if (this._arrowRaf) cancelAnimationFrame(this._arrowRaf);
    }
  }

  // Guarded define: this snippet renders on the PDP (its section) AND the cart
  // (the cart-recommendations module), and its JS bundles on each -- the guard
  // keeps two bundles on one page from re-defining.
  if (!customElements.get("recently-viewed")) {
    customElements.define("recently-viewed", RecentlyViewed);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rich-text"] && !Shopify.designMode) return;
  try {
    // Links the richtext editor sets to open in a new tab carry no `rel`. The value must
  // stay the wrapper's sole, unfiltered child for the theme editor's live preview, so
  // the opener guard is applied to the rendered DOM rather than in Liquid.
  const NEW_TAB_LINK = '.rich-text a[target="_blank"]';
  const harden = (link) => {
    const rel = (link.getAttribute("rel") || "").split(/\s+/).filter(Boolean);
    if (rel.includes("noopener")) return;
    rel.push("noopener");
    link.setAttribute("rel", rel.join(" "));
  };
  const hardenNewTabLinks = (root) => {
    if (root.matches && root.matches(NEW_TAB_LINK)) harden(root);
    root.querySelectorAll(NEW_TAB_LINK).forEach(harden);
  };

  // Rich text also arrives after load: theme-editor section reloads and rails that
  // fetch section HTML and insert it client-side. Observing the whole body catches
  // every insertion path without each surface having to announce itself.
  const start = () => {
    hardenNewTabLinks(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) hardenNewTabLinks(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chip"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedSizeChipBound) return;
    window.__seedSizeChipBound = true;

    document.addEventListener("click", function (event) {
      var chip = event.target.closest(".size-chip");
      if (!chip) return;
      if (chip.disabled || chip.getAttribute("aria-disabled") === "true") return;

      chip.dispatchEvent(
        new CustomEvent("size-chip:change", {
          bubbles: true,
          detail: {
            value: chip.dataset.sizeChipValue || "",
            name: chip.dataset.sizeChipName || "",
            label: chip.dataset.sizeChipLabel || "",
          },
        }),
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-select"] && !Shopify.designMode) return;
  try {
    class XSizeSelect extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector("[data-size-select]");
      this.valueEl = this.querySelector("[data-size-select-value]");
      this._onChange = this._onChange.bind(this);
      if (this.select) this.select.addEventListener("change", this._onChange);
    }

    disconnectedCallback() {
      if (this.select) this.select.removeEventListener("change", this._onChange);
    }

    // setValue mirrors external state without emitting size-select:change.
    setValue(value) {
      if (!this.select) return;
      this.select.value = String(value);
      const option = this.select.options[this.select.selectedIndex];
      if (this.valueEl && option) this.valueEl.textContent = option.text;
      this.dataset.value = this.select.value;
    }

    _onChange() {
      if (!this.select) return;
      const value = this.select.value;
      const option = this.select.options[this.select.selectedIndex];
      const label = option ? option.text : "";
      if (this.valueEl) this.valueEl.textContent = label;
      const previousValue = this.dataset.value || "";
      this.dataset.value = value;
      this.dispatchEvent(
        new CustomEvent("size-select:change", {
          bubbles: true,
          detail: { value: value, label: label, previousValue: previousValue },
        }),
      );
    }
  }

  if (!customElements.get("x-size-select")) {
    customElements.define("x-size-select", XSizeSelect);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["star-rating-input"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedStarRatingInit) return;
    window.__seedStarRatingInit = true;

    document.addEventListener("change", function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains("star-rating__input")) return;
      var root = input.closest("star-rating-input");
      if (!root) return;
      root.dispatchEvent(
        new CustomEvent("rating:change", {
          bubbles: true,
          detail: { value: Number(input.value), name: input.name },
        }),
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-map"] && !Shopify.designMode) return;
  try {
    // Lazy single-load of the Mapbox GL JS bundle + CSS, shared by every map on
  // the page; mapboxLoader memoises the promise so one fetch serves all maps.
  const MAPBOX_VERSION = "v3.25.0";
  let mapboxLoader;
  function loadMapbox() {
    mapboxLoader =
      mapboxLoader ||
      new Promise((resolve, reject) => {
        if (window.mapboxgl) {
          resolve(window.mapboxgl);
          return;
        }
        const base = "https://api.mapbox.com/mapbox-gl-js/" + MAPBOX_VERSION + "/mapbox-gl";
        const css = document.createElement("link");
        css.rel = "stylesheet";
        css.href = base + ".css";
        document.head.appendChild(css);
        const js = document.createElement("script");
        js.src = base + ".js";
        js.onload = () => resolve(window.mapboxgl);
        js.onerror = reject;
        document.head.appendChild(js);
      });
    return mapboxLoader;
  }

  class StoreMap extends HTMLElement {
    connectedCallback() {
      this.token = this.dataset.token || "";
      this.canvas = this.querySelector("[data-store-map-canvas]");
      this.surface = this.querySelector("[data-store-map-surface]");
      this.pinTemplate = this.querySelector("[data-store-map-pin]");
      this.tooltipTemplate = this.querySelector("[data-store-map-tooltip]");
      this.singlePin = this.hasAttribute("data-single-pin");
      this.zoom = parseFloat(this.dataset.zoom) || 14;
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.markers = [];
      this.fitPoints = null;
      this.glMarkers = [];
      this.map = null;
      this.ready = false;
      // First camera placement is instant; later marker updates animate unless
      // reduced motion is preferred.
      this._hasFit = false;

      // The controller (or a re-render) pushes a fresh marker set here.
      this._onUpdate = (e) => {
        const d = (e && e.detail) || {};
        const next = d.markers ? d.markers : this._readMarkers();
        this.setMarkers(next, d.fit);
      };
      this.addEventListener("store-map:update", this._onUpdate);

      // Frame one point without touching the marker set.
      this._onFocus = (e) => {
        const d = (e && e.detail) || {};
        if (!this.map || d.lat == null || d.lng == null) return;
        const center = [d.lng, d.lat];
        const zoom = parseFloat(d.zoom) || this.zoom;
        if (this.reduceMotion) {
          this.map.setCenter(center);
          this.map.setZoom(zoom);
        } else {
          this.map.easeTo({ center: center, zoom: zoom });
        }
      };
      this.addEventListener("store-map:focus", this._onFocus);

      // No token -> keep the placeholder until a Mapbox token is configured.
      if (!this.token || !this.canvas) return;

      // Lazy-init when the map approaches the viewport.
      this._io = new IntersectionObserver(
        (entries, obs) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          obs.disconnect();
          loadMapbox()
            .then((mapboxgl) => this.init(mapboxgl))
            .catch(() => {
              /* SDK failed to load (offline / CSP / 401) -> keep placeholder. */
            });
        },
        { rootMargin: "200px" },
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      this.removeEventListener("store-map:update", this._onUpdate);
      this.removeEventListener("store-map:focus", this._onFocus);
      if (this._io) this._io.disconnect();
      if (this._ro) this._ro.disconnect();
      if (this.map) this.map.remove();
    }

    _readMarkers() {
      try {
        return JSON.parse(this.dataset.markers || "[]");
      } catch (e) {
        return [];
      }
    }

    // Pre-marker camera: a caller-supplied region centroid (data-default-center
    // "lng,lat" + data-default-zoom), else Australia. Only used before the first
    // marker resolves; a marker set overrides it immediately.
    _defaultCamera() {
      const parts = (this.dataset.defaultCenter || "").split(",");
      const lng = parseFloat(parts[0]);
      const lat = parseFloat(parts[1]);
      const z = parseFloat(this.dataset.defaultZoom);
      return {
        center: !isNaN(lng) && !isNaN(lat) ? [lng, lat] : [134.0, -25.0],
        zoom: !isNaN(z) ? z : 3,
      };
    }

    init(mapboxgl) {
      this._mapboxgl = mapboxgl;
      this.markers = this._readMarkers();
      const fallback = this._defaultCamera();
      const center = this.markers.length
        ? [this.markers[0].lng, this.markers[0].lat]
        : fallback.center;

      this.map = new mapboxgl.Map({
        container: this.canvas,
        accessToken: this.token,
        style: "mapbox://styles/mapbox/light-v11",
        center: center,
        zoom: this.markers.length ? this.zoom : fallback.zoom,
        interactive: this.dataset.interactive !== "false",
        attributionControl: true,
      });

      if (this.dataset.interactive !== "false" && !this.singlePin) {
        this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), "top-right");
      }

      this.map.on("load", () => {
        this.ready = true;
        this.classList.add("store-map--hydrated");
        this.renderMarkers();
      });

      // A map sized inside a not-yet-laid-out / reveal-on-scroll container reads
      // 0x0 and renders a sliver; resize once it has real dimensions.
      this._ro = new ResizeObserver(() => {
        if (this.offsetWidth && this.offsetHeight && this.map) this.map.resize();
      });
      this._ro.observe(this);
    }

    // `fit` (optional) is the subset the camera frames; without it the camera
    // frames every marker.
    setMarkers(next, fit) {
      this.markers = Array.isArray(next) ? next : [];
      this.fitPoints = Array.isArray(fit) && fit.length ? fit : null;
      this.dataset.markers = JSON.stringify(this.markers);
      if (this.ready) this.renderMarkers();
    }

    clearMarkers() {
      this.glMarkers.forEach((m) => m.remove());
      this.glMarkers = [];
    }

    buildPinElement(marker) {
      const el = document.createElement("div");
      el.className = "store-map__marker-el";
      // Detail page: default-open tooltip above the pin.
      if (this.singlePin && this.tooltipTemplate) {
        el.appendChild(this.tooltipTemplate.content.cloneNode(true));
      }
      if (this.pinTemplate) {
        el.appendChild(this.pinTemplate.content.cloneNode(true));
      }
      // The pin -- and, on the detail page, its default-open tooltip -- act as a
      // single link. Finder pins open the store page in the same tab; the detail
      // pin opens directions (an external maps URL) in a new tab. A click on the
      // tooltip bubbles up to this handler (its pointer-events are re-enabled).
      if (marker.url) {
        const newTab = this.singlePin;
        el.dataset.href = marker.url;
        if (marker.label) el.setAttribute("title", marker.label);
        el.setAttribute("role", "link");
        el.setAttribute("tabindex", "0");
        el.setAttribute("aria-label", marker.label || marker.url);
        const go = () => {
          if (newTab) {
            window.open(marker.url, "_blank", "noopener");
          } else {
            window.location.href = marker.url;
          }
        };
        el.addEventListener("click", go);
        el.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            go();
          }
        });
      }
      return el;
    }

    renderMarkers() {
      if (!this.map || !this._mapboxgl) return;
      const mapboxgl = this._mapboxgl;
      this.clearMarkers();

      const points = this.markers.filter(
        (m) => m && m.lat != null && m.lng != null && !isNaN(m.lat) && !isNaN(m.lng),
      );
      if (!points.length) return;

      points.forEach((marker) => {
        const gl = new mapboxgl.Marker({ element: this.buildPinElement(marker), anchor: "bottom" })
          .setLngLat([marker.lng, marker.lat])
          .addTo(this.map);
        this.glMarkers.push(gl);
      });

      // Entry places the camera instantly; subsequent updates animate (unless the
      // user prefers reduced motion, which stays instant throughout).
      const animate = this._hasFit && !this.reduceMotion;

      // The camera frames the caller's subset when one was supplied -- pins can
      // cover a far wider area than the view is meant to open on.
      const frame = this.fitPoints || points;

      if (this.singlePin || frame.length === 1) {
        const center = [frame[0].lng, frame[0].lat];
        if (animate) {
          this.map.easeTo({ center: center, zoom: this.zoom });
        } else {
          this.map.setCenter(center);
          this.map.setZoom(this.zoom);
        }
        this._hasFit = true;
        return;
      }

      const bounds = new mapboxgl.LngLatBounds();
      frame.forEach((m) => bounds.extend([m.lng, m.lat]));
      this.map.fitBounds(bounds, {
        padding: { top: 48, bottom: 48, left: 48, right: 48 },
        maxZoom: 15,
        animate: animate,
      });
      this._hasFit = true;
    }
  }

  if (!customElements.get("store-map")) {
    customElements.define("store-map", StoreMap);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swatch"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedSwatchBound) return;
    window.__seedSwatchBound = true;

    document.addEventListener("click", function (event) {
      var swatch = event.target.closest("[data-swatch]");
      if (!swatch) return;

      swatch.dispatchEvent(
        new CustomEvent("swatch:change", {
          bubbles: true,
          detail: {
            value: swatch.dataset.swatchValue || "",
            name: swatch.dataset.swatchName || "",
            label: swatch.dataset.swatchLabel || "",
          },
        }),
      );
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs"] && !Shopify.designMode) return;
  try {
    class XTabs extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('[role="tablist"]');
      if (!this.tablist) return;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      if (!this.tabs.length) return;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.tablist.addEventListener("click", this.onClick);
      this.tablist.addEventListener("keydown", this.onKeydown);

      // Normalise roving tabindex from the initial aria-selected state.
      let selected = this.tabs.find((t) => t.getAttribute("aria-selected") === "true");
      if (!selected) selected = this.tabs[0];
      this.select(selected, false);
    }

    disconnectedCallback() {
      if (!this.tablist) return;
      this.tablist.removeEventListener("click", this.onClick);
      this.tablist.removeEventListener("keydown", this.onKeydown);
    }

    enabledTabs() {
      return this.tabs.filter((t) => t.getAttribute("aria-disabled") !== "true" && !t.disabled);
    }

    panelFor(tab) {
      const id = tab.getAttribute("aria-controls");
      return id ? this.querySelector("#" + CSS.escape(id)) : null;
    }

    onClick(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !this.tabs.includes(tab)) return;
      if (tab.getAttribute("aria-disabled") === "true" || tab.disabled) return;
      // Only intercept link navigation when there is a panel to switch to.
      if (tab.tagName === "A" && !this.panelFor(tab)) return;
      event.preventDefault();
      this.select(tab, true);
    }

    onKeydown(event) {
      const tabs = this.enabledTabs();
      const current = event.target.closest('[role="tab"]');
      const index = tabs.indexOf(current);
      if (index === -1) return;

      let next = null;
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          next = tabs[(index + 1) % tabs.length];
          break;
        case "ArrowLeft":
        case "ArrowUp":
          next = tabs[(index - 1 + tabs.length) % tabs.length];
          break;
        case "Home":
          next = tabs[0];
          break;
        case "End":
          next = tabs[tabs.length - 1];
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          this.select(current, true);
          return;
        default:
          return;
      }
      if (next) {
        event.preventDefault();
        // Automatic activation: moving focus selects the tab.
        this.select(next, true);
      }
    }

    select(tab, focus) {
      this.tabs.forEach((t) => {
        const isCurrent = t === tab;
        t.setAttribute("aria-selected", isCurrent ? "true" : "false");
        t.setAttribute("tabindex", isCurrent ? "0" : "-1");
        t.classList.toggle("tab-item--selected", isCurrent);
        const panel = this.panelFor(t);
        if (panel) panel.hidden = !isCurrent;
      });
      if (focus) tab.focus();
    }
  }

  if (!customElements.get("x-tabs")) {
    customElements.define("x-tabs", XTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tag"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", function (event) {
    var chip = event.target.closest("[data-tag]");
    if (!chip || chip.disabled) {
      return;
    }

    chip.dispatchEvent(
      new CustomEvent("tag:remove", {
        bubbles: true,
        detail: {
          value: chip.getAttribute("data-tag-value"),
          label: chip.querySelector(".tag__label")
            ? chip.querySelector(".tag__label").textContent.trim()
            : "",
        },
      }),
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["textarea"] && !Shopify.designMode) return;
  try {
    class SeedTextarea extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector(".textarea__control");
      if (!this.control) return;
      this.field = this.closest(".form-field");
      this.shell = this.closest(".form-field__shell");

      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onShellDown = this.onShellDown.bind(this);

      this.control.addEventListener("focus", this.onFocus);
      this.control.addEventListener("blur", this.onBlur);
      this.control.addEventListener("input", this.onInput);
      if (this.shell) this.shell.addEventListener("mousedown", this.onShellDown);

      this.counter = this.field ? this.field.querySelector("[data-form-field-counter]") : null;
      this.maxLength = this.control.getAttribute("maxlength");

      this.requiredError = this.control.getAttribute("data-required-error");
      this.minLength = this.control.getAttribute("data-min-length");
      this.minLengthWarning = this.control.getAttribute("data-min-length-warning");

      const msgEl = this.field ? this.field.querySelector(".form-field__message") : null;
      this.defaultMessage = msgEl ? msgEl.textContent.trim() : "";

      // Auto-grow uses scrollHeight because CSS field-sizing would disable
      // manual resize. A manual resize becomes the floor that auto-grow can exceed.
      this.resizable = this.getAttribute("data-resizable") !== "false";
      this.userHeight = 0;
      const styles = window.getComputedStyle(this.control);
      this.minHeight = parseFloat(styles.minBlockSize) || parseFloat(styles.minHeight) || 0;
      // The single-line rest height (padding + one line) -- the hard lower
      // bound for a manual resize, so an empty field can never be dragged
      // below its default shell.
      const padBlock =
        (parseFloat(styles.paddingBlockStart || styles.paddingTop) || 0) +
        (parseFloat(styles.paddingBlockEnd || styles.paddingBottom) || 0);
      this.restHeight = Math.max((parseFloat(styles.lineHeight) || 0) + padBlock, this.minHeight);

      // Clamp BEFORE the first grow (same order as onInput), so an over-long
      // server-rendered value can't size the box to its untruncated content.
      this.clampToMaxLength();
      this.grow();

      // Re-fit on width changes because wrapping can make the fixed height stale.
      // Guard on width so height writes from grow() do not re-enter.
      this.lastWidth = this.control.clientWidth;
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(() => {
          const w = this.control.clientWidth;
          if (w === this.lastWidth) return;
          this.lastWidth = w;
          this.grow();
        });
        this.resizeObserver.observe(this.control);
      }

      // A web-font swap changes line metrics after connect (grow() first ran with
      // fallback-font metrics); re-fit once the real font is ready so the taller
      // lines don't overflow into a scrollbar.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.grow();
        });
      }

      // The grip is the resize handle: a pointer drag on it sets the height
      // directly (native textarea resize is off -- Safari cannot drag a
      // textarea whose ::-webkit-resizer is hidden).
      this.grip = this.querySelector(".textarea__grip");
      if (this.grip && this.resizable && !this.control.disabled) {
        this.onGripDown = this.onGripDown.bind(this);
        this.onGripMove = this.onGripMove.bind(this);
        this.onGripUp = this.onGripUp.bind(this);
        this.grip.addEventListener("pointerdown", this.onGripDown);
      }

      this.updateCounter();
      this.setState("completed", !!this.control.value);

      // Back/forward form restoration can repopulate after connect without input;
      // resync state, clamp, height, and counter on pageshow.
      this.onPageShow = () => {
        this.setState("completed", !!this.control.value);
        this.clampToMaxLength();
        this.grow();
        this.updateCounter();
      };
      window.addEventListener("pageshow", this.onPageShow);
    }

    disconnectedCallback() {
      window.removeEventListener("pageshow", this.onPageShow);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    setState(name, on) {
      if (this.field) this.field.classList.toggle("form-field--" + name, on);
    }

    onFocus() {
      this.setState("focused", true);
    }

    onBlur() {
      this.setState("focused", false);
      this.setState("completed", !!this.control.value);
      this.validate();
    }

    onShellDown(event) {
      if (event.target.closest(".textarea__control")) return;
      if (event.target.closest(".textarea__grip")) return;
      event.preventDefault();
      this.control.focus();
    }

    onInput() {
      this.clampToMaxLength();
      this.grow();
      this.updateCounter();
      if (this.field && this.field.classList.contains("form-field--error")) this.validate();
      if (this.field && this.field.classList.contains("form-field--warning")) this.validate();
    }

    grow() {
      if (this.control.disabled) return;
      this.control.style.height = "auto";
      const next = Math.max(this.control.scrollHeight, this.minHeight, this.userHeight);
      this.control.style.height = next + "px";
    }

    onGripDown(event) {
      event.preventDefault();
      this.dragStartY = event.clientY;
      this.dragStartHeight = this.control.offsetHeight;
      // Clamp the drag at the larger of the rest height and the content
      // height (measured once -- content cannot change mid-drag): a resize
      // can neither shrink the field below its single-line default nor
      // introduce a scrollbar.
      const prev = this.control.style.height;
      this.control.style.height = "auto";
      this.dragMin = Math.max(this.control.scrollHeight, this.restHeight, this.minHeight);
      this.control.style.height = prev;
      this.grip.setPointerCapture(event.pointerId);
      this.grip.addEventListener("pointermove", this.onGripMove);
      this.grip.addEventListener("pointerup", this.onGripUp);
      this.grip.addEventListener("pointercancel", this.onGripUp);
    }

    onGripMove(event) {
      // The dragged height applies immediately and becomes the floor that
      // auto-grow respects (it still expands past it when the content needs
      // more).
      const next = Math.max(this.dragStartHeight + event.clientY - this.dragStartY, this.dragMin);
      this.control.style.height = next + "px";
      this.userHeight = next;
    }

    onGripUp(event) {
      if (this.grip.hasPointerCapture(event.pointerId)) {
        this.grip.releasePointerCapture(event.pointerId);
      }
      this.grip.removeEventListener("pointermove", this.onGripMove);
      this.grip.removeEventListener("pointerup", this.onGripUp);
      this.grip.removeEventListener("pointercancel", this.onGripUp);
    }

    /* The limit guards what is TRANSMITTED, not the DOM value: form encoding
       normalises every line break to CRLF, so each LF in the API value costs
       2 characters on the wire (and in what Shopify stores). Native maxlength
       counts an LF as 1 and ignores programmatic assignment, so this measure
       is the authoritative one for both the clamp and the counter. */
    effectiveLength(value) {
      let length = value.length;
      for (let i = 0; i < value.length; i += 1) {
        if (value[i] === "\n") length += 1;
      }
      return length;
    }

    clampToMaxLength() {
      const max = parseInt(this.maxLength, 10);
      if (!max) return;
      const value = this.control.value;
      if (this.effectiveLength(value) <= max) return;
      let cost = 0;
      let cut = 0;
      while (cut < value.length) {
        const next = cost + (value[cut] === "\n" ? 2 : 1);
        if (next > max) break;
        cost = next;
        cut += 1;
      }
      /* Never cut between the halves of a surrogate pair. */
      const tail = value.charCodeAt(cut - 1);
      if (cut > 0 && tail >= 0xd800 && tail <= 0xdbff) cut -= 1;
      const caret = this.control.selectionStart;
      this.control.value = value.slice(0, cut);
      const pos = Math.min(caret == null ? cut : caret, cut);
      this.control.setSelectionRange(pos, pos);
    }

    updateCounter() {
      if (!this.counter || !this.maxLength) return;
      this.counter.textContent =
        this.effectiveLength(this.control.value) + "/" + this.maxLength + " characters";
    }

    setMessage(text) {
      if (!this.field) return;
      const msg = this.field.querySelector(".form-field__message");
      if (msg) msg.textContent = text;
    }

    validate() {
      if (!this.requiredError && !this.minLengthWarning) return;

      const value = this.control.value;
      const empty = value.trim() === "";
      let errorMsg = null;
      let warningMsg = null;

      if (this.requiredError && empty) {
        errorMsg = this.requiredError;
      }

      if (!errorMsg && this.minLength && this.minLengthWarning) {
        if (!empty && value.length < parseInt(this.minLength, 10)) {
          warningMsg = this.minLengthWarning;
        }
      }

      if (this.requiredError) {
        this.setState("error", !!errorMsg);
        this.control.setAttribute("aria-invalid", errorMsg ? "true" : "false");
      }
      if (this.minLengthWarning) {
        this.setState("warning", !!warningMsg);
      }

      this.setMessage(errorMsg || warningMsg || this.defaultMessage);
    }
  }

  if (!customElements.get("x-textarea")) {
    customElements.define("x-textarea", SeedTextarea);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-button"] && !Shopify.designMode) return;
  try {
    /* Tap-animation trigger for the wishlist heart. Presentation-only: the
     runtime (wishlist-runtime) owns state + aria-pressed; this listener only
     stamps a short-lived class so CSS keyframes fire on real taps, never on
     hydration or wishlist:content re-syncs. Delegated + init-guarded, so it
     works for AJAX-injected hearts and never double-binds. It runs after the
     runtime click handler, so aria-pressed already reflects the post-tap state. */
  (function () {
    if (window.__seedWishlistBtnAnim) return;
    window.__seedWishlistBtnAnim = true;

    var ADD = "wishlist-button--anim-add";
    var REMOVE = "wishlist-button--anim-remove";

    document.addEventListener("click", function (e) {
      var host = e.target.closest ? e.target.closest("x-wishlist-button") : null;
      if (!host) return;
      var btn = host.querySelector("[data-wishlist-toggle]");
      if (!btn) return;
      // Guests never toggle -- their tap opens the login gate (wishlist-runtime's
      // _onClick returns early), so aria-pressed never flips off 'false'. Keying
      // the animation on aria-pressed alone would fire the REMOVE fade (flashing
      // the filled heart in via wl-heart-out's from:opacity:1) on every guest tap.
      if (
        window.SeedWishlist &&
        window.SeedWishlist.isLoggedIn &&
        !window.SeedWishlist.isLoggedIn()
      )
        return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return;
      var saved = btn.getAttribute("aria-pressed") === "true";
      host.classList.remove(ADD, REMOVE);
      void host.offsetWidth; /* restart keyframes on a rapid re-tap */
      host.classList.add(saved ? ADD : REMOVE);
    });

    /* Clear the gate class when each variant's LONGEST-RUNNING animation ends
       (clearing early would cancel the rest of the sequence mid-flight):
       pop variant -> the ring (outlives the pop) / the dip (outlives the fade);
       sweep variant -> the jelly settle (chained after the fill) / the drain. */
    var FINAL_ANIMS = {
      "wl-heart-ring": 1,
      "wl-heart-dip": 1,
      "wl-heart-jelly": 1,
      "wl-heart-drain": 1,
    };
    document.addEventListener("animationend", function (e) {
      if (!FINAL_ANIMS[e.animationName]) return;
      var host = e.target.closest ? e.target.closest("x-wishlist-button") : null;
      if (!host) return;
      host.classList.remove(ADD, REMOVE);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-login"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedWishlistLoginInit) return;
    window.__seedWishlistLoginInit = true;

    var OVERLAY_ID = "wishlist-login";

    /* Shopper returns to the surface that gated them: product/PDP hearts return to
       the current page, while header-heart triggers can declare the wishlist page.
       Shopify redirects to `return_to` server-side, so no client state survives
       the hosted-auth trip. */
    var returnTo = null;

    function currentPath() {
      return location.pathname + location.search + location.hash;
    }

    // `return_to` accepts relative URLs only: accept a root-relative path, reduce a
    // same-origin absolute URL to its path, and reject anything else. This is the
    // open-redirect guard.
    function sanitizeReturn(url) {
      if (!url) return null;
      url = String(url);
      if (url.indexOf("//") === 0 || url.indexOf("://") > -1) {
        try {
          var u = new URL(url, location.origin);
          if (u.origin !== location.origin) return null;
          return u.pathname + u.search + u.hash;
        } catch (e) {
          return null;
        }
      }
      if (url.charAt(0) !== "/") return null;
      return url;
    }

    // Overlay triggers can declare a return destination; capture it at open time
    // alongside the overlay base's own delegated open.
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest('[data-overlay-trigger="' + OVERLAY_ID + '"]');
      if (!trigger) return;
      returnTo = trigger.getAttribute("data-wishlist-login-return") || currentPath();
    });

    function host() {
      return document.querySelector('x-overlay[data-overlay-id="' + OVERLAY_ID + '"]');
    }

    // Open the gate. Prefer the overlay element's own API; fall back to a
    // delegated trigger click if the custom element hasn't upgraded yet.
    // Programmatic opens (the product hearts, the wishlist page boot) return
    // to the CURRENT page after sign-in unless opts.returnTo overrides.
    function prompt(opts) {
      returnTo = opts && opts.returnTo ? opts.returnTo : currentPath();
      var h = host();
      if (h && typeof h.open === "function") {
        h.open();
        return;
      }
      var dialog = h ? h.querySelector("dialog.overlay") : null;
      // Never showModal() directly -- that bypasses the overlay's scroll lock.
      if (dialog && window.SeedOverlay) window.SeedOverlay.open(dialog);
    }

    function closeGate() {
      var h = host();
      var dialog = h ? h.querySelector("dialog.overlay") : null;
      if (dialog && dialog.open) dialog.close();
    }

    // Sign In: close our modal, then navigate to the new-customer-accounts
    // sign-in path with the return destination. Shopify redirects to
    // `return_to` server-side once the hosted auth completes.
    // (Shopify.routes.root always carries a trailing slash: '/', '/fr/', ...)
    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-wishlist-login-signin]");
      if (!btn) return;
      event.preventDefault();
      closeGate();
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var target = sanitizeReturn(returnTo) || currentPath();
      window.location.href =
        root + "customer_authentication/login?return_to=" + encodeURIComponent(target);
    });

    window.SeedWishlistGate = window.SeedWishlistGate || {};
    window.SeedWishlistGate.prompt = prompt;
    window.SeedWishlistGate.close = closeGate;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-runtime"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__seedWishlistInit) return;
    window.__seedWishlistInit = true;

    var EVT_CONTENT = "wishlist:content";
    var EVT_COUNT = "wishlist:count";
    var LIST_NAME = "Wishlist";

    var state = {
      ready: false,
      unavailable: false,
      swat: null,
      lid: null,
      contents: [], // [{ empi, epi, du, cts }]
    };

    // Toggles requested by a logged-in shopper before SWYM has resolved. Held
    // here and replayed once the list is ready (or released if SWYM gives up) so
    // an early heart click is never silently dropped.
    var pending = [];

    // Products with an add/remove round-trip in flight (keyed by empi). Blocks a
    // rapid re-click from firing a second, conflicting SWYM call against the
    // not-yet-refreshed cache.
    var inFlight = {};

    // Latest variant swap requested for a product while an earlier one is still in
    // flight (keyed by empi, one entry per product -- last write wins). Drained when
    // the in-flight call settles.
    var queuedVariant = {};

    function markUnavailable() {
      if (state.unavailable) return;
      state.unavailable = true;
      document.documentElement.setAttribute("data-wishlist-unavailable", "");
      broadcast();
      // Release any clicks queued before SWYM gave up: their done() reverts the
      // optimistic fill (the heart hides via the unavailable flag regardless).
      releasePending();
      // Drop in-flight guards; state is torn down (a stuck key must not survive a
      // later markAvailable() and block that product forever).
      inFlight = {};
      queuedVariant = {};
    }

    // SWYM resolved after the grace-period timeout had already flagged it
    // unavailable (a slow SDK that only just missed the deadline): bring the
    // hearts back so they're functional again instead of stranded hidden while
    // the header heart fills from the freshly-fetched list.
    function markAvailable() {
      if (!state.unavailable) return;
      state.unavailable = false;
      document.documentElement.removeAttribute("data-wishlist-unavailable");
    }

    // Replay queued toggles once the list is ready. state.ready is already true
    // when this runs, so each re-entrant toggle() executes for real.
    function drainPending() {
      if (!pending.length) return;
      var q = pending;
      pending = [];
      for (var i = 0; i < q.length; i++) toggle(q[i].item, q[i].done);
    }

    // Invoke every queued done() without acting (SWYM unavailable).
    function releasePending() {
      if (!pending.length) return;
      var q = pending;
      pending = [];
      for (var i = 0; i < q.length; i++) {
        if (q[i].done) q[i].done();
      }
    }

    // Wishlists are CUSTOMER-ONLY (never tied to a guest). Login state is
    // stamped on <html> at render (theme.liquid) so it's known before any fetch.
    function isLoggedIn() {
      return document.documentElement.hasAttribute("data-customer-logged-in");
    }

    // Membership: match empi, and epi too when an epi is supplied (variant-level).
    function isSaved(empi, epi) {
      if (!empi) return false;
      for (var i = 0; i < state.contents.length; i++) {
        var it = state.contents[i];
        if (String(it.empi) === String(empi)) {
          if (epi === undefined || epi === null || epi === "") return true;
          if (String(it.epi) === String(epi)) return true;
        }
      }
      return false;
    }

    function getCount() {
      var seen = {};
      var n = 0;
      for (var i = 0; i < state.contents.length; i++) {
        var k = String(state.contents[i].empi);
        if (!seen[k]) {
          seen[k] = 1;
          n++;
        }
      }
      return n;
    }

    // Handles of every product in the list, parsed from each item's `du`
    // (destination URL). Handle-keyed surfaces -- the Coveo cards, which know the
    // product HANDLE at render time but not the numeric empi -- hydrate saved state
    // from this map WITHOUT a per-card /products/<handle>.js fetch. Membership is
    // by handle, matching the empi-keyed `isSaved` semantics. The regex mirrors the
    // card delegator's own handle parse (`/products/<handle>`).
    function savedHandles() {
      var out = {};
      for (var i = 0; i < state.contents.length; i++) {
        var du = state.contents[i].du;
        if (!du) continue;
        var m = String(du).match(/\/products\/([^/?#]+)/);
        if (m) out[m[1]] = true;
      }
      return out;
    }

    function broadcast() {
      var count = getCount();
      // Global "wishlist has items" flag -> the header heart fills (no count badge).
      document.documentElement.classList.toggle("is-wishlist-active", count > 0);
      document.dispatchEvent(new CustomEvent(EVT_CONTENT));
      document.dispatchEvent(new CustomEvent(EVT_COUNT, { detail: { count: count } }));
    }

    function flatten(lists) {
      var out = [];
      for (var i = 0; i < lists.length; i++) {
        var lc = lists[i].listcontents || [];
        for (var j = 0; j < lc.length; j++) {
          // cts (SWYM's create timestamp, epoch ms) rides along so list surfaces
          // can order newest-first. SWYM's `dt` field is the display title, not a
          // timestamp, so ordering keys on `cts`. The toggle/update payloads only
          // ever send empi/epi/du.
          out.push({ empi: lc[j].empi, epi: lc[j].epi, du: lc[j].du, cts: lc[j].cts });
        }
      }
      return out;
    }

    // Raw saved items for list surfaces (the wishlist page). A copy, so a consumer
    // can sort/filter without mutating the cache. Empty until ready (guests resolve
    // ready with an empty list and stay empty).
    function items() {
      return state.contents.slice();
    }

    // First-party cookie read. SWYM stores its identity (regid, sessionid) and
    // the store public key (pid) in `swym-*` cookies on the storefront domain.
    // Returns the value with any wrapping JSON quotes stripped, or null.
    function swymCookie(name) {
      var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
      if (!m) return null;
      var v;
      try {
        v = decodeURIComponent(m[1]);
      } catch (e) {
        v = m[1];
      }
      if (v.charAt(0) === '"' && v.charAt(v.length - 1) === '"') v = v.slice(1, -1);
      return v;
    }

    // Resolve the SWYM relay API host from the config SWYM injects into the page
    // (the web-pixels block carries `swymstore-<tier>.swymrelay.com`), so this
    // works per-store (AU/NZ) with no hardcoded host. Cached after first hit;
    // null if not found.
    var _swymHost;
    function swymHost() {
      if (_swymHost !== undefined) return _swymHost;
      _swymHost = null;
      try {
        // Scan only inline <script> config blobs (SWYM's web-pixels config carries
        // `swymstore-<tier>.swymrelay.com`) instead of serializing the whole
        // document -- avoids an O(page-size) innerHTML build on card-heavy pages.
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++) {
          var txt = scripts[i].textContent;
          if (!txt) continue;
          var m = txt.match(/swymstore-[a-z0-9.-]+\.swymrelay\.com/i);
          if (m) {
            _swymHost = "https://" + m[0];
            break;
          }
        }
      } catch (e) {}
      return _swymHost;
    }

    // Fast-path list read for the wishlist page. Fetches the saved list in a single
    // direct REST call to the SWYM relay, authenticated with the pid/regid/sessionid
    // the SDK has already written to first-party cookies, without waiting for the
    // heavy SDK to download and boot. The relay returns `listcontents` inline, so one
    // round-trip yields the items. READ-ONLY: it never mutates runtime state;
    // add/remove/updateVariant still go through the SDK, which boots in parallel and
    // remains the source of truth. Any missing cookie / non-200 / parse error /
    // timeout resolves done(null) so the caller falls back to the SDK path. done
    // receives [{ empi, epi, du, cts }] or null.
    function fastFetch(done) {
      var finish = function (v) {
        if (done) {
          var d = done;
          done = null;
          d(v);
        }
      };
      if (!isLoggedIn()) {
        finish(null);
        return;
      }
      var pid = swymCookie("swym-pid");
      var regid = swymCookie("swym-swymRegid");
      var sessionid = swymCookie("swym-session-id");
      var host = swymHost();
      if (!pid || !regid || !sessionid || !host) {
        finish(null);
        return;
      }
      // Bound the wait so a hung relay call never delays the SDK fallback.
      var timer = setTimeout(function () {
        finish(null);
      }, 4000);
      var url = host + "/api/v3/lists/fetch-lists?pid=" + encodeURIComponent(pid);
      var body =
        "regid=" + encodeURIComponent(regid) + "&sessionid=" + encodeURIComponent(sessionid);
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body,
        priority: "high",
      })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (lists) {
          clearTimeout(timer);
          if (!lists) {
            finish(null);
            return;
          }
          var arr = Array.isArray(lists) ? lists : lists.lists || [];
          var lc = (arr[0] && arr[0].listcontents) || [];
          var out = [];
          for (var i = 0; i < lc.length; i++) {
            out.push({ empi: lc[i].empi, epi: lc[i].epi, du: lc[i].du, cts: lc[i].cts });
          }
          finish(out);
        })
        .catch(function () {
          clearTimeout(timer);
          finish(null);
        });
    }

    /* SWYM adapter. The enterprise SDK (`swym-ext-shopify.js` /
       `async-wishlist-apis.js`) exposes addToList / deleteFromList / fetchLists /
       createList and updateListItem / updateList / updateVariant; the update calls
       live on `swat.api.*` (root may also carry the add/delete/fetch/create set).
       Prefer the root methods where present; use `swat.api` for the rest.
       `updateVariant(lid, oldItem, newItem, ok, err)` is the purpose-built atomic
       variant swap (one `/lists/update-ctx` call, d:[old]+a:[new]) that keeps the
       item's slot -- used by `updateVariant()` below to change a saved size without
       reordering the list, instead of a separate deleteFromList + addToList. */
    function api(swat) {
      if (swat && typeof swat.addToList === "function") return swat;
      if (swat && swat.api && typeof swat.api.addToList === "function") return swat.api;
      return swat;
    }
    function lister(swat) {
      // fetchLists lives on the root swat in the docs; fall back to .api.
      if (swat && typeof swat.fetchLists === "function") return swat;
      return api(swat);
    }

    function refreshLists(done) {
      var l = lister(state.swat);
      if (!l || typeof l.fetchLists !== "function") {
        markUnavailable();
        return;
      }
      l.fetchLists({
        callbackFn: function (lists) {
          lists = lists || [];
          if (lists.length) {
            state.lid = lists[0].lid;
            state.contents = flatten(lists);
          } else {
            state.contents = [];
          }
          state.ready = true;
          markAvailable();
          broadcast();
          if (done) done();
          drainPending();
          maybeValidateOrphans();
        },
        errorFn: function () {
          markUnavailable();
          if (done) done();
        },
      });
    }

    function ensureList(cb) {
      if (state.lid) {
        cb(state.lid);
        return;
      }
      var a = api(state.swat);
      if (!a || typeof a.createList !== "function") {
        markUnavailable();
        return;
      }
      a.createList(
        { lname: LIST_NAME },
        function (res) {
          state.lid = res && res.lid ? res.lid : state.lid;
          cb(state.lid);
        },
        function () {
          markUnavailable();
        },
      );
    }

    // Product-level toggle. item: { empi, epi, du } (epi = a representative variant
    // for adds; SWYM stores items per-variant, but we treat the wishlist as
    // product-level - a product is "saved" if ANY of its variants is in the list).
    // Optimistic caller flips the button; we re-pull the list on completion so the
    // cache reflects the server, then re-sync.
    function toggle(item, done) {
      if (state.unavailable) {
        if (done) done();
        return;
      }
      // SWYM hasn't resolved yet: defer a logged-in shopper's early click and
      // replay it once ready (the optimistic fill stays put), rather than
      // dropping it. A guest never reaches a real toggle, so just release it.
      if (!state.ready || !state.swat) {
        if (isLoggedIn()) {
          pending.push({ item: item, done: done });
          return;
        }
        if (done) done();
        return;
      }
      // In-flight guard: ignore a re-click on the same product while its round-trip
      // runs, so a double-tap can't fire a second call against the stale cache. The
      // ignored click's done() reconciles the button back to the true (pending) state.
      var key = String(item.empi);
      if (inFlight[key]) {
        if (done) done();
        return;
      }
      inFlight[key] = true;
      var finish = function () {
        delete inFlight[key];
        if (done) done();
      };

      var a = api(state.swat);
      // Every stored entry for this product (usually one; may be >1 from legacy
      // variant-level saves) - remove ALL so the product-level heart truly clears.
      var saved = state.contents.filter(function (c) {
        return String(c.empi) === String(item.empi);
      });

      if (saved.length) {
        if (typeof a.deleteFromList !== "function") {
          finish();
          return;
        }
        var i = 0;
        var removeNext = function () {
          if (i >= saved.length) {
            refreshLists(finish);
            return;
          }
          var s = saved[i++];
          a.deleteFromList(
            state.lid,
            { empi: s.empi, epi: s.epi, du: s.du },
            removeNext,
            removeNext,
          );
        };
        removeNext();
      } else {
        ensureList(function (lid) {
          if (typeof a.addToList !== "function") {
            finish();
            return;
          }
          var refetch = function () {
            refreshLists(finish);
          };
          a.addToList(lid, { empi: item.empi, epi: item.epi, du: item.du }, refetch, refetch);
        });
      }
    }

    // Variant update for the wishlist page: swap a saved product's stored variant
    // (epi) to a newly chosen one via SWYM's purpose-built, atomic `updateVariant`
    // -- a single `/lists/update-ctx` call carrying d:[oldItem] + a:[newItem].
    // Unlike a separate delete-then-add it keeps the item's slot, so the size change
    // never floats the row to the top of the list. The method
    // lives on the API instance (`swat.api.updateVariant`); resolve it there or on
    // the root. done(ok) reports success so the caller can revert an optimistic
    // selection.
    function updateVariant(empi, newEpi, du, done) {
      if (state.unavailable || !state.ready || !state.swat || !isLoggedIn()) {
        if (done) done(false);
        return;
      }
      var a = api(state.swat);
      var host =
        typeof a.updateVariant === "function"
          ? a
          : state.swat.api && typeof state.swat.api.updateVariant === "function"
            ? state.swat.api
            : null;
      if (!host) {
        if (done) done(false);
        return;
      }

      // Sizes tapped in quick succession queue instead of failing: the newest
      // request for this product replaces any earlier queued one and runs once the
      // in-flight swap settles, so the stored variant lands on the last tap.
      var key = String(empi);
      if (inFlight[key]) {
        queuedVariant[key] = { epi: newEpi, du: du, done: done };
        return;
      }
      inFlight[key] = true;
      var finish = function (ok) {
        refreshLists(function () {
          delete inFlight[key];
          var next = queuedVariant[key];
          if (next) {
            // A later tap already replaced this call's optimistic selection on
            // screen, so its outcome must not drive the UI -- reporting it would
            // revert the chip the shopper actually wants.
            delete queuedVariant[key];
            updateVariant(empi, next.epi, next.du, next.done);
            return;
          }
          if (done) done(ok);
        });
      };

      var saved = state.contents.filter(function (c) {
        return String(c.empi) === String(empi);
      });
      // No known prior entry for this product in the authoritative cache (a cache/
      // fast tier rendered ahead of state.contents, or SWYM's list lags this view).
      // A self-referential swap (old.epi === newEpi) would no-op the delete side of
      // the atomic call and risk leaving/duplicating a row, so bail and let the
      // caller revert -- the SDK's own list stays the source of truth.
      if (!saved.length) {
        delete inFlight[key];
        if (done) done(false);
        return;
      }
      var old = saved[0];
      host.updateVariant(
        state.lid,
        { empi: old.empi, epi: old.epi, du: old.du || du },
        { empi: empi, epi: newEpi, du: du || old.du },
        function () {
          finish(true);
        },
        function () {
          finish(false);
        },
      );
    }

    // Self-heal storage keys (namespace:camelCase, matching the theme's other
    // client keys). `validated` gates the background pass to once per browser
    // session; `sectionId` caches the wishlist section id used by the id-search.
    var SS_VALIDATED = "wishlist:validated";
    var SS_SECTION = "wishlist:sectionId";
    function sessionGet(k) {
      try {
        return sessionStorage.getItem(k);
      } catch (e) {
        return null;
      }
    }
    function sessionSet(k, v) {
      try {
        sessionStorage.setItem(k, v);
      } catch (e) {}
    }

    // Locale/market-aware storefront root, mirroring the wishlist page's own URL
    // build so the id-search resolves against the same catalogue the page sees.
    function shopRoot() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      return root.charAt(root.length - 1) === "/" ? root : root + "/";
    }

    // Remove every stored entry for each orphan product (empi) via the same
    // deleteFromList path a user remove uses, then re-pull once so the header +
    // count reflect the cleaned list. Only entries with no toggle in flight are
    // touched, and the inFlight guard blocks a concurrent user toggle from racing
    // the prune. No-ops unless the list is live and the shopper is signed in.
    function pruneOrphans(empis, done) {
      if (
        !empis ||
        !empis.length ||
        state.unavailable ||
        !state.ready ||
        !state.lid ||
        !isLoggedIn()
      ) {
        if (done) done();
        return;
      }
      var a = api(state.swat);
      if (!a || typeof a.deleteFromList !== "function") {
        if (done) done();
        return;
      }
      var wanted = {};
      for (var i = 0; i < empis.length; i++) {
        var k = String(empis[i]);
        if (k && !inFlight[k]) wanted[k] = true;
      }
      var targets = state.contents.filter(function (c) {
        return wanted[String(c.empi)];
      });
      if (!targets.length) {
        if (done) done();
        return;
      }
      var keys = Object.keys(wanted);
      keys.forEach(function (k) {
        inFlight[k] = true;
      });
      var clear = function () {
        keys.forEach(function (k) {
          delete inFlight[k];
        });
      };
      var i2 = 0;
      var removeNext = function () {
        if (i2 >= targets.length) {
          clear();
          refreshLists(function () {
            if (done) done();
          });
          return;
        }
        var s = targets[i2++];
        a.deleteFromList(state.lid, { empi: s.empi, epi: s.epi, du: s.du }, removeNext, removeNext);
      };
      removeNext();
    }

    // Discover the wishlist section id needed to render the id-search. The runtime
    // JS carries no Liquid, so the wishlist page URL is read from the header link
    // and the section id from the fetched page's `.shopify-section--wishlist`
    // wrapper. Cached per session. cb(null) when it can't be resolved -> the
    // caller leaves the list untouched rather than guessing.
    function resolveWishlistSectionId(cb) {
      var cached = sessionGet(SS_SECTION);
      if (cached) {
        cb(cached);
        return;
      }
      var link = document.querySelector(".header-wishlist");
      var href = link && link.getAttribute("href");
      if (!href) {
        cb(null);
        return;
      }
      fetch(href, { priority: "low" })
        .then(function (res) {
          return res.ok ? res.text() : null;
        })
        .then(function (htmlText) {
          if (!htmlText) {
            cb(null);
            return;
          }
          var doc = new DOMParser().parseFromString(htmlText, "text/html");
          var sec = doc.querySelector(".shopify-section--wishlist");
          var id = sec && sec.id ? sec.id.replace(/^shopify-section-/, "") : null;
          if (id) sessionSet(SS_SECTION, id);
          cb(id);
        })
        .catch(function () {
          cb(null);
        });
    }

    // Background self-heal for pages OTHER than the wishlist page: resolve the
    // saved empis against the storefront with the SAME id-search the wishlist page
    // uses, and prune the ones that no longer render (product deleted / unpublished
    // / drafted). Matching by product id (not handle) keeps it in step with the
    // page, so a renamed product is never pruned; an OOS product still renders a
    // card, so it is never an orphan. GUARDRAIL: a chunk counts only when its fetch
    // returned a recognizable wishlist-section render (SRA cards OR the empty-state
    // branch); a failed/foreign response contributes no orphans, and if no chunk
    // proves the endpoint live nothing is pruned and the session is not marked
    // validated (retry next load).
    function validateOrphans() {
      resolveWishlistSectionId(function (sectionId) {
        if (!sectionId) return;
        var root = shopRoot();
        var empis = [];
        var seen = {};
        for (var i = 0; i < state.contents.length; i++) {
          var k = String(state.contents[i].empi);
          if (k && !seen[k]) {
            seen[k] = 1;
            empis.push(k);
          }
        }
        if (!empis.length) return;
        var CHUNK = 24;
        var chunks = [];
        for (var c = 0; c < empis.length; c += CHUNK) chunks.push(empis.slice(c, c + CHUNK));
        var resolved = {};
        var okIds = {};
        var anyOk = false;
        var remaining = chunks.length;
        var settle = function () {
          if (--remaining > 0) return;
          if (!anyOk) return;
          sessionSet(SS_VALIDATED, "1");
          var orphans = [];
          for (var i = 0; i < empis.length; i++) {
            if (okIds[empis[i]] && !resolved[empis[i]]) orphans.push(empis[i]);
          }
          if (orphans.length) pruneOrphans(orphans);
        };
        chunks.forEach(function (chunk) {
          var q = chunk
            .map(function (id) {
              return "id:" + id;
            })
            .join(" OR ");
          var url =
            root +
            "search?q=" +
            encodeURIComponent(q) +
            "&type=product&section_id=" +
            encodeURIComponent(sectionId);
          fetch(url, { priority: "low" })
            .then(function (res) {
              return res.ok ? res.text() : null;
            })
            .then(function (htmlText) {
              if (htmlText != null) {
                var doc = new DOMParser().parseFromString(htmlText, "text/html");
                var inner = doc.querySelector(".wishlist__inner");
                // The section emits `.wishlist__inner` only when at least one id
                // matched; an all-orphan chunk falls to its empty-state branch
                // (`[data-wishlist-empty]`). Either is proof the search ran, so a
                // chunk with zero matches still yields orphans -- while a
                // failed/foreign response carries neither marker and is skipped.
                var ran = inner || doc.querySelector("[data-wishlist-empty]");
                if (ran) {
                  anyOk = true;
                  for (var j = 0; j < chunk.length; j++) okIds[chunk[j]] = true;
                  var cards = (inner || doc).querySelectorAll("[data-wishlist-card]");
                  for (var m = 0; m < cards.length; m++) {
                    var pid = cards[m].getAttribute("data-product-id");
                    if (pid) resolved[String(pid)] = true;
                  }
                }
              }
            })
            .catch(function () {})
            .then(settle);
        });
      });
    }

    // Run the background self-heal at most once per page load, and once per browser
    // session across loads. Skips the wishlist page (it heals for free from its own
    // render) and empty lists (the header is already correct).
    var _validateRan = false;
    function maybeValidateOrphans() {
      if (_validateRan) return;
      if (!isLoggedIn() || state.unavailable || !state.ready || !state.contents.length) return;
      if (document.querySelector("x-wishlist-page")) return;
      if (sessionGet(SS_VALIDATED) === "1") return;
      _validateRan = true;
      validateOrphans();
    }

    window.SeedWishlist = window.SeedWishlist || {};
    window.SeedWishlist.isSaved = isSaved;
    window.SeedWishlist.items = items;
    window.SeedWishlist.fastFetch = fastFetch;
    window.SeedWishlist.updateVariant = updateVariant;
    window.SeedWishlist.getCount = getCount;
    window.SeedWishlist.savedHandles = savedHandles;
    window.SeedWishlist.toggle = toggle;
    window.SeedWishlist.pruneOrphans = pruneOrphans;
    window.SeedWishlist.isReady = function () {
      return state.ready;
    };
    window.SeedWishlist.isUnavailable = function () {
      return state.unavailable;
    };
    window.SeedWishlist.isLoggedIn = isLoggedIn;

    // Bootstrap. If the Swym app embed is disabled its globals are never injected
    // (`window.SwymCallbacks` / `window._swat` both absent) -> the feature is OFF, so
    // mark unavailable immediately and hide every heart for all shoppers (no 8s
    // dead-heart window). Otherwise: guests never touch SWYM (wishlist is customer-only)
    // -> resolve to an empty, ready state so hearts render (outline) and route clicks to
    // the login gate. Only a logged-in shopper queues into SwymCallbacks and fetches
    // their list; if SWYM is present but never resolves, degrade after a grace period.
    (function boot() {
      if (!window.SwymCallbacks && !window._swat) {
        markUnavailable();
        return;
      }
      if (!isLoggedIn()) {
        state.ready = true;
        broadcast();
        return;
      }
      if (!window.SwymCallbacks) window.SwymCallbacks = [];
      window.SwymCallbacks.push(function (swat) {
        state.swat = swat;
        refreshLists();
      });
      setTimeout(function () {
        if (!state.ready && !state.unavailable) markUnavailable();
      }, 8000);
    })();

    if (!customElements.get("x-wishlist-button")) {
      customElements.define(
        "x-wishlist-button",
        class extends HTMLElement {
          connectedCallback() {
            this._btn = this.querySelector("[data-wishlist-toggle]");
            this._empi = this.dataset.empi || "";
            this._epi = this.dataset.epi || ""; // representative variant, for the add payload
            this._du = this.dataset.du || "";
            this._source = this.dataset.source || "";
            this._labelAdd = this.dataset.labelAdd || "";
            this._labelRemove = this.dataset.labelRemove || "";
            if (!this._btn || !this._empi) return; // gallery / mock card: inert demo

            this._onClick = this._onClick.bind(this);
            this._onContent = this.sync.bind(this);
            this._btn.addEventListener("click", this._onClick);
            document.addEventListener(EVT_CONTENT, this._onContent);
            this.sync();
          }

          disconnectedCallback() {
            if (this._btn && this._onClick) this._btn.removeEventListener("click", this._onClick);
            if (this._onContent) document.removeEventListener(EVT_CONTENT, this._onContent);
          }

          // Product-level: saved if ANY variant of this product is in the list.
          sync() {
            if (!window.SeedWishlist || !this._btn) return;
            var saved = window.SeedWishlist.isSaved(this._empi);
            this._btn.setAttribute("aria-pressed", saved ? "true" : "false");
            var label = saved ? this._labelRemove : this._labelAdd;
            if (label) this._btn.setAttribute("aria-label", label);
          }

          // Resolve the representative variant at click time. On the PDP
          // (source=product_details_page), use the currently selected variant from
          // the buy-box input so the wishlist page can pre-select the saved size.
          // Everywhere else, fall back to the server-stamped epi. Saved state stays
          // product-level (keyed on empi); this only sets which variant is stored.
          _currentEpi() {
            if (this._source === "product_details_page") {
              var scope = this.closest(".shopify-section") || document;
              var input = scope.querySelector("[data-buy-box-id]");
              if (input && input.value) return input.value;
            }
            return this._epi;
          }

          _onClick(e) {
            e.preventDefault();
            if (!window.SeedWishlist || !this._empi) return;
            // Guest -> prompt login instead of toggling (wishlist is customer-only).
            if (!window.SeedWishlist.isLoggedIn()) {
              if (window.SeedWishlistGate && window.SeedWishlistGate.prompt) {
                window.SeedWishlistGate.prompt();
              }
              return;
            }
            var self = this;
            // Optimistic flip; sync() on completion reconciles against the server.
            var next = self._btn.getAttribute("aria-pressed") !== "true";
            self._btn.setAttribute("aria-pressed", next ? "true" : "false");
            window.SeedWishlist.toggle(
              { empi: self._empi, epi: self._currentEpi(), du: self._du },
              function () {
                self.sync();
              },
            );
          }
        },
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
